import { Component, OnInit, OnDestroy, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { PersonBeneficiary, regional, Beneficiarios, sectoresCIIU, tiposDeAsesor, sucursalRegional } from '../../models/cotizador/response/model.data.response';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm, FormArray } from '@angular/forms';
import { DateAdapter, ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogBeneficiaryComponent } from '../common/dialogs/dialog-beneficiary/dialog-beneficiary.component';
import { campanias, ContratPeopleResponse, QuotationPeopleResponse } from '../../models/cotizador/response/model.data.response';
import { MatTableDataSource } from '@angular/material/table';
import { DialogContratComponent } from '../common/dialogs/dialog-contrat/dialog-contrat.component';
import { SnackBarService } from '../../utils/util.SnackBarService';
import { DialogColectivoComponent } from '../common/dialogs/dialog-colectivo/dialog-colectivo.component';
import { StorageService } from '../../utils/util.storage.service';
import { Codigo } from '../common/Codigo';
import { CampaniaRequest, ModeloCotizacion, ModeloNegocioRequest, QuotationPeopleRequest } from '../../models/cotizador/request/model.data.request';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import IListDetail from '../../models/cotizador/IListDetail';
import { IListTarifa } from '../../models/cotizador/IListTarifa';
import { IDataTarifa } from '../../models/cotizador/IDataTarifa';
import { NetworkingQuotation } from '../../services/servicioCotizador/cotizador.service';
import { BodyResponse } from '../../models/cotizador/BodyResponse';
import { error, Key } from 'protractor';
import { ModelDefaultResponse } from '../../models/cotizador/response/model.default.response';
import { IPorcentajeDescuentos } from '../../models/cotizador/IPorcentajesDescuentos';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base } from '../common/base';
import Swal from 'sweetalert2';
import { Observable, of, forkJoin, firstValueFrom, Subject } from 'rxjs';
import { catchError, map, take, takeUntil } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { UserLoggedResponse } from '../../models/user';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';
import { AuthService } from '../../services/security/auth.service';
import { MatTabGroup } from '@angular/material/tabs';
import { MatPaginator } from '@angular/material/paginator';
import { FormularioContratanteComponent } from './pages/contratante-page/components/formulario-contratante/formulario-contratante.component';
import { DialogCuotaInscripcionComponent } from '../common/dialogs/dialog-cuota-inscripcion/dialog-cuota-inscripcion.component';
import { TipoDocumento } from '../../models/cotizador-contratante/consultarDocumentos/response/consultar-documentos-response.model';
import { BeneficiariosModel } from '../../models/person-beneficiary.model';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ConsultarLineasGruposProgramasService } from '../../services/cotizador-programas/consultar-lineas-grupos-programas.service';
import { CotizacionService } from '../../services/cotizacion/cotizacion.service';
import { AsesorService } from '../../services/codigo-asesor-cotizador/codigo_asesor-cotizador.service';
import { CotizacionColectivoService } from '../../services/cotizacion-colectivo/cotizacion-colectivo.service';
import { CotizacionColectivoContactoService } from '../../services/cotizacion-colectivo-contacto/cotizacion-colectivo-contacto.service';
import { CotizacionColectivo, CotizacionColectivoProducto } from '../../models/cotizacion-colectivo/cotizacion-colectivo.model';
import { CotizacionColectivoContacto } from '../../models/cotizacion-colectivo-contacto/cotizacion-colectivo-contacto.model';
import { CotizadorTarifaColectivo } from '../../models/cotizador-tarifa-colectivo/cotizador-tarifa-colectivo.model';
import { CotizadorTarifaColectivoAnexo } from '../../models/cotizador-tarifa-colectivo/cotizador-tarifa-colectivo-anexo.model';
import { CotizadorTarifaColectivoService } from '../../services/cotizador-tarifa-colectivo/cotizador-tarifa-colectivo.service';
import { CrearCotizacionRequest } from '../../models/crear-cotizacion/cotizacion.model';
import { SubcuentaItem } from '../../models/cotizador-contratante/consultar-subcuentas/ressponse/consultar-subcuentas-response.model';
import { ConsultarSubcuentasService } from '../../services/cotizador-contratante/consultar-subcuentas.service';
import { NetworkingMyQuotation, CotizacionEdicionData, CotizacionVersion, BeneficiarioEdicionItem } from '../../services/mis-cotizaciones/miscotizaciones.service';
import { NetworkingBeneficiary } from '../../services/beneficiario/beneficiario.service';
import { BeneficiarioLocalStorageService, DatosBeneficiarioLocal, ProgramasBeneficiarioEnvelope } from '../../services/beneficiario/beneficiario-local-storage.service';
import { limpiarValidacionesBeneficiarioSiRecargaNavegador } from '../../services/beneficiario/validaciones-beneficiario-local-storage.service';
import { ProgramaItemStore } from '../../services/cotizador-contratante/programa-seleccion.store';
import { LiquidacionColectivoRequest, LiquidacionColectivoItem } from '../../models/cotizacion-colectivo/liquidacion-colectivo.model';
import { ModalEnviarCotizacionComponent, ModalEnviarCotizacionData } from './pages/cotizador-cotizacion-page/components/modal-enviar-cotizacion/modal-enviar-cotizacion.component';
import { CotizadorCotizacionComponent } from './pages/cotizador-cotizacion-page/components/cotizador-cotizacion/cotizador-cotizacion.component';
import { ConsultarAsesorByIDService } from '../../services/cotizador-contratante/consultar-asesor-by-id.service';
import { ConsultarCotizacionService } from '../../services/cotizador-cotizacion/consultar-cotizacion.service';
import { ConsultarAsesorByIDRequest } from '../../models/cotizador-contratante/consultar-asesor/request/consultar-asesor-byID-request.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import {
  CotizacionEdicionContratanteContexto,
  obtenerProgramasPersistidosContratante,
  tieneProgramasPersistidosContratante
} from '../../models/cotizador-contratante/cotizacion-edicion-contexto.model';

interface Program {
  code: string;
  // Otras propiedades que pueda tener `prog`
}

interface ProgramaAnexoInfo {
  code: string;
  program: string;
  file?: string;
  subcta?: string;
  planGrupo?: string;
  deno?: string;
  anexos?: any[];
  isFetchingSubcuenta?: boolean;
  isFetchingAnexos?: boolean;
  lastError?: string;
}

interface ResumenCotizacionColectivoItem {
  programa: string;
  rangoEdad: string;
  edadDesde: string;
  edadHasta: string;
  tarifaSinSubsidio: number;
  tarifaSubsidio50: number;
  tarifaSubsidio100: number;
  tarifaAnexo: number;
  cantidadUsuarios: string;
  aplicaAnexoServicio: boolean;
  lineaNegocioCol: string;
  grupoProgramaCol: string;
  programaCode: string;
  idBenPrograma: number;
  aplicaAnexos: boolean;
}

interface ColectivoProductosStorage {
  lineasNegocio: string[];
  programasSeleccionados: string[];
  requiereIncluirAnexos: 'si' | 'no' | null;
  programasConAnexosSeleccionados: string[];
  derechoAsubsidio: string | null;
  mostrarTodosEscenariosSubsidio?: boolean;
}

interface ColectivoFormStorage extends ColectivoProductosStorage {
  ID_COTIZACION: number;
  fechaPresentacion: string | null;
  fechaInicioVigencia: string | null;
  regional: string | null;
  canal: string | null;
  oficina: string | null;
  tipoAsesor: string | null;
  nit: string | null;
  colectivoNombre: string | null;
  sector: string | null;
  departamento: string | null;
  municipio: string | null;
  clienteActual: string | null;
  tarifa: string | null;
  usuariosCotizar: string | null;
  usuariosMayor60: string | null;
  UsuariosMayor60Total: string | null;
  embarazosCurso: string | null;
  NombreContacto: string | null;
  cargoContacto: string | null;
  emailContacto: string | null;
  telefonoContacto: string | null;
  NombreDestinatario: string | null;
  cargoDestinatario: string | null;
  emailDestinatario: string | null;
  telefonoDestinatario: string | null;
  igualAQuienSeDirige: boolean | string | null;
  porcentajeSubsidio: string | null;
  savedAt: string;
}

interface ContratanteStorageData {
  tipoDocumento?: string;
  numeroDocumento?: string;
  primerNombre?: string;
  segundoNombre?: string;
  primerApellido?: string;
  segundoApellido?: string;
  genero?: string;
  fechaNacimiento?: string;
  esUsuario?: boolean;
  idBeneficiario?: number;
  id_beneficiario_guardado?: number;
}

interface ProgramaContratanteStorageItem {
  lineaNegocio?: string;
  programa?: string;
  nombrePrograma?: string;
  grupoPrograma?: string;
  tarifa?: string;
  tarifaDetalle?: any;
  campana?: string;
  campanaNombre?: string;
  campaniaDetalle?: any;
  anexoCodigo?: string;
  tarifaAnexo?: string;
  anexoDetalle?: any;
  requiereAnexo?: 'si' | 'no' | null | string;
  idBeneficiario?: number;
  idBenPrograma?: number;
  idSubcuenta?: number;
  idCotizacionTarifa?: number;
  idCotizacionTarifaAnexo?: number;
  idCotizacionCampania?: number;
  idBenCampania?: number;
  guardadoEnBd?: boolean;
  id?: string;
  nombre?: string;
}

interface ProgramasContratanteStorageEnvelope {
  idCotizacion?: number;
  tipoDocumento?: string;
  numeroDocumento?: string;
  savedAt?: string;
  programas?: ProgramaContratanteStorageItem[];
}

export default interface IListInfoPago {
  programa: any[];
  data: any[];
}

interface IMapTarifa {
  [key: string]: string;
}

interface IMapB {
  [key: number]: IMapTarifa;
}

interface ValorFamiliarItem {
  beneficiario: any;
  programa: any;
  subcuenta: any;
  tarifa: any;
  tarifaAsociado: any;
  tarifa_asociado: any;
  linea_negocio: number;
  valor1: any;
  valor2: any;
  valorBruto1: any;
  valorBruto2: any;
}

interface BeneficiaryDeletePlan {
  idBeneficiario: number;
  idBenPrograma: number;
  idSubcuenta: number;
  idCotizacionTarifa: number;
  idCotizacionTarifaAnexo: number;
  idCotizacionCampania: number;
  deleteDatosBeneficiarios: boolean;
}

interface FlechaPersistenciaBdPrograma {
  programa: string;
  lineaNegocio: string;
  idBenPrograma: number;
  idSubcuenta: number;
  idCotizacionTarifa: number;
  idCotizacionTarifaAnexo: number;
  idCotizacionCampania: number;
}

interface FlechaPersistenciaBdSnapshot {
  idBeneficiario: number;
  programas: FlechaPersistenciaBdPrograma[];
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: [
    "./cotizador.component.css",
    "./cotizador.component.scss",
    "./cotizador-card.component.scss"
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})

export class CotizadorComponent extends Base implements OnDestroy {

  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  @ViewChild(FormularioContratanteComponent) formularioContratanteComponent!: FormularioContratanteComponent;
  @ViewChild('cotizadorCotizacion') cotizadorCotizacionComponent?: CotizadorCotizacionComponent;

  public emailPattern: string | RegExp = new RegExp(
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/
  );
  public number: string | RegExp = new RegExp(/^[0-9]*$/);
  public alphaNumeric: string | RegExp = new RegExp(
    /(^[a-zA-ZÀ-ÿ\u00f1\u00d1\d]+([a-zA-ZÀ-ÿ\u00f1\u00d1\s.\d])*)$/
  );
  public alphabeticalPattern: string | RegExp = new RegExp(
    /(^[a-zA-ZÀ-ÿ\u00f1\u00d1]+([a-zA-ZÀ-ÿ\u00f1\u00d1\s.])*)$/
  );
  valorFamiliar: ValorFamiliarItem[] = [];
  programasOrdenados: string[] = [];
  programasOrdenadosAsociado: string[] = [];
  selectedValue: { [key: string]: any; } = {};
  cotizacionMultiAsociado: boolean = true;
  TITLE = "Cotizador";
  idCollapse: number[] = [];
  selectedIndex = 0;
  bloqueoTabsPorGuardadoCotizacion = false;
  formInit!: FormGroup;
  listProgramas: any = [];
  imgPrograma: string = '';
  listCodeProgramas: string[] = [];
  programasPorLineaSeleccionadas: Record<string, string[]> = {};
  programasCarnetPorLinea: Record<string, { code: string; program: string; file: string; grupoPrograma?: string;}[]> = {};
  /** Guard para evitar llamadas duplicadas a consultarCarnets (cambio de versión / reentradas al tab disparan la misma consulta antes de que responda la primera). */
  private _carnetsRequestEnVuelo = false;
  private _carnetsFirmaEnVuelo = '';
  private _catalogoBenefProgramasCargando = false;
  private _catalogoBenefProgramasCargado = false;
  private _datosCompletosColectivoAC: any[] = [];
  private gruposProgramaColectivoPorPlan:
    Record<string, string> = {};
  private gruposProgramaColectivoPorNombre:
    Record<string, string> = {};
  programasConAnexosDisponibles: ProgramaAnexoInfo[] = [];
  programasConAnexosSeleccionados: Set<string> = new Set();
  requiereIncluirAnexos: 'si' | 'no' | null = 'no';
  tarifasColectivoPorPrograma: Record<string, CotizadorTarifaColectivo[]> = {};
  cuentaColectivo: string | null = null;
  colectivoSubcta: string | null = null;
  programaAnexoInfoMap: Record<string, ProgramaAnexoInfo> = {};
  programasSeleccionadosUI: Set<string> = new Set();
  tipoSolicitudTemporal: string = "1";
  valContrato = {
    codigoAsesor: 0,
    codigoCuenta: 0,
    codigoLineaNegocio: "",
    codigoPrograma: "",
    codigoSubcuenta: "",
    codigoSucursal: "",
    codigoTarifa: "",
    codigoTipoPlan: "",
    contrato: "",
    descripcionTarifa: "",
  };
  resetData: boolean = false;
  valAllContract = null;
  blockedTipoPlanQuestion: boolean = false;
  blockedTipoCotizacionQuestion: boolean = false;


  // true activa el multiproducto
  isMultiproduct: boolean = true;
  blockedLineaNegocioQuestion: boolean = true;
  blockedProgramaQuestion: boolean = false;
  tipoSolicitud: string = "1";
  form!: FormGroup;
  formColectivo!: FormGroup;
  mostcampaniaContra = false;
  mostcampaniaContraInhabilitado = false;
  dataCampania: CampaniaRequest = {
    cuenta: 0,
    tipo_solicitud: 0,
    codigo_sucursal: "",
    codigo_tipo_plan: "",
    tarifa: "",
    edad: 0,
    sexo: "",
    modelo_negocio: [],
    descripcionTarifa: "",
  };
  listLineaTableMulti: IListDetail[] = [];
  modeloAsociadoUnico: Array<ModeloNegocioRequest> = [];
  detalle_descuentos = [
    {
      cantidad_mes: 3,
      valor_pago_anticipado_asociado: 0,
      valor_descuento_asociado: 0,
      valor_descuento_familiar: 0,
      valor_pago_anticipado_familiar: 0,
    },
    {
      cantidad_mes: 6,
      valor_pago_anticipado_asociado: 0,
      valor_descuento_asociado: 0,
      valor_descuento_familiar: 0,
      valor_pago_anticipado_familiar: 0,
    },
    {
      cantidad_mes: 12,
      valor_pago_anticipado_asociado: 0,
      valor_descuento_asociado: 0,
      valor_descuento_familiar: 0,
      valor_pago_anticipado_familiar: 0,
    },
  ];

  cotizacionIndividualModificada = false;
  sectorFiltro = new FormControl();
  sectoresFiltrados: sectoresCIIU[] = [];
  private ultimoSectorEmpresa: string | null = null;
  cedulaAsesor: string = '';
  idAsesor: number | null = null;
  nombreAsesor: string = '';
  correoAsesor: string = '';
  celularAsesor: string = '';
  ciudadAsesor: string = '';
  asesorLogueadoData: any | null = null;
  cargoAsesor: string = '';

  valorAsociado = [];
  // matcher = new MyErrorStateMatcher();
  displayedColumns: string[] = ["name", "documentnumber", "type", "lineofbusiness", "program", "opcion"];
  dataSourceBeneficiary = new MatTableDataSource<PersonBeneficiary>([]);
  datasSourceBeneficiary = new MatTableDataSource<Beneficiarios>([]);
  @ViewChild(MatPaginator)
  set matPaginator(p: MatPaginator) {
    if (p) {
      this.datasSourceBeneficiary.paginator = p;
    }
  }
  dataBeneficiary: PersonBeneficiary[] = [];
  datasBeneficiary: Beneficiarios[] = [];
  private beneficiaryRowsBackup: any[] = [];
  public searchText: string = '';
  /** Evita reentrada/doble refresh al sincronizar programas heredados. */
  private _refrescoHeredadosEnCurso = false;
  private mSelBenTari: IMapB = {};
  private contratanteTarifa = '';
  valCuota: any | null = 0;
  contratante_usuario = false;
  numeroCotizacion = "";
  lineaNombre = "";
  planNombre = "";
  cuotaInscripcion: any = null;
  cuotaTotal: any = null;
  cuotaTotalAsociado: any = "";
  listDetallePagoMensual: any;
  mostrarResumen = true;
  mostrarTodosEscenariosSubsidio = false;
  busquedaResumenColectivo = '';
  busquedaResumenColectivoInput = '';
  registrosPorPaginaResumenColectivo = 10;
  paginaResumenColectivoActual = 0;
  mostrarResumenCotizacionProgramaVisual = true;
  errorgetCampania = "";
  maxDate: any;
  minDate: any;
  minDateTarifas!: string;
  listDataCampania: Array<campanias> | undefined;
  listTarifa: IListTarifa[] = [];
  dataTarifa: IDataTarifa = {
    cuenta: 0,
    modelo_negocio: [],
  };
  modeloAsociadoMultiple: Array<ModeloNegocioRequest> = [];
  objDataCotizador: any;
  dataCotizacion!: ModeloCotizacion;
  listLineaTable: Array<any> = [];
  listContract: Array<ContratPeopleResponse> = [];
  lineaNegocio: string = "";
  private readonly lineaNegocioParametroMap: Record<string, string> = {
    "1": "programasLineaMI",
    "2": "programasLineaSAO",
    "3": "programasLineaCEM",
  };
  private readonly parametroLineaNegocioMap: Record<string, string> = {
    programasLineaMI: "1",
    programasLineaSAO: "2",
    programasLineaCEM: "3",
  };
  private readonly lineaNegocioDisplayName: Record<string, string> = {
    "1": "MEDICINA INTEGRAL",
    "2": "SALUD ORAL",
    "3": "CEM",
  };
  private readonly KEY_DATOS_CONTRATANTE_STORAGE = 'datosRQ002_Contratante';
  private readonly KEY_PROGRAMAS_CONTRATANTE_STORAGE = 'programas_contratante';
  private readonly KEY_FLECHA_BENEFICIARIOS_SNAPSHOT = 'cotizador_flecha_beneficiarios_snapshot';
  private readonly KEY_FLECHA_DEPENDIENTES_PERSISTENCIA = 'cotizador_flecha_dependientes_persistencia';
  private readonly KEY_COLECTIVO_PRODUCTOS_STORAGE = 'cotizador_colectivo_productos';
  private readonly KEY_COLECTIVO_FORM_STORAGE = 'cotizador_colectivo_form';
  private readonly KEY_COLECTIVO_ID_COTIZACION_SEQ = 'cotizador_colectivo_id_cotizacion_seq';
  lineasNegocioBloqueadas: Set<string> = new Set();
  valorAsociadoTotal = 0;
  valorFamiliaTotal = 0;
  valorAsociadoTotalBruto = 0;
  valorFamiliaTotalBruto = 0;
  tarifaColectiva: string = "";
  datePerson: number | null = null;
  rProgram: string = "rProgram";
  isShowCampain: boolean = false;

  ocultarPlanFamiliar: boolean = true;
  ocultarPlanAsociado: boolean = true;
  esInclusion: boolean = false;
  /** Variable para ocultar el boton de Linea de Negocio : Salud Oral */
  ocultarBotonSaludOral: boolean = true;
  listInfoPago: Array<IListInfoPago> = [];
  programaTemp = [];
  programaTempAsociado = [];
  esModalColectivoConfirmado = false;
  esNuevoColectivo = false;
  colectivoFormSaved = false;
  liquidacionColectivoGuardada = false;
  /** True si el usuario modificó datos colectivos durante la sesión de edición actual. */
  private _editSessionDirty = false;
  resumenCotizacionColectivoData: ResumenCotizacionColectivoItem[] = [];
  idCotizacionColectivo: number = 0;
  mostrarAlertaCamposColectivo = false;
  private _pendingOficinaEdicion: string | null = null;
  private _pendingProgramasEdicion: string[] | null = null;
  // Códigos de programa cuyo anexo debe restaurarse (anexos === 1) al editar.
  // Se consume de forma diferida en actualizarProgramasConAnexosDisponibles()
  // a medida que cada programa pasa a estar disponible tras cargar sus tarifas.
  private _pendingAnexosEdicion: Set<string> | null = null;
  private _idContactoEdicion: number | null = null;
  private _idDestinatarioEdicion: number | null = null;
  private _pendingRegionalEdicion: string | null = null;
  private _pendingCanalEdicion: string | null = null;
  private _pendingTipoAsesorEdicion: string | null = null;
  private _pendingSectorNombreEdicion: string | null = null;
  private _pendingLineasEdicion: string[] | null = null;
  private _liquidacionesEdicion: LiquidacionColectivoItem[] = [];
  // Snapshot de los códigos de programa (uppercase) cargados al iniciar la edición.
  // Permite detectar programas quitados por el usuario para confirmar el borrado en backend.
  private _programasOriginalesEdicion: Set<string> | null = null;
  private readonly camposContactoColectivo = [
    'NombreContacto',
    'cargoContacto',
    'emailContacto',
    'telefonoContacto',
  ] as const;
  private readonly camposDestinatarioColectivo = [
    'NombreDestinatario',
    'cargoDestinatario',
    'emailDestinatario',
    'telefonoDestinatario',
  ] as const;

  tabHabilitado = {
    inicio: true,
    contratante: false,
    beneficiarios: false,
    cotizacion: false,
    colectivo: false
  };

  get mostrarResumenCotizacionColectivo(): boolean {
    return this.esNuevoColectivo && this.colectivoFormSaved;
  }

  /** Pestaña COTIZACIÓN solo resumen colectivo (tras COLECTIVO, sin BENEFICIARIOS). */
  get mostrarTabCotizacionSoloColectivo(): boolean {
    return this.tabHabilitado.cotizacion && this.esNuevoColectivo && !this.tabHabilitado.beneficiarios;
  }

  /** Pestaña COTIZACIÓN RQ005 / comparativo (flujo no colectivo o tras BENEFICIARIOS). */
  get mostrarTabCotizacionBeneficiarios(): boolean {
    return this.tabHabilitado.cotizacion && (!this.esNuevoColectivo || this.tabHabilitado.beneficiarios);
  }

  get botonesCotizacionColectivoDeshabilitados(): boolean {
    return !this.colectivoFormSaved || this.formColectivo.invalid;
  }

  get botonDescargarCotizacionColectivoDeshabilitado(): boolean {
    return this.botonesCotizacionColectivoDeshabilitados || !this.liquidacionColectivoGuardada;
  }

  get derechoASubsidioSeleccionado(): string {
    return (this.formColectivo?.get('derechoAsubsidio')?.value || '').toString();
  }

  get porcentajeSubsidioSeleccionado(): string {
    return (this.formColectivo?.get('porcentajeSubsidio')?.value || '').toString();
  }

  get mostrarColumnaTarifaSinSubsidioResumen(): boolean {
    return this.mostrarTodosEscenariosSubsidio || this.derechoASubsidioSeleccionado !== '1';
  }

  get mostrarColumnaTarifaSubsidio50Resumen(): boolean {
    return this.mostrarTodosEscenariosSubsidio
      || (this.derechoASubsidioSeleccionado === '1' && this.porcentajeSubsidioSeleccionado === '1');
  }

  get mostrarColumnaTarifaSubsidio100Resumen(): boolean {
    return this.mostrarTodosEscenariosSubsidio
      || (this.derechoASubsidioSeleccionado === '1' && this.porcentajeSubsidioSeleccionado === '2');
  }

  get mostrarColumnaTarifaAnexoResumen(): boolean {
    return this.resumenCotizacionColectivo.some((item) => Boolean(item.aplicaAnexoServicio));
  }

  get botonContinuarInicioDeshabilitado(): boolean {
    const tipoSolicitud = (this.formInit?.get('tipoSolicitud')?.value || '').toString().trim();
    const tipoPlan = (this.formInit?.get('tipoPlan')?.value || '').toString().trim();

    if (!tipoSolicitud) {
      return true;
    }

    if (tipoSolicitud === '3') {
      return false;
    }

    return !tipoPlan;
  }

  get botonContinuarPaso2Deshabilitado(): boolean {
    if (this.isEditMode && !this.esVersionMasReciente) {
      return false;
    }

    if (this.esNuevoColectivo) {
      return !this.formColectivo || this.formColectivo.invalid;
    }

    return !(this.formularioContratanteComponent?.puedeContinuar?.() ?? false);
  }

  get botonContinuarPaso3Deshabilitado(): boolean {
    return !this.tieneBeneficiarios && !(this.isEditMode && !this.esVersionMasReciente);
  }

  get totalColumnasTablaResumenColectivo(): number {
    let total = 2;
    if (this.mostrarColumnaTarifaSinSubsidioResumen) total++;
    if (this.mostrarColumnaTarifaSubsidio50Resumen) total++;
    if (this.mostrarColumnaTarifaSubsidio100Resumen) total++;
    if (this.mostrarColumnaTarifaAnexoResumen) total++;
    return total;
  }

  private getAliasLineaResumen(linea: string): string {
    const normalized = (linea || '').toString().trim().toUpperCase();
    if (normalized === '1' || normalized === 'MI' || normalized === 'SMP' || normalized.includes('MEDICINA')) {
      return 'MI';
    }
    if (normalized === '2' || normalized === 'SO' || normalized === 'SAO' || normalized.includes('SALUD ORAL')) {
      return 'SAO';
    }
    if (normalized === '3' || normalized === 'CEM') {
      return 'CEM';
    }
    return normalized;
  }

  private clasificarLineaCarnet(linea: any, codigo: string, programa: string): '1' | '2' | '3' {
    const lineaNormalizada = this._norm2(linea);
    const codigoNormalizado = this._norm2(codigo);
    const programaNormalizado = this._norm2(programa);

    if (lineaNormalizada.includes('SAO') || lineaNormalizada.includes('ORAL')) {
      return '2';
    }
    if (lineaNormalizada.includes('CEM') || lineaNormalizada.includes('EMERGENCIA')) {
      return '3';
    }
    if (lineaNormalizada.includes('MI') || lineaNormalizada.includes('INTEGRAL') || lineaNormalizada.includes('SMP')) {
      return '1';
    }

    if (
      programaNormalizado.includes('DENTAL') ||
      codigoNormalizado.startsWith('DE') ||
      codigoNormalizado.startsWith('SAO')
    ) {
      return '2';
    }

    if (
      programaNormalizado.includes('CEM') ||
      programaNormalizado.includes('EMERGENCIA') ||
      codigoNormalizado.includes('CEM') ||
      codigoNormalizado === 'OROC'
    ) {
      return '3';
    }

    return '1';
  }

  private obtenerLineaDePrograma(programaCode: string): string {
    const code = (programaCode || '').toString().trim();
    if (!code) {
      return '';
    }

    const linea = Object.entries(this.programasCarnetPorLinea).find(([, programas]) =>
      (programas || []).some((item) => (item.code || '').toString().trim() === code),
    )?.[0];

    return linea || '';
  }

  get resumenCotizacionColectivo(): ResumenCotizacionColectivoItem[] {
    return this.construirResumenCotizacionColectivoLocal();
  }

  private construirResumenCotizacionColectivoLocal(): ResumenCotizacionColectivoItem[] {
    return Array.from(this.programasSeleccionadosUI)
      .flatMap((programaCode) => {
        const code = (programaCode || '').toString().trim();
        if (!code) {
          return [];
        }

        const tarifas = this.tarifasColectivoPorPrograma[code] ?? [];
        if (!tarifas.length) {
          const fallback = this.construirResumenCotizacionColectivoItem(code);
          return fallback ? [fallback] : [];
        }

        return tarifas
          .map((tarifa) => this.construirResumenCotizacionColectivoItem(code, tarifa))
          .filter((item): item is ResumenCotizacionColectivoItem => !!item);
      });
  }

  private construirResumenCotizacionColectivoItem(
    programaCode: string,
    tarifaColectiva?: CotizadorTarifaColectivo,
  ): ResumenCotizacionColectivoItem | null {
    const code = (programaCode || '').toString().trim();
    if (!code) {
      return null;
    }

    const programaInfo = this.findProgramaMetadata(code);
    const nombrePrograma = (programaInfo?.program || code).toString().trim();
    const linea = this.getAliasLineaResumen(this.obtenerLineaDePrograma(code));
    const nombreConLinea = linea ? `${linea} - ${nombrePrograma}` : nombrePrograma;
    const programaUpper = nombrePrograma.toUpperCase();

    let grupoProgramaCol = 'ASOCIADO';
    if (programaUpper.includes('FAMILIAR')) {
      grupoProgramaCol = 'FAMILIAR';
    } else if (programaUpper.includes('ASOCIADO')) {
      grupoProgramaCol = 'ASOCIADO';
    } else if (tarifaColectiva?.grupoPrograma) {
      grupoProgramaCol = tarifaColectiva.grupoPrograma.toString().trim().toUpperCase();
    }

    const idBenPrograma = Number(this.formColectivo.get('nit')?.value || 0);
    const aplicaAnexoServicio = this.toBooleanFromSN(tarifaColectiva?.aplicaAnexo);
    const anexoTarifa = aplicaAnexoServicio
      ? (tarifaColectiva?.anexos || []).find((anexo) => this.toBooleanFromSN(anexo?.estado))
      : undefined;
    const aplicaAnexos = aplicaAnexoServicio;
    const tarifaAnexo = this.resolverTarifaAnexoPorSubsidio(anexoTarifa);

    const edadDesde = (tarifaColectiva?.edadDesde ?? '').toString().trim();
    const edadHasta = (tarifaColectiva?.edadHasta ?? '').toString().trim();
    const cantidadUsuarios = (tarifaColectiva?.cantidadUsuarios ?? '').toString().trim();

    return {
      programa: nombreConLinea,
      rangoEdad: this.construirRangoEdad(edadDesde, edadHasta),
      edadDesde,
      edadHasta,
      // Las columnas principales siempre deben mostrar la tarifa base del programa.
      tarifaSinSubsidio: this.toSafeCurrencyNumber(tarifaColectiva?.valorSinSubsidio),
      tarifaSubsidio50: this.toSafeCurrencyNumber(tarifaColectiva?.valor50Subsidio),
      tarifaSubsidio100: this.toSafeCurrencyNumber(tarifaColectiva?.valor100Subsidio),
      tarifaAnexo,
      cantidadUsuarios,
      aplicaAnexoServicio,
      lineaNegocioCol: linea,
      grupoProgramaCol,
      programaCode: code,
      idBenPrograma,
      aplicaAnexos,
    };
  }

  private construirRangoEdad(edadDesde: string, edadHasta: string): string {
    if (edadDesde && edadHasta) {
      return `${edadDesde} - ${edadHasta}`;
    }
    return edadDesde || edadHasta || '-';
  }

  private resolverTarifaAnexoPorSubsidio(anexoTarifa?: CotizadorTarifaColectivoAnexo): number {
    if (!anexoTarifa) {
      return 0;
    }

    const derechoSubsidio = this.derechoASubsidioSeleccionado;
    const porcentajeSubsidio = this.porcentajeSubsidioSeleccionado;

    // NO subsidio -> valor sin subsidio
    if (derechoSubsidio !== '1') {
      return this.toSafeCurrencyNumber(anexoTarifa?.valorSinSubsidio as any);
    }

    // SI subsidio + 50%
    if (porcentajeSubsidio === '1') {
      return this.toSafeCurrencyNumber(anexoTarifa?.valor50Subsidio as any);
    }

    // SI subsidio + 100%
    if (porcentajeSubsidio === '2') {
      return this.toSafeCurrencyNumber(anexoTarifa?.valor100Subsidio as any);
    }

    // Fallback seguro cuando aún no han elegido porcentaje.
    return this.toSafeCurrencyNumber(anexoTarifa?.valorSinSubsidio as any);
  }

  private toSafeCurrencyNumber(value: string | number | null | undefined): number {
    const parsed = Number((value ?? '').toString().replace(/,/g, '').trim());
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private toBooleanFromSN(value: string | null | undefined): boolean {
    const normalized = (value ?? '').toString().trim().toUpperCase();
    return normalized === 'S' || normalized === 'SI' || normalized === 'TRUE' || normalized === '1';
  }

  private normalizarTextoBusqueda(value: unknown): string {
    return (value ?? '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  private tokensTarifaBusqueda(value: number): string[] {
    const n = this.toSafeCurrencyNumber(value);
    const locale = n.toLocaleString('es-CO');
    return [
      String(n),
      locale,
      `$${locale}`,
      `$ ${locale}`
    ];
  }

  get resumenCotizacionColectivoFiltrado(): ResumenCotizacionColectivoItem[] {
    const termino = this.normalizarTextoBusqueda(this.busquedaResumenColectivo);
    return this.resumenCotizacionColectivo.filter((item) => {
      const camposBusqueda = [
        item.programa,
        item.rangoEdad,
        ...this.tokensTarifaBusqueda(item.tarifaSinSubsidio),
        ...this.tokensTarifaBusqueda(item.tarifaSubsidio50),
        ...this.tokensTarifaBusqueda(item.tarifaSubsidio100),
        ...this.tokensTarifaBusqueda(item.tarifaAnexo)
      ];

      const coincideBusqueda =
        !termino ||
        camposBusqueda.some(campo => this.normalizarTextoBusqueda(campo).includes(termino));

      const coincideSubsidio =
        this.mostrarTodosEscenariosSubsidio
          ? // Con switch ON: mostrar todas las filas que tengan al menos una tarifa real.
          // Excluir filas fallback (sin tarifas reales) que se generan cuando no hay tarifaColectiva.
          (item.tarifaSinSubsidio > 0 || item.tarifaSubsidio50 > 0 || item.tarifaSubsidio100 > 0 || item.tarifaAnexo > 0)
          : item.tarifaSinSubsidio > 0;

      return coincideBusqueda && coincideSubsidio;
    });
  }

  get totalRegistrosResumenColectivo(): number {
    return this.resumenCotizacionColectivoFiltrado.length;
  }

  get totalPaginasResumenColectivo(): number {
    return Math.max(
      1,
      Math.ceil(this.totalRegistrosResumenColectivo / this.registrosPorPaginaResumenColectivo),
    );
  }

  get paginaActualResumenColectivoVisual(): number {
    if (this.totalRegistrosResumenColectivo === 0) return 0;
    return this.paginaResumenColectivoActual + 1;
  }

  get totalPaginasResumenColectivoVisual(): number {
    if (this.totalRegistrosResumenColectivo === 0) return 0;
    return this.totalPaginasResumenColectivo;
  }

  get resumenCotizacionColectivoPaginado() {
    const inicio = this.paginaResumenColectivoActual * this.registrosPorPaginaResumenColectivo;
    const fin = inicio + this.registrosPorPaginaResumenColectivo;
    return this.resumenCotizacionColectivoFiltrado.slice(inicio, fin);
  }

  get primerRegistroResumenColectivo(): number {
    if (this.totalRegistrosResumenColectivo === 0) return 0;
    return this.paginaResumenColectivoActual * this.registrosPorPaginaResumenColectivo + 1;
  }

  get ultimoRegistroResumenColectivo(): number {
    return Math.min(
      (this.paginaResumenColectivoActual + 1) * this.registrosPorPaginaResumenColectivo,
      this.totalRegistrosResumenColectivo
    );
  }

  programasMedicinaGeneral = [
    {
      f: "OPLF",
      a: "OPLA",
    },
    {
      f: "PJVF",
      a: "PJVA",
    },
    {
      f: "PRIMF",
      a: "PRIMA",
    },
    {
      f: "PREFF",
      a: "PREFA",
    },
    // {
    //   f: "AESF",
    //   a: "AESF",
    // },
    {
      f: "AESF",
      a: "AESA",
    },
    {
      f: "AESEF",
      a: "AESEA",
    },
    {
      f: "ASOA",
      a: "ASOA",
    },
    {
      f: "TESA",
      a: "TESA",
    },
  ];
  programasSaludOral = [
    {
      f: "DESCB",
      a: "DESCB",
    },
    {
      f: "DEB",
      a: "DEB",
    },
  ];

  programasSeleccionados: any = [];
  responseEnviar = false;
  responseGuardar = false;
  logInfo: any;
  NumeroDocumento: any;
  NombreCompleto: any;
  trackDataCarnet!: TrackData;
  programasEmpresa: any[] = [];
  maxStepReached = 0;
  canal = [
    { label: 'Interno', value: 'INTERNO' },
    { label: 'Externo', value: 'EXTERNO' }
  ];

  regional: Array<regional> | undefined;
  tiposDeAsesor: Array<tiposDeAsesor> | [] = [];
  tiposFiltrados: any[] = [];
  regionalSeleccionada: string = "";
  sucursalesRegional: sucursalRegional[] = [];
  sucursalesLoading: boolean = false;
  private readonly KEY_COTIZACION_COLECTIVO_ACTUAL = 'cotizacion_colectivo_actual';
  private readonly KEY_COTIZACION_COLECTIVO_SEQ = 'cotizacion_colectivo_seq';
  cotizacionColectivoActual: CotizacionColectivo | null = null;
  empresaColectivoActual: any | null = null;
  private ultimaRegionalSolicitada: string | null = null;
  sectores: sectoresCIIU[] = [];
  departamentos = [
    { codigo: '05', nombre: 'ANTIOQUIA' },
    { codigo: '08', nombre: 'ANTLATICO' },
    { codigo: '11', nombre: 'BOGOTÁ, D.C.' },
    { codigo: '13', nombre: 'BOLÍVAR' },
    { codigo: '15', nombre: 'BOYACÁ' },
    { codigo: '17', nombre: 'CALDAS' },
    { codigo: '18', nombre: 'CAQUETÁ' },
    { codigo: '19', nombre: 'CAUCA' },
    { codigo: '20', nombre: 'CESAR' },
    { codigo: '23', nombre: 'CÓRDOBA' },
    { codigo: '25', nombre: 'CUNDINAMARCA' },
    { codigo: '27', nombre: 'CHOCÓ' },
    { codigo: '41', nombre: 'HUILA' },
    { codigo: '44', nombre: 'LA GUAJIRA' },
    { codigo: '47', nombre: 'MAGDALENA' },
    { codigo: '50', nombre: 'META' },
    { codigo: '52', nombre: 'NARIÑO' },
    { codigo: '54', nombre: 'NORTE DE SANTANDER' },
    { codigo: '63', nombre: 'QUINDIO' },
    { codigo: '66', nombre: 'RISARALDA' },
    { codigo: '68', nombre: 'SANTANDER' },
    { codigo: '70', nombre: 'SUCRE' },
    { codigo: '73', nombre: 'TOLIMA' },
    { codigo: '76', nombre: 'VALLE DEL CAUCA' },
    { codigo: '81', nombre: 'ARAUCA' },
    { codigo: '85', nombre: 'CASANARE' },
    { codigo: '86', nombre: 'PUTUMAYO' },
    { codigo: '88', nombre: 'SAN ANDRÉS, PROVIDENCIA Y SANTA CATALINA' },
    { codigo: '91', nombre: 'AMAZONAS' },
    { codigo: '94', nombre: 'GUAINÍA' },
    { codigo: '95', nombre: 'GUAVIARE' },
    { codigo: '97', nombre: 'VAUPÉS' },
    { codigo: '99', nombre: 'VICHADA' }
  ].sort((a, b) => a.nombre.localeCompare(b.nombre));

  municipios: any[] = [];
  loadingMunicipios = false;

  // Modo edición (al venir desde mis-cotizaciones con clic en "Editar")
  isEditMode = false;
  idCotizacionEdicion: number | null = null;
  versiones: CotizacionVersion[] = [];
  selectedVersion: CotizacionVersion | null = null;
  cotizacionEdicionData: CotizacionEdicionData | null = null;
  /** Estado live de la cotización al entrar a editar (resultado de iniciar-edición).
   * Se restaura al volver al dropdown a la versión más reciente, evitando que el
   * snapshot desactualizado pise el estado actual (ej: beneficiarios agregados post-snapshot). */
  private _cotizacionEdicionDataLatest: CotizacionEdicionData | null = null;

  /** true cuando el usuario está viendo la versión más reciente (o no hay dropdown aún) */
  get esVersionMasReciente(): boolean {
    return !this.selectedVersion
      || this.versiones.length === 0
      || this.selectedVersion.idVersion === this.versiones[0].idVersion;
  }

  private _prefillColectivoEnCurso = false;
  // Beneficiarios en modo edición
  todosLosBeneficiariosEdicion: BeneficiarioEdicionItem[] = [];
  esBeneficiarioEditable = true;
  private _parentescosMap: Map<string, string> = new Map();
  /** Preserva idBeneficiario cuando el backend no lo incluye en GET /edit */
  private _beneficiarioIdMap: Map<string, number> = new Map();
  private _omitirSiguienteSyncContratanteBeneficiario = false;
  private _requiereRefreshBeneficiariosLatest = false;
  /** Tras editar/crear un beneficiario, el GET /edit pisa al titular con lo persistido. */
  private _reaplicarTitularTrasCargaEdicion = false;
  private _versionChangeSeq = 0;
  private colaAlertas: Promise<any> = Promise.resolve();
  private actualizandoTipoPlanCotizacion = false;
  private spinnerUltimaPantallaActivo = false;

  constructor(
    private networking: NetworkingQuotation,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private SnackBarService: SnackBarService,
    private storageService: StorageService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private mainCmp: MaincontainerComponent,
    private authService: AuthService,
    private trackingService: TrackingService,
    private cotizacionService: CotizacionService,
    private asesorService: AsesorService,
    private cotizacionColectivoService: CotizacionColectivoService,
    private cotizacionColectivoContactoService: CotizacionColectivoContactoService,
    private consultarSubcuentasService: ConsultarSubcuentasService,
    private consultarLineasGruposProgramasService: ConsultarLineasGruposProgramasService,
    private networkingMisCot: NetworkingMyQuotation,
    private networkingBeneficiary: NetworkingBeneficiary,
    private beneficiarioLocalStorage: BeneficiarioLocalStorageService,
    private cotizadorTarifaColectivoService: CotizadorTarifaColectivoService,
    private consultarAsesorByIDService: ConsultarAsesorByIDService,
    private consultarCotizacionService: ConsultarCotizacionService,
  ) {
    super();
    this.initForm();
  }

  ngAfterViewInit() {
    this.datasSourceBeneficiary.paginator = this.matPaginator;
    setTimeout(() => {
      this.mainCmp.setTitle("Cotizador");
    });
  }
  /** Metodo para obtener la tarifas en base de datos */
  buscararTarifas() {
    this.spinner.show();
    this.networking.bucarTarifa(this.dataTarifa).subscribe((response: any) => {
      this.tarifasSuccessfulNetworkingOutput(response);
    }, (error) => {
      this.tarifasFailureNetworkingOutput(1, error);
    });
  }

  tarifasSuccessfulNetworkingOutput(data: IListTarifa[]): void {
    this.spinner.hide();
    this.listTarifa = data;
    if (this.tipoSolicitud === "2") {
      this.getCampania();
      this.buscarCampaña();
    }
  }

  tarifasFailureNetworkingOutput(errorCode: number, message: string): void {
    this.spinner.hide();
    this.showMessageDialog(
      "Error", // Título del diálogo
      `No se pudo obtener las tarifas, contacte con el administrador`, // Mensaje del diálogo
      "Aceptar", // Texto del primer botón
      "", // Texto del segundo botón (vacío si no se usa)
      true, // Uso de un botón (true) o dos botones (false)
      1, // Tipo de icono (puedes ajustar según tu lógica)
      this.dialog, // Objeto MatDialog
      (_: any) => { console.error("No se pudo obtener las tarifas, contacte con el administrador"); } // Callback
    );
  }

  /** Metodo que inicializa los formulario */
  initForm() {
    this.formInit = this.fb.group({
      tipoSolicitud: new FormControl(null, [Validators.required]),
      tipoPlan: new FormControl(null, [Validators.required]),
      tipoCotizacion: new FormControl(null, [Validators.required]),
      lineaNegocio: new FormControl(null, [Validators.required]),
      programa: new FormControl(null),
    });
    this.form = this.fb.group({
      contratanteTipoDocumento: new FormControl("", Validators.required),
      contratanteDocumento: new FormControl("", [
        Validators.required,
        Validators.pattern(this.number),
      ]),
      contratanteNombre: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(25),
        Validators.pattern(this.alphabeticalPattern),
      ]),
      contratanteSegundoNombre: new FormControl("", [
        Validators.minLength(3),
        Validators.maxLength(25),
        Validators.pattern(this.alphabeticalPattern),
      ]),
      contratanteApellido: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(25),
        Validators.pattern(this.alphabeticalPattern),
      ]),
      contratanteSegundoApellido: new FormControl("", [
        Validators.minLength(3),
        Validators.maxLength(25),
        Validators.pattern(this.alphabeticalPattern),
      ]),
      contratanteGenero: new FormControl(null, [Validators.required]),
      contratanteFechaNacimiento: new FormControl("", [Validators.required]),
      contratanteFechaTarifa: new FormControl(""),
      contratanteTarifa: new FormControl(""),
      tarifaInclusion: new FormControl(""),
      contratanteEdad: new FormControl(null, [Validators.required]),
      contratanteEmail: new FormControl("", [
        Validators.required,
        Validators.pattern(this.emailPattern),
      ]),
      contratanteEmail2: new FormControl("", [
        Validators.pattern(this.emailPattern),
      ]),
      contratanteTelefono: new FormControl("", [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(10),
        Validators.pattern(this.number),
      ]),
      contratanteUsuario: new FormControl("2", Validators.required),
      telefonoFijo: new FormControl("", [
        Validators.minLength(7),
        Validators.maxLength(10),
      ]),
      campaniaContratante: new FormControl(""),
      id: new FormControl([0]),
      status: new FormControl([1]),
    });
    this.formColectivo = this.fb.group({
      fechaPresentacion: [null, Validators.required],
      fechaInicioVigencia: [null, Validators.required],
      regional: [null, Validators.required],
      canal: [null, Validators.required],
      oficina: [null, Validators.required],
      tipoAsesor: [null, Validators.required],
      nit: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[0-9]+$/)
        ]
      ],
      colectivoNombre: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(40),
        ],
      ],
      sector: [null, Validators.required],
      departamento: [null, Validators.required],
      municipio: [null, Validators.required],
      clienteActual: [null, Validators.required],
      tarifa: new FormControl(""),
      usuariosCotizar: new FormControl("", [
        Validators.required,
        Validators.maxLength(6),
        Validators.pattern(this.number),
        Validators.pattern(/^[0-9]+$/),
      ]),
      usuariosMayor60: new FormControl("", [
        Validators.required,
        Validators.maxLength(6),
        Validators.pattern(this.number),
        Validators.pattern(/^[0-9]+$/),
      ]),
      UsuariosMayor60Total: new FormControl({ value: "", disabled: true }),
      embarazosCurso: new FormControl("", [
        Validators.maxLength(6),
        Validators.pattern(this.number),
        Validators.pattern(/^[0-9]+$/),
      ]),
      lineaNegocio: this.fb.array([]),
      NombreContacto: [null, [Validators.required, Validators.maxLength(40)]],
      cargoContacto: [null, [Validators.required, Validators.maxLength(40)]],
      emailContacto: [
        null,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
        ]
      ],
      telefonoContacto: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[0-9]+$/),
          Validators.maxLength(15)
        ]
      ],
      derechoAsubsidio: [null, Validators.required],
      NombreDestinatario: [null, [Validators.required, Validators.maxLength(40)]],
      cargoDestinatario: [null, [Validators.required, Validators.maxLength(40)]],
      emailDestinatario: [null,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
        ]
      ],
      telefonoDestinatario: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[0-9]+$/),
          Validators.maxLength(15)
        ]
      ],
      igualAQuienSeDirige: new FormControl(""),
      porcentajeSubsidio: new FormControl(""),
    });
    this.formColectivo.get('oficina')?.disable();
    this.formColectivo.get('municipio')?.disable();
  }

  permitirSoloNumeros(event: KeyboardEvent): void {
    const teclasPermitidas = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];

    if (teclasPermitidas.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }

    const regex = /^[0-9]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  validarPegadoSoloNumeros(event: ClipboardEvent): void {
    const textoPegado = event.clipboardData?.getData('text') ?? '';
    const regex = /^[0-9]+$/;

    if (!regex.test(textoPegado)) {
      event.preventDefault();
    }
  }

  normalizarTelefonoColectivo(controlName: string): void {
    const control = this.formColectivo.get(controlName);
    if (!control) {
      return;
    }

    const value = (control.value || '').toString();
    const normalized = value.replace(/\D+/g, '');

    if (value !== normalized) {
      control.setValue(normalized, { emitEvent: false });
    }
  }

  private esSwitchContactoIgualActivo(value = this.formColectivo?.get('igualAQuienSeDirige')?.value): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  private sincronizarDestinatarioConContacto(): void {
    if (!this.esSwitchContactoIgualActivo()) {
      return;
    }

    this.formColectivo.patchValue(
      {
        NombreDestinatario: this.formColectivo.get('NombreContacto')?.value ?? null,
        cargoDestinatario: this.formColectivo.get('cargoContacto')?.value ?? null,
        emailDestinatario: this.formColectivo.get('emailContacto')?.value ?? null,
        telefonoDestinatario: this.formColectivo.get('telefonoContacto')?.value ?? null,
      },
      { emitEvent: false }
    );
  }

  private actualizarEstadoCamposDestinatario(): void {
    const raw = this.formColectivo.getRawValue();
    const igualAQuienSeDirige = this.esSwitchContactoIgualActivo(raw.igualAQuienSeDirige);

    if (igualAQuienSeDirige) {
      this.copiarContactoADestinatario(false);

      this.camposDestinatarioColectivo.forEach((campo) => {
        this.formColectivo.get(campo)?.disable({ emitEvent: false });
      });
    } else {
      this.camposDestinatarioColectivo.forEach((campo) => {
        this.formColectivo.get(campo)?.enable({ emitEvent: false });
      });
    }
  }

  private configurarSincronizacionContactoDestinatario(): void {
    this.formColectivo.get('igualAQuienSeDirige')?.valueChanges.subscribe((value) => {
      if (this.esSwitchContactoIgualActivo(value)) {
        this.sincronizarDestinatarioConContacto();
      }
      this.actualizarEstadoCamposDestinatario();
    });

    this.camposContactoColectivo.forEach((campo) => {
      this.formColectivo.get(campo)?.valueChanges.subscribe(() => {
        this.sincronizarDestinatarioConContacto();
      });
    });

    this.actualizarEstadoCamposDestinatario();
  }

  private aplicarRegionalAsesorPorDefecto(): void {
    if (!this.asesorLogueadoData || !this.regional?.length) {
      return;
    }

    if (this.isEditMode) {
      return;
    }

    const regionalControl = this.formColectivo.get('regional');

    if (!regionalControl) {
      return;
    }

    // No sobrescribir si ya hay regional seleccionada o restaurada desde storage
    if (regionalControl.value) {
      return;
    }

    const codRegionalAsesor = this.normalizarComparacion(this.asesorLogueadoData.cod_regional);
    const nombreRegionalAsesor = this.normalizarComparacion(this.asesorLogueadoData.regional);

    const regionalEncontrada = this.regional.find((item: any) => {
      const codigoRegional = this.normalizarComparacion(item.Codigo_regional);
      const nombreRegional = this.normalizarComparacion(item.Nombre_regional);

      return (
        codigoRegional === codRegionalAsesor ||
        nombreRegional === nombreRegionalAsesor
      );
    });

    if (!regionalEncontrada) {
      console.warn('No se encontró la regional del asesor en el catálogo:', {
        asesor: this.asesorLogueadoData,
        regionales: this.regional,
      });
      return;
    }

    regionalControl.setValue(regionalEncontrada.Codigo_regional, {
      emitEvent: true,
    });
  }

  private aplicarOficinaAsesorPorDefecto(): void {
    if (!this.asesorLogueadoData || !this.sucursalesRegional?.length) {
      return;
    }

    if (this.isEditMode) {
      return;
    }

    const oficinaControl = this.formColectivo.get('oficina');

    if (!oficinaControl) {
      return;
    }

    // No sobrescribir si ya hay oficina seleccionada o restaurada desde storage
    if (oficinaControl.value) {
      return;
    }

    const codCiudadAsesor = this.normalizarComparacion(this.asesorLogueadoData.cod_ciudad);
    const ciudadAsesor = this.normalizarComparacion(this.asesorLogueadoData.ciudad);

    const oficinaEncontrada = this.sucursalesRegional.find((item: any) => {
      const codSucursal = this.normalizarComparacion(item.cod_sucursal);
      const nombreSucursal = this.normalizarComparacion(item.nombre_sucursal);

      return (
        codSucursal === codCiudadAsesor ||
        nombreSucursal === ciudadAsesor
      );
    });

    if (!oficinaEncontrada) {
      console.warn('No se encontró la oficina del asesor en el catálogo:', {
        asesor: this.asesorLogueadoData,
        sucursales: this.sucursalesRegional,
      });
      return;
    }

    oficinaControl.enable({ emitEvent: false });
    oficinaControl.setValue(oficinaEncontrada.cod_sucursal, {
      emitEvent: false,
    });
  }

  private mostrarAdvertenciaEnCola(mensaje: string): Promise<any> {
    this.colaAlertas = this.colaAlertas
      .catch(() => null)
      .then(() => {
        return Swal.fire({
          title: 'Advertencia',
          html: mensaje,
          icon: 'warning',
          showCloseButton: true,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: true,
        });
      });

    return this.colaAlertas;
  }

  private normalizarComparacion(valor: any): string {
    return (valor ?? '')
      .toString()
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  async ngOnInit(): Promise<void> {
    // Solo al refrescar el navegador: limpia validaciones_beneficiario.
    limpiarValidacionesBeneficiarioSiRecargaNavegador();

    this.beneficiarioLocalStorage.programasHeredadosSincronizados$
      .pipe(takeUntil(this.cotizadorCancel$))
      .subscribe({
        next: () => {
          // Si el refresh ya lo disparó sincronizarYRefrescar..., no repetir.
          if (this._refrescoHeredadosEnCurso) return;
          try {
            this.refrescarFilasBeneficiariosHeredadosDesdeLocalStorage();
          } catch {
            // no-op: no tumbar el flujo por un refresh puntual
          }
        },
        error: () => {
          // no-op: el Subject no debe romper el cotizador
        }
      });

    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = (userCC || '').toString().includes('.')
      ? (userCC.split('.')[1] || '').toString().trim()
      : (userCC || '').toString().trim();
    console.log('PortafolioComponent: cedulaAsesor ->', this.cedulaAsesor);
    this.nombreAsesor = this.logInfo
      ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${this.logInfo.segundoApellido ?? ''
        }`.trim()
      : 'N/A';
    console.log('PortafolioComponent: nombreAsesor ->', this.nombreAsesor);


    this.trackDataCarnet = {
      module: 'Cotizador',
      category: 'N/A',
      submodule: 'Cotizador',
      functionality: 'Generar cotización',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombreAsesor,
      identificadorInteraccion: 'COTIZADOR_GENERAR_COTIZACION'
    };

    // let data = this.storageService.getItem('user')
    // console.log('aqui viene la data del usuario makia', data);

    // let objPersona: PersonBeneficiary = new PersonBeneficiary();
    let fechaActual = new Date().toLocaleDateString("es-CO").split(`/`);
    const mes =
      parseInt(fechaActual[1]) < 10 ? `0${fechaActual[1]}` : fechaActual[1];
    const dia =
      parseInt(fechaActual[0]) < 10 ? `0${fechaActual[0]}` : fechaActual[0];
    const fechaTemporalMax =
      parseInt(fechaActual[2]) - 18 + "-" + mes + "-" + dia;
    const fechaTemporalMin =
      parseInt(fechaActual[2]) - 130 + "-" + mes + "-" + dia;
    const fechaTemporalTarifas =
      parseInt(fechaActual[2]) - 130 + "-" + mes + "-" + dia;
    this.maxDate = fechaTemporalMax;
    this.minDate = fechaTemporalMin;
    this.minDateTarifas = fechaTemporalTarifas;

    this.formInit.get('tipoSolicitud')?.valueChanges.subscribe((val) => {
      this.esModalColectivoConfirmado = false;
      if (val === '3') {
        console.log('[COLECTIVO-DEBUG] Detectado cambio en tipoSolicitud -> 3');
        this.validateTipoSolicitud();
      }
    });
    this.formInit.get('tipoPlan')?.valueChanges.subscribe(() => {
      this.esModalColectivoConfirmado = false;
    });

    localStorage.removeItem('contrato_radicado');

    this.formColectivo.get('derechoAsubsidio')?.valueChanges.subscribe((value) => {
      console.log(value, typeof value);
      const porcentajeControl = this.formColectivo.get('porcentajeSubsidio');

      if (value === '1') {
        porcentajeControl?.setValidators([Validators.required]);
      } else {
        porcentajeControl?.clearValidators();
        porcentajeControl?.setValue(null); // limpia selección si cambia a NO
      }

      porcentajeControl?.updateValueAndValidity();
    });

    this.formColectivo.get('nit')?.valueChanges.subscribe((value) => {
      const nitActual = (value || "").toString().trim();
      const nitCotizacionActual = (this.cotizacionColectivoActual?.numDocumento || "").toString().trim();
      if (nitCotizacionActual && nitActual !== nitCotizacionActual) {
        this.asignarCotizacionColectivoActual(null);
      }
      if (this.empresaColectivoActual && nitActual !== (this.empresaColectivoActual?.numDocumento || nitActual).toString().trim()) {
        this.empresaColectivoActual = null;
      }
    });

    this.formColectivo.get('igualAQuienSeDirige')?.valueChanges.subscribe(() => {
      this.actualizarEstadoCamposDestinatario();
    });

    this.camposContactoColectivo.forEach((campo) => {
      this.formColectivo.get(campo)?.valueChanges.subscribe(() => {
        const raw = this.formColectivo.getRawValue();
        const igualAQuienSeDirige = this.esSwitchContactoIgualActivo(raw.igualAQuienSeDirige);

        if (igualAQuienSeDirige) {
          this.copiarContactoADestinatario(false);
        }
      });
    });

    this.formColectivo.get('usuariosCotizar')?.valueChanges.subscribe(() => {
      this.actualizarPorcentajeUsuariosMayores();
    });

    this.formColectivo.get('usuariosMayor60')?.valueChanges.subscribe(() => {
      this.actualizarPorcentajeUsuariosMayores();
    });

    this.actualizarPorcentajeUsuariosMayores();
    this.configurarSincronizacionContactoDestinatario();

    // Inicializar select de tipo de regionales
    this.networking.consutarRegionales().subscribe({
      next: (nombres) => {
        this.regional = nombres;

        if (this.isEditMode && this._pendingRegionalEdicion) {
          const pending = this._pendingRegionalEdicion;
          this._pendingRegionalEdicion = null;

          const matchR = nombres.find(r =>
            r.Nombre_regional?.trim().toUpperCase() === pending.trim().toUpperCase()
            || r.Codigo_regional?.toString().trim() === pending.trim()
          );

          this.formColectivo.get('regional')?.setValue(
            matchR?.Codigo_regional ?? pending,
            { emitEvent: true }
          );

          return;
        }

        this.aplicarRegionalAsesorPorDefecto();
      },
      error: (err) => console.error(err),
    });

    this.networking.consultarTiposDeAsesor().subscribe({
      next: (tipos) => {
        this.tiposDeAsesor = tipos;
        if (this.isEditMode && this._pendingCanalEdicion) {
          const pendingCanal = this._pendingCanalEdicion;
          const pendingTipoAsesor = this._pendingTipoAsesorEdicion;
          this._pendingCanalEdicion = null;
          this._pendingTipoAsesorEdicion = null;
          const cMatch = this.canal.find(c =>
            c.label.toUpperCase() === pendingCanal.toUpperCase()
            || c.value === pendingCanal.toUpperCase()
          );
          this.formColectivo.get('canal')?.setValue(cMatch?.value ?? pendingCanal.toUpperCase(), { emitEvent: true });
          setTimeout(() => {
            if (pendingTipoAsesor) {
              const tipoControl = this.formColectivo.get('tipoAsesor');

              const tMatch = this.tiposFiltrados.find((t: any) =>
                this.normalizarTextoTipoAsesor(t.nombre) ===
                this.normalizarTextoTipoAsesor(pendingTipoAsesor)
                || (t.tipo || '').toString().trim() === pendingTipoAsesor.toString().trim()
              );

              tipoControl?.setValue(tMatch?.tipo ?? null, { emitEvent: false });
            }
          }, 0);
        }
      },
      error: (err) => console.error(err),
    });

    this.formColectivo.get('canal')?.valueChanges.subscribe(value => {
      this.filtrarTipos(value);
    });

    this.formColectivo.get('regional')?.valueChanges.subscribe((valor) => {
      const oficinaControl = this.formColectivo.get('oficina');
      oficinaControl?.setValue(null);
      oficinaControl?.disable();
      this.sucursalesRegional = [];
      this.sucursalesLoading = false;

      if (!valor) {
        this.regionalSeleccionada = "";
        this.ultimaRegionalSolicitada = null;
        return;
      }

      const codigoRegional = String(valor);
      this.regionalSeleccionada = codigoRegional;
      this.ultimaRegionalSolicitada = codigoRegional;
      this.sucursalesLoading = true;

      this.networking.consultarSucursalesXRegional(codigoRegional).subscribe({
        next: (sucursales) => {
          if (this.ultimaRegionalSolicitada !== codigoRegional) {
            return;
          }
          // this.sucursalesRegional = sucursales ?? [];
          // this.sucursalesLoading = false;
          // if (this.sucursalesRegional.length > 0) {
          //   oficinaControl?.enable();
          // }
          // if (this._pendingOficinaEdicion) {
          //   const pendingCod = this._pendingOficinaEdicion;
          //   this._pendingOficinaEdicion = null;
          //   const sMatch = this.sucursalesRegional.find(s =>
          //     s.cod_sucursal === pendingCod
          //     || s.nombre_sucursal?.toUpperCase() === pendingCod.toUpperCase()
          //   );
          //   if (sMatch) {
          //     setTimeout(() => oficinaControl?.setValue(sMatch.cod_sucursal), 0);
          //   }
          // }
          this.sucursalesRegional = sucursales ?? [];
          this.sucursalesLoading = false;

          if (this.sucursalesRegional.length > 0) {
            oficinaControl?.enable();
          }

          if (this._pendingOficinaEdicion) {
            const pendingCod = this._pendingOficinaEdicion;
            this._pendingOficinaEdicion = null;

            const sMatch = this.sucursalesRegional.find(s =>
              s.cod_sucursal === pendingCod
              || s.nombre_sucursal?.toUpperCase() === pendingCod.toUpperCase()
            );

            if (sMatch) {
              setTimeout(() => oficinaControl?.setValue(sMatch.cod_sucursal), 0);
            }

            return;
          }

          this.aplicarOficinaAsesorPorDefecto();
        },
        error: (err) => {
          console.error(err);
          if (this.ultimaRegionalSolicitada !== codigoRegional) {
            return;
          }
          this.sucursalesLoading = false;
          oficinaControl?.disable();
          this.sucursalesRegional = [];
        },
      });
    });

    this.formColectivo.valueChanges.subscribe(() => {
      // Versión histórica: el form es de solo lectura; los cambios provienen del prefill async
      // (oficina, sector, etc.). No deben resetear los flags de guardado ni deshabilitar el tab.
      if (this.isEditMode && !this.esVersionMasReciente) return;
      // Prefill en curso: los setValue programáticos no son edición real del usuario.
      // No apagar tabHabilitado.cotizacion (ocultaría el tab COTIZACIÓN al editar colectiva).
      if (this._prefillColectivoEnCurso) return;
      this.colectivoFormSaved = false;
      this.mostrarAlertaCamposColectivo = false;
      this.tabHabilitado.cotizacion = false;
    });

    this.networking.consultarSectores().subscribe({
      next: (sectores) => {
        this.sectores = sectores.map((item: any) => this.formatearSector(item));
        this.sectoresFiltrados = this.sectores;

        this.aplicarSectorGuardado();

        if (this.isEditMode && this._pendingSectorNombreEdicion) {
          const valorAlmacenado = this._pendingSectorNombreEdicion.trim();
          this._pendingSectorNombreEdicion = null;

          const idSectorNumerico = Number(valorAlmacenado);
          let codigoSector: any;

          if (!isNaN(idSectorNumerico) && idSectorNumerico > 0) {
            // El backend guardó el idSector como número/string numérica → usarlo directamente
            codigoSector = idSectorNumerico;
          } else {
            // Fallback: buscar por nombre (datos guardados con nombre en lugar de ID)
            const sectorObj = this.sectores.find((s: any) =>
              (s.deno || '').trim().toLowerCase() === valorAlmacenado.toLowerCase() ||
              (s.nombreSector || '').trim().toLowerCase() === valorAlmacenado.toLowerCase()
            );
            codigoSector = sectorObj ? sectorObj.idSector : valorAlmacenado;
          }

          this.formColectivo.get('sector')?.setValue(codigoSector, {
            emitEvent: false,
          });
        }
      },
      error: (err) => console.error(err),
    });

    this.sectorFiltro.valueChanges.subscribe(value => {
      this.filtrarSectores(value);
    });

    this.formColectivo
      .get('departamento')
      ?.valueChanges.subscribe((value) => {
        this.cargarMunicipiosPorDepartamento(value);
      });

    // Cargar datos de edición si vienen desde mis-cotizaciones
    const stored = localStorage.getItem('cotizacionEdicion');
    if (stored) {
      try {
        this.cotizacionEdicionData = JSON.parse(stored);
        this._cotizacionEdicionDataLatest = this.cotizacionEdicionData; // guardar estado live
        localStorage.removeItem('cotizacionEdicion');
        this._cargaInicialPendiente = true; // bloquear navegación hasta que todos los servicios iniciales respondan
        this.isEditMode = true;
        this._editSessionDirty = false;
        this.idCotizacionEdicion = this.cotizacionEdicionData!.idCotizacion;
        this.prefillFormInit(this.cotizacionEdicionData!);
        this.cargarVersiones(this.idCotizacionEdicion);
      } catch (e) {
        console.error('❌ Error al parsear cotizacionEdicion desde localStorage:', e);
        localStorage.removeItem('cotizacionEdicion');
      }
    } else {
      // Limpieza preventiva: si no es modo edición, asegurarse de que no queden datos de edición previos
      localStorage.removeItem('cotizacion_edicion_contratante');
      localStorage.removeItem('cotizacion_precargada');
      localStorage.removeItem('cotizacion_cargada');
      localStorage.removeItem('idCotizacion');
    }

    await this.consultarIDxAsesor();

    // Desbloquear navegación una vez que todos los servicios iniciales (awaited + paralelos) hayan respondido
    if (this._cargaInicialPendiente) {
      this._cargaInicialPendiente = false;
    }

  }



  /**
   * Reconstruye la configuración persistida del programa del titular en modo edición
   * (inclusión: extrae campaña y metadatos sin valores quemados).
   */
  private normalizarProgramaTitularEdicion(p: any): any {
    if (!p) return null;
    const code = (p.programa || p.id || p.codigo || p.code || p.planCodi || '').toString().trim().toUpperCase();
    if (!code) return null;

    const tarifas: any[] = Array.isArray(p.tarifas) ? p.tarifas : [];
    const campanias: any[] = Array.isArray(p.campanias) ? p.campanias : [];
    const esTarifaAnexo = (tarifa: any): boolean => {
      const value = tarifa?.esAnexo ?? tarifa?.es_anexo;
      const normalizado = (value ?? '').toString().trim().toUpperCase();
      return value === true || ['S', 'SI', 'TRUE', '1'].includes(normalizado);
    };
    const tarifaAnexoRec = tarifas.find(esTarifaAnexo);
    const tarifaBase = tarifas.find((tarifa: any) => !esTarifaAnexo(tarifa)) ?? tarifas[0];
    const campaniaSel = campanias.find((c: any) => c.fueSeleccionada !== false) ?? campanias[0] ?? null;

    const codTarifa = (tarifaBase?.tari || tarifaBase?.tarifa || p.tarifa || p.codTarifa || '').toString().trim();
    const nomTarifa = (tarifaBase?.nombreTarifa || p.nombreTarifa || p.nombre_tarifa || codTarifa).toString().trim();
    const valBaseNum = Number(tarifaBase?.valorMensualBase ?? p.valorMensualBase ?? p.valor_mensual_base ?? p.valor_tari ?? 0);
    const valIvaNum = Number(tarifaBase?.valorMensualIva ?? p.valorMensualIva ?? p.valor_mensual_iva ?? valBaseNum);

    const codCamp = (campaniaSel?.codCampComercial || campaniaSel?.codigo_campania || campaniaSel?.codigoCampania || p.campana || p.campania || p.codCampComercial || p.codigo_campania || '').toString().trim();
    const nomCamp = (campaniaSel?.nombreCampania || campaniaSel?.nombre || p.campanaNombre || p.nombre_campana || '').toString().trim();
    const iniVig = campaniaSel?.inicioVigencia || campaniaSel?.inicio_vigencia || p.inicioVigencia || p.inicio_vigencia || undefined;
    const finVig = campaniaSel?.finVigencia || campaniaSel?.fin_vigencia || p.finVigencia || p.fin_vigencia || undefined;

    let subctaCode = (p.subcta || p.codigoSubcuenta || p.subcuenta || '').toString().trim();
    let subctaNombre = (p.nombreSubcuenta || p.subcuenta || subctaCode).toString().trim();

    // Separar numérico (código) de texto (deno)
    if (!subctaCode && /^\d+$/.test(subctaNombre)) {
      subctaCode = subctaNombre;
      subctaNombre = '';
    }
    if (subctaCode && !/^\d+$/.test(subctaCode)) {
      if (!subctaNombre) subctaNombre = subctaCode;
      subctaCode = '';
    }

    // Resolver con el catálogo _datosCompletosColectivoAC
    if (code) {
      const matchAc: any = (this._datosCompletosColectivoAC || []).find((r: any) =>
        (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase() === code &&
        (!subctaCode || (r?.subcta ?? r?.SUBCTA ?? '').toString().trim() === subctaCode)
      );
      if (matchAc) {
        if (!subctaCode && (matchAc.subcta || matchAc.SUBCTA)) subctaCode = (matchAc.subcta || matchAc.SUBCTA).toString().trim();
        if (matchAc.deno || matchAc.DENO) subctaNombre = (matchAc.deno || matchAc.DENO).toString().trim();
      }
    }

    console.log(`[INCLUSION-SUBCUENTA-DEBUG] Normalizado Titular Edición '${code}' -> subctaCode: "${subctaCode}", subctaNombre (deno): "${subctaNombre}"`);

    if (!subctaNombre) subctaNombre = subctaCode;

    const codTarifaAnexo = (
      tarifaAnexoRec?.tari
      || tarifaAnexoRec?.tarifa
      || p.anexoDetalle?.tari
      || p.tarifaAnexo
      || p.anexoCodigo
      || ''
    ).toString().trim();
    const claveAnexo = (
      p.anexoDetalle?.clave
      || tarifaAnexoRec?.clave
      || tarifaAnexoRec?.plan_codi_adi
      || tarifaAnexoRec?.planCod2
      || p.plan_codi_adi
      || p.anexoCodigo
      || codTarifaAnexo
    ).toString().trim();
    const nombreAnexo = (
      tarifaAnexoRec?.nombreTarifa
      || tarifaAnexoRec?.nombre
      || p.anexoDetalle?.nombreTarifa
      || p.nombreAnexo
      || ''
    ).toString().trim();
    const normalizarRequiereAnexo = (value: any): 'si' | 'no' | null => {
      const normalizado = (value ?? '').toString().trim().toUpperCase();
      if (value === true || ['SI', 'S', 'TRUE', '1'].includes(normalizado)) return 'si';
      if (value === false || ['NO', 'N', 'FALSE', '0'].includes(normalizado)) return 'no';
      return null;
    };

    return {
      id: code,
      programa: code,
      nombrePrograma: (p.nombrePrograma || p.nombre || code).toString().trim(),
      lineaNegocio: (p.lineaNegocio || p.linea_negocio || '').toString().trim(),
      subcta: subctaCode,
      subcuenta: subctaNombre,
      nombreSubcuenta: subctaNombre,
      tarifa: codTarifa,
      nombreTarifa: nomTarifa,
      valorMensualBase: Number.isFinite(valBaseNum) && valBaseNum > 0 ? valBaseNum : undefined,
      valorMensualIva: Number.isFinite(valIvaNum) && valIvaNum > 0 ? valIvaNum : undefined,
      porcentajeIva: Number(tarifaBase?.porcentajeIva ?? p.porcentajeIva ?? 0) || undefined,
      tarifaDetalle: {
        tari: codTarifa,
        nombreTarifa: nomTarifa,
        valorMensualBase: valBaseNum > 0 ? valBaseNum : null,
        valorMensualIva: valIvaNum > 0 ? valIvaNum : null,
        porcentajeIva: Number(tarifaBase?.porcentajeIva ?? p.porcentajeIva ?? 0) || null,
        fueSeleccionada: true,
        esAnexo: false
      },
      campana: codCamp,
      campanaNombre: nomCamp,
      inicioVigencia: iniVig,
      finVigencia: finVig,
      campaniaDetalle: campaniaSel ? {
        ...campaniaSel,
        codCampComercial: codCamp,
        nombreCampania: nomCamp,
        inicioVigencia: iniVig,
        finVigencia: finVig,
        fueSeleccionada: true
      } : null,
      // NC 1078 (solo edición): no usar p.esAnexo del PROGRAMA (casi siempre false).
      // Fuente de verdad: tarifa anexo del /edit o códigos anexo ya resueltos.
      requiereAnexo: (tarifaAnexoRec || claveAnexo || codTarifaAnexo)
        ? 'si'
        : (normalizarRequiereAnexo(p.requiereAnexo) ?? 'no'),
      anexoCodigo: claveAnexo,
      tarifaAnexo: codTarifaAnexo,
      nombreAnexo,
      idBeneficiario: Number(p.idBeneficiario ?? p.id_beneficiario ?? 0) || undefined,
      idBenPrograma: Number(p.idBenPrograma ?? p.idBenProgramaCotizacion ?? p.__idBenPrograma ?? 0) || undefined,
      idSubcuenta: Number(p.idSubcuenta ?? p.id_subcuenta ?? p.__idSubcuenta ?? 0) || undefined,
      idCotizacionTarifa: Number(tarifaBase?.idCotizacionTarifa ?? p.idCotizacionTarifa ?? p.__idCotizacionTarifa ?? 0) || undefined,
      idCotizacionTarifaAnexo: Number(tarifaAnexoRec?.idCotizacionTarifa ?? p.idCotizacionTarifaAnexo ?? p.__idCotizacionTarifaAnexo ?? 0) || undefined,
      idCotizacionCampania: Number(campaniaSel?.idCotizacionCampania ?? p.idCotizacionCampania ?? p.__idCotizacionCampania ?? 0) || undefined,
      guardadoEnBd: true
    };
  }
  /**
   * Rellena formInit con los datos de la cotización en edición.
   * idTipoPlan numérico → código de plan: 1=A, 2=F, 3=E, 4=C, 5=GA
   */
  prefillFormInit(data: CotizacionEdicionData): void {
    // Marcar que estamos poblando el form: evita que los setValue programáticos
    // apaguen tabHabilitado.cotizacion vía formColectivo.valueChanges.
    this._prefillColectivoEnCurso = true;
    const planMap: Record<number, string> = { 2: 'F', 1: 'A', 3: 'E', 4: 'C', 5: 'GA' };
    const tipoSolicitudStr = data.idTipoSolicitud?.toString() ?? null;
    if (tipoSolicitudStr) {
      localStorage.setItem('tipoSolicitud', tipoSolicitudStr);
    }
    if (Array.isArray(data.contratosInclusion) && data.contratosInclusion.length > 0) {
      localStorage.setItem('contratos_inclusion_edicion', JSON.stringify(data.contratosInclusion));
    }
    if (tipoSolicitudStr === '2' && ((Array.isArray(data.beneficiarios) && data.beneficiarios.length > 0) || (Array.isArray(data.contratosInclusion) && data.contratosInclusion.length > 0))) {
      console.log('[Inclusion-Edicion] Detectado flujo de inclusión. Inicializando .');
      const codigosProgramas: string[] = [];
      const descripcionesMap: Record<string, string> = {};

      if (Array.isArray(data.contratosInclusion)) {
        data.contratosInclusion.forEach((ci: any) => {
          const code = (ci.programa ?? '').toString().trim().toUpperCase();
          if (code && !codigosProgramas.includes(code)) {
            codigosProgramas.push(code);
          }
        });
      }

      (data.beneficiarios || []).forEach((b: any) => {
        const programasBeneficiario = Array.isArray(b.programas) ? b.programas : [];
        programasBeneficiario.forEach((p: any) => {
          const code = (p.programa ?? p.id ?? p.code ?? p.codigo ?? p.planCodi ?? '').toString().trim().toUpperCase();
          const desc = (p.nombrePrograma ?? p.nombre ?? p.descripcion ?? p.programaDeno ?? '').toString().trim();
          if (code && !codigosProgramas.includes(code)) {
            codigosProgramas.push(code);
            if (desc) {
              descripcionesMap[code] = desc;
            }
          }
        });
      });

      if (codigosProgramas.length > 0) {
        localStorage.setItem('programas_seleccionados_inclusion', JSON.stringify(codigosProgramas));
        localStorage.setItem('programas_descripciones_inclusion', JSON.stringify(descripcionesMap));
        console.log('[Inclusion-Edicion] Almacenes de control pre-poblados:', codigosProgramas);
      }

      if (tipoSolicitudStr === '2') {
        const titular = data.beneficiarios.find((b: any) =>
          b?.parentescoId?.toString() === 'T' ||
          b?.parentesco_id?.toString() === 'T' ||
          b?.esContratante === 'S' ||
          b?.es_contratante === 'S' ||
          b?.esContratante === true
        );
        if (titular) {
          const titularAny = titular as any;
          const progsRaw = titularAny.programasConfig?.programas || titularAny.programas || [];
          const programasMapeados = Array.isArray(progsRaw) ? progsRaw
            .map((p: any) => this.normalizarProgramaTitularEdicion(p))
            .filter(Boolean) : [];

          localStorage.setItem('programas_contratante', JSON.stringify(programasMapeados));
          localStorage.setItem('programas_contratante_inclusiones', JSON.stringify(programasMapeados));
          console.log('[INCLUSION-DEBUG] [prefillFormInit] Programas del Titular inyectados en LocalStorage para Inclusión:', programasMapeados);
        }
      }



    }
    const tipoPlanStr = data.idTipoPlan != null ? (planMap[data.idTipoPlan] ?? null) : null;

    const esEdicionNuevoColectivo =
      this.isEditMode && Number(data.idTipoSolicitud) === 3;

    this.formInit.get('tipoSolicitud')?.setValue(tipoSolicitudStr, {
      emitEvent: !esEdicionNuevoColectivo,
    });
    if (tipoPlanStr) {
      this.formInit
        .get('tipoPlan')
        ?.setValue(tipoPlanStr, { emitEvent: false });

      localStorage.setItem('tipoPlan', tipoPlanStr);
    }
    if (this.isEditMode && (tipoPlanStr === 'C' || tipoPlanStr === 'GA')) {
      this.persistirDocumentoEmpresaEdicion(data);
    }
    // Activar visibilidad de pestañas según tipo de solicitud
    this.validateTipoSolicitud();

    // En modo edición, habilitar inmediatamente todas las pestañas correspondientes
    if (this.isEditMode) {
      if (this.esNuevoColectivo) {
        // Colectivo estándar: INICIO + COLECTIVO + COTIZACIÓN
        this.tabHabilitado.cotizacion = true;
        this.maxStepReached = Math.max(this.maxStepReached, 1);
        // Abrir directo en COLECTIVO. validateTipoSolicitud ya NO hace el setTimeout
        // que antes competía con este seteo (ese setTimeout solo corre en !isEditMode).
        this.selectedIndex = 1;
      } else {
        // Individual: INICIO + CONTRATANTE + BENEFICIARIOS + COTIZACIÓN
        this.tabHabilitado.contratante = true;
        this.tabHabilitado.beneficiarios = true;
        this.tabHabilitado.cotizacion = true;
        this.selectedIndex = 0;
      }
    }

    // Emitir datos del contratante para que el formulario-contratante los precargue
    if (data.contratante) {
      const programasContratantePersistidos = obtenerProgramasPersistidosContratante(data.beneficiarios)
        .map((programa: any) => this.normalizarProgramaTitularEdicion(programa))
        .filter(Boolean);
      const contextoContratante: CotizacionEdicionContratanteContexto = {
        idCotizacion: data.idCotizacion,
        contratante: data.contratante,
        pasoActual: Number(data.pasoActual ?? 0),
        idTipoSolicitud: data.idTipoSolicitud,
        tieneProgramasContratantePersistidos: tieneProgramasPersistidosContratante(data.beneficiarios),
        programasContratantePersistidos
      };
      localStorage.setItem('cotizacion_edicion_contratante', JSON.stringify(contextoContratante));
      window.dispatchEvent(new CustomEvent('cotizacion-edicion-contratante'));
    }

    // Cargar beneficiarios en la tabla (modo edición)
    if (this.isEditMode) {
      this.cargarBeneficiariosDesdeEdicion();
    }

    // En edición individual: escribir localStorage para que app-cotizador-cotizacion
    // encuentre el idCotizacion y los datos del contratante (usados para PDF)
    if (this.isEditMode && !this.esNuevoColectivo && data.idCotizacion) {
      const c = data.contratante;
      // Guardar documento junto al id para que getIdCotizacionFromKey pueda validar
      // que el id pertenece al contratante actual (evita id residual de otra edición).
      const tipoDocumentoCargada = (c?.tipoDocumento ?? c?.tipo_documento ?? '').toString().trim();
      const numeroDocumentoCargada = (c?.numDocumento ?? c?.numero_documento ?? c?.numeroDocumento ?? '').toString().trim();
      localStorage.setItem('cotizacion_cargada', JSON.stringify({
        idCotizacion: data.idCotizacion,
        tipoDocumento: tipoDocumentoCargada,
        numeroDocumento: numeroDocumentoCargada,
      }));
      if (data.contratante) {
        localStorage.setItem('datosRQ002_Contratante', JSON.stringify({
          tipoDocumento: tipoDocumentoCargada,
          numeroDocumento: numeroDocumentoCargada,
          primerNombre: c.primerNombre ?? c.primer_nombre ?? '',
          segundoNombre: c.segundoNombre ?? c.segundo_nombre ?? '',
          primerApellido: c.primerApellido ?? c.primer_apellido ?? '',
          segundoApellido: c.segundoApellido ?? c.segundo_apellido ?? '',
          emailPrincipal: c.email ?? c.correoElectronico ?? c.correo ?? c.emailPrincipal ?? '',
        }));
      }
    }

    // Cargar datos del colectivo en modo edición
    if (this.esNuevoColectivo && data.colectivo) {
      const colectivoConLineas = { ...data.colectivo };

      // Guardar liquidaciones existentes para hacer UPDATE en vez de INSERT al re-guardar
      if (this.isEditMode && Array.isArray(data.liquidaciones)) {
        this._liquidacionesEdicion = data.liquidaciones as LiquidacionColectivoItem[];
      }

      // Si el backend no manda lineasNegocio explícitas (array), derivarlas desde liquidaciones.lineaNegocioCol.
      // Nota: lineaNegocio (singular) es solo el primer registro → no se usa como guard para evitar
      // que bloquee la deducción en snapshots históricos que no tienen el array.
      const tieneLineas = colectivoConLineas.lineasNegocio || colectivoConLineas.lineasSeleccionadas;
      if (!tieneLineas && Array.isArray(data.liquidaciones) && data.liquidaciones.length) {
        const nombreACodigo: Record<string, string> = {
          'MEDICINA INTEGRAL': '1',
          'SALUD ORAL': '2',
          'CEM': '3',
        };
        const lineasDeducidas = [...new Set(
          data.liquidaciones
            .map((l: any) => (l.lineaNegocioCol || '').toString().trim().toUpperCase())
            .filter(Boolean)
            .map((nombre: string) => {
              if (nombre === 'CEM' || nombre.includes('CEM')) return '3';
              if (nombre.includes('SALUD ORAL') || nombre === 'SAO') return '2';
              if (nombre.includes('MEDICINA') || nombre.includes('INTEGRAL')) return '1';
              return nombreACodigo[nombre] ?? null;
            })
            .filter((v: string | null): v is string => v !== null)
        )];
        if (lineasDeducidas.length) {
          colectivoConLineas.lineasNegocio = lineasDeducidas;
        }
      }

      // Enriquecer con campos del root de data (canal/regional/oficina/tipoAsesor) que no
      // vienen dentro de data.colectivo (corresponden a tabla cotizacion, no cotizacion_colectivo)
      if (this.isEditMode) {
        const dataAny = data as any;
        if (!colectivoConLineas.canal && dataAny.canal) colectivoConLineas.canal = dataAny.canal;
        if (!colectivoConLineas.regional && dataAny.regional) colectivoConLineas.regional = dataAny.regional;
        if (!colectivoConLineas.oficina && dataAny.oficina) colectivoConLineas.oficina = dataAny.oficina;
        if (!colectivoConLineas.tipoAsesor && dataAny.tipoAsesor) colectivoConLineas.tipoAsesor = dataAny.tipoAsesor;

        // Deducir programasSeleccionados desde liquidaciones si no viene explícito (o viene vacío [])
        if (!colectivoConLineas.programasSeleccionados?.length && Array.isArray(data.liquidaciones) && data.liquidaciones.length) {
          const programasDeducidos = [...new Set(
            data.liquidaciones
              .map((l: any) => (l.programaCol || l.grupoProgramaCol || '').toString().trim())
              .filter(Boolean)
          )];
          if (programasDeducidos.length) colectivoConLineas.programasSeleccionados = programasDeducidos;
        }
      }

      this.prefillFormColectivo(colectivoConLineas);
      // Si hay liquidaciones guardadas, marcar como ya guardada para habilitar PDF
      if (this.isEditMode && Array.isArray(data.liquidaciones) && data.liquidaciones.length > 0) {
        this.liquidacionColectivoGuardada = true;
      }
    }

    if (this.esNuevoColectivo && Array.isArray(data.liquidaciones) && data.liquidaciones.length > 0) {
      setTimeout(() => {
        this.sincronizarProgramasColectivoParaBeneficiarios();
      }, 200);
    }

    console.log('✅ Formulario prefillado — tipoSolicitud:', tipoSolicitudStr, 'tipoPlan:', tipoPlanStr);
  }

  /**
   * Pre-rellena formColectivo con los datos de la cotización colectiva en edición.
   * Gestiona la carga asíncrona de sucursales (regional → oficina) y la population
   * de los checkboxes de línea de negocio que son controles DOM nativos.
   */
  private prefillFormColectivo(colectivo: any): void {
    if (!colectivo) return;

    // 1. Fechas
    if (colectivo.fechaPresentacion) {
      this.formColectivo.get('fechaPresentacion')?.setValue(new Date(colectivo.fechaPresentacion), { emitEvent: false });
    }
    if (colectivo.fechaInicioVigencia) {
      this.formColectivo.get('fechaInicioVigencia')?.setValue(new Date(colectivo.fechaInicioVigencia), { emitEvent: false });
    }

    // 2. Canal y tipoAsesor: catálogo tiposDeAsesor carga async → pendientes hasta que retorne
    if (colectivo.canal) this._pendingCanalEdicion = colectivo.canal;
    if (colectivo.tipoAsesor) this._pendingTipoAsesorEdicion = colectivo.tipoAsesor;

    // 3. Regional → Oficina: catálogo regional carga async → pendiente hasta que retorne
    if (colectivo.oficina) this._pendingOficinaEdicion = colectivo.oficina.toString().trim();

    if (colectivo.regional) {
      if (this.regional && this.regional.length > 0) {
        // Catálogo ya disponible (cambio de versión o recarga posterior al init)
        const pendingR = (colectivo.regional as string).toString().trim();
        const matchR = this.regional.find((r: any) =>
          r.Nombre_regional?.trim().toUpperCase() === pendingR.toUpperCase() ||
          r.Codigo_regional?.toString().trim() === pendingR
        );
        this.formColectivo.get('regional')?.setValue(matchR?.Codigo_regional ?? pendingR, { emitEvent: true });
        // emitEvent:true dispara valueChanges → consultarSucursalesXRegional → consume _pendingOficinaEdicion
      } else {
        // Catálogo aún no llegó (primera carga al init): dejar en pending
        this._pendingRegionalEdicion = colectivo.regional;
      }
    }

    // 4. Datos simples de la empresa
    const nit = (colectivo.numDocumento ?? colectivo.nitEmpresa ?? '').toString().trim();

    // Conversión "S"/"N" → "1"/"2" (radio buttons del form usan valores 1/2)
    const snToRadio = (v: any): string | null => {
      if (v === 'S' || v === 's') return '1';
      if (v === 'N' || v === 'n') return '2';
      return v != null ? String(v) : null;
    };

    // porcentajeSubsidio: backend retorna 50 o 100 (número); el form usa "1" = 50%, "2" = 100%
    const pctToRadio = (v: any): string | null => {
      if (v === 50 || v === '50') return '1';
      if (v === 100 || v === '100') return '2';
      return v != null ? String(v) : null;
    };

    // Sector: catálogo sectores carga async → pendiente hasta que retorne (backend guarda nombre, form usa código)
    if (colectivo.sector) this._pendingSectorNombreEdicion = colectivo.sector;

    // Contactos: vienen en un array colectivo.contactos[{ rolContacto, nombre, cargo, email, telefono }]
    const contactos: any[] = Array.isArray(colectivo.contactos) ? colectivo.contactos : [];
    const contacto = contactos.find((c: any) => c.rolContacto === 'CONTACTO') ?? {};
    const destinatario = contactos.find((c: any) => c.rolContacto === 'DESTINATARIO') ?? {};

    // Guardar IDs para actualizar en vez de crear en modo edición
    if (this.isEditMode) {
      this._idContactoEdicion = (contacto as any).idContacto ?? null;
      this._idDestinatarioEdicion = (destinatario as any).idContacto ?? null;
    }

    this.formColectivo.patchValue({
      nit: nit || null,
      colectivoNombre: colectivo.nombreEmpresa ?? null,
      clienteActual: snToRadio(colectivo.esClienteActual),
      usuariosCotizar: colectivo.usuariosACotizar != null ? String(colectivo.usuariosACotizar) : null,
      usuariosMayor60: colectivo.usuariosMayores60 != null ? String(colectivo.usuariosMayores60) : null,
      embarazosCurso: colectivo.embarazosEnCurso != null ? String(colectivo.embarazosEnCurso) : null,
      derechoAsubsidio: snToRadio(colectivo.tieneSubsidio),
      porcentajeSubsidio: pctToRadio(colectivo.porcentajeSubsidio),
      // Datos de contacto extraídos del array contactos[]
      NombreContacto: contacto.nombre ?? null,
      cargoContacto: contacto.cargo ?? null,
      emailContacto: contacto.email ?? null,
      telefonoContacto: contacto.telefono ?? null,
      NombreDestinatario: destinatario.nombre ?? null,
      cargoDestinatario: destinatario.cargo ?? null,
      emailDestinatario: destinatario.email ?? null,
      telefonoDestinatario: destinatario.telefono ?? null,
      igualAQuienSeDirige: colectivo.igualAQuienSeDirige ?? null,
    }, { emitEvent: false });
    this.actualizarEstadoCamposDestinatario();

    // Recalcular % usuarios > 60 (patchValue con emitEvent:false no dispara valueChanges)
    setTimeout(() => this.actualizarPorcentajeUsuariosMayores(), 0);

    // 5. Departamento → municipio (backend guarda nombre; form usa código; municipio se restaura por nombre en el callback)
    if (colectivo.departamento) {
      const rawDept = (colectivo.departamento || '').toString().trim();
      // Reverse lookup: si backend guardó el nombre, convertir a código
      const deptObj = this.departamentos.find(d => d.codigo === rawDept)
        ?? this.departamentos.find(d => d.nombre?.toUpperCase() === rawDept.toUpperCase());
      const codigoDept = deptObj?.codigo ?? rawDept;
      this.formColectivo.get('departamento')?.setValue(codigoDept, { emitEvent: false });
      this.cargarMunicipiosPorDepartamento(codigoDept, colectivo.municipio);
    }

    // 6. Líneas de negocio: limpiar FormArray, popular y marcar checkboxes DOM
    while (this.lineasNegocio.length) { this.lineasNegocio.removeAt(0); }
    const rawLineas = colectivo.lineasNegocio ?? colectivo.lineasSeleccionadas ?? colectivo.lineaNegocio;
    const lineasSeleccionadas: string[] = (Array.isArray(rawLineas)
      ? rawLineas.map((l: any) => l.toString().trim())
      : (rawLineas ? rawLineas.toString().split(',').map((l: string) => l.trim()) : [])
    ).filter(Boolean);

    lineasSeleccionadas.forEach(linea => {
      this.lineasNegocio.push(new FormControl(linea));
    });

    setTimeout(() => {
      lineasSeleccionadas.forEach(linea => {
        const el = document.getElementById(`linea${linea}`) as HTMLInputElement | null;
        if (el) el.checked = true;
      });
      if (lineasSeleccionadas.length) {
        this.actualizarProgramasPorLineasSeleccionadas();
      }
    }, 0);

    // Guardar lineas pendientes para aplicar checkboxes DOM cuando el tab COLECTIVO se renderice
    this._pendingLineasEdicion = lineasSeleccionadas.length ? [...lineasSeleccionadas] : null;

    // 7. Programas seleccionados en modo edición (se aplican en cargarCarnetsParaProgramas)
    // programasSeleccionados = array completo con todos los programas — fuente primaria
    // programa = código del primer registro (ej: "OPLC") — fuente secundaria / fallback retrocompatibilidad
    if (this.isEditMode) {
      const src = (Array.isArray(colectivo.programasSeleccionados) && colectivo.programasSeleccionados.length)
        ? colectivo.programasSeleccionados
        : colectivo.programa
          ? [colectivo.programa]
          : null;
      if (src?.length) {
        const codigos = src.map((p: any) => p.toString().trim()).filter(Boolean);
        this._pendingProgramasEdicion = codigos;
        // Snapshot de los programas originales para detectar cuáles quita el usuario al guardar.
        this._programasOriginalesEdicion = new Set(codigos.map((c: string) => c.toUpperCase()));
      }

      // 7.1 Restaurar selección de anexos por programa desde colectivo.productos
      // (anexos === 1 → SI). Los programas sin anexo no llegan a la sección, por lo
      // que no se restauran. La aplicación es diferida vía _pendingAnexosEdicion.
      const productos: CotizacionColectivoProducto[] = Array.isArray(colectivo.productos)
        ? colectivo.productos
        : [];
      const codigosConAnexo = productos
        .filter((producto) => Number(producto?.anexos) === 1)
        .map((producto) => (producto?.programa ?? '').toString().trim().toUpperCase())
        .filter((codigo): codigo is string => !!codigo);
      this._pendingAnexosEdicion = codigosConAnexo.length ? new Set(codigosConAnexo) : null;
    }

    // 8. Restaurar líneas bloqueadas (backend manda "1" o "1,2" como string)
    if (colectivo.lineasBloqueadas) {
      const bloq = colectivo.lineasBloqueadas.toString().split(',').map((v: string) => v.trim()).filter(Boolean);
      this.lineasNegocioBloqueadas = new Set(bloq);
    }

    // 9. Obtener cuenta colectivo para habilitar los anexos (no llama buscarEmpresa para
    //    evitar sobrescribir campos ni disparar advertencias de cotización activa)
    if (nit) {
      this.obtenerCuentaColectivo(nit);
    }

    // 10. Marcar como guardado para no mostrar alerta "sin guardar" al navegar entre pestañas
    setTimeout(() => {
      this.colectivoFormSaved = true;
      this.formColectivo.markAsPristine();
      // Prefill terminado: reactivar la detección de edición real del usuario.
      this._prefillColectivoEnCurso = false;
    }, 50);

    // 11. Asignar cotizacionColectivoActual en edición para que obtenerIdCotizacionDesdeStorage()
    //     devuelva el idCotizacion correcto al guardar la liquidación colectiva
    if (this.isEditMode && this.idCotizacionEdicion) {
      this.asignarCotizacionColectivoActual({
        ...colectivo,
        idCotizacion: this.idCotizacionEdicion,
      } as CotizacionColectivo);
    }
  }

  /**
   * Carga la lista de versiones de la cotización en edición
   */
  cargarVersiones(idCotizacion: number): void {
    this.networkingMisCot.getVersionesCotizacion(idCotizacion).subscribe({
      next: (response) => {
        this.versiones = response.data ?? [];
        if (this.versiones.length > 0) {
          this.selectedVersion = this.versiones[0]; // la más reciente (API retorna ordenado)
          console.log('✅ Versiones cargadas:', this.versiones, '— seleccionada:', this.selectedVersion);
        }
      },
      error: (err) => {
        console.warn('⚠️ No se pudieron cargar las versiones de la cotización:', err);
      }
    });
  }

  /**
   * Al cambiar la versión en el dropdown, recarga los datos del formulario
   */
  onVersionChange(version: CotizacionVersion): void {
    if (!this.idCotizacionEdicion) return;
    const versionChangeSeq = ++this._versionChangeSeq;
    this.selectedVersion = version;
    this.spinner.show();

    // Limpiar estado de programas/tarifas de la versión anterior antes de cargar la nueva
    this.programasSeleccionadosUI.clear();
    this.tarifasColectivoPorPrograma = {};
    this.resumenCotizacionColectivoData = [];
    this._pendingProgramasEdicion = null;
    this._pendingAnexosEdicion = null;
    this._programasOriginalesEdicion = null;
    // Limpiar pendientes de regional/oficina para evitar que valores residuales
    // de la versión anterior interfieran con la nueva (fix: pending huérfano)
    this._pendingRegionalEdicion = null;
    this._pendingOficinaEdicion = null;

    // Si el usuario vuelve a la versión más reciente, usar el estado live (del init)
    // en lugar del snapshot que puede estar desactualizado respecto a cambios posteriores.
    const esLatest = this.versiones.length > 0 && version.idVersion === this.versiones[0].idVersion;
    if (esLatest && this._cotizacionEdicionDataLatest) {
      this.spinner.hide();
      this.cotizacionEdicionData = this._cotizacionEdicionDataLatest;
      this.prefillFormInit(this._cotizacionEdicionDataLatest);
      this._omitirSiguienteSyncContratanteBeneficiario = true;
      this._requiereRefreshBeneficiariosLatest = !this.esNuevoColectivo;
      this.mantenerTabActual(0);
      this.refrescarBeneficiariosUltimaVersionDesdeEdit();
      console.log('✅ Versión', version.numeroVersion, 'restaurada desde estado live (sin HTTP)');
      return;
    }

    this.networkingMisCot.getVersionById(this.idCotizacionEdicion, version.idVersion).subscribe({
      next: (response) => {
        this.spinner.hide(); // ocultar antes de prefillFormInit para evitar loading infinito si lanza excepción
        if (versionChangeSeq !== this._versionChangeSeq || this.selectedVersion?.idVersion !== version.idVersion) {
          return;
        }
        this.cotizacionEdicionData = response.data;
        this.prefillFormInit(response.data);
        this.mantenerTabActual(0);
        console.log('✅ Versión', version.numeroVersion, 'cargada');
      },
      error: (err) => {
        if (versionChangeSeq !== this._versionChangeSeq || this.selectedVersion?.idVersion !== version.idVersion) {
          return;
        }
        this.spinner.hide();
        console.error('❌ Error al cargar la versión:', err);
      }
    });
  }

  /**
   * Función de comparación para mat-select de versiones
   */
  compareVersiones(v1: CotizacionVersion, v2: CotizacionVersion): boolean {
    return v1 && v2 && v1.idVersion === v2.idVersion;
  }

  onVersionCreadaCotizacion(idCotizacion: number): void {
    if (!idCotizacion) {
      return;
    }

    this.cotizacionIndividualModificada = false;
    this.idCotizacionEdicion = idCotizacion;
    this.cargarVersiones(idCotizacion);

    if (this.isEditMode) {
      this.refreshBeneficiarios();
    }
  }

  private marcarCotizacionIndividualModificada(): void {
    if (
      this.isEditMode &&
      this.esVersionMasReciente &&
      !this.esNuevoColectivo
    ) {
      this.cotizacionIndividualModificada = true;

      console.log(
        '[VERSIONAMIENTO] Cotización individual marcada como modificada'
      );
    }
  }

  /**
   * Carga los beneficiarios desde `cotizacionEdicionData` y los distribuye en la tabla,
   * filtrando según `versionFiltroBeneficiarios` si hay un filtro activo.
   */
  cargarBeneficiariosDesdeEdicion(): void {
    const renderizar = () => {
      if (!this.cotizacionEdicionData?.beneficiarios?.length) {
        this.todosLosBeneficiariosEdicion = [];
        this.datasBeneficiary = [];
        this.updateTableBeneficiary();
        this._reaplicarTitularTrasCargaEdicion = false;
        return;
      }
      const unicos = new Map<string, BeneficiarioEdicionItem>();
      const keyPrograma = (p: any): string => {
        const idBenProg = Number(p?.idBenPrograma ?? p?.idBenProgramaCotizacion ?? 0);
        if (idBenProg > 0) return `idBenPrograma:${idBenProg}`;
        const programa = (p?.programa ?? p?.id ?? '').toString().trim().toUpperCase();
        const linea = (p?.lineaNegocio ?? p?.linea_negocio ?? '').toString().trim().toUpperCase();
        const subcta = (p?.subcta ?? p?.codigoSubcuenta ?? p?.subcuenta ?? '').toString().trim().toUpperCase();
        return `${programa}|${linea}|${subcta}`;
      };

      (this.cotizacionEdicionData.beneficiarios || []).forEach((item: any) => {
        const id = Number(item?.idBeneficiario ?? 0);
        const clave = id > 0
          ? `id:${id}`
          : `doc:${item?.tipoDocumento ?? ''}|${item?.numDocumento ?? ''}|${item?.parentescoId ?? ''}|${item?.primerNombre ?? ''}|${item?.primerApellido ?? ''}`;

        const programasItem = Array.isArray(item?.programas) ? item.programas : [];

        if (!unicos.has(clave)) {
          unicos.set(clave, {
            ...(item as any),
            programas: [...programasItem]
          } as any);
          return;
        }

        const existente: any = unicos.get(clave) as any;
        const programasExistentes = Array.isArray(existente?.programas) ? existente.programas : [];
        const mergedByKey = new Map<string, any>();

        programasExistentes.forEach((p: any) => mergedByKey.set(keyPrograma(p), p));
        programasItem.forEach((p: any) => {
          const k = keyPrograma(p);
          const prev = mergedByKey.get(k);
          mergedByKey.set(k, prev ? { ...(prev as any), ...(p as any) } : p);
        });

        unicos.set(clave, {
          ...(existente as any),
          ...(item as any),
          programas: Array.from(mergedByKey.values())
        } as any);
      });

      // el mapa a arreglo y ordenamos antes de asignar
      const listaBeneficiariosOrdenados = Array.from(unicos.values());

      listaBeneficiariosOrdenados.sort((a, b) => {
        const esTitularA = a.parentescoId === 'T' || a.esContratante === 'S' || (a as any).esContratante === true;
        const esTitularB = b.parentescoId === 'T' || b.esContratante === 'S' || (b as any).esContratante === true;
        if (esTitularA && !esTitularB) return -1;
        if (!esTitularA && esTitularB) return 1;
        const idA = a.idBeneficiario ?? 0;
        const idB = b.idBeneficiario ?? 0;
        return idA - idB;
      });

      this.todosLosBeneficiariosEdicion = listaBeneficiariosOrdenados;
      this.aplicarFiltroBeneficiariosPorVersion();
      this.consumirReaplicacionTitularTrasCargaEdicion();
    };
    if (this._parentescosMap.size === 0) {
      this.networkingBeneficiary.consultarParentescos().pipe(take(1)).subscribe({
        next: (resp: any) => {
          try {
            const arr: any[] = Array.isArray(resp) ? resp
              : Array.isArray(resp?.data) ? resp.data
                : [];
            arr.forEach((p: any) => this._parentescosMap.set(String(p.id), String(p.parentesco)));
          } catch (_) { }
          renderizar();
        },
        error: () => {
          this._reaplicarTitularTrasCargaEdicion = false;
        }
      });
    }
    renderizar();
  }

  /**
   * NC 1065: el GET /edit todavía trae los programas viejos del titular.
   * La misma sincronización que al entrar al paso 3 los vuelve a tomar de la sesión.
   */
  private consumirReaplicacionTitularTrasCargaEdicion(): void {
    if (!this._reaplicarTitularTrasCargaEdicion) return;
    this.sincronizarContratanteComoBeneficiario();
    if (this._parentescosMap.size > 0) {
      this._reaplicarTitularTrasCargaEdicion = false;
    }
  }

  /**
   * Aplica el filtro y actualiza la tabla con todos los beneficiarios de edición.
   */
  aplicarFiltroBeneficiariosPorVersion(): void {
    this.datasBeneficiary = this.todosLosBeneficiariosEdicion.map(item => this.mapearBeneficiarioEdicion(item));
    this.updateTableBeneficiary();
  }

  /**
   * Convierte un BeneficiarioEdicionItem en un Beneficiarios compatible con la tabla.
   */
  mapearBeneficiarioEdicion(item: BeneficiarioEdicionItem): any {
    const b = new BeneficiariosModel();
    // Intentar restaurar el idBeneficiario desde el mapa si el backend devuelve 0 o null
    const idFromMap = this.getBeneficiarioIdFromMap(item);
    const resolvedBenId = (item.idBeneficiario && item.idBeneficiario > 0)
      ? item.idBeneficiario
      : idFromMap;
    // Si el backend trajo un id válido, actualizar el mapa
    if (item.idBeneficiario && item.idBeneficiario > 0) {
      this.rememberBeneficiarioId(item, item.idBeneficiario);
    }
    b.id_beneficiario = resolvedBenId > 0 ? resolvedBenId : undefined;
    b.es_contratante = item.esContratante === 'S';
    b.parentesco_id = item.parentescoId?.toString() ?? '';
    b.tipo_documento = item.tipoDocumento ?? '';
    b.num_documento = item.numDocumento ?? '';
    b.primer_nombre = item.primerNombre ?? '';
    b.segundo_nombre = item.segundoNombre ?? '';
    b.primer_apellido = item.primerApellido ?? '';
    b.segundo_apellido = item.segundoApellido ?? '';
    b.genero = item.genero ?? '';
    b.fecha_nacimiento = item.fechaNacimiento ?? (item as any)?.fecha_nacimiento ?? '';
    (b as any).fechaNacimiento = b.fecha_nacimiento;
    b.edad = item.edad?.toString() ?? '';
    b.position = item.idBeneficiario ?? 0;
    b.typeDescripcion = this._parentescosMap.get(item.parentescoId?.toString() ?? '') ?? item.parentescoId?.toString() ?? '';
    (b as any)._edicionItem = item;
    // Columna NOMBRE del HTML usa element.name
    (b as any).name = item.primerNombre ?? '';
    // Construir programasConfig para que updateTableBeneficiary() FORMAT 1
    // genere una fila por cada programa del beneficiario
    const programasEdicion = this.obtenerProgramasBeneficiarioEdicion(item);
    if (programasEdicion.length > 0) {
      const normalizarRequiereAnexo = (value: any): 'si' | 'no' | null => {
        const v = (value ?? '').toString().trim().toUpperCase();
        if (value === true || v === 'SI' || v === 'S' || v === 'TRUE' || v === '1') return 'si';
        if (value === false || v === 'NO' || v === 'N' || v === 'FALSE' || v === '0') return 'no';
        return null;
      };

      (b as any).programasConfig = {
        lineasSeleccionadas: [],
        programas: programasEdicion.map((p: any) => {
          const tarifas: any[] = Array.isArray(p.tarifas) ? p.tarifas : [];
          const campanias: any[] = Array.isArray(p.campanias) ? p.campanias : [];
          const tarifaBase = tarifas.find((t: any) => t.esAnexo === false || t.esAnexo == null && tarifas.length === 1)
            ?? tarifas.find((t: any) => !t.esAnexo);
          const tarifaAnexoRec = tarifas.find((t: any) => t.esAnexo === true);
          const campaniaSel = campanias.find((c: any) => c.fueSeleccionada !== false) ?? campanias[0] ?? null;
          const codigoPrograma = this.leerCampoProgramaEdicion(p, [
            'programa',
            'id',
            'code',
            'codigo',
            'codigoPrograma',
            'codigo_programa',
            'cod_programa',
            'codPrograma',
            'planCodigo',
            'plan_codigo',
            'planCodi',
            'plan_codi',
            'plan',
            'codProgramaAfi',
            'cod_programa_afi',
            'programaCol',
            'grupoProgramaCol',
            'codigo_programa_grupo',
          ]);
          const nombrePrograma = this.leerCampoProgramaEdicion(p, [
            'nombrePrograma',
            'nombre_programa',
            'nombre',
            'program',
            'descripcion',
            'descripcionPrograma',
            'descripcion_programa',
            'programaNombre',
            'programa_nombre',
            'programa_afi',
            'programaGrupo',
            'programa_grupo',
          ]) || codigoPrograma;
          const lineaNegocio = this.normalizarLineaNegocioBeneficiarioEdicion(
            this.leerCampoProgramaEdicion(p, [
              'lineaNegocio',
              'linea_negocio',
              'lineaNegocioNombre',
              'linea_negocio_nombre',
              'linea',
              'lineOfBusiness',
              'lineaNego',
              'linea_nego',
              'lineaNegocioCol',
              'codigoLineaNegocio',
              'codigo_linea_negocio',
              'codLineaNegocio',
              'cod_linea_negocio',
            ])
          );

          // NC 1050: edit trae subcuentas aparte (item.subcuentas + planCodi), no dentro del programa.
          // Sin este cruce, programas con varias opciones (p.ej. DECE) quedan en "Seleccione".
          const subcuentaEdicion = this.resolverSubcuentaEdicionPorPrograma(item, codigoPrograma);
          const subctaCode = (
            p.subcta ?? p.codigoSubcuenta ?? subcuentaEdicion?.subcta ?? ''
          ).toString().trim();
          const nombreSubcuenta = (
            p.nombreSubcuenta ?? p.subcuenta ?? subcuentaEdicion?.nombreSubcuenta ?? ''
          ).toString().trim();
          // Preferir código numérico en `subcuenta` para que el modal matchee por subcta
          // aunque el nombre BD no coincida con el deno del catálogo.
          const subcuentaUi = subctaCode || nombreSubcuenta || null;
          const idSubcuentaResuelto = Number(
            p.idSubcuenta ?? p.id_subcuenta ?? p.idBenSubcuenta ?? p.id_ben_subcuenta
            ?? subcuentaEdicion?.idSubcuenta ?? 0
          ) || null;

          const codTarifaAnexoBen = (tarifaAnexoRec?.tari ?? p.anexoCodigo ?? p.tarifaAnexo ?? '').toString().trim();
          const anexoCodigoBen = (
            p.anexoCodigo
            || tarifaAnexoRec?.clave
            || tarifaAnexoRec?.plan_codi_adi
            || tarifaAnexoRec?.planCod2
            || codTarifaAnexoBen
          ).toString().trim();

          return {
            id: codigoPrograma,
            programa: codigoPrograma,
            idBenPrograma: p.idBenPrograma ?? p.idBenProgramaCotizacion ?? null,
            __idBenPrograma: p.idBenPrograma ?? p.idBenProgramaCotizacion ?? null,
            idSubcuenta: idSubcuentaResuelto,
            __idSubcuenta: idSubcuentaResuelto,
            idCotizacionTarifa: tarifaBase?.idCotizacionTarifa ?? p.idCotizacionTarifa ?? p.id_cotizacion_tarifa ?? null,
            __idCotizacionTarifa: tarifaBase?.idCotizacionTarifa ?? p.idCotizacionTarifa ?? p.id_cotizacion_tarifa ?? null,
            idCotizacionTarifaAnexo: tarifaAnexoRec?.idCotizacionTarifa ?? p.idCotizacionTarifaAnexo ?? p.id_cotizacion_tarifa_anexo ?? null,
            __idCotizacionTarifaAnexo: tarifaAnexoRec?.idCotizacionTarifa ?? p.idCotizacionTarifaAnexo ?? p.id_cotizacion_tarifa_anexo ?? null,
            idCotizacionCampania: campaniaSel?.idCotizacionCampania ?? p.idCotizacionCampania ?? p.id_cotizacion_campania ?? null,
            __idCotizacionCampania: campaniaSel?.idCotizacionCampania ?? p.idCotizacionCampania ?? p.id_cotizacion_campania ?? null,
            nombre: nombrePrograma,
            tarifa: tarifaBase?.tari ?? p.tarifa ?? p.codTarifa ?? '',
            campana: campaniaSel?.codCampComercial ?? p.codCampComercial ?? p.campania ?? p.campana ?? '',
            // NC 1078: no usar p.esAnexo (programa). Si hay tarifa/código anexo → 'si'.
            requiereAnexo: (tarifaAnexoRec || anexoCodigoBen || codTarifaAnexoBen)
              ? 'si'
              : (normalizarRequiereAnexo(p.requiereAnexo) ?? null),
            tarifaAnexo: codTarifaAnexoBen,
            anexoCodigo: anexoCodigoBen,
            subcuenta: subcuentaUi,
            nombreSubcuenta: nombreSubcuenta || subctaCode || null,
            subcta: subctaCode || null,
            // Candidatos por si BD dejó filas huérfanas del mismo plan (probar match en modal).
            __subctaCandidates: subcuentaEdicion?.candidates ?? (subctaCode ? [subctaCode] : []),
            lineaNegocio,
          };
        })
      };
    }
    return b;
  }

  /**
   * Une subcuentas del DTO de edición (lista aparte) al programa por planCodi.
   * Si hay varias filas del mismo programa, prioriza la de mayor idSubcuenta (última persistida)
   * y expone el resto como candidates para el match del modal.
   */
  private resolverSubcuentaEdicionPorPrograma(
    item: BeneficiarioEdicionItem,
    codigoPrograma: string
  ): {
    idSubcuenta: number;
    subcta: string;
    nombreSubcuenta: string;
    candidates: string[];
  } | null {
    const plan = (codigoPrograma || '').toString().trim().toUpperCase();
    if (!plan) {
      return null;
    }

    const list = Array.isArray(item?.subcuentas) ? item.subcuentas : [];
    const matches = list
      .map((s: any) => ({
        idSubcuenta: Number(s?.idSubcuenta ?? s?.id_subcuenta ?? 0) || 0,
        subcta: (s?.subcta ?? s?.codigoSubcuenta ?? '').toString().trim(),
        nombreSubcuenta: (
          s?.nombreSubcuenta ?? s?.nombre_subcuenta ?? s?.subcuenta ?? ''
        ).toString().trim(),
        planCodi: (
          s?.planCodi ?? s?.plan_codi ?? s?.programa ?? ''
        ).toString().trim().toUpperCase(),
      }))
      .filter((s) => s.planCodi === plan && (!!s.subcta || !!s.nombreSubcuenta));

    if (!matches.length) {
      return null;
    }

    matches.sort((a, b) => a.idSubcuenta - b.idSubcuenta);
    const latest = matches[matches.length - 1];
    // newest first, then older — modal prueba hasta hallar una en el catálogo filtrado
    const candidates = [...matches]
      .reverse()
      .flatMap((m) => [m.subcta, m.nombreSubcuenta])
      .map((v) => (v || '').toString().trim())
      .filter(Boolean)
      .filter((v, idx, arr) => arr.findIndex((x) => x.toUpperCase() === v.toUpperCase()) === idx);

    return {
      idSubcuenta: latest.idSubcuenta,
      subcta: latest.subcta,
      nombreSubcuenta: latest.nombreSubcuenta,
      candidates,
    };
  }

  private obtenerProgramasBeneficiarioEdicion(item: BeneficiarioEdicionItem): any[] {
    const programas = Array.isArray(item.programas) ? item.programas : [];
    if (programas.length > 0) {
      return programas;
    }

    const itemAny = item as any;
    const codigoPrograma = this.leerCampoProgramaEdicion(itemAny, [
      'programa',
      'id',
      'code',
      'codigo',
      'codigoPrograma',
      'codigo_programa',
      'cod_programa',
      'codPrograma',
      'planCodigo',
      'plan_codigo',
      'planCodi',
      'plan_codi',
      'plan',
      'codProgramaAfi',
      'cod_programa_afi',
      'programaCol',
      'grupoProgramaCol',
      'codigo_programa_grupo',
    ]);
    const nombrePrograma = this.leerCampoProgramaEdicion(itemAny, [
      'nombrePrograma',
      'nombre_programa',
      'nombre',
      'program',
      'descripcion',
      'descripcionPrograma',
      'descripcion_programa',
      'programaNombre',
      'programa_nombre',
      'programa_afi',
      'programaGrupo',
      'programa_grupo',
    ]);
    const lineaNegocio = this.leerCampoProgramaEdicion(itemAny, [
      'lineaNegocio',
      'linea_negocio',
      'lineaNegocioNombre',
      'linea_negocio_nombre',
      'linea',
      'lineOfBusiness',
      'lineaNego',
      'linea_nego',
      'lineaNegocioCol',
      'codigoLineaNegocio',
      'codigo_linea_negocio',
      'codLineaNegocio',
      'cod_linea_negocio',
    ]);

    if (!codigoPrograma && !nombrePrograma && !lineaNegocio) {
      return [];
    }

    return [{
      ...itemAny,
      programa: codigoPrograma,
      nombrePrograma,
      lineaNegocio,
    }];
  }

  private leerCampoProgramaEdicion(source: any, campos: string[]): string {
    if (!source || typeof source !== 'object') {
      return '';
    }

    const keysByLower = new Map<string, string>();
    Object.keys(source).forEach((key) => keysByLower.set(key.toLowerCase(), key));

    for (const campo of campos) {
      const key = keysByLower.get(campo.toLowerCase()) ?? campo;
      const value = source?.[key];
      if (value != null && value !== '') {
        return value.toString().trim();
      }
    }
    return '';
  }

  private normalizarLineaNegocioBeneficiarioEdicion(value: unknown): string {
    const v = (value ?? '').toString().trim().toUpperCase();
    if (!v) return '';
    if (v === '1' || v === 'MI' || v === 'SMP' || v.includes('MEDICINA')) return 'MI';
    if (v === '2' || v === 'SO' || v === 'SAO' || v.includes('SALUD ORAL') || v.includes('DENTAL')) return 'SO';
    if (v === '3' || v === 'CEM' || v.includes('EMERGENCIA')) return 'CEM';
    return v;
  }

  /**
   * Recarga la lista de beneficiarios desde la API (después de guardar/editar
   * un beneficiario en modo edición). Usa GET /edit, NO re-llama a POST iniciar-edicion.
   */
  refreshBeneficiarios(reaplicarTitularDeSesion = false): void {
    if (!this.idCotizacionEdicion) return;
    this._reaplicarTitularTrasCargaEdicion = reaplicarTitularDeSesion;
    this.networkingMisCot.refreshBeneficiariosEdicion(this.idCotizacionEdicion).subscribe({
      next: (response) => {
        if (response.data) {
          this.cotizacionEdicionData = response.data;
          this._cotizacionEdicionDataLatest = response.data;
          this._requiereRefreshBeneficiariosLatest = false;
          this.cargarBeneficiariosDesdeEdicion();
          if (reaplicarTitularDeSesion) {
            this.sincronizarContratanteComoBeneficiario();
          }
        } else {
          this._reaplicarTitularTrasCargaEdicion = false;
        }
        this.invocarRecargaResumenCotizacion();
      },
      error: (err) => {
        this._reaplicarTitularTrasCargaEdicion = false;
        console.warn(' No se pudo refrescar la lista de beneficiarios:', err);
        this.invocarRecargaResumenCotizacion();
      }
    });
  }

  /**
   * Al mostrar la pestaña COTIZACIÓN (flujo individual): GET /edit y repintar resumen RQ005.
   */
  private refrescarBeneficiariosUltimaVersionDesdeEdit(callback?: () => void): void {
    if (!this.isEditMode || !this.idCotizacionEdicion || !this.esVersionMasReciente) {
      callback?.();
      return;
    }

    this.networkingMisCot.refreshBeneficiariosEdicion(this.idCotizacionEdicion).pipe(take(1)).subscribe({
      next: (response) => {
        if (response.data && this.esVersionMasReciente) {
          this.cotizacionEdicionData = response.data;
          this._cotizacionEdicionDataLatest = response.data;
          this._requiereRefreshBeneficiariosLatest = false;
          this.cargarBeneficiariosDesdeEdicion();
        }
        callback?.();
      },
      error: (err) => {
        console.warn('No se pudo refrescar beneficiarios de la ultima version:', err);
        callback?.();
      }
    });
  }

  private refrescarAlEntrarTabCotizacionIndividual(): void {
    if (this.isEditMode && !this.esVersionMasReciente) {
      return;
    }

    const cargar = () => this.cargarResumenAlEntrarTabCotizacionIndividual();
    const tipoCargado = (this.cotizacionEdicionData?.idTipoSolicitud ?? '').toString().trim();
    const esInclusionCargada = tipoCargado === '2'
      || (!tipoCargado && (this.esInclusion || localStorage.getItem('tipoSolicitud') === '2'));
    // Antes de leer la cotización, los programas que se ven del titular se agregan
    // o se quitan en base. Si no, el resumen no muestra a esa persona.
    if (this.isEditMode && this.esVersionMasReciente && !esInclusionCargada) {
      void this.asegurarProgramasTitularVisiblesEnEdicion().finally(cargar);
      return;
    }
    cargar();
  }

  private cargarResumenAlEntrarTabCotizacionIndividual(): void {
    if (this.isEditMode && this.idCotizacionEdicion && this.esVersionMasReciente) {
      this.networkingMisCot.refreshBeneficiariosEdicion(this.idCotizacionEdicion).subscribe({
        next: (response) => {
          if (response.data) {
            this.cotizacionEdicionData = response.data;
            this._cotizacionEdicionDataLatest = response.data;
            this._requiereRefreshBeneficiariosLatest = false;
            this.cargarBeneficiariosDesdeEdicion();
          }
          this.invocarRecargaResumenCotizacion();
        },
        error: () => this.invocarRecargaResumenCotizacion()
      });
      return;
    }
    this.invocarRecargaResumenCotizacion();
  }

  private invocarRecargaResumenCotizacion(): void {
    if (this.isEditMode && !this.esVersionMasReciente) {
      return;
    }

    if (this.isEditMode && !this.esNuevoColectivo && this.esVersionMasReciente) {
      this.spinnerUltimaPantallaActivo = true;
      this.spinner.show();
    }

    setTimeout(() => {
      if (this.cotizadorCotizacionComponent) {
        this.cotizadorCotizacionComponent.recargarResumenDesdeEdit();
      }
    }, 50);
  }

  private formatearSector(item: any): any {
    const codigo = Number(item.sector);
    const denoMayuscula = (item.deno || '').toString().trim().toUpperCase();

    let seccion = '';

    if (codigo >= 10 && codigo <= 33) seccion = 'SECCIÓN A';
    else if (codigo >= 50 && codigo <= 99) seccion = 'SECCIÓN B';
    else if (codigo >= 100 && codigo <= 329) seccion = 'SECCIÓN C';
    else if (codigo >= 350 && codigo <= 352) seccion = 'SECCIÓN D';
    else if (codigo >= 360 && codigo <= 390) seccion = 'SECCIÓN E';
    else if (codigo >= 410 && codigo <= 439) seccion = 'SECCIÓN F';
    else if (codigo >= 450 && codigo <= 479) seccion = 'SECCIÓN G';
    else if (codigo >= 490 && codigo <= 532) seccion = 'SECCIÓN H';
    else if (codigo >= 551 && codigo <= 563) seccion = 'SECCIÓN I';
    else if (codigo >= 580 && codigo <= 639) seccion = 'SECCIÓN J';
    else if (codigo >= 640 && codigo <= 663) seccion = 'SECCIÓN K';
    else if (codigo >= 681 && codigo <= 682) seccion = 'SECCIÓN L';
    else if (codigo >= 690 && codigo <= 750) seccion = 'SECCIÓN M';
    else if (codigo >= 770 && codigo <= 829) seccion = 'SECCIÓN N';
    else if (codigo >= 841 && codigo <= 843) seccion = 'SECCIÓN O';
    else if (codigo >= 850 && codigo <= 856) seccion = 'SECCIÓN P';
    else if (codigo >= 861 && codigo <= 889) seccion = 'SECCIÓN Q';
    else if (codigo >= 900 && codigo <= 932) seccion = 'SECCIÓN R';
    else if (codigo >= 941 && codigo <= 960) seccion = 'SECCIÓN S';
    else if (codigo >= 970 && codigo <= 982) seccion = 'SECCIÓN T';
    else if (codigo >= 990 && codigo <= 999) seccion = 'SECCIÓN U';

    return {
      ...item,
      denoMostrar: seccion ? `${seccion} - ${denoMayuscula}` : denoMayuscula,
    };
  }

  filtrarSectores(valor: string) {
    if (!valor) {
      this.sectoresFiltrados = this.sectores;
      return;
    }

    const filtro = valor.toLowerCase();

    this.sectoresFiltrados = this.sectores.filter((item: any) =>
      item.deno?.toLowerCase().includes(filtro) ||
      item.denoMostrar?.toLowerCase().includes(filtro)
    );
  }

  // private obtenerSectorPorCodigo(codigoSector: string): sectoresCIIU | undefined {
  //   const codigoNormalizado = (codigoSector || "").trim();
  //   if (!codigoNormalizado) {
  //     return undefined;
  //   }

  //   const coincidenciaExacta = this.sectores.find(
  //     (item) => (item.sector || "").trim() === codigoNormalizado
  //   );
  //   if (coincidenciaExacta) {
  //     return coincidenciaExacta;
  //   }

  //   return this.sectores.find((item) => {
  //     const sectorItem = (item.sector || "").trim();
  //     if (!sectorItem) {
  //       return false;
  //     }
  //     return (
  //       codigoNormalizado.startsWith(sectorItem) ||
  //       sectorItem.startsWith(codigoNormalizado)
  //     );
  //   });
  // }

  private aplicarSectorGuardado(): void {
    if (!this.formColectivo) {
      return;
    }
    const sectorControl = this.formColectivo.get("sector");
    if (!sectorControl || !this.ultimoSectorEmpresa) {
      return;
    }

    // const sectorEncontrado = this.obtenerSectorPorCodigo(
    //   this.ultimoSectorEmpresa,
    // );

    // if (sectorEncontrado) {
    //   const sectorValor = sectorEncontrado.sector?.trim();
    //   if (!sectorValor) {
    //     return;
    //   }
    //   const sectorActual = (sectorControl.value || "").toString().trim();
    //   if (sectorActual !== sectorValor) {
    //     sectorControl.setValue(sectorValor, { emitEvent: false });
    //   }
    // }
  }

  get lineasNegocio(): FormArray {
    return this.formColectivo.get('lineaNegocio') as FormArray;
  }

  private cargarMunicipiosPorDepartamento(
    departamento: string,
    municipioSeleccionado?: string
  ): void {
    const municipioControl = this.formColectivo.get("municipio");
    municipioControl?.setValue(null);
    this.municipios = [];

    const codigoDepartamento = (departamento || "").toString().trim();
    if (!codigoDepartamento) {
      return;
    }

    this.networking.municipiosxDepartamento(codigoDepartamento).subscribe({
      next: (data) => {
        this.municipios = data
          .map((m: any) => ({
            codigo: m.codigo,
            municipio: m.municipio.split("-")[0].trim(),
          }))
          .sort((a: any, b: any) => a.municipio.localeCompare(b.municipio));

        const municipioCandidato = (municipioSeleccionado || "").trim();
        if (municipioCandidato) {
          const byCode = this.municipios.find((item) => item.codigo === municipioCandidato);
          if (byCode) {
            municipioControl?.setValue(byCode.codigo);
          } else {
            // Fallback: comparar por nombre (backend guarda el nombre del municipio)
            const byName = this.municipios.find((item) =>
              item.municipio?.toUpperCase() === municipioCandidato.toUpperCase());
            if (byName) {
              municipioControl?.setValue(byName.codigo);
            }
          }
        }
      },
      error: (err) => console.error(err),
    });
  }

  private readonly tiposAsesorPermitidosPorCanal: Record<string, any[]> = {
    INTERNO: [
      { nombreServicio: 'CALL CENTER', nombreMostrar: 'Call center' },
      { nombreServicio: 'EJECUTIVO AFILIACION MI', nombreMostrar: 'Ejecutivo Afiliación MI' },
      { nombreServicio: 'EJECUTIVO AFILIACION SAO', nombreMostrar: 'Ejecutivo Afiliación SAO' },
      { nombreServicio: 'EJECUTIVO AFILIACION CEM', nombreMostrar: 'Ejecutivo Afiliación CEM' },
      { nombreServicio: 'EJECUTIVO PROFUNDIZACION', nombreMostrar: 'Profundización' },
      { nombreServicio: 'AGENTE COMERCIAL MI', nombreMostrar: 'Agente Comercial MI' },
      { nombreServicio: 'AGENTE COMERCIAL SAO', nombreMostrar: 'Agente Comercial SAO' },
      { nombreServicio: 'AGENTE COMERCIAL CEM', nombreMostrar: 'Agente Comercial CEM' },
    ],
    EXTERNO: [
      { nombreServicio: 'CORREDOR COMERCIAL', nombreMostrar: 'Corredor Comercial' },
      { nombreServicio: 'AGENCIA MERCANTIL', nombreMostrar: 'Agencia Mercantil' },
      { nombreServicio: 'BROKER', nombreMostrar: 'Broker' },
    ],
  };

  filtrarTipos(canalSeleccionado: string): void {
    const canal = (canalSeleccionado || '').toString().trim().toUpperCase();

    const nombresPermitidos =
      this.tiposAsesorPermitidosPorCanal[canal] || [];

    this.tiposFiltrados = this.tiposDeAsesor
      .map((tipoServicio: any) => {
        const nombreTipoServicio = this.normalizarTextoTipoAsesor(tipoServicio.nombre);

        const tipoPermitido = nombresPermitidos.find((permitido: any) =>
          this.normalizarTextoTipoAsesor(permitido.nombreServicio) === nombreTipoServicio
        );

        if (!tipoPermitido) {
          return null;
        }

        return {
          ...tipoServicio,
          nombreMostrar: tipoPermitido.nombreMostrar,
        };
      })
      .filter((item: any) => item !== null);

    this.formColectivo.get('tipoAsesor')?.reset();
  }

  private normalizarTextoTipoAsesor(valor: any): string {
    return (valor ?? '')
      .toString()
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private tabRestoreTimeout: ReturnType<typeof setTimeout> | null = null;
  /** Cancela la petición HTTP de cotización en-vuelo al disparar una nueva o al destruir el componente. */
  private readonly cotizadorCancel$ = new Subject<void>();
  /** Bloquea la navegación entre tabs mientras la carga inicial de edición no termina. */
  private _cargaInicialPendiente = false;

  /**
   * Fija el índice del tab por código. Angular Material vuelve a emitir
   * (selectedTabChange) cuando esto cambia el tab activo; ese eco es inofensivo
   * porque tabOption() lo corta con el guard `nextIndex === currentIndex`.
   *
   * REGLA CLAVE: nunca setear el índice a dos valores distintos dentro de un mismo
   * flujo síncrono de tabOption(). Eso generaba dos ecos diferidos que llegaban
   * desordenados respecto al estado y producían un bucle infinito (visible al
   * cambiar a una versión histórica), disparando peticiones HTTP repetidas.
   */
  private mantenerTabActual(index: number): void {
    this.selectedIndex = index;
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = index;
    }
  }

  private cancelarRestoreTab(): void {
    if (this.tabRestoreTimeout !== null) {
      clearTimeout(this.tabRestoreTimeout);
      this.tabRestoreTimeout = null;
    }
  }

  onBloqueoNavegacionCotizacion(bloquear: boolean): void {
    this.bloqueoTabsPorGuardadoCotizacion = !!bloquear;
  }

  onCargaInicialCotizacionChange(cargando: boolean): void {
    if (cargando) {
      if (this.selectedIndex !== 3 && !this.spinnerUltimaPantallaActivo) {
        return;
      }
      this.spinnerUltimaPantallaActivo = true;
      this.spinner.show();
    } else if (this.spinnerUltimaPantallaActivo) {
      this.spinnerUltimaPantallaActivo = false;
      this.spinner.hide();
    }
  }

  /** Metodo para evaluar la traza en la navegaicon del cotizador */
  tabOption(event: any, option: any) {
    this.idCollapse = [];

    const currentIndex = this.selectedIndex;
    const nextIndex = event ? event.index : parseInt(option);
    if (isNaN(nextIndex)) return;

    if (this.bloqueoTabsPorGuardadoCotizacion && nextIndex !== currentIndex) {
      this.mantenerTabActual(currentIndex);
      this.SnackBarService.alert(
        'alert-info',
        'La cotización ya fue guardada. Para continuar use ENVIAR COTIZACIÓN o SALIR.',
        7000,
      );
      return;
    }

    // Bloquear navegación mientras los servicios de carga inicial (edit mode) no han terminado
    if (this._cargaInicialPendiente && nextIndex > currentIndex) {
      this.mantenerTabActual(currentIndex);
      this.SnackBarService.alert('alert-info', 'Cargando datos de la cotización, por favor espera un momento...');
      return;
    }

    // Eco de (selectedTabChange) por un cambio programático: ya estamos sincronizados.
    if (nextIndex === currentIndex) return;

    // No permitir saltar más de un paso adelante.
    if (nextIndex > this.maxStepReached + 1) {
      this.mantenerTabActual(this.maxStepReached);
      return;
    }

    // ¿Confirmar salida sin guardar? Revertir el tab mientras el usuario decide.
    // Sólo aquí revertimos el índice; si NO hay confirmación vamos directo a
    // executeTabOption para no setear el índice dos veces (evita el bucle).
    if (this.shouldConfirmExitColectivo(currentIndex)) {
      this.mantenerTabActual(currentIndex);
      this.confirmarSalidaSinGuardar(nextIndex, "colectivo");
      return;
    }

    if (this.shouldConfirmExitCotizacion(currentIndex)) {
      this.mantenerTabActual(currentIndex);
      this.confirmarSalidaSinGuardar(nextIndex, "cotizacion");
      return;
    }

    this.executeTabOption(nextIndex);
  }

  private executeTabOption(nextIndex: number) {
    this.cancelarRestoreTab();
    if (this.esNuevoColectivo) {
      switch (nextIndex) {
        case 0:
          this.selectedIndex = 0;
          localStorage.removeItem('contrato_radicado');
          return;
        case 1:
          this.selectedIndex = 1;

          if (!this.esModalColectivoConfirmado) {
            console.log('[COLECTIVO-DEBUG] [Cotizador] Entrando a tab Colectivo sin confirmar modal. Abriendo modal...');
            setTimeout(() => this.openModalColectivo(), 100);
          }

          if (this.isEditMode && this._pendingLineasEdicion) {
            const pendingLineas = this._pendingLineasEdicion;
            this._pendingLineasEdicion = null;
            setTimeout(() => {
              pendingLineas.forEach(linea => {
                const el = document.getElementById(`linea${linea}`) as HTMLInputElement | null;
                if (el) el.checked = true;
              });
            }, 100);
          }
          if (this.isEditMode && this.lineasNegocio.length > 0 && Object.keys(this.programasCarnetPorLinea).length === 0) {
            this.actualizarProgramasPorLineasSeleccionadas();
          }
          return;
        case 2:
          if (this.isEditMode && !this.esVersionMasReciente) {
            this.colectivoFormSaved = true;
            this.formColectivo.markAsPristine();
            this.responseGuardar = false;
            this.tabHabilitado.cotizacion = true;
            this.maxStepReached = Math.max(this.maxStepReached, 2);
            this.selectedIndex = 2;
            if (!this.liquidacionColectivoGuardada) {
              this.resetResumenCotizacionColectivo();
            }
            return;
          }
          if (!this.guardarInformacionColectivo()) {
            this.selectedIndex = 1;
            return;
          }
          this.responseGuardar = false;
          this.tabHabilitado.cotizacion = true;
          this.maxStepReached = Math.max(this.maxStepReached, 2);
          this.selectedIndex = 2;
          if (!this.liquidacionColectivoGuardada) {
            this.resetResumenCotizacionColectivo();
          }
          return;
      }
    }
    switch (nextIndex) {
      case 0:
        this.selectedIndex = 0;
        localStorage.removeItem('contrato_radicado');
        break;
      case 1: // CONTRATANTE
        if (this.validarInicio()) {
          this.procesarCambioInicioYContinuar();
        } else {
          this.selectedIndex = 0;
        }
        break;
      case 2: // BENEFICIARIOS
        if (this.formularioContratanteComponent?.puedeContinuar()) {
          this.cargarCatalogoProgramasBeneficiariosSiHaceFalta();
          this.tabHabilitado.beneficiarios = true;
          this.maxStepReached = Math.max(this.maxStepReached, 2);
          this.formularioContratanteComponent.obtenerDatosParaContinuar();
          if (this.isEditMode && this.esVersionMasReciente) {
            this.selectedIndex = 2;
            this.refrescarBeneficiariosUltimaVersionDesdeEdit(() => {
              this.sincronizarContratanteComoBeneficiario();
            });
            return;
          }

          this.sincronizarContratanteComoBeneficiario();
          this.selectedIndex = 2;
        } else {
          this.selectedIndex = 1;
          if (this.formularioContratanteComponent) {
            const mensaje = this.formularioContratanteComponent.getMensajeErrorContinuar();
            this.SnackBarService.alert("alert-danger", mensaje);
          }
        }
        break;
      case 3: // COTIZACIÓN
        if (!this.validarContratante()) {
          this.selectedIndex = 2;
          return;
        }
        if (this.valCuota == null) {
          this.SnackBarService.alert(
            "alert-danger",
            "Para continuar debe seleccionar una couta de inscripcion."
          );
          this.selectedIndex = 2;
          return;
        }
        this.tabHabilitado.cotizacion = true;
        this.responseGuardar = false;
        this.maxStepReached = Math.max(this.maxStepReached, 3);
        // Mantener el último paso cubierto mientras terminan sus liquidaciones.
        if (this.isEditMode && !this.esNuevoColectivo && this.esVersionMasReciente) {
          this.spinnerUltimaPantallaActivo = true;
          this.spinner.show();
        }
        this.selectedIndex = 3;
        this.inicioCotizacion();
        this.refrescarAlEntrarTabCotizacionIndividual();
        break;
    }
  }
  private shouldConfirmExitContratante(currentIndex: number): boolean {
    const isContratanteTab = currentIndex === 1 && !this.esNuevoColectivo;
    if (!isContratanteTab || !this.formularioContratanteComponent?.formContratante) return false;
    return this.formularioContratanteComponent.formContratante.dirty;
  }

  private shouldConfirmExitColectivo(currentIndex: number): boolean {
    const isColectivoTab = this.esNuevoColectivo && currentIndex === 1;
    if (!isColectivoTab) return false;
    if (this.isEditMode && !this.esVersionMasReciente) return false;
    return this.hayCambiosColectivoPendientes();
  }

  private hayCambiosColectivoPendientes(): boolean {
    const payloadGuardado = this.obtenerFormularioColectivoGuardado();

    if (!payloadGuardado) {
      return this.formColectivo.dirty
        || this.lineasNegocioSeleccionadas.length > 0
        || this.programasSeleccionadosUI.size > 0
        || this.programasConAnexosSeleccionados.size > 0
        || this.requiereIncluirAnexos !== 'no';
    }

    const actual = this.construirDatosFormularioColectivoStorage();
    const guardado = this.obtenerDatosFormularioColectivoGuardado(payloadGuardado);

    return JSON.stringify(actual) !== JSON.stringify(guardado);
  }

  private shouldConfirmExitCotizacion(currentIndex: number): boolean {
    const isCotizacionTab = this.esNuevoColectivo ? currentIndex === 2 : currentIndex === 3;
    if (!isCotizacionTab) return false;
    if (this.isEditMode && !this.esVersionMasReciente) return false;

    const hasCotizacionData = this.esNuevoColectivo
      ? this.mostrarResumenCotizacionColectivo
      || this.colectivoFormSaved
      || this.formColectivo.dirty
      || this.resumenCotizacionColectivo.length > 0
      : !!this.numeroCotizacion
      || (this.listDetallePagoMensual?.length ?? 0) > 0
      || (this.listLineaTable?.length ?? 0) > 0
      || (this.listLineaTableMulti?.length ?? 0) > 0;

    if (this.esNuevoColectivo) {
      return hasCotizacionData && !this.liquidacionColectivoGuardada;
    }

    return hasCotizacionData && !this.responseGuardar;
  }

  private confirmarSalidaSinGuardar(nextIndex: number, source: "contratante" | "colectivo" | "cotizacion"): void {
    Swal.fire({
      title: "Confirmación",
      text: "¿Deseas salir sin guardar la información actual? Los datos ingresados podrían perderse.",
      icon: "warning",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Guardar y salir",
      denyButtonText: "Salir sin guardar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#0372b9",
      denyButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (source === "contratante") {
          this.formularioContratanteComponent?.guardarEnLocalStorage();
          this.formularioContratanteComponent?.formContratante?.markAsPristine();
          this.executeTabOption(nextIndex);
          return;
        }

        if (source === "cotizacion") {
          if (!this.esNuevoColectivo) {
            this.guardar();
            this.executeTabOption(nextIndex);
            return;
          }
          this.guardarResumenCotizacionColectivo(nextIndex);
          return;
        }

        if (await this.guardarInformacionColectivo()) {
          this.executeTabOption(nextIndex);
        }

        this.guardarInformacionColectivo(() => this.continuarDespuesDeGuardarColectivo(nextIndex));
        return;
      }

      if (result.isDenied) {
        if (source === "contratante") {
          this.formularioContratanteComponent?.formContratante?.markAsPristine();
        } else if (source === "cotizacion") {
          if (this.esNuevoColectivo) {
            this.liquidacionColectivoGuardada = false;
            this.resetResumenCotizacionColectivo();
          }
          this.executeTabOption(nextIndex);
          return;
        } else {
          if (!this.isEditMode && !this.colectivoFormSaved && nextIndex > 1) {
            this.mantenerTabActual(1);
            return;
          }
          this.limpiarColectivoSinGuardar();
        }
        this.executeTabOption(nextIndex);
        return;
      }

      if (source === "colectivo") {
        this.mantenerTabActual(1);
        return;
      }

      this.mantenerTabActual(source === "cotizacion" ? (this.esNuevoColectivo ? 2 : 3) : 1);
    });
  }

  private limpiarColectivoSinGuardar(): void {
    this.resetFormularioColectivo();
    this.liquidacionColectivoGuardada = false;
    this.resetResumenCotizacionColectivo();
    localStorage.removeItem(this.KEY_COLECTIVO_FORM_STORAGE);
    localStorage.removeItem(this.KEY_COLECTIVO_PRODUCTOS_STORAGE);
    localStorage.removeItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
  }

  private inicioCotizacion() {

    const tipoSolicitud = localStorage.getItem('tipoSolicitud');
    if (tipoSolicitud === '2') {
      console.log('[Inclusion]  Saltando liquidación legacy individual. Los valores se pintarán desde el componente de resumen de la BD.');
      return;
    }

    this.mSelBenTari = {};
    const tipoCotizacion = this.formInit.get("tipoCotizacion")?.value;
    if (tipoCotizacion === 'm') {
      this.valorFamiliaTotal = 0;
      this.valorAsociadoTotal = 0;
      this.valorFamiliaTotalBruto = 0;
      this.valorAsociadoTotalBruto = 0;
      this.valorFamiliar = [];
      this.selectedValue = [];
      this.listLineaTable = this.listLineaTable.map((t) => {
        let beneficiary = t.listBeneficiario;
        beneficiary = beneficiary.map((b: { list_tarifa: never[]; }) => {
          b.list_tarifa = [];
          return b;
        });
        t.listBeneficiario = beneficiary;
        return t;
      });
    }
    const validateInicio1 = this.validarInicio() ? 1 : 0;
    if (validateInicio1 === 1) {
      const validateContratante = this.validarContratante() ? 2 : 1;
      if (validateContratante === 2) {
        if (this.valCuota == null) {
          this.SnackBarService.alert(
            "alert-danger",
            "Para continuar debe seleccionar una couta de inscripcion."
          );
          this.selectedIndex = 2;
        } else {
          this.tabHabilitado.cotizacion = true;
          this.maxStepReached = Math.max(this.maxStepReached, 3);
          this.enviarCotizador();
        }
      } else {
        this.selectedIndex = 1;
      }
    } else {
      this.selectedIndex = 0;
    }
  }

  /** Metodo para validar el tipo de solicitud */
  validateTipoSolicitud() {
    const value = (this.formInit.get("tipoSolicitud")?.value || "").toString().trim();
    const tipoPlan = (this.formInit.get("tipoPlan")?.value || "").toString().trim().toUpperCase();
    this.tipoSolicitud = value;
    this.esNuevoColectivo = value === "3";
    this.tabHabilitado.colectivo = this.esNuevoColectivo;

    // Nuevo Colectivo en edición: recuperar los datos persistidos.
    // La búsqueda de empresa se mantiene para la creación.
    if (
      this.isEditMode &&
      this.esNuevoColectivo &&
      this.cotizacionEdicionData?.colectivo
    ) {
      this.esModalColectivoConfirmado = true;

      const tipoPlanControl = this.formInit.get("tipoPlan");
      tipoPlanControl?.setValue("C", { emitEvent: false });
      tipoPlanControl?.clearValidators();
      tipoPlanControl?.updateValueAndValidity({ emitEvent: false });

      localStorage.setItem("tipoPlan", "C");
      localStorage.setItem("tipoSolicitud", "3");

      const colectivo = this.cotizacionEdicionData.colectivo;
      const nit = (
        colectivo.numDocumento ??
        colectivo.nitEmpresa ??
        ""
      ).toString().trim();

      if (nit) {
        localStorage.setItem("tipoDocumentoEmpresa", "NI");
        localStorage.setItem("numeroDocumentoEmpresa", nit);
      }

      return;
    }

    if (value === "2") {
      this.onInclusion();
      return;
    }

    // Modal colectivo aplica tanto para Venta Nueva (Solicitud 1 + Plan C/GA) como para Solicitud 3
    const esColectivo = this.esNuevoColectivo || (value === "1" && (tipoPlan === "C" || tipoPlan === "GA"));

    if (esColectivo) {
      if (this.esNuevoColectivo) {
        this.formInit.get("tipoPlan")?.setValue("C");
        localStorage.setItem('tipoPlan', 'C');
        localStorage.setItem('tipoSolicitud', '3');
        this.formInit.get("tipoPlan")?.clearValidators();
        this.formInit.get("tipoPlan")?.updateValueAndValidity();
        this.tabHabilitado.cotizacion = false;
        this.maxStepReached = 1;
        if (!this.isEditMode) {
          setTimeout(() => this.mantenerTabActual(1));
        }
      }

      if (!this.esModalColectivoConfirmado) {
        this.openModalColectivo();
      }
      return;
    }

    if (value !== this.tipoSolicitudTemporal) {
      this.tabHabilitado.cotizacion = false;
      this.formInit.get("tipoPlan")?.setValue("");
      this.formInit.get("tipoCotizacion")?.setValue("");
      this.formInit.get("lineaNegocio")?.setValue("");
      this.formInit.get("programa")?.setValue("");
      this.listProgramas = [];
      this.listCodeProgramas = [];
      this.valContrato = {
        codigoAsesor: 0,
        codigoCuenta: 0,
        codigoLineaNegocio: "",
        codigoPrograma: "",
        codigoSubcuenta: "",
        codigoSucursal: "",
        codigoTarifa: "",
        codigoTipoPlan: "",
        contrato: "",
        descripcionTarifa: "",
      };
      this.blockedTipoPlanQuestion = false;
      this.blockedTipoCotizacionQuestion = false;
      this.blockedLineaNegocioQuestion = false;
      this.blockedProgramaQuestion = false;
      this.enableFormInit([
        "tipoPlan",
        "tipoSolicitud",
        "programa",
        "lineaNegocio",
        "tipoCotizacion",
      ]);
      this.enableForm([
        "contratanteDocumento",
        "contratanteTipoDocumento",
        "tarifaInclusion",
      ]);
      this.listDataCampania = [];
      this.listTarifa = [];
      this.resetPeople();
      this.resetData = true;
      this.valorFamiliar = [];
      this.modeloAsociadoMultiple = [];
      this.valorAsociadoTotal = 0;
      this.valorFamiliaTotal = 0;
      this.tipoSolicitudTemporal = value;
      this.datePerson = null;
    }
  }

  /** Metodo para buscar los contratos por usuario */
  onInclusion() {
    this.esInclusion = true;
    localStorage.removeItem('numeroDocumentoEmpresa');
    localStorage.removeItem('tipoDocumentoEmpresa');
    this.formColectivo?.get('nit')?.setValue(null, { emitEvent: false });
    this.resetAnexoContext();
    this._datosCompletosColectivoAC = [];

    const contratanteEdicion = this.cotizacionEdicionData?.contratante;
    const tipoDocPrefill = contratanteEdicion?.tipoDocumento ?? contratanteEdicion?.tipo_documento ?? this.form.get("contratanteTipoDocumento")?.value ?? '';
    const numDocPrefill = contratanteEdicion?.numDocumento ?? contratanteEdicion?.numero_documento ?? contratanteEdicion?.numeroDocumento ?? this.form.get("contratanteDocumento")?.value ?? '';

    const dialogRef = this.dialog.open(DialogContratComponent, {
      data: {
        opciones: true,
        data: this.valAllContract,
        select: this.valContrato,
        idAsesorLogueado: this.idAsesor,
        isEditMode: this.isEditMode,
        tipoDocumento: tipoDocPrefill.toString().trim(),
        numeroDocumento: numDocPrefill.toString().trim(),
        tipoSolicitud: '2',
        contratosInclusion: this.cotizacionEdicionData?.contratosInclusion
      },
      id: "panelContrato",
      width: '55vw',
      maxWidth: '50vw',
      panelClass: "dialog-contrato",
      maxHeight: "90vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        if (!this.isEditMode) {
          this.formInit.get("tipoSolicitud")?.setValue(null);
          this.validateTipoSolicitud();
        }
      } else {
        // NC0090: en editMode preservar snapshot completo antes del wipe (códigos del Dialog no traen campaña/tarifa).
        const snapshotProgramasEdicion = this.isEditMode
          ? this.obtenerSnapshotProgramasInclusionEdicion()
          : [];

        localStorage.removeItem('programas_seleccionados_inclusion');
        localStorage.removeItem('programas_contratante');
        localStorage.removeItem('programas_contratante_inclusiones');
        localStorage.removeItem('validaciones_contratante');
        if (this.consultarLineasGruposProgramasService) {
          delete (this.consultarLineasGruposProgramasService as any).cacheCarnetsInclusion;
        }
        this._catalogoBenefProgramasCargado = false;
        this.programasSeleccionadosUI.clear();
        this.programasCarnetPorLinea = {};
        this.listProgramas = [];
        this.valContrato = this.mapContratoInclusion(result.select);

        if (result.select && Array.isArray(result.select)) {
          const descripcionesMap: Record<string, string> = {};
          const todosLosCodigosSeleccionados = result.select.map((c: any) => {
            const code = (c.codigoPrograma ?? c.cod_programa_afi ?? c.programa ?? c.PROGRAMA ?? c.plan_codi ?? c.PLAN_CODI ?? '').toString().trim().toUpperCase();
            const desc = (c.programa_afi ?? c.descripcionTarifa ?? c.nombrePrograma ?? '').toString().trim();
            if (code && desc) {
              descripcionesMap[code] = desc;
            }
            return code;
          }).filter(Boolean);

          localStorage.setItem('programas_seleccionados_inclusion', JSON.stringify(todosLosCodigosSeleccionados));
          localStorage.setItem('programas_descripciones_inclusion', JSON.stringify(descripcionesMap));
          console.log('[LOG-INCLUSION] Array completo indexado con éxito:', todosLosCodigosSeleccionados);

          if (this.isEditMode && snapshotProgramasEdicion.length > 0) {
            this.restaurarProgramasInclusionDesdeSnapshot(snapshotProgramasEdicion, todosLosCodigosSeleccionados);
          }
        } else if (this.valContrato.codigoPrograma) {
          const codigoUnico = this.valContrato.codigoPrograma.trim().toUpperCase();
          localStorage.setItem('programas_seleccionados_inclusion', JSON.stringify([codigoUnico]));
          if (this.isEditMode && snapshotProgramasEdicion.length > 0) {
            this.restaurarProgramasInclusionDesdeSnapshot(snapshotProgramasEdicion, [codigoUnico]);
          }
        }

        this.dataPersona(result.persona);
        this.formularioContratanteComponent?.cargarDatosDesdeLocalStorage();
        this.blockedForm(["contratanteDocumento", "contratanteTipoDocumento", "tarifaInclusion"]);

        const cantidadContratos = result.select && Array.isArray(result.select) ? result.select.length : 1;
        const tipoCotizacionCalculado = cantidadContratos > 1 ? "m" : "u";
        this.formInit.get("tipoCotizacion")?.setValue(tipoCotizacionCalculado);

        this.blockedFormInit(["tipoCotizacion", "programa"]);
        this.blockedTipoCotizacionQuestion = true;
        this.blockedProgramaQuestion = true;

        switch (this.valContrato.codigoTipoPlan) {
          case "F":
            this.esModalColectivoConfirmado = false;
            this.formInit.get("tipoPlan")?.setValue("F");
            this.blockedFormInit(["tipoPlan", "programa"]);
            this.blockedTipoPlanQuestion = true;
            break;
          case "A":
            this.esModalColectivoConfirmado = false;
            this.formInit.get("tipoPlan")?.setValue("A");
            this.blockedFormInit(["tipoPlan", "programa"]);
            this.blockedTipoPlanQuestion = true;
            break;
          case "C":
            this.esModalColectivoConfirmado = true;
            this.formInit.get("tipoPlan")?.setValue("C");
            this.blockedFormInit(["tipoPlan", "programa"]);
            this.blockedTipoPlanQuestion = true;
            break;
          case "E":
            this.esModalColectivoConfirmado = false;
            this.formInit.get("tipoPlan")?.setValue("E");
            this.blockedFormInit(["tipoPlan", "programa"]);
            this.blockedTipoPlanQuestion = true;
            break;
          case "GA":
            this.esModalColectivoConfirmado = false;
            this.formInit.get("tipoPlan")?.setValue("GA");
            this.blockedFormInit(["tipoPlan", "programa"]);
            this.blockedTipoPlanQuestion = true;
            break;
          default:
            this.esModalColectivoConfirmado = false;
            this.formInit.get("tipoPlan")?.setValue("C");
            this.blockedTipoPlanQuestion = false;
            break;
        }

        const tipoPlanConfirmado = (this.formInit.get("tipoPlan")?.value || "").toString().trim();
        localStorage.setItem("tipoSolicitud", "2");
        if (tipoPlanConfirmado) {
          localStorage.setItem("tipoPlan", tipoPlanConfirmado);
        }

        if (tipoCotizacionCalculado === "m") {
          this.formInit.get("lineaNegocio")?.setValue("all");
          this.blockedFormInit(["lineaNegocio", "programa"]);
          this.blockedLineaNegocioQuestion = true;
        } else {
          switch (this.valContrato.codigoLineaNegocio) {
            case "1":
              this.formInit.get("lineaNegocio")?.setValue("SMP");
              this.blockedFormInit(["lineaNegocio", "programa"]);
              this.blockedLineaNegocioQuestion = true;
              break;
            case "2":
              this.formInit.get("lineaNegocio")?.setValue("SAO");
              this.blockedFormInit(["lineaNegocio", "programa"]);
              this.blockedLineaNegocioQuestion = true;
              break;
            default:
              this.formInit.get("lineaNegocio")?.setValue("SMP");
              this.blockedFormInit(["lineaNegocio", "programa"]);
              this.blockedLineaNegocioQuestion = true;
              break;
          }
        }
        this.selectPrograms();
      }
    });
  }

  /**
   * NC0090 — Snapshot de programas del titular antes del wipe de onInclusion (solo editMode).
   * Prioriza LS inyectado por prefill; fallback a cotizacion_precargada / cotizacionEdicionData.
   */
  private obtenerSnapshotProgramasInclusionEdicion(): any[] {
    const parseLista = (raw: string | null): any[] => {
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        const arr = Array.isArray(parsed) ? parsed : (parsed?.programas ?? []);
        return Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch {
        return [];
      }
    };

    const desdeContratante = parseLista(localStorage.getItem('programas_contratante'));
    if (desdeContratante.length > 0) {
      return desdeContratante;
    }
    const desdeInclusiones = parseLista(localStorage.getItem('programas_contratante_inclusiones'));
    if (desdeInclusiones.length > 0) {
      return desdeInclusiones;
    }

    try {
      const precRaw = localStorage.getItem('cotizacion_precargada');
      const prec = precRaw ? JSON.parse(precRaw) : null;
      if (Array.isArray(prec?.programasContratantePersistidos) && prec.programasContratantePersistidos.length > 0) {
        return prec.programasContratantePersistidos;
      }
    } catch { /* ignore */ }

    const data = this.cotizacionEdicionData;
    if (data?.beneficiarios && Array.isArray(data.beneficiarios)) {
      const titular = data.beneficiarios.find((b: any) =>
        b?.parentescoId?.toString() === 'T' ||
        b?.parentesco_id?.toString() === 'T' ||
        b?.esContratante === 'S' ||
        b?.es_contratante === 'S' ||
        b?.esContratante === true
      );
      if (titular) {
        const progsRaw = (titular as any).programasConfig?.programas || (titular as any).programas || [];
        if (Array.isArray(progsRaw) && progsRaw.length > 0) {
          return progsRaw
            .map((p: any) => this.normalizarProgramaTitularEdicion(p))
            .filter(Boolean);
        }
      }
    }

    return [];
  }

  /**
   * NC0090 — Tras el Dialog, restaura objetos completos (tarifa/campaña/anexo) filtrados a códigos aceptados.
   * Alta nueva no llama este método (isEditMode false).
   */
  private restaurarProgramasInclusionDesdeSnapshot(snapshot: any[], codigosAceptados: string[]): void {
    const codes = new Set(
      (codigosAceptados || [])
        .map(c => (c ?? '').toString().trim().toUpperCase())
        .filter(Boolean)
    );
    if (codes.size === 0 || !Array.isArray(snapshot) || snapshot.length === 0) {
      return;
    }

    const restored = snapshot.filter((p: any) => {
      const codigo = (p?.programa ?? p?.id ?? p?.codigo ?? p?.code ?? '')
        .toString()
        .trim()
        .toUpperCase();
      return !!codigo && codes.has(codigo);
    });

    if (restored.length === 0) {
      return;
    }

    localStorage.setItem('programas_contratante', JSON.stringify(restored));
    localStorage.setItem('programas_contratante_inclusiones', JSON.stringify(restored));
    console.log('[NC0090][Inclusion-Edicion] Snapshot restaurado tras Dialog:', restored.map((p: any) => ({
      programa: p?.programa ?? p?.id,
      tarifa: p?.tarifa,
      campana: p?.campana
    })));
  }

  private mapContratoInclusion(result: any) {
    const contrato = Array.isArray(result) ? result[0] : result;

    if (!contrato) {
      return this.valContrato;
    }

    const cuenta = (contrato.codigoTipoPlan ?? contrato.Cuenta ?? '').toString().trim().toUpperCase();
    const lineaNegocio = (contrato.codigoLineaNegocio ?? contrato.cod_linea_negocio ?? contrato.Linea_Negocio ?? '').toString().trim().toUpperCase();

    const codigoTipoPlan =
      cuenta === 'F' || cuenta === 'FAMILIAR' ? 'F' :
        cuenta === 'A' || cuenta === 'ASOCIADO' ? 'A' :
          cuenta === 'E' || cuenta === 'EM' || cuenta === 'EMPLEADO' ? 'E' :
            cuenta === 'C' || cuenta === 'COLECTIVO' ? 'C' :
              cuenta === 'AC' || cuenta === 'ACUERDO CORPORATIVO' ? 'GA' :
              'GA';
    const codigoLineaNegocio =
      lineaNegocio === '1' || lineaNegocio === 'MI' || lineaNegocio === 'SMP' ? '1' :
        lineaNegocio === '2' || lineaNegocio === 'SAO' ? '2' :
          lineaNegocio === '3' || lineaNegocio === 'CEM' ? '3' :
            '';

    const asesorSesionActiva = this.idAsesor ?? Number(contrato.codigoAsesor ?? contrato.IdAsesor ?? 0);

    return {
      codigoAsesor: Number(contrato.codigoAsesor ?? contrato.IdAsesor ?? 0),
      codigoCuenta: Number(contrato.codigoCuenta ?? contrato.cuenta ?? 0),
      codigoLineaNegocio,
      codigoPrograma: (contrato.codigoPrograma ?? contrato.cod_programa_afi ?? '').toString().trim(),
      codigoSubcuenta: (contrato.codigoSubcuenta ?? '').toString().trim(),
      codigoSucursal: (contrato.codigoSucursal ?? '').toString().trim(),
      codigoTarifa: (contrato.codigoTarifa ?? '').toString().trim(),
      codigoTipoPlan,
      contrato: (contrato.contrato ?? contrato.contra ?? '').toString().trim(),
      descripcionTarifa: (contrato.descripcionTarifa ?? contrato.programa_afi ?? '').toString().trim(),
    };
  }

  private persistirDocumentoEmpresaEdicion(data: CotizacionEdicionData): void {
    const edicionData = data as any;
    let nitEmpresa = (
      edicionData?.colectivo?.numDocumento ??
      edicionData?.colectivo?.nitEmpresa ??
      edicionData?.empresa?.numeroDocumento ??
      edicionData?.empresa?.nit ??
      ''
    ).toString().trim();

    if (!nitEmpresa && Array.isArray(edicionData?.beneficiarios)) {
      for (const ben of edicionData.beneficiarios) {
        if (!Array.isArray(ben?.programas)) continue;
        for (const prog of ben.programas) {
          if (!Array.isArray(prog?.tarifas)) continue;
          for (const tari of prog.tarifas) {
            const tCode = (tari?.tari || '').toString().trim();
            const matchNit = tCode.match(/\d{8,15}/);
            if (!matchNit?.[0]) continue;
            let extracted = matchNit[0];
            if (extracted.startsWith('2') && (extracted.length === 10 || extracted.length === 11)) {
              extracted = extracted.substring(1);
            }
            nitEmpresa = extracted;
            break;
          }
          if (nitEmpresa) break;
        }
        if (nitEmpresa) break;
      }
    }

    if (!nitEmpresa) {
      return;
    }

    localStorage.setItem('tipoDocumentoEmpresa', 'NI');
    localStorage.setItem('numeroDocumentoEmpresa', nitEmpresa);
  }

  openModalColectivo() {
    const esNuevoColectivo =
    Number(this.formInit.get('tipoSolicitud')?.value) === 3;

    if (esNuevoColectivo) {
      this.esModalColectivoConfirmado = true;
      return;
    }
    const tipoPlan = (this.formInit.get("tipoPlan")?.value || localStorage.getItem('tipoPlan') || "C")
      .toString()
      .trim()
      .toUpperCase();
    const tipoSolicitud = (this.formInit.get("tipoSolicitud")?.value || localStorage.getItem('tipoSolicitud') || "1")
      .toString()
      .trim();
    const planEdicionMap: Record<number, string> = { 2: 'F', 1: 'A', 3: 'E', 4: 'C', 5: 'GA' };
    const tipoPlanOriginal = this.isEditMode
      ? (planEdicionMap[Number(this.cotizacionEdicionData?.idTipoPlan)] || '')
      : '';
    const esCambioPlanEnEdicion =
      this.isEditMode && !!tipoPlanOriginal && tipoPlanOriginal !== tipoPlan;

    if (tipoSolicitud === "2") {
      this.esModalColectivoConfirmado = true;
      return;
    }

    let nitEmpresa = '';
    let tipoDoc = 'NI';

    if (this.isEditMode) {
      const edicionData = this.cotizacionEdicionData as any;

      nitEmpresa = (
        edicionData?.colectivo?.numDocumento ??
        edicionData?.colectivo?.nitEmpresa ??
        edicionData?.empresa?.numeroDocumento ??
        edicionData?.empresa?.nit ??
        edicionData?.contratante?.numeroDocumento ??
        ''
      ).toString().trim();

      tipoDoc = (
        edicionData?.colectivo?.tipoDocumento ??
        edicionData?.colectivo?.tipoDoc ??
        edicionData?.empresa?.tipoDocumento ??
        edicionData?.empresa?.tipoDoc ??
        edicionData?.contratante?.tipoDocumento ??
        localStorage.getItem('tipoDocumentoEmpresa') ??
        'NI'
      ).toString().trim() || 'NI';

      if (tipoPlan === 'C' || tipoPlan === 'GA') {
        tipoDoc = 'NI';
      }

      if (!nitEmpresa && Array.isArray(edicionData?.beneficiarios)) {
        for (const ben of edicionData.beneficiarios) {
          if (Array.isArray(ben.programas)) {
            for (const prog of ben.programas) {
              if (Array.isArray(prog.tarifas)) {
                for (const tari of prog.tarifas) {
                  const tCode = (tari.tari || '').toString().trim();
                  const matchNit = tCode.match(/\d{8,15}/);
                  if (matchNit && matchNit[0]) {
                    let extracted = matchNit[0];
                    // Quitar el '2' inicial solo si la longitud total indica que tiene un prefijo (10 u 11 dígitos)
                    if (extracted.startsWith('2') && (extracted.length === 10 || extracted.length === 11)) {
                      extracted = extracted.substring(1);
                    }
                    nitEmpresa = extracted;
                    break;
                  }
                }
              }
              if (nitEmpresa) break;
            }
          }
          if (nitEmpresa) break;
        }
      }

      if (!nitEmpresa) {
        nitEmpresa = (localStorage.getItem('numeroDocumentoEmpresa') || '').toString().trim();
      }

    } else {
      localStorage.removeItem('numeroDocumentoEmpresa');
      localStorage.removeItem('tipoDocumentoEmpresa');
    }

    // Asignación final
    const nitFinal = nitEmpresa || (this.formColectivo?.get('nit')?.value || '').toString().trim();

    console.log('[COLECTIVO-NIT-MODE-DEBUG] [Cotizador] Apertura modal:', {
      isEditMode: this.isEditMode,
      nitResuelto: nitFinal,
      tipoDocumentoResuelto: tipoDoc
    });

    const dialogRef = this.dialog.open(DialogColectivoComponent, {
      data: {
        opciones: true,
        data: this.valAllContract,
        select: this.valContrato,
        tipoPlan: tipoPlan || 'C',
        tipoSolicitud: tipoSolicitud,
        isEditMode: this.isEditMode,
        // Al cambiar entre planes colectivos, el documento del plan anterior
        // no debe disparar una consulta automática ni cerrar el modal.
        tipoDocumento: esCambioPlanEnEdicion ? 'NI' : (tipoDoc || 'NI'),
        numeroDocumento: esCambioPlanEnEdicion ? '' : nitFinal
      },
      id: "panelContrato",
      width: '55vw',
      maxWidth: '50vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.esModalColectivoConfirmado = false;
        this.formInit.get("tipoPlan")?.setValue(null);
        this.formInit.get("tipoSolicitud")?.setValue(null);
        return;
      }
      const tipoDocumento = result.tipoDocumento;
      const numeroDocumento = result.numeroDocumento;
      localStorage.setItem('tipoDocumentoEmpresa', tipoDocumento ?? 'NI');
      localStorage.setItem('numeroDocumentoEmpresa', numeroDocumento ?? '');
      this.esModalColectivoConfirmado = true;
      this.selectPrograms();
    });
  }
  /** Metodo para setear el contratante por inclusion */
  dataPersona(result: QuotationPeopleResponse) {
    if (!result) {
      return;
    }

    const persona: any = result;

    const fechaNacimiento =
      persona.fechaNacimiento ??
      persona.fecha_naci_benef ??
      null;

    const documento = (
      persona.documento ??
      persona.docu_nro ??
      persona.docu_nro_benef ??
      ''
    ).toString().trim();

    const tipoDocumento = (
      persona.tipoDocumento ??
      persona.docu_tipo ??
      persona.docu_tipo_benef ??
      ''
    ).toString().trim();

    if (documento) {
      this.form.get("contratanteDocumento")?.setValue(documento);
    }

    if (tipoDocumento) {
      this.form.get("contratanteTipoDocumento")?.setValue(tipoDocumento);
    }

    if (!fechaNacimiento) {
      return;
    }

    const now = new Date();
    // const dataBirthe = new Date(result.fechaNacimiento);
    //const dataBirthe = new Date(result.fechaNacimiento);
    // console.log('fecha de nacimientooo ',result.fechaNacimiento);
    const dataBirthe = new Date(fechaNacimiento);

    let birthAge = now.getFullYear() - dataBirthe.getFullYear();
    const mes = now.getMonth() - dataBirthe.getMonth();
    if (mes < 0 || (mes === 0 && now.getDate() < dataBirthe.getDate()))
      birthAge--;

    // this.form.get("contratanteDocumento")?.setValue(result.documento);
    // this.form.get("contratanteTipoDocumento")?.setValue(result.tipoDocumento);
    this.form.get("contratanteDocumento")?.setValue(documento);
    this.form.get("contratanteTipoDocumento")?.setValue(tipoDocumento);
    this.form.get("contratanteNombre")?.setValue(result.primerNombre);
    this.form.get("contratanteSegundoNombre")?.setValue(result.segundoNombre);
    this.form.get("contratanteApellido")?.setValue(result.primerApellido);
    this.form.get("contratanteSegundoApellido")?.setValue(result.segundoApellido);
    this.form.get("contratanteGenero")?.setValue(result.codigoGenero === "F" ? "1" : "2");
    // this.form.get("contratanteFechaNacimiento")?.setValue(result.fechaNacimiento);
    this.form.get("contratanteFechaNacimiento")?.setValue(fechaNacimiento);

    this.form.get("contratanteEdad")?.setValue(birthAge);
    // console.log('edad ',this.form.get("contratanteEdad")?.setValue(birthAge));

    if (this.tipoSolicitud === "2") {
      this.form.get("tarifaInclusion")?.setValue(`${this.valContrato.descripcionTarifa}`);
      this.form.get("contratanteTarifa")?.setValue(this.valContrato.codigoTarifa);
    }
    this.datePerson = birthAge;
    if (result.correos) {
      if (result.correos[0])
        this.form.get("contratanteEmail")?.setValue(result.correos[0].email);
      if (result.correos[1])
        this.form.get("contratanteEmail2")?.setValue(result.correos[1].email);
    }
    if (result.telefonos?.length > 0)
      this.form.get("contratanteTelefono")?.setValue(result.telefonos[0].telefono);
  }

  /** Metodo para bloquear el formInit */
  blockedFormInit(value: string[]) {
    for (let index = 0; index < value.length; index++) {
      this.formInit.controls[value[index]].disable();
    }
  }

  /** Metodo para habilitar el formInit */
  enableFormInit(value: string[]) {
    for (let index = 0; index < value.length; index++) {
      this.formInit.controls[value[index]].enable();
    }
  }


  /**
   * Obtiene las tarjetas de productos comerciales traduciendo "SMP" a "MI"
   */
  selectPrograms() {
    sessionStorage.removeItem("type");
    this.listCodeProgramas = [];
    this.tipoSolicitud === "2" ? this.formInit.get("programa")?.setValue(this.valContrato.codigoPrograma) : this.formInit.get("programa")?.setValue("");
    this.lineaNegocio = this.formInit.get("lineaNegocio")?.value;
    const tipoPlan = this.formInit.get("tipoPlan")?.value;

    if ((tipoPlan === "C" || tipoPlan === "GA") && !this.esModalColectivoConfirmado) {
      this.openModalColectivo();
      return;
    }

    const tipoCotizacion = this.formInit.get("tipoCotizacion")?.value;
    this.ocultarPlanFamiliar = tipoPlan == 'F';
    let lineasParaBuscar: string[] = [];

    if (tipoCotizacion === "m") {
      sessionStorage.setItem("type", JSON.stringify("multi"));
      this.blockedFormInit(["programa", "lineaNegocio"]);
      this.blockedLineaNegocioQuestion = true;
      this.blockedProgramaQuestion = true;
      this.lineaNegocio = "all";
      lineasParaBuscar = ["MI", "SAO", "CEM"];
    } else {
      if (this.tipoSolicitud !== "2") {
        this.enableFormInit(["programa", "lineaNegocio"]);
        this.blockedLineaNegocioQuestion = false;
        this.blockedProgramaQuestion = false;
        if (this.lineaNegocio && this.lineaNegocio !== "all") {
          // Normalización preventiva para venta nueva
          const lineaNormalizada = this.lineaNegocio === 'SMP' ? 'MI' : this.lineaNegocio;
          lineasParaBuscar.push(lineaNormalizada);
        }
      } else {
        this.blockedFormInit(["programa", "lineaNegocio"]);
        this.blockedLineaNegocioQuestion = true;
        this.blockedProgramaQuestion = true;
        if (this.lineaNegocio) {
          const lineaNormalizada = this.lineaNegocio === 'SMP' ? 'MI' : this.lineaNegocio;
          lineasParaBuscar.push(lineaNormalizada);
        }
      }
    }

    if (lineasParaBuscar.length > 0 && tipoPlan && tipoCotizacion) {
      this.obtenerTarjetas(lineasParaBuscar, tipoPlan);
    }
    this.resetDataCampain(false);
  }

  /** Metodo para obtener tarjetas */
  obtenerTarjetas(lineas: string[], tipoPlan: string): void { //Nuevo
    this.spinner.show();
    this.networking.searchProduct(lineas, tipoPlan).subscribe({ //Nuevo
      next: (data) => {
        this.searchProductOutputSuccessful(data);
      },
      error: (err) => {
        this.searchProductOutputFailure(1, err);
        console.error("Error al buscar productos: ", err.message);
      }
    });
  }

  validarInicio() {
    const tipoSolicitud = this.formInit.get("tipoSolicitud")?.value;
    const tipoPlan = this.formInit.get("tipoPlan")?.value;

    if (tipoSolicitud === "3") {
      return true;
    }

    const pass = !!tipoSolicitud && !!tipoPlan;
    if (!pass) {
      this.SnackBarService.alert(
        'alert-danger',
        'No se puede continuar, Todos los campos son obligatoríos',
      );
    }
    return pass;
  }

  /**
   * Persiste el inicio y conserva la cotización activa cuando una Venta Nueva
   * cambia entre los planes individuales F/A/E.
   */
  private procesarCambioInicioYContinuar(): void {
    if (this.actualizandoTipoPlanCotizacion) return;

    const tipoSolicitud = (this.formInit.get('tipoSolicitud')?.value || '').toString().trim();
    const tipoPlan = (this.formInit.get('tipoPlan')?.value || '').toString().trim().toUpperCase();
    const planEdicionMap: Record<number, string> = { 2: 'F', 1: 'A', 3: 'E', 4: 'C', 5: 'GA' };
    const tipoSolicitudAnterior = this.isEditMode
      ? (this.cotizacionEdicionData?.idTipoSolicitud ?? '').toString().trim()
      : (localStorage.getItem('tipoSolicitud') || '').toString().trim();
    const tipoPlanAnterior = this.isEditMode
      ? (planEdicionMap[Number(this.cotizacionEdicionData?.idTipoPlan)] || '')
      : (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();

    const planesVentaNueva = new Set([
      'F',
      'A',
      'E',
      'C',
      'GA'
    ]);
    const esCambioPlanVentaNueva =
      tipoSolicitud === '1'
      && tipoSolicitudAnterior === '1'
      && tipoPlanAnterior !== tipoPlan
      && planesVentaNueva.has(tipoPlanAnterior)
      && planesVentaNueva.has(tipoPlan)
      && (!this.isEditMode || this.esVersionMasReciente);

    const cotizacionActiva = esCambioPlanVentaNueva
      ? (this.isEditMode
        ? this.obtenerCotizacionActivaEdicion()
        : this.obtenerCotizacionActivaMismoContratante())
      : null;

    if (cotizacionActiva) {
      const request: CrearCotizacionRequest = {
        idAsesor: cotizacionActiva.idAsesor,
        idTipoSolicitud: cotizacionActiva.idTipoSolicitud,
        idTipoPlan: this.mapTipoPlanToId(tipoPlan),
        pasoActual: cotizacionActiva.pasoActual,
        observaciones: cotizacionActiva.observaciones,
        idTipoCotizacion: cotizacionActiva.idTipoCotizacion,
        cotizacionProbabilidadCierre: { idProbabilidadCierre: cotizacionActiva.idProbabilidadCierre },
        cotizacionEstado: { idCotizacionEstado: cotizacionActiva.idEstado }
      };

      this.actualizandoTipoPlanCotizacion = true;
      this.spinner.show();
      this.cotizacionService.actualizarCotizacion(cotizacionActiva.idCotizacion, request).pipe(take(1)).subscribe({
        next: () => {
          this.actualizandoTipoPlanCotizacion = false;
          this.spinner.hide();
          this.limpiarDatosDependientesDelPlan();
          localStorage.setItem('tipoSolicitud', tipoSolicitud);
          localStorage.setItem('tipoPlan', tipoPlan);
          if (this.isEditMode) {
            this.actualizarContextoEdicionTrasCambioPlan(tipoPlan);
          }
          this.avanzarAContratante();
        },
        error: (error: any) => {
          this.actualizandoTipoPlanCotizacion = false;
          this.spinner.hide();
          this.formInit.get('tipoPlan')?.setValue(tipoPlanAnterior, { emitEvent: false });
          this.selectedIndex = 0;
          this.SnackBarService.alert(
            'alert-danger',
            error?.error?.errorMessage || error?.error?.message || 'No fue posible actualizar el tipo de plan de la cotización.'
          );
        }
      });
      return;
    }

    if (esCambioPlanVentaNueva && this.isEditMode) {
      this.formInit
        .get('tipoPlan')
        ?.setValue(tipoPlanAnterior, { emitEvent: false });

      this.selectedIndex = 0;

      this.SnackBarService.alert(
        'alert-danger',
        'No se encontró la cotización activa que se desea actualizar.'
      );

      return;
    }

    // NC0107: al Continuar desde Inicio (fuera de edición y fuera del UPDATE por cambio de plan),
    // siempre resetear sesión/keys de cotización. Si solo se limpiaba cuando cambiaba
    // tipoSolicitud/plan, reusar el mismo documento dejaba sesion_activa + id viejo y bloqueaba.
    if (!this.isEditMode) {
      this.limpiarStoragesDependientesDeInicio();
    }

    localStorage.setItem('tipoSolicitud', tipoSolicitud);
    localStorage.setItem('tipoPlan', tipoPlan);
    this.avanzarAContratante();
  }

  private avanzarAContratante(): void {
    if (!this.esInclusion) {
      this.cargarCatalogoProgramasBeneficiariosSiHaceFalta();
    }
    this.tabHabilitado.contratante = true;
    this.maxStepReached = Math.max(this.maxStepReached, 1);
    this.selectedIndex = 1;
  }

  /**
   * Solo reconoce la cotización creada en la visita actual y exige que el
   * documento guardado corresponda al contratante que permanece en el formulario.
   */
  private obtenerCotizacionActivaMismoContratante(): {
    idCotizacion: number;
    idAsesor: string;
    pasoActual: number;
    idTipoSolicitud: number;
    observaciones: string;
    idTipoCotizacion: number;
    idProbabilidadCierre: number;
    idEstado: number;
  } | null {
    if (sessionStorage.getItem('cotizacion_contratante_sesion_activa') !== '1') return null;

    try {
      const creadaRaw = localStorage.getItem('cotizacion_creada_desde_contratante');
      const contratanteRaw = localStorage.getItem('datosRQ002_Contratante');
      if (!creadaRaw || !contratanteRaw) return null;

      const creada = JSON.parse(creadaRaw);
      const contratante = JSON.parse(contratanteRaw);
      const tipoDocumentoCreada = (creada?.tipoDocumento || '').toString().trim().toUpperCase();
      const numeroDocumentoCreada = (creada?.numeroDocumento || '').toString().trim();
      const tipoDocumentoActual = (contratante?.tipoDocumento || '').toString().trim().toUpperCase();
      const numeroDocumentoActual = (contratante?.numeroDocumento || '').toString().trim();
      const idCotizacion = Number(creada?.idCotizacion ?? creada?.data?.idCotizacion);
      const idAsesor = (contratante?.idAsesor || '').toString().trim();

      if (
        !Number.isFinite(idCotizacion)
        || idCotizacion <= 0
        || !idAsesor
        || !tipoDocumentoCreada
        || !numeroDocumentoCreada
        || tipoDocumentoCreada !== tipoDocumentoActual
        || numeroDocumentoCreada !== numeroDocumentoActual
      ) {
        return null;
      }

      let pasoActual = Math.max(2, this.maxStepReached + 1);
      const precargadaRaw = localStorage.getItem('cotizacion_precargada');
      if (precargadaRaw) {
        const precargada = JSON.parse(precargadaRaw);
        if (Number(precargada?.idCotizacion) === idCotizacion) {
          pasoActual = Math.max(pasoActual, Number(precargada?.pasoActual) || 0);
        }
      }

      return {
        idCotizacion,
        idAsesor,
        pasoActual,
        idTipoSolicitud: 1,
        observaciones: '',
        idTipoCotizacion: 1,
        idProbabilidadCierre: 3,
        idEstado: 1
      };
    } catch {
      return null;
    }
  }

  private obtenerCotizacionActivaEdicion(): {
    idCotizacion: number;
    idAsesor: string;
    pasoActual: number;
    idTipoSolicitud: number;
    observaciones: string;
    idTipoCotizacion: number;
    idProbabilidadCierre: number;
    idEstado: number;
  } | null {
    const data = this.cotizacionEdicionData;
    const idCotizacion = Number(this.idCotizacionEdicion ?? data?.idCotizacion);
    const idAsesor = (data?.idAsesor || '').toString().trim();
    if (!data || !Number.isFinite(idCotizacion) || idCotizacion <= 0 || !idAsesor) return null;

    return {
      idCotizacion,
      idAsesor,
      pasoActual: Number(data.pasoActual) || 2,
      idTipoSolicitud: Number(data.idTipoSolicitud) || 1,
      observaciones: data.observaciones || '',
      idTipoCotizacion: Number(data.idTipoCotizacion) || 1,
      idProbabilidadCierre: Number((data as any).idProbabilidadCierre ?? (data as any).ultimaIdProbabilidad) || 3,
      idEstado: Number(data.idEstado) || 1
    };
  }

  private actualizarContextoEdicionTrasCambioPlan(tipoPlan: string): void {
    const data = this.cotizacionEdicionData;
    if (!data?.contratante) return;

    data.idTipoPlan = this.mapTipoPlanToId(tipoPlan);
    if (this._cotizacionEdicionDataLatest?.idCotizacion === data.idCotizacion) {
      this._cotizacionEdicionDataLatest.idTipoPlan = data.idTipoPlan;
    }

    const contextoContratante: CotizacionEdicionContratanteContexto = {
      idCotizacion: data.idCotizacion,
      contratante: data.contratante,
      pasoActual: Number(data.pasoActual ?? 0),
      idTipoSolicitud: data.idTipoSolicitud,
      tieneProgramasContratantePersistidos: false,
      programasContratantePersistidos: [],
      reiniciarProgramasPorCambioPlan: true
    };
    localStorage.setItem('cotizacion_edicion_contratante', JSON.stringify(contextoContratante));
    window.dispatchEvent(new CustomEvent('cotizacion-edicion-contratante'));
  }

  /** Limpia selecciones que ya no son válidas sin perder el ID ni el contratante. */
  private limpiarDatosDependientesDelPlan(): void {
    localStorage.removeItem('validaciones_contratante');
    localStorage.removeItem('programas_contratante');
    localStorage.removeItem('datosRQ003_Beneficiarios');
    localStorage.removeItem('datosRQ003_EleccionPrograma');

    try {
      const contratanteRaw = localStorage.getItem('datosRQ002_Contratante');
      if (contratanteRaw) {
        const contratante = JSON.parse(contratanteRaw);
        delete contratante.esUsuario;
        localStorage.setItem('datosRQ002_Contratante', JSON.stringify(contratante));
      }
    } catch { }
  }


  /** Metodo para obtener tarjetas */
  /*selectPrograms() {
    sessionStorage.removeItem("type");
    this.listCodeProgramas = [];
    this.tipoSolicitud === "2"
      ? this.formInit.get("programa")?.setValue(this.valContrato.codigoPrograma)
      : this.formInit.get("programa")?.setValue("");
    this.lineaNegocio = this.formInit.get("lineaNegocio")?.value;
    const tipoPlan = this.formInit.get("tipoPlan")?.value;
    // ABRIR MODAL SOLO PARA C y AC
    const requiereModalColectivo =
      (tipoPlan === "C" || tipoPlan === "GA") &&
      this.tipoSolicitud !== "2" &&
      !this.esModalColectivoConfirmado;

    if (requiereModalColectivo) {
      this.openModalColectivo();
      return;
    }
    const tipoCotizacion = this.formInit.get("tipoCotizacion")?.value;
    this.ocultarPlanFamiliar = tipoPlan == 'F';
    switch (tipoPlan) {
      case "F":
        if (tipoCotizacion === "m") {
          // TODO: Agregar "DEB", "DESCB"
          this.validateProgramaMulti([
            "OPLF",
            "PJVF",
            "PREFF",
            "AESEF",
            "AESF",
            "PRIMF",
            "DEB",
            "DESCB"
          ]);
          this.lineaNegocio = "all";
          this.blockedLineaNegocioQuestion = true;
          this.blockedProgramaQuestion = true;
        } else {
          if (this.tipoSolicitud !== "2") {
            this.enableFormInit(["programa", "lineaNegocio"]);
            this.blockedLineaNegocioQuestion = false;
            this.blockedProgramaQuestion = false;
            if (this.lineaNegocio === "SMP")
              this.listCodeProgramas.push(
                "OPLF",
                "PJVF",
                "PREFF",
                "AESEF",
                "AESF",
                "PRIMF"
              );
            if (this.lineaNegocio === "SAO")
              this.listCodeProgramas.push("DEB", "DESCB");
          } else {
            this.listCodeProgramas.push(this.valContrato.codigoPrograma);
          }
        }
        break;
      case "A":
        if (tipoCotizacion === "m") {
          // TODO: Agregar "DEB", "DESCB"
          this.validateProgramaMulti([
            "OPLA",
            "PJVA",
            "ASOA",
            "TESA",
            "PREFA",
            "AESEA",
            "AESA",
            "PRIMA",
            "DEB",
            "DESCB"
          ]);
          this.lineaNegocio = "all";
          this.blockedLineaNegocioQuestion = true;
          this.blockedProgramaQuestion = true;
        } else {
          if (this.tipoSolicitud !== "2") {
            this.enableFormInit(["programa", "lineaNegocio"]);
            this.blockedLineaNegocioQuestion = false;
            this.blockedProgramaQuestion = false;
            if (this.lineaNegocio === "SMP")
              this.listCodeProgramas.push(
                "OPLA",
                "PJVA",
                "ASOA",
                "TESA",
                "PREFA",
                "AESEA",
                "PRIMA",
                "AESA"
              );
            if (this.lineaNegocio === "SAO")
              this.listCodeProgramas.push("DEB", "DESCB");
          } else {
            this.listCodeProgramas.push(this.valContrato.codigoPrograma);
          }
        }
        break;
      case "C":
        if (tipoCotizacion === "m") {
          this.validateProgramaMulti([
            "OROC",
            "OPLC",
            "PJVC",
            "TESC",
            "PLATC",
            "HCMC",
            "PREFC",
            "AESEC",
            "ORPRC",
            "DECERC",
            "SAOB",
          ]);
          this.lineaNegocio = "all";
          this.blockedLineaNegocioQuestion = true;
          this.blockedProgramaQuestion = true;
        } else {
          if (this.tipoSolicitud !== "2") {
            this.enableFormInit(["programa", "lineaNegocio"]);
            this.blockedLineaNegocioQuestion = false;
            this.blockedProgramaQuestion = false;
            if (this.lineaNegocio === "SMP")
              this.listCodeProgramas.push(
                "OROC",
                "OPLC",
                "PJVC",
                "TESC",
                "PLATC",
                "HCMC",
                "PREFC",
                "AESEC",
                "ORPRC"
              );
            if (this.lineaNegocio === "SAO")
              this.listCodeProgramas.push("DEB", "SAOB", "DECERC");
          } else {
            this.listCodeProgramas.push(this.valContrato.codigoPrograma);
          }
        }
        break;
      default:
        if (tipoCotizacion === "m" || this.tipoSolicitud === "2") {
          this.blockedFormInit(["programa", "lineaNegocio"]);
          this.blockedLineaNegocioQuestion = true;
          this.blockedProgramaQuestion = true;
        }
        if (tipoCotizacion !== "m")
          this.enableFormInit(["programa", "lineaNegocio"]);
        break;
    }

    if (tipoCotizacion === "m") {
      sessionStorage.setItem("type", JSON.stringify("multi"));
    }

    if (this.lineaNegocio && tipoPlan && tipoCotizacion) this.obtenerTarjetas();
    this.resetDataCampain(false);
  }

  // Logica de negocio al seleccionar el tipo de cotizacion multiple 
  validateProgramaMulti(programs: string[]) {
    this.blockedFormInit(["programa", "lineaNegocio"]);
    programs.forEach((prg) => {
      this.listCodeProgramas.push(prg);
    });
    this.formInit.get("lineaNegocio")?.setValue("all");
  }

  // Metodo para obtener tarjetas 
  obtenerTarjetas(): void {
    this.spinner.show();
    this.networking.searchProduct(this.listCodeProgramas).subscribe({
      next: (data) => {
        this.searchProductOutputSuccessful(data);
      },
      error: (err) => {
        this.searchProductOutputFailure(1, err);
        console.error("Error al buscar productos: ", err.message);
      }
    });
  }

  // Metodo para valida el inicio 
  validarInicio() {
    const tipoSolicitud = this.formInit.get("tipoSolicitud")?.value;
    const tipoPlan = this.formInit.get("tipoPlan")?.value;

    if (tipoSolicitud === "3") {
      return true;
    }

    const pass = !!tipoSolicitud && !!tipoPlan;
    if (!pass) {
      this.SnackBarService.alert(
        'alert-danger',
        'No se puede continuar, Todos los campos son obligatoríos',
      );
    } else {
      const tipoSolicitudAnterior = (localStorage.getItem('tipoSolicitud') || '').toString().trim();
      const tipoPlanAnterior = (localStorage.getItem('tipoPlan') || '').toString().trim();
      const inicioCambio =
        (tipoSolicitudAnterior !== '' && tipoSolicitudAnterior !== tipoSolicitud) ||
        (tipoPlanAnterior !== '' && tipoPlanAnterior !== tipoPlan);

      if (inicioCambio && !this.isEditMode) {
        this.limpiarStoragesDependientesDeInicio();
      }

      // Guardar en localStorage
      localStorage.setItem('tipoSolicitud', tipoSolicitud);
      localStorage.setItem('tipoPlan', tipoPlan);
      console.log('Datos guardados en localStorage: tipoSolicitud=', tipoSolicitud, ', tipoPlan=', tipoPlan);
    }
    return pass;
  } */

  private limpiarStoragesDependientesDeInicio(): void {
    localStorage.removeItem('datosRQ002_Contratante');
    localStorage.removeItem('validaciones_contratante');
    localStorage.removeItem('programas_contratante');
    localStorage.removeItem('cotizacion_contratante_actual');
    localStorage.removeItem('cotizacion_precargada');
    localStorage.removeItem('cotizacion_creada_desde_contratante');
    sessionStorage.removeItem('cotizacion_contratante_sesion_activa');
    localStorage.removeItem('cotizacion_cargada');
    localStorage.removeItem('idCotizacion');
    localStorage.removeItem('datosRQ003_Beneficiarios');
    localStorage.removeItem('datosRQ003_Beneficiario');
    localStorage.removeItem('programas_beneficiario');
  }

  get lineasNegocioSeleccionadas(): string[] {
    return this.lineasNegocio.controls
      .map((control) => control.value?.toString().trim())
      .filter((value): value is string => !!value);
  }

  isLineaNegocioSeleccionada(linea: string): boolean {
    return this.lineasNegocioSeleccionadas.includes((linea || '').toString().trim());
  }

  get hayProgramasSeleccionados(): boolean {
    return this.lineasNegocioSeleccionadas.some(
      (linea) => (this.programasCarnetPorLinea[linea] ?? []).length > 0
    );
  }

  displayNameForLinea(linea: string): string {
    return this.lineaNegocioDisplayName[linea] ?? linea;
  }

  get mostrarSeccionAnexos(): boolean {
    return this.programasSeleccionadosUI.size > 0 && this.programasConAnexosDisponibles.length > 0;
  }

  isProgramaAnexoSelected(programaCode: string): boolean {
    const code = (programaCode || '').toString().trim();
    return this.programasConAnexosSeleccionados.has(code);
  }

  toggleAnexoSelection(programaCode: string, event: Event): void {
    const target = event.target as HTMLInputElement | null;
    if (!target) return;
    const programaKey = (programaCode || "").toString().trim();
    if (!programaKey) {
      return;
    }
    if (target.checked) {
      this.programasConAnexosSeleccionados.add(programaKey);
    } else {
      this.programasConAnexosSeleccionados.delete(programaKey);
    }
    this.sincronizarEstadoGeneralAnexos();
    this.guardarProductosColectivoEnStorage();
  }

  setProgramaAnexoSelection(programaCode: string, value: 'si' | 'no'): void {
    const code = (programaCode || '').toString().trim();

    if (!code) {
      return;
    }

    if (value === 'si') {
      this.programasConAnexosSeleccionados.add(code);
    } else {
      this.programasConAnexosSeleccionados.delete(code);
    }

    this.sincronizarEstadoGeneralAnexos();
    this.guardarProductosColectivoEnStorage();

    console.log('PROGRAMA ANEXO:', code, value);
    console.log('PROGRAMAS CON ANEXOS SELECCIONADOS:', Array.from(this.programasConAnexosSeleccionados));
  }

  onRequiereIncluirAnexosChange(value: 'si' | 'no'): void {
    this.requiereIncluirAnexos = value;
    if (value !== 'si') {
      this.programasConAnexosSeleccionados.clear();
    }
    this.guardarProductosColectivoEnStorage();
  }

  esProgramaSeleccionado(programaCode: string): boolean {
    return this.programasSeleccionadosUI.has(programaCode);
  }

  toggleProgramaSeleccion(programaCode: string): void {
    const programaKey = (programaCode || "").toString().trim();

    if (!programaKey) {
      return;
    }

    if (this.programasSeleccionadosUI.has(programaKey)) {
      this.programasSeleccionadosUI.delete(programaKey);
      delete this.tarifasColectivoPorPrograma[programaKey];
      this.programasConAnexosSeleccionados.delete(programaKey);
    } else {
      this.programasSeleccionadosUI.add(programaKey);

      this.ensureProgramaAnexoInfo(programaKey);

      this.cargarTarifasColectivoParaPrograma(programaKey);
    }

    if (this.programasSeleccionadosUI.size === 0) {
      this.requiereIncluirAnexos = 'no';
      this.programasConAnexosSeleccionados.clear();
    }

    this.actualizarProgramasConAnexosDisponibles();

    this.resumenCotizacionColectivoData =
      this.construirResumenCotizacionColectivoLocal();
  }

  onLineaNegocioChange(event: any) {

    const value = event.target.value;

    if (event.target.checked) {
      this.lineasNegocio.push(new FormControl(value));
    } else {

      const index = this.lineasNegocio.controls
        .findIndex(x => x.value === value);

      if (index > -1) {
        this.lineasNegocio.removeAt(index);
      }
    }

    this.actualizarProgramasPorLineasSeleccionadas();
    this.guardarProductosColectivoEnStorage();

  }
  /*
    private actualizarProgramasPorLineasSeleccionadas(): void {
      const seleccionadas = this.lineasNegocio.controls
        .map((control) => control.value?.toString().trim())
        .filter((value): value is string => !!value);
  
      if (!seleccionadas.length) {
        this.programasPorLineaSeleccionadas = {};
        this.programasCarnetPorLinea = {};
        this.actualizarProgramasConAnexosDisponibles();
        return;
      }
  
      const gruposParametro = Array.from(
        new Set(
          seleccionadas
            .map((linea) => this.lineaNegocioParametroMap[linea])
            .filter((param): param is string => !!param)
        )
      );
  
      if (!gruposParametro.length) {
        this.programasPorLineaSeleccionadas = {};
        return;
      }
  
      this.consultarLineasGruposProgramasService
        .consultarProgramasByParametro({ gruposParametro })
        .subscribe({
          next: (response) => {
            const agrupado: Record<string, string[]> = {};
            (response.data?.programasPorParametro || []).forEach((item) => {
              const linea = this.parametroLineaNegocioMap[item.grupoParametro];
              if (!linea) {
                return;
              }
              agrupado[linea] = (item.valores || []).flatMap((valor) =>
                String(valor)
                  .split(',')
                  .map((codigo) => codigo.trim())
                  .filter((codigo): codigo is string => !!codigo)
              );
            });
            this.programasPorLineaSeleccionadas = agrupado;
            this.cargarCarnetsParaProgramas(agrupado);
          },
          error: (error) => {
            console.error('Error al consultar programas por parámetro:', error);
            this.programasPorLineaSeleccionadas = {};
          }
        });
    }*/

  private actualizarProgramasPorLineasSeleccionadas(): void {
    console.log('[actualizarProgramasPorLineasSeleccionadas] Iniciando procesamiento de líneas...');

    const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');
    const tipoPlan = this.formInit?.get('tipoPlan')?.value || localStorage.getItem('tipoPlan');
    const tipoCotizacion = this.formInit?.get('tipoCotizacion')?.value;

    let seleccionadas: string[] = [];

    if (tipoSolicitud === '3') {
      // Flujo Colectivo Puro: Lee los checkboxes del FormArray
      seleccionadas = this.lineasNegocio.controls
        .map((control: any) => control.value?.toString().trim())
        .filter((value: any): value is string => !!value);
    } else {
      // Flujos Individuales / Inclusión / Grupo de Afinidad (GA)
      if (tipoCotizacion === 'm') {
        seleccionadas = ['1', '2', '3']; // Multiproducto: habilita todas
      } else {
        const lineaForm = this.formInit.get('lineaNegocio')?.value || this.lineaNegocio;
        if (lineaForm === 'all') {
          seleccionadas = ['1', '2', '3'];
        } else if (lineaForm) {
          const l = lineaForm.toString().trim().toUpperCase();
          if (l === 'SMP' || l === 'MI' || l === '1') seleccionadas.push('1');
          else if (l === 'SAO' || l === 'SO' || l === '2') seleccionadas.push('2');
          else if (l === 'CEM' || l === '3') seleccionadas.push('3');
        }
      }
    }

    // Seguridad elástica para Afinidad (GA): Si está vacío, fuerza la lógica de selección del formulario
    const tipoPlanStr = (tipoPlan || '').toString().trim().toUpperCase();
    if (!seleccionadas.length && tipoPlanStr === 'GA') {
      console.log('[actualizarProgramasPorLineasSeleccionadas] GA detectado sin selección activa, forzando línea del formulario.');
      const lineaForm = this.formInit.get('lineaNegocio')?.value || this.lineaNegocio;
      if (lineaForm) {
        const l = lineaForm.toString().trim().toUpperCase();
        if (l === 'SMP' || l === 'MI' || l === '1') seleccionadas.push('1');
        else if (l === 'SAO' || l === 'SO' || l === '2') seleccionadas.push('2');
        else if (l === 'CEM' || l === '3') seleccionadas.push('3');
      }
    }

    console.log('[actualizarProgramasPorLineasSeleccionadas] Líneas finales a consultar:', seleccionadas);

    if (!seleccionadas.length) {
      console.log('[actualizarProgramasPorLineasSeleccionadas] No hay líneas mapeadas, limpiando estado.');
      this.programasPorLineaSeleccionadas = {};
      if (tipoSolicitud !== '2') {
        this.programasCarnetPorLinea = {};
      }
      this.actualizarProgramasConAnexosDisponibles();
      return;
    }

    const aliasMap: Record<string, string> = { "1": "MI", "2": "SAO", "3": "CEM" };
    const lineasParaCarnets = seleccionadas.map(s => aliasMap[s] || s);
    const tipoPlanActual = (tipoPlan || 'C').toString().trim().toUpperCase();
    let programasParaEnviar: string[] = [];
    if (tipoSolicitud === '3') {
      programasParaEnviar = Array.from(new Set(
        (this._datosCompletosColectivoAC || []).map((row: any) =>
          (row?.plan_codi ?? row?.PLAN_CODI ?? row?.codigo_plan ?? '').toString().trim().toUpperCase()
        )
      )).filter(Boolean);
    } else {
      programasParaEnviar = this.obtenerProgramasParaCarnets([]);
    }


    const firmaRequest = JSON.stringify({ lineasParaCarnets, tipoPlanActual, programasParaEnviar });
    if (this._carnetsRequestEnVuelo && this._carnetsFirmaEnVuelo === firmaRequest) {
      return;
    }
    this._carnetsRequestEnVuelo = true;
    this._carnetsFirmaEnVuelo = firmaRequest;

    console.log('[actualizarProgramasPorLineasSeleccionadas] Consultando API Carnets:', { lineasParaCarnets, tipoPlanActual });

    const edadContratante = Number(
      this.form.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('edad')?.value ||
      0
    );

    const params: any = {
      lineaNegocio: lineasParaCarnets,
      tipoPlan: tipoPlanActual,
      programas: programasParaEnviar,
      edad: edadContratante
    };
    if (tipoSolicitud === '3') {
      params.tipoSolicitud = '3';
    }

    this.consultarLineasGruposProgramasService.consultarCarnets(params).subscribe({
      next: (response: any) => {
        const carnets = response.data?.data || response?.data || response || [];
        const carnetsArray = Array.isArray(carnets) ? carnets : [];
        console.log(`[actualizarProgramasPorLineasSeleccionadas] Carnets devueltos por el Core: ${carnetsArray.length}`);

        const agrupado: Record<string, { code: string; program: string; file: string; }[]> = {};
        seleccionadas.forEach(s => agrupado[s] = []);

        const deInclusionGlobal: any[] = [];
        const deLineaMedicina: any[] = [];
        const deLineaDental: any[] = [];
        const deLineaCem: any[] = [];
        const deListProgramasCards: any[] = [];

        carnetsArray.forEach((carnet: any) => {
          const codigoLimpio = (
            carnet.code ||
            carnet.codigo ||
            carnet.id ||
            carnet.programa ||
            ''
          )
            .toString()
            .trim()
            .toUpperCase();

          if (!codigoLimpio) return;

          /*
          * Busca el programa dentro de la respuesta que ya entregó
          * getconsultacolectivoac.
          */
          const matchedRow = (this._datosCompletosColectivoAC || []).find(
            (row: any) =>
              (
                row?.plan_codi ??
                row?.PLAN_CODI ??
                ''
              )
                .toString()
                .trim()
                .toUpperCase() === codigoLimpio
          );

          let nombrePrograma =
            carnet.program ||
            carnet.programa ||
            carnet.nombre ||
            carnet.nombrePrograma ||
            '';

          if (matchedRow) {
            const nombreDesdeColectivo = (
              matchedRow?.plan_deno ??
              matchedRow?.PLAN_DENO ??
              ''
            )
              .toString()
              .trim();

            if (
              nombreDesdeColectivo &&
              nombreDesdeColectivo.toUpperCase() !== codigoLimpio
            ) {
              nombrePrograma = nombreDesdeColectivo;
            }
          }

          const esPlanColectivoOAfinidad =
            tipoPlanActual === 'C' ||
            tipoPlanActual === 'GA';

          /*
          * Para colectivo y grupo de afinidad se extrae exclusivamente
          * de GRUPO_PROGRAMA de getconsultacolectivoac.
          */
          const grupoPrograma = (
            esPlanColectivoOAfinidad
              ? this.obtenerGrupoProgramaColectivo(
                  codigoLimpio,
                  nombrePrograma
                )
              : (
                  carnet?.grupoPrograma ??
                  carnet?.grupo_programa ??
                  carnet?.GRUPO_PROGRAMA ??
                  carnet?.groupCode ??
                  ''
                )
          )
            .toString()
            .trim()
            .toUpperCase();

          const carnetData = {
            code: codigoLimpio,
            program: nombrePrograma.toString().trim(),
            file: carnet.file,
            grupoPrograma
          };
          deInclusionGlobal.push(carnetData);

          const nombreLinea = (carnet.lineaNegocio || carnet.lineOfBusiness || carnet.linea || '').toString();
          const lineaAsignada = this.clasificarLineaCarnet(nombreLinea, codigoLimpio, carnetData.program);

          let lineaCardFormato = 'SMP';
          if (lineaAsignada === '2') {
            deLineaDental.push(carnetData);
            lineaCardFormato = 'SAO';
          } else if (lineaAsignada === '3') {
            deLineaCem.push(carnetData);
            lineaCardFormato = 'CEM';
          } else {
            deLineaMedicina.push(carnetData);
            lineaCardFormato = 'SMP';
          }

          if (agrupado[lineaAsignada]) {
            agrupado[lineaAsignada].push(carnetData);
          } else if (tipoPlanStr === 'GA' && seleccionadas.length === 1) {
            agrupado[seleccionadas[0]].push(carnetData);
          }

          deListProgramasCards.push({
            ...carnet,
            code: codigoLimpio,
            codigo: codigoLimpio,
            id: codigoLimpio,
            program: carnetData.program,
            nombre: carnetData.program,
            file: carnet.file,
            lineaNegocio: lineaCardFormato,
            linea: lineaCardFormato,
            lineOfBusiness: lineaCardFormato,
            linea_nego: lineaCardFormato,
            grupoPrograma: carnetData.grupoPrograma,
            grupo_programa: carnetData.grupoPrograma
          });
        });

        this.programasCarnetPorLinea = {
          ...this.programasCarnetPorLinea,
          CAT: deInclusionGlobal,
          '1': deLineaMedicina, 'MI': deLineaMedicina, 'SMP': deLineaMedicina,
          '2': deLineaDental, 'SAO': deLineaDental, 'SO': deLineaDental,
          '3': deLineaCem, 'CEM': deLineaCem
        };

        this.listProgramas = deListProgramasCards;

        console.log('[actualizarProgramasPorLineasSeleccionadas] Sincronización multillave exitosa.', {
          programasCarnetPorLinea_Keys: Object.keys(this.programasCarnetPorLinea),
          listProgramas_Length: this.listProgramas.length
        });


        this._carnetsRequestEnVuelo = false;
        this._carnetsFirmaEnVuelo = '';

        this.aplicarFiltroInclusionGlobal();
        this.actualizarProgramasConAnexosDisponibles();
        this.refrescarNombresProgramaBeneficiariosDesdeCatalogo();

        if (this._pendingProgramasEdicion) {
          const pendingProgs = this._pendingProgramasEdicion;
          this._pendingProgramasEdicion = null;
          pendingProgs.forEach((pendingNombre: any) => {
            const trimmed = pendingNombre.trim();
            let keyEncontrado: string | null = null;
            const trimmedSuffix = trimmed.includes(' - ') ? trimmed.split(' - ').slice(1).join(' - ').trim() : null;
            for (const progs of Object.values(this.programasCarnetPorLinea)) {
              for (const c of progs) {
                const key = (c.code || c.program || '').trim();
                const nombre = (c.program || '').trim();
                if (key === trimmed || nombre === trimmed || (trimmedSuffix && (key === trimmedSuffix || nombre === trimmedSuffix))) {
                  keyEncontrado = key || nombre;
                  break;
                }
              }
              if (keyEncontrado) break;
            }
            const valorFinal = keyEncontrado ?? trimmed;
            this.programasSeleccionadosUI.add(valorFinal);
            this.ensureProgramaAnexoInfo(valorFinal);
          });
          this.actualizarProgramasConAnexosDisponibles();
        }

        this.recargarTarifasColectivasSeleccionadas();
      },
      error: (error: any) => {
        console.error('[actualizarProgramasPorLineasSeleccionadas] Error crítico en la llamada de red:', error);

        // Liberación de flags en caso de error para evitar bloqueos permanentes
        this._carnetsRequestEnVuelo = false;
        this._carnetsFirmaEnVuelo = '';

        this.programasCarnetPorLinea = {};
        this.tarifasColectivoPorPrograma = {};
        this.resumenCotizacionColectivoData = this.construirResumenCotizacionColectivoLocal();
        this.actualizarProgramasConAnexosDisponibles();
        this._pendingProgramasEdicion = null;
      }
    });
  }

  private cargarCarnetsParaProgramas(programasPorLinea: Record<string, string[]>): void {
    const todosLosCodigos = Array.from(
      new Set(
        Object.values(programasPorLinea)
          .flatMap((codigos) => codigos)
          .map((codigo) => codigo.trim())
          .filter((codigo): codigo is string => !!codigo)
      )
    );

    if (!todosLosCodigos.length) {
      this.programasCarnetPorLinea = {};
      this.actualizarProgramasConAnexosDisponibles();
      return;
    }
    const tipoPlanForm = this.formInit.get('tipoPlan')?.value;
    const tipoPlanActual = (tipoPlanForm || localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();
    const programasParaEnviar = this.obtenerProgramasParaCarnets(todosLosCodigos);

    const edadContratante = Number(
      this.form.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('edad')?.value ||
      0
    );

    console.log('--- DEBUG: Llamando Carnets desde cargarCarnetsParaProgramas ---');
    this.consultarLineasGruposProgramasService.consultarCarnets({
      lineaNegocio: ['MI', 'SAO', 'CEM'],
      tipoPlan: tipoPlanActual,
      programas: programasParaEnviar,
      edad: edadContratante
    }).subscribe({
      next: (response) => {
        const carnets = response.data?.data || [];
          type CarnetProgramaItem = {
          code: string;
          program: string;
          file: string;
          grupoPrograma?: string;
        };
        const mapa = new Map<string, CarnetProgramaItem>();

        carnets.forEach((carnet) => {
          const codigoLimpio = (carnet.code || '').toString().trim();
          if (!codigoLimpio) {
            return;
          }
          mapa.set(codigoLimpio, {
            code: codigoLimpio,
            program: this.resumirNombreCarnetColectivo(
              carnet.program,
              ''
            ),
            file: carnet.file,
            grupoPrograma: (
              (carnet as any).grupoPrograma ??
              (carnet as any).grupo_programa ??
              (carnet as any).GRUPO_PROGRAMA ??
              ''
            ).toString().trim()
          });
        });

        const agrupado: Record<string, CarnetProgramaItem[]> = {};
        Object.entries(programasPorLinea).forEach(([linea, codigos]) => {
          agrupado[linea] = codigos
            .map((codigo) => mapa.get(codigo.trim()))
            .filter((item): item is { code: string; program: string; file: string; } => !!item);
        });

        this.programasCarnetPorLinea = agrupado;
        this.actualizarProgramasConAnexosDisponibles();
        this.refrescarNombresProgramaBeneficiariosDesdeCatalogo();

        // Modo edición: restaurar programas seleccionados antes de recargar tarifas
        if (this._pendingProgramasEdicion) {
          const pendingProgs = this._pendingProgramasEdicion;
          this._pendingProgramasEdicion = null;
          pendingProgs.forEach(pendingNombre => {
            const trimmed = pendingNombre.trim();
            let keyEncontrado: string | null = null;

            // El API puede devolver "LINEA - NOMBRE" (ej: "SO - DENTAL ESPECIAL"); extraer solo el nombre
            const trimmedSuffix = trimmed.includes(' - ') ? trimmed.split(' - ').slice(1).join(' - ').trim() : null;

            // Buscar el programa por código O por nombre (completo o sufijo tras " - ") en todas las lineas
            for (const carnets of Object.values(this.programasCarnetPorLinea)) {
              for (const carnet of (carnets as { code: string; program: string; file: string }[])) {
                const key = (carnet.code || carnet.program || '').trim();
                const nombre = (carnet.program || '').trim();
                if (key === trimmed || nombre === trimmed
                  || (trimmedSuffix && (key === trimmedSuffix || nombre === trimmedSuffix))) {
                  keyEncontrado = key || nombre;
                  break;
                }
              }
              if (keyEncontrado) break;
            }

            const valorFinal = keyEncontrado ?? trimmed;
            this.programasSeleccionadosUI.add(valorFinal);
            this.ensureProgramaAnexoInfo(valorFinal);
          });
          this.actualizarProgramasConAnexosDisponibles();
        }

        this.recargarTarifasColectivasSeleccionadas();
      },
      error: (error) => {
        console.error('Error al consultar carnets:', error);
        this.programasCarnetPorLinea = {};
        this.tarifasColectivoPorPrograma = {};
        this.resumenCotizacionColectivoData = this.construirResumenCotizacionColectivoLocal();
        this.actualizarProgramasConAnexosDisponibles();
        this._pendingProgramasEdicion = null;
      }
    });
  }

  private recargarTarifasColectivasSeleccionadas(): void {
    Array.from(this.programasSeleccionadosUI).forEach((programaCode) => {
      this.cargarTarifasColectivoParaPrograma(programaCode);
    });
  }

  private cargarTarifasColectivoParaPrograma(programaCode: string): void {
    const programaKey = (programaCode || '').toString().trim();

    if (!programaKey) {
      return;
    }

    const lineaNegocio = this.obtenerLineaDePrograma(programaKey);

    if (!lineaNegocio) {
      return;
    }

    this.cotizadorTarifaColectivoService
      .consultarTarifasColectivo(lineaNegocio, programaKey)
      .subscribe({
        next: (response) => {
          this.tarifasColectivoPorPrograma[programaKey] =
            Array.isArray(response?.data) ? response.data : [];

          this.actualizarProgramasConAnexosDisponibles();

          this.resumenCotizacionColectivoData =
            this.construirResumenCotizacionColectivoLocal();
        },
        error: (error) => {
          console.error(
            `Error consultando tarifas colectivo para ${programaKey}:`,
            error
          );

          this.tarifasColectivoPorPrograma[programaKey] = [];

          this.actualizarProgramasConAnexosDisponibles();

          this.resumenCotizacionColectivoData =
            this.construirResumenCotizacionColectivoLocal();
        }
      });
  }

  private actualizarProgramasConAnexosDisponibles(): void {
    const disponiblesMap = new Map<string, ProgramaAnexoInfo>();

    Array.from(this.programasSeleccionadosUI).forEach((code) => {
      const key = (code || '').toString().trim();

      if (!key) {
        return;
      }

      const info = this.programaAnexoInfoMap[key];
      const metadata = this.findProgramaMetadata(key);

      const tieneAnexosAfilmed =
        !!info &&
        Array.isArray(info.anexos) &&
        info.anexos.length > 0;

      const tieneAnexosParametrizados =
        this.programaTieneAnexosParametrizados(key);

      if (tieneAnexosAfilmed || tieneAnexosParametrizados) {
        disponiblesMap.set(key, {
          code: key,
          program: metadata?.program || info?.program || key,
          file: metadata?.file || info?.file,
          subcta: info?.subcta,
          deno: info?.deno,
          planGrupo: info?.planGrupo,
          anexos: info?.anexos ?? [],
          isFetchingSubcuenta: info?.isFetchingSubcuenta,
          isFetchingAnexos: info?.isFetchingAnexos,
          lastError: info?.lastError,
        });
      }
    });

    const disponibles = Array.from(disponiblesMap.values());

    this.programasConAnexosDisponibles = disponibles;

    const disponiblesSet = new Set(
      disponibles.map((programa) => programa.code)
    );

    // Modo edici\u00f3n: a medida que cada programa con anexo se vuelve disponible (tras
    // cargar sus tarifas async), restaurar su selecci\u00f3n y retirarlo del pendiente.
    if (this._pendingAnexosEdicion?.size) {
      this._pendingAnexosEdicion.forEach((code) => {
        if (disponiblesSet.has(code)) {
          this.programasConAnexosSeleccionados.add(code);
          this._pendingAnexosEdicion?.delete(code);
        }
      });
      if (this._pendingAnexosEdicion.size === 0) {
        this._pendingAnexosEdicion = null;
      }
    }

    Array.from(this.programasConAnexosSeleccionados).forEach((code) => {
      if (!disponiblesSet.has(code)) {
        this.programasConAnexosSeleccionados.delete(code);
      }
    });

    if (!disponibles.length) {
      this.requiereIncluirAnexos = 'no';
      this.programasConAnexosSeleccionados.clear();
    }

    this.sincronizarEstadoGeneralAnexos();

    this.guardarProductosColectivoEnStorage();
  }

  private sincronizarEstadoGeneralAnexos(): void {
    this.requiereIncluirAnexos =
      this.programasConAnexosSeleccionados.size > 0 ? 'si' : 'no';
  }

  private obtenerValorAnexosColectivo(): number {
    return this.requiereIncluirAnexos === 'si' ? 1 : 0;
  }

  private programaTieneAnexosParametrizados(programaCode: string): boolean {
    const key = (programaCode || '').toString().trim();

    if (!key) {
      return false;
    }

    const tarifas = this.tarifasColectivoPorPrograma[key] ?? [];

    return tarifas.some((tarifa: any) => {
      const aplicaAnexo = this.toBooleanFromSN(tarifa?.aplicaAnexo);

      const tieneAnexos =
        Array.isArray(tarifa?.anexos) &&
        tarifa.anexos.some((anexo: any) =>
          this.toBooleanFromSN(anexo?.estado)
        );

      return aplicaAnexo || tieneAnexos;
    });
  }

  private isRestoring = false;

  private guardarProductosColectivoEnStorage(): void {
    if (this.isRestoring) return;

    if (!this.formColectivo) {
      return;
    }

    const payload: ColectivoProductosStorage = {
      lineasNegocio: [...this.lineasNegocioSeleccionadas],
      programasSeleccionados: Array.from(this.programasSeleccionadosUI),
      requiereIncluirAnexos: this.requiereIncluirAnexos,
      programasConAnexosSeleccionados: Array.from(this.programasConAnexosSeleccionados),
      derechoAsubsidio: this.formColectivo.get('derechoAsubsidio')?.value ?? null,
      mostrarTodosEscenariosSubsidio: this.mostrarTodosEscenariosSubsidio,
    };

    localStorage.setItem(this.KEY_COLECTIVO_PRODUCTOS_STORAGE, JSON.stringify(payload));
  }

  private guardarFormularioColectivoEnStorage(): number {
    const datosFormulario = this.construirDatosFormularioColectivoStorage();
    const payloadGuardado = this.obtenerFormularioColectivoGuardado();
    const datosGuardados = payloadGuardado
      ? this.obtenerDatosFormularioColectivoGuardado(payloadGuardado)
      : null;
    const idCotizacion =
      payloadGuardado
        && datosGuardados
        && JSON.stringify(datosGuardados) === JSON.stringify(datosFormulario)
        && Number.isFinite(Number(payloadGuardado.ID_COTIZACION))
        ? Number(payloadGuardado.ID_COTIZACION)
        : this.obtenerSiguienteIdCotizacionStorage();

    const payload: ColectivoFormStorage = {
      ID_COTIZACION: idCotizacion,
      ...datosFormulario,
      savedAt: new Date().toISOString(),
    };

    localStorage.setItem(this.KEY_COLECTIVO_FORM_STORAGE, JSON.stringify(payload));
    this.guardarProductosColectivoEnStorage();
    return idCotizacion;
  }

  private construirDatosFormularioColectivoStorage(): Omit<ColectivoFormStorage, 'ID_COTIZACION' | 'savedAt'> {
    const rawValue = this.formColectivo.getRawValue();
    return {
      fechaPresentacion: this.serializarFechaStorage(rawValue.fechaPresentacion),
      fechaInicioVigencia: this.serializarFechaStorage(rawValue.fechaInicioVigencia),
      regional: this.normalizarValorStorage(rawValue.regional),
      canal: this.normalizarValorStorage(rawValue.canal),
      oficina: this.normalizarValorStorage(rawValue.oficina),
      tipoAsesor: this.normalizarValorStorage(rawValue.tipoAsesor),
      nit: this.normalizarValorStorage(rawValue.nit),
      colectivoNombre: this.normalizarValorStorage(rawValue.colectivoNombre),
      sector: this.normalizarValorStorage(rawValue.sector),
      departamento: this.normalizarValorStorage(rawValue.departamento),
      municipio: this.normalizarValorStorage(rawValue.municipio),
      clienteActual: this.normalizarValorStorage(rawValue.clienteActual),
      tarifa: this.normalizarValorStorage(rawValue.tarifa),
      usuariosCotizar: this.normalizarValorStorage(rawValue.usuariosCotizar),
      usuariosMayor60: this.normalizarValorStorage(rawValue.usuariosMayor60),
      UsuariosMayor60Total: this.normalizarValorStorage(rawValue.UsuariosMayor60Total),
      embarazosCurso: this.normalizarValorStorage(rawValue.embarazosCurso),
      NombreContacto: this.normalizarValorStorage(rawValue.NombreContacto),
      cargoContacto: this.normalizarValorStorage(rawValue.cargoContacto),
      emailContacto: this.normalizarValorStorage(rawValue.emailContacto),
      telefonoContacto: this.normalizarValorStorage(rawValue.telefonoContacto),
      derechoAsubsidio: this.normalizarValorStorage(rawValue.derechoAsubsidio),
      NombreDestinatario: this.normalizarValorStorage(rawValue.NombreDestinatario),
      cargoDestinatario: this.normalizarValorStorage(rawValue.cargoDestinatario),
      emailDestinatario: this.normalizarValorStorage(rawValue.emailDestinatario),
      telefonoDestinatario: this.normalizarValorStorage(rawValue.telefonoDestinatario),
      igualAQuienSeDirige: rawValue.igualAQuienSeDirige ?? null,
      porcentajeSubsidio: this.normalizarValorStorage(rawValue.porcentajeSubsidio),
      lineasNegocio: this.normalizarListadoStorage(this.lineasNegocioSeleccionadas),
      programasSeleccionados: this.normalizarListadoStorage(Array.from(this.programasSeleccionadosUI)),
      requiereIncluirAnexos: this.requiereIncluirAnexos,
      programasConAnexosSeleccionados: this.normalizarListadoStorage(Array.from(this.programasConAnexosSeleccionados)),
    };
  }

  private obtenerFormularioColectivoGuardado(): ColectivoFormStorage | null {
    try {
      const raw = localStorage.getItem(this.KEY_COLECTIVO_FORM_STORAGE);
      if (!raw) {
        return null;
      }

      return JSON.parse(raw) as ColectivoFormStorage;
    } catch (error) {
      console.error('No se pudo leer el formulario colectivo guardado:', error);
      return null;
    }
  }

  private obtenerDatosFormularioColectivoGuardado(
    payload: Partial<ColectivoFormStorage>
  ): Omit<ColectivoFormStorage, 'ID_COTIZACION' | 'savedAt'> {
    return {
      fechaPresentacion: this.normalizarValorStorage(payload.fechaPresentacion),
      fechaInicioVigencia: this.normalizarValorStorage(payload.fechaInicioVigencia),
      regional: this.normalizarValorStorage(payload.regional),
      canal: this.normalizarValorStorage(payload.canal),
      oficina: this.normalizarValorStorage(payload.oficina),
      tipoAsesor: this.normalizarValorStorage(payload.tipoAsesor),
      nit: this.normalizarValorStorage(payload.nit),
      colectivoNombre: this.normalizarValorStorage(payload.colectivoNombre),
      sector: this.normalizarValorStorage(payload.sector),
      departamento: this.normalizarValorStorage(payload.departamento),
      municipio: this.normalizarValorStorage(payload.municipio),
      clienteActual: this.normalizarValorStorage(payload.clienteActual),
      tarifa: this.normalizarValorStorage(payload.tarifa),
      usuariosCotizar: this.normalizarValorStorage(payload.usuariosCotizar),
      usuariosMayor60: this.normalizarValorStorage(payload.usuariosMayor60),
      UsuariosMayor60Total: this.normalizarValorStorage(payload.UsuariosMayor60Total),
      embarazosCurso: this.normalizarValorStorage(payload.embarazosCurso),
      NombreContacto: this.normalizarValorStorage(payload.NombreContacto),
      cargoContacto: this.normalizarValorStorage(payload.cargoContacto),
      emailContacto: this.normalizarValorStorage(payload.emailContacto),
      telefonoContacto: this.normalizarValorStorage(payload.telefonoContacto),
      derechoAsubsidio: this.normalizarValorStorage(payload.derechoAsubsidio),
      NombreDestinatario: this.normalizarValorStorage(payload.NombreDestinatario),
      cargoDestinatario: this.normalizarValorStorage(payload.cargoDestinatario),
      emailDestinatario: this.normalizarValorStorage(payload.emailDestinatario),
      telefonoDestinatario: this.normalizarValorStorage(payload.telefonoDestinatario),
      igualAQuienSeDirige: payload.igualAQuienSeDirige ?? null,
      porcentajeSubsidio: this.normalizarValorStorage(payload.porcentajeSubsidio),
      lineasNegocio: this.normalizarListadoStorage(payload.lineasNegocio ?? []),
      programasSeleccionados: this.normalizarListadoStorage(payload.programasSeleccionados ?? []),
      requiereIncluirAnexos: payload.requiereIncluirAnexos === 'si' || payload.requiereIncluirAnexos === 'no'
        ? payload.requiereIncluirAnexos
        : null,
      programasConAnexosSeleccionados: this.normalizarListadoStorage(payload.programasConAnexosSeleccionados ?? []),
    };
  }

  private restaurarColectivoDesdeStorage(): void {
    this.isRestoring = true;

    if (this.restaurarFormularioColectivoDesdeStorage()) {
      this.isRestoring = false;
      return;
    }

    this.restaurarProductosColectivoDesdeStorage();

    this.isRestoring = false;
  }

  private restaurarFormularioColectivoDesdeStorage(): boolean {
    try {
      const raw = localStorage.getItem(this.KEY_COLECTIVO_FORM_STORAGE);
      if (!raw) {
        return false;
      }

      const parsed = JSON.parse(raw) as Partial<ColectivoFormStorage>;
      const lineas = Array.isArray(parsed.lineasNegocio)
        ? parsed.lineasNegocio
          .map((item) => (item ?? '').toString().trim())
          .filter((item): item is string => !!item)
        : [];

      this.lineasNegocio.clear();
      lineas.forEach((linea) => this.lineasNegocio.push(new FormControl(linea)));

      this.programasSeleccionadosUI = new Set(
        Array.isArray(parsed.programasSeleccionados)
          ? parsed.programasSeleccionados
            .map((item) => (item ?? '').toString().trim())
            .filter((item): item is string => !!item)
          : []
      );

      this.requiereIncluirAnexos = parsed.requiereIncluirAnexos === 'si' || parsed.requiereIncluirAnexos === 'no'
        ? parsed.requiereIncluirAnexos
        : 'no';

      this.programasConAnexosSeleccionados = new Set(
        Array.isArray(parsed.programasConAnexosSeleccionados)
          ? parsed.programasConAnexosSeleccionados
            .map((item) => (item ?? '').toString().trim())
            .filter((item): item is string => !!item)
          : []
      );

      this.mostrarTodosEscenariosSubsidio = parsed.mostrarTodosEscenariosSubsidio === true;

      this.formColectivo.patchValue(
        {
          fechaPresentacion: this.parseFechaStorage(parsed.fechaPresentacion),
          fechaInicioVigencia: this.parseFechaStorage(parsed.fechaInicioVigencia),
          regional: this.valorPatchStorage(parsed.regional),
          canal: this.valorPatchStorage(parsed.canal),
          oficina: this.valorPatchStorage(parsed.oficina),
          tipoAsesor: this.valorPatchStorage(parsed.tipoAsesor),
          nit: this.valorPatchStorage(parsed.nit),
          colectivoNombre: this.valorPatchStorage(parsed.colectivoNombre),
          sector: this.valorPatchStorage(parsed.sector),
          departamento: this.valorPatchStorage(parsed.departamento),
          municipio: this.valorPatchStorage(parsed.municipio),
          clienteActual: this.valorPatchStorage(parsed.clienteActual),
          tarifa: this.valorPatchStorage(parsed.tarifa),
          usuariosCotizar: this.valorPatchStorage(parsed.usuariosCotizar),
          usuariosMayor60: this.valorPatchStorage(parsed.usuariosMayor60),
          UsuariosMayor60Total: this.valorPatchStorage(parsed.UsuariosMayor60Total),
          embarazosCurso: this.valorPatchStorage(parsed.embarazosCurso),
          NombreContacto: this.valorPatchStorage(parsed.NombreContacto),
          cargoContacto: this.valorPatchStorage(parsed.cargoContacto),
          emailContacto: this.valorPatchStorage(parsed.emailContacto),
          telefonoContacto: this.valorPatchStorage(parsed.telefonoContacto),
          derechoAsubsidio: this.valorPatchStorage(parsed.derechoAsubsidio),
          NombreDestinatario: this.valorPatchStorage(parsed.NombreDestinatario),
          cargoDestinatario: this.valorPatchStorage(parsed.cargoDestinatario),
          emailDestinatario: this.valorPatchStorage(parsed.emailDestinatario),
          telefonoDestinatario: this.valorPatchStorage(parsed.telefonoDestinatario),
          igualAQuienSeDirige: parsed.igualAQuienSeDirige ?? '',
          porcentajeSubsidio: this.valorPatchStorage(parsed.porcentajeSubsidio),
        },
        { emitEvent: false }
      );
      this.actualizarEstadoCamposDestinatario();

      if (lineas.length) {
        this.actualizarProgramasPorLineasSeleccionadas();
      } else {
        this.actualizarProgramasConAnexosDisponibles();
      }

      this.formColectivo.markAsPristine();
      return true;
    } catch (error) {
      console.error('No se pudo restaurar el formulario colectivo:', error);
      return false;
    }
  }

  private restaurarProductosColectivoDesdeStorage(): void {
    try {
      const raw = localStorage.getItem(this.KEY_COLECTIVO_PRODUCTOS_STORAGE);
      if (!raw) {
        return;
      }

      const parsed = JSON.parse(raw) as Partial<ColectivoProductosStorage>;
      const lineas = Array.isArray(parsed.lineasNegocio)
        ? parsed.lineasNegocio
          .map((item) => (item ?? '').toString().trim())
          .filter((item): item is string => !!item)
        : [];

      this.lineasNegocio.clear();
      lineas.forEach((linea) => this.lineasNegocio.push(new FormControl(linea)));

      this.programasSeleccionadosUI = new Set(
        Array.isArray(parsed.programasSeleccionados)
          ? parsed.programasSeleccionados
            .map((item) => (item ?? '').toString().trim())
            .filter((item): item is string => !!item)
          : []
      );

      this.requiereIncluirAnexos = parsed.requiereIncluirAnexos === 'si' || parsed.requiereIncluirAnexos === 'no'
        ? parsed.requiereIncluirAnexos
        : 'no';

      this.programasConAnexosSeleccionados = new Set(
        Array.isArray(parsed.programasConAnexosSeleccionados)
          ? parsed.programasConAnexosSeleccionados
            .map((item) => (item ?? '').toString().trim())
            .filter((item): item is string => !!item)
          : []
      );

      this.mostrarTodosEscenariosSubsidio = parsed.mostrarTodosEscenariosSubsidio === true;

      const derechoAsubsidio = (parsed.derechoAsubsidio ?? '').toString().trim();
      if (derechoAsubsidio) {
        this.formColectivo.get('derechoAsubsidio')?.setValue(derechoAsubsidio);
      }

      if (lineas.length) {
        this.actualizarProgramasPorLineasSeleccionadas();
      } else {
        this.actualizarProgramasConAnexosDisponibles();
      }
    } catch (error) {
      console.error('No se pudo restaurar la sección de productos a cotizar:', error);
    }
  }

  private obtenerSiguienteIdCotizacionStorage(): number {
    const raw = localStorage.getItem(this.KEY_COLECTIVO_ID_COTIZACION_SEQ);
    const actual = Number(raw);
    const siguiente = Number.isFinite(actual) && actual > 0 ? actual + 1 : 1;
    localStorage.setItem(this.KEY_COLECTIVO_ID_COTIZACION_SEQ, siguiente.toString());
    return siguiente;
  }

  private normalizarValorStorage(value: any): string | null {
    if (value === undefined || value === null || value === '') {
      return null;
    }

    return value.toString();
  }

  private normalizarListadoStorage(values: any[]): string[] {
    return (values ?? [])
      .map((value) => (value ?? '').toString().trim())
      .filter((value): value is string => !!value)
      .sort((a, b) => a.localeCompare(b));
  }

  private valorPatchStorage(value: any): string | null {
    if (value === undefined || value === null || value === '') {
      return null;
    }

    return value.toString();
  }


  private serializarFechaStorage(value: any): string | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return this.formatDate(value);
    }

    if (typeof value === 'object' && typeof value.format === 'function') {
      return value.format('YYYY-MM-DD');
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : this.formatDate(parsed);
  }

  private parseFechaStorage(value: any): Date | null {
    if (!value) {
      return null;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  private ensureProgramaAnexoInfo(programaCode: string): void {
    const trimmedCode = (programaCode || "").toString().trim();
    if (!trimmedCode) {
      return;
    }
    const existing = this.programaAnexoInfoMap[trimmedCode];
    const metadata = this.findProgramaMetadata(trimmedCode);
    if (existing?.anexos?.length) {
      this.actualizarProgramasConAnexosDisponibles();
      return;
    }

    if (existing?.subcta && existing?.planGrupo) {
      this.programaAnexoInfoMap[trimmedCode] = {
        ...existing,
        program: metadata?.program || existing.program || trimmedCode,
        file: metadata?.file || existing.file,
        isFetchingSubcuenta: false,
      };
      this.tryLoadAnexosForProgram(trimmedCode);
      return;
    }

    if (existing?.isFetchingSubcuenta) {
      return;
    }

    this.programaAnexoInfoMap[trimmedCode] = {
      code: trimmedCode,
      program: metadata?.program || trimmedCode,
      file: metadata?.file,
      subcta: existing?.subcta,
      planGrupo: existing?.planGrupo,
      anexos: existing?.anexos,
      isFetchingSubcuenta: true,
      isFetchingAnexos: existing?.isFetchingAnexos,
      lastError: existing?.lastError,
    };

    this.fetchSubcuentasParaPrograma(trimmedCode);
  }

  private fetchSubcuentasParaPrograma(programaCode: string): void {
    const entry = this.programaAnexoInfoMap[programaCode];
    if (!entry || !entry.isFetchingSubcuenta) {
      return;
    }

    this.consultarSubcuentasService.consultarSubcuentas(programaCode).subscribe({
      next: (response) => {
        const subcuentas: SubcuentaItem[] = response?.data?.jsonRespuesta ?? [];
        const candidate = this.findSubcuentaMatch(subcuentas);
        const updated: ProgramaAnexoInfo = {
          ...entry,
          isFetchingSubcuenta: false,
          subcta: candidate?.subcta?.toString().trim() || "",
          deno: candidate?.deno?.toString().trim() || "",
          planGrupo: candidate?.plan_grupo?.toString().trim() || "",
        };
        this.programaAnexoInfoMap[programaCode] = updated;
        this.tryLoadAnexosForProgram(programaCode);
      },
      error: (err) => {
        const updated: ProgramaAnexoInfo = {
          ...entry,
          isFetchingSubcuenta: false,
          lastError: err?.message,
          subcta: "",
          planGrupo: "",
          anexos: [],
        };
        this.programaAnexoInfoMap[programaCode] = updated;
        this.actualizarProgramasConAnexosDisponibles();
      },
    });
  }

  private tryLoadAnexosForProgram(programaCode: string): void {
    const entry = this.programaAnexoInfoMap[programaCode];
    if (!entry) {
      return;
    }
    if (entry.isFetchingAnexos) {
      return;
    }
    if (!entry.deno || !entry.planGrupo) {
      return;
    }
    if (!this.cuentaColectivo) {
      return;
    }

    const updated: ProgramaAnexoInfo = {
      ...entry,
      isFetchingAnexos: true,
    };
    this.programaAnexoInfoMap[programaCode] = updated;

    this.networking
      .consultarAnexos(this.cuentaColectivo, entry.deno, entry.planGrupo)
      .subscribe({
        next: (response) => {
          const anexosPayload: any[] = this.normalizeAnexosResponse(response);
          const result: ProgramaAnexoInfo = {
            ...updated,
            isFetchingAnexos: false,
            anexos: anexosPayload,
          };
          this.programaAnexoInfoMap[programaCode] = result;
          this.actualizarProgramasConAnexosDisponibles();
        },
        error: (error) => {
          const result: ProgramaAnexoInfo = {
            ...updated,
            isFetchingAnexos: false,
            lastError: error?.message,
            anexos: [],
          };
          this.programaAnexoInfoMap[programaCode] = result;
          this.actualizarProgramasConAnexosDisponibles();
        },
      });
  }

  private normalizeAnexosResponse(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (response?.data) {
      return Array.isArray(response.data) ? response.data : [response.data];
    }
    if (Array.isArray(response?.jsonRespuesta)) {
      return response.jsonRespuesta;
    }
    if (response?.json) {
      return Array.isArray(response.json) ? response.json : [response.json];
    }
    return [];
  }

  private findProgramaMetadata(
    programaCode: string
  ): {
    program: string;
    file?: string;
    grupoPrograma?: string;
  } | null {
    const trimmedCode = (programaCode || '')
      .toString()
      .trim();

    const listado = Object
      .values(this.programasCarnetPorLinea)
      .flat();

    const encontrado = listado.find(
      item =>
        (item.code || '').toString().trim() === trimmedCode
    );

    if (!encontrado) {
      return null;
    }

    return {
      program: encontrado.program,
      file: encontrado.file,
      grupoPrograma: encontrado.grupoPrograma
    };
  }

  private findSubcuentaMatch(subcuentas: SubcuentaItem[]): SubcuentaItem | undefined {
    if (!Array.isArray(subcuentas) || subcuentas.length === 0) {
      return undefined;
    }
    if (!this.colectivoSubcta) {
      return subcuentas[0];
    }
    const trimmedSubcta = this.colectivoSubcta;
    const trimmedCuenta = (this.cuentaColectivo || '').toString().trim();
    return (
      subcuentas.find((item) => {
        const subMatch = (item.subcta || '').toString().trim() === trimmedSubcta;
        if (!trimmedCuenta) {
          return subMatch;
        }
        return subMatch && String(item.cuenta ?? '').trim() === trimmedCuenta;
      }) ?? subcuentas[0]
    );
  }

  /** Metodo para bloquear el form */
  blockedForm(value: string[]) {
    for (let index = 0; index < value.length; index++) {
      this.form.controls[value[index]].disable();
    }
  }

  /** Metodo para habilitar el form */
  enableForm(value: string[]) {
    for (let index = 0; index < value.length; index++) {
      this.form.controls[value[index]].enable();
    }
  }

  /** Metodo para mostrar errores */
  errorsMsg(campo: string): string {
    const control = this.form.get(campo) ?? this.formColectivo.get(campo);
    const errors = control?.errors;
    if (errors?.['required']) return "El campo es requerido";
    if (errors?.['minlength'])
      return `El mínimo es de ${errors?.['minlength']?.requiredLength} caracteres`;
    if (errors?.['maxlength'])
      return `El máximo es de ${errors?.['maxlength']?.requiredLength} caracteres`;
    if (errors?.['pattern']) return "Formato inválido";
    if (errors?.['greaterThanTotal'])
      return "No puede ser mayor que usuarios a cotizar";
    return "";
  }

  /** Metodo para disparar alertas al tocar el input */
  fieldsValidators(campo: string) {
    const control = this.form.get(campo) ?? this.formColectivo.get(campo);
    return !!(control?.invalid && control?.touched);
  }

  private actualizarPorcentajeUsuariosMayores(): void {
    const totalUsuarios = Number(this.formColectivo.get('usuariosCotizar')?.value);
    const usuariosMayores = Number(this.formColectivo.get('usuariosMayor60')?.value);
    const porcentajeControl = this.formColectivo.get('UsuariosMayor60Total');
    const usuariosMayoresControl = this.formColectivo.get('usuariosMayor60');

    if (!porcentajeControl || !usuariosMayoresControl) {
      return;
    }

    if (usuariosMayoresControl.hasError('greaterThanTotal')) {
      const { greaterThanTotal, ...otrosErrores } = usuariosMayoresControl.errors ?? {};
      usuariosMayoresControl.setErrors(Object.keys(otrosErrores).length ? otrosErrores : null);
    }

    if (!totalUsuarios || Number.isNaN(totalUsuarios) || Number.isNaN(usuariosMayores)) {
      porcentajeControl.setValue('', { emitEvent: false });
      return;
    }

    if (usuariosMayores > totalUsuarios) {
      usuariosMayoresControl.setErrors({
        ...(usuariosMayoresControl.errors ?? {}),
        greaterThanTotal: true,
      });
      porcentajeControl.setValue('', { emitEvent: false });
      return;
    }

    const porcentaje = (usuariosMayores / totalUsuarios) * 100;
    porcentajeControl.setValue(`${porcentaje.toFixed(2)}%`, { emitEvent: false });
  }

  async guardarInformacionColectivo(onSuccess?: () => void): Promise<boolean> {
    this.mostrarAlertaCamposColectivo = false;
    this.formColectivo.markAllAsTouched();

    if (this.formColectivo.invalid) {
      this.mostrarAlertaCamposColectivo = true;
      return false;
    }

    const hayCambiosPendientes = this.hayCambiosColectivoPendientes();

    // Si no hay cambios desde el último guardado, no invalidar liquidación ni resetear el resumen.
    if (!hayCambiosPendientes) {
      this.colectivoFormSaved = true;
      this.formColectivo.markAsPristine();
      onSuccess?.();
      return true;
    }

    const idCotizacion = this.guardarFormularioColectivoEnStorage();
    this.idCotizacionColectivo = idCotizacion;

    // Solo resetea la liquidación cuando hubo cambios reales en colectivo/productos.
    if (hayCambiosPendientes) {
      this._editSessionDirty = true;
      this.liquidacionColectivoGuardada = false;
      this.resetResumenCotizacionColectivo();
      this.resumenCotizacionColectivoData = [];
    }

    //const payload = this.construirPayloadCotizacionColectivo();

    const payload = await this.construirPayloadCotizacionColectivo();

    const continuarGuardado = () => {
      this.validarNitDisponibleParaGuardarColectivo(
        payload.numDocumento || "",
        payload.idCotizacion,
        () => this.guardarCotizacionGeneralYColectivoYContacto(payload, onSuccess),
      );
    };

    continuarGuardado();

    return true;
  }

  /**
   * Detecta los programas que estaban en la cotización al iniciar la edición y que el
   * usuario quitó de la selección actual. Devuelve los códigos quitados (uppercase).
   */
  private obtenerProgramasQuitadosEdicion(): string[] {
    if (!this.isEditMode || !this._programasOriginalesEdicion?.size) {
      return [];
    }
    const seleccionActual = new Set(
      Array.from(this.programasSeleccionadosUI).map((c) => (c || '').toString().trim().toUpperCase()),
    );
    return Array.from(this._programasOriginalesEdicion).filter((code) => !seleccionActual.has(code));
  }

  /**
   * Muestra un diálogo de confirmación antes de guardar cuando se quitaron programas,
   * advirtiendo que se eliminarán esos programas y sus liquidaciones asociadas.
   */
  private confirmarEliminacionProgramasColectivo(programasQuitados: string[], onConfirm: () => void): void {
    const nombres = programasQuitados
      .map((code) => (this.findProgramaMetadata(code)?.program || code).toString().trim())
      .join(', ');
    const esPlural = programasQuitados.length > 1;
    this.showMessageDialog(
      'Confirmar cambios',
      `Vas a quitar ${esPlural ? 'los programas' : 'el programa'}: ${nombres}. ` +
      `Esta acción eliminará su información y las liquidaciones asociadas. ¿Deseas continuar?`,
      'Continuar',
      'Cancelar',
      false,
      2,
      this.dialog,
      (confirmado: boolean) => {
        if (confirmado) {
          onConfirm();
        }
      },
    );
  }

  /**
   * Refresca el estado local de liquidaciones desde el backend tras un guardado en
   * edición. El PUT colectivo puede haber eliminado liquidaciones en cascada (líneas
   * quitadas); este refresco evita que queden IDs fantasma en _liquidacionesEdicion.
   */
  private refrescarLiquidacionesEdicion(idCotizacion: number): void {
    if (!this.isEditMode || !idCotizacion) {
      return;
    }
    this.networking.getLiquidacionColectivo(idCotizacion).subscribe({
      next: (resp) => {
        this._liquidacionesEdicion = Array.isArray(resp?.data) ? resp.data : [];
      },
      error: (err) => {
        console.warn('No se pudo refrescar las liquidaciones tras guardar:', err);
      },
    });
  }

  private validarNitDisponibleParaGuardarColectivo(
    nit: string,
    idCotizacionActual: number,
    onContinue: () => void,
  ): void {
    const nitTrimmed = (nit || "").toString().trim();

    if (!nitTrimmed) {
      onContinue();
      return;
    }

    // En modo edición la cotización activa ES la que estamos editando → no bloquear
    if (this.isEditMode) {
      onContinue();
      return;
    }

    const idAsesorActual = this.obtenerIdAsesorActual() ?? 0;

    this.spinner.show();
    this.cotizacionColectivoService.buscarEmpresaPorNit(nitTrimmed, idAsesorActual).subscribe({
      next: (response) => {
        this.spinner.hide();

        if (!response?.tieneCotizacionActiva) {
          onContinue();
          return;
        }

        const cotizacionActiva =
          response?.cotizacionActiva ??
          response?.data?.cotizacionActiva ??
          response?.cotizacion ??
          response?.data?.cotizacion ??
          null;

        const idCotizacionEncontrada = Number(
          cotizacionActiva?.idCotizacion ??
          cotizacionActiva?.id ??
          0
        );

        // Permitir continuar si es la misma cotización en edición
        if (
          idCotizacionActual &&
          idCotizacionEncontrada &&
          idCotizacionActual === idCotizacionEncontrada
        ) {
          onContinue();
          return;
        }

        this.showMessageDialog(
          "Información",
          "Ya existe una cotización activa con ese NIT. Inténtalo nuevamente.",
          "Aceptar",
          "",
          true,
          1,
          this.dialog,
          (_: any) => { },
        );
      },
      error: (error) => {
        this.spinner.hide();
        console.error("Error validando NIT:", error);
        this.SnackBarService.alert(
          "alert-danger",
          "No fue posible validar el NIT antes de guardar la cotización.",
          4000,
          "Cerrar",
        );
      },
    });
  }

  private guardarCotizacionColectivaEnApi(
    payload: CotizacionColectivo,
    onSuccess?: (cotizacionGuardada: CotizacionColectivo) => void,
  ): void {
    this.spinner.show();

    this.cotizacionColectivoService.guardar(payload).subscribe({
      next: (response: CotizacionColectivo) => {
        console.log('Cotización colectiva guardada con éxito:', response);
        this.spinner.hide();

        const cotizacionGuardada: CotizacionColectivo = {
          ...payload,
          ...response,
          idCotizacion: Number(response?.idCotizacion ?? payload.idCotizacion),
        };

        this.asignarCotizacionColectivoActual(cotizacionGuardada);
        this.idCotizacionColectivo = cotizacionGuardada.idCotizacion;
        localStorage.setItem('idCotizacion', cotizacionGuardada.idCotizacion.toString());
        this.resumenCotizacionColectivoData = this.construirResumenCotizacionColectivoLocal();

        this.colectivoFormSaved = true;
        this.tabHabilitado.cotizacion = true;
        this.formColectivo.markAsPristine();

        this.SnackBarService.alert(
          "alert-success",
          "Información guardada correctamente.",
          3000,
          "Cerrar",
        );
        onSuccess?.(cotizacionGuardada);
      },
      error: (error: any) => {
        this.spinner.hide();
        this.colectivoFormSaved = false;

        console.error("Error guardando cotizacion colectiva:", error);

        const mensaje =
          error?.error?.message ||
          "No fue posible guardar la cotización colectiva.";

        this.SnackBarService.alert(
          "alert-danger",
          mensaje,
          4000,
          "Cerrar",
        );
      }
    });
  }

  /**
   * Actualiza una cotización colectiva existente (modo edición).
   * Usa PUT en vez de POST para no crear duplicados.
   */
  private actualizarCotizacionColectivaEnApi(
    payload: CotizacionColectivo,
    onSuccess?: (cotizacionGuardada: CotizacionColectivo) => void,
  ): void {
    this.spinner.show();
    const idCotizacion = payload.idCotizacion;
    // console.log('[PUT colectivo] payload enviado:', JSON.stringify(payload, null, 2));

    this.cotizacionColectivoService.actualizar(idCotizacion, payload).subscribe({
      next: (response: CotizacionColectivo) => {
        this.spinner.hide();

        const cotizacionGuardada: CotizacionColectivo = {
          ...payload,
          ...response,
          idCotizacion: Number(response?.idCotizacion ?? payload.idCotizacion),
        };

        this.asignarCotizacionColectivoActual(cotizacionGuardada);
        this.idCotizacionColectivo = cotizacionGuardada.idCotizacion;
        this.resumenCotizacionColectivoData = this.construirResumenCotizacionColectivoLocal();

        this.colectivoFormSaved = true;
        this.tabHabilitado.cotizacion = true;
        this.formColectivo.markAsPristine();

        this.SnackBarService.alert(
          "alert-success",
          "Información actualizada correctamente.",
          3000,
          "Cerrar",
        );
        // Refrescar liquidaciones: el PUT pudo eliminar en cascada las de programas quitados.
        this.refrescarLiquidacionesEdicion(cotizacionGuardada.idCotizacion);
        onSuccess?.(cotizacionGuardada);
      },
      error: (error: any) => {
        this.spinner.hide();
        this.colectivoFormSaved = false;

        console.error("Error actualizando cotización colectiva:", error);
        console.error('[PUT colectivo] error body:', JSON.stringify(error?.error));

        const mensaje =
          error?.error?.message ||
          "No fue posible actualizar la cotización colectiva.";

        this.SnackBarService.alert(
          "alert-danger",
          mensaje,
          4000,
          "Cerrar",
        );
      }
    });
  }

  onBusquedaResumenColectivoChange(value: string): void {
    this.busquedaResumenColectivo = this.sanitizarBusquedaResumenColectivo(value);
    this.paginaResumenColectivoActual = 0;
  }

  onBusquedaResumenColectivoInputChange(value: string): void {
    this.busquedaResumenColectivoInput = this.sanitizarBusquedaResumenColectivo(value);
  }

  onBusquedaResumenColectivoKeyPress(event: KeyboardEvent): void {
    const key = event.key;
    if (!key || key.length !== 1) return;

    const esPermitido = /^[a-zA-Z0-9]$/.test(key);
    if (!esPermitido) {
      event.preventDefault();
    }
  }

  private sanitizarBusquedaResumenColectivo(value: string | null | undefined): string {
    return (value ?? '').replace(/[^a-zA-Z0-9]/g, '');
  }

  limpiarResumenCotizacionColectivo(): void {
    this.resetResumenCotizacionColectivo();
  }

  private obtenerIdCotizacionDesdeStorage(): number {
    const rawCurrent = localStorage.getItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
    if (rawCurrent) {
      try {
        const parsed = JSON.parse(rawCurrent) as Partial<CotizacionColectivo> & {
          id?: number | string;
          ID_COTIZACION?: number | string;
          id_cotizacion?: number | string;
        };
        const currentId = Number(
          parsed?.idCotizacion ??
          parsed?.id ??
          parsed?.ID_COTIZACION ??
          parsed?.id_cotizacion ??
          0
        );
        if (Number.isFinite(currentId) && currentId > 0) {
          return currentId;
        }
      } catch (e) {
        console.error('Error leyendo cotizacion_colectivo_actual', e);
      }
    }

    const fromCurrent = Number(this.cotizacionColectivoActual?.idCotizacion ?? 0);
    if (Number.isFinite(fromCurrent) && fromCurrent > 0) {
      return fromCurrent;
    }

    const rawGeneralId = localStorage.getItem('idCotizacion');
    const generalId = Number(rawGeneralId ?? 0);
    if (Number.isFinite(generalId) && generalId > 0) {
      return generalId;
    }

    return 0;
  }

  guardarResumenCotizacionColectivo(nextIndex?: number): void {
    const items = this.resumenCotizacionColectivo;
    if (!items.length) {
      this.SnackBarService.alert('alert-warning', 'No hay programas en el resumen para guardar.', 3000, 'Cerrar');
      this.liquidacionColectivoGuardada = false;
      return;
    }

    const idCotizacion = this.obtenerIdCotizacionDesdeStorage();
    if (!Number.isFinite(idCotizacion) || idCotizacion <= 0) {
      this.SnackBarService.alert(
        'alert-danger',
        'No se encontró un idCotizacion válido para guardar la liquidación colectiva. Guarda primero la cotización del colectivo.',
        4000,
        'Cerrar'
      );
      this.liquidacionColectivoGuardada = false;
      return;
    }

    const huboModificaciones = this._editSessionDirty || this.hayCambiosColectivoPendientes();

    const usuarioCreacion = this.cedulaAsesor || 'cotizador';
    const cantidadUsuariosFormulario = (this.formColectivo.get('usuariosCotizar')?.value || '').toString();
    const derechoASubsidio = this.derechoASubsidioSeleccionado;
    const porcentajeSubsidio = this.porcentajeSubsidioSeleccionado;

    // Set para evitar que dos items del resumen reclamen el mismo idLiquidacionCol.
    const claimedLiqIds = new Set<number>();

    const payload: LiquidacionColectivoRequest[] = items.map(item => {
      // Base del objeto que siempre se envía
      const baseObj: any = {
        idCotizacion,
        idBenPrograma: item.idBenPrograma,
        rangoEdad: item.rangoEdad,
        edadDesde: item.edadDesde,
        edadHasta: item.edadHasta,
        tarifaSinSubsidio: 0,
        tarifa50PctSubsidio: 0,
        tarifa100PctSubsidio: 0,
        tarifaAnexo: 0,
        lineaNegocioCol: item.lineaNegocioCol,
        grupoProgramaCol: item.grupoProgramaCol,
        programaCol: item.programa,
        cantidadUsuarios: item.cantidadUsuarios || cantidadUsuariosFormulario,
        aplicaAnexos: item.aplicaAnexoServicio,
        usuarioCreacion,
      };

      if (item.aplicaAnexoServicio || Number(item.tarifaAnexo) > 0) {
        baseObj.tarifaAnexo = item.tarifaAnexo;
      }

      // En modo edición, buscar idLiquidacionCol existente para que el backend haga UPDATE.
      // Tier 1: match exacto (idBenPrograma + rangoEdad + programaCol + cantidadUsuarios)
      // Tier 2: fallback por programaCol si los metadatos cambiaron y hay un único candidato no reclamado.
      if (this.isEditMode && this._liquidacionesEdicion.length) {
        const programaColNorm = String(baseObj.programaCol ?? '').trim().toLowerCase();
        let existente = this._liquidacionesEdicion.find(
          liq => !claimedLiqIds.has(liq.idLiquidacionCol) &&
            Number(liq.idBenPrograma) === Number(item.idBenPrograma) &&
            String(liq.rangoEdad ?? '').trim() === String(item.rangoEdad ?? '').trim() &&
            String(liq.programaCol ?? '').trim().toLowerCase() === programaColNorm &&
            String(liq.cantidadUsuarios ?? '').trim() === String(baseObj.cantidadUsuarios ?? '').trim()
        );
        if (!existente) {
          const candidates = this._liquidacionesEdicion.filter(
            liq => !claimedLiqIds.has(liq.idLiquidacionCol) &&
              Number(liq.idBenPrograma) === Number(item.idBenPrograma) &&
              String(liq.programaCol ?? '').trim().toLowerCase() === programaColNorm
          );
          if (candidates.length === 1) existente = candidates[0];
        }
        if (existente?.idLiquidacionCol) {
          baseObj.idLiquidacionCol = existente.idLiquidacionCol;
          claimedLiqIds.add(existente.idLiquidacionCol);
        }
      }

      // El switch muestra todos los escenarios.
      if (this.mostrarTodosEscenariosSubsidio) {
        baseObj.tarifaSinSubsidio = item.tarifaSinSubsidio;
        baseObj.tarifa50PctSubsidio = item.tarifaSubsidio50;
        baseObj.tarifa100PctSubsidio = item.tarifaSubsidio100;
        return baseObj;
      }

      // Sin switch: derecho a subsidio = NO -> solo tarifa sin subsidio.
      if (derechoASubsidio !== '1') {
        baseObj.tarifaSinSubsidio = item.tarifaSinSubsidio;
        return baseObj;
      }

      // Sin switch: derecho a subsidio = SI -> solo la tarifa del porcentaje seleccionado.
      if (porcentajeSubsidio === '1') {
        baseObj.tarifa50PctSubsidio = item.tarifaSubsidio50;
      } else if (porcentajeSubsidio === '2') {
        baseObj.tarifa100PctSubsidio = item.tarifaSubsidio100;
      } else {
        // Fallback defensivo si no hay porcentaje seleccionado.
        baseObj.tarifaSinSubsidio = item.tarifaSinSubsidio;
      }

      return baseObj;
    });

    this.guardarFormularioColectivoEnStorage();
    this.guardarProductosColectivoEnStorage();
    this.liquidacionColectivoGuardada = false;
    this.spinner.show();

    // Modo edición: sincronizar (DELETE + INSERT) para dejar la tabla con exactamente los programas vigentes
    if (this.isEditMode) {
      const payloadSinId = payload.map(({ idLiquidacionCol: _, ...rest }) => rest);
      this.networking.sincronizarLiquidacionColectivo(idCotizacion, payloadSinId).pipe(
        switchMap((response) => {
          if (!response?.status) {
            throw new Error(response?.errorMessage || 'Error al sincronizar la liquidación colectiva.');
          }
          if (Array.isArray(response.data)) {
            this._liquidacionesEdicion = response.data as LiquidacionColectivoItem[];
          }
          return this.networking.actualizarEstadoCotizacion(idCotizacion, 2).pipe(
            map(() => response),
          );
        }),
      ).subscribe({
        next: async (response) => {
          this.spinner.hide();
          this.liquidacionColectivoGuardada = true;
          this.colectivoFormSaved = true;
          this.formColectivo.markAsPristine();
          this.guardarProductosColectivoEnStorage();
          await this.sincronizarProgramasColectivoParaBeneficiarios();
          this.SnackBarService.alert('alert-success', response.message || 'Liquidación colectiva guardada y estado actualizado correctamente.', 4000, 'Cerrar');
          if (huboModificaciones) {
            this._editSessionDirty = false;
            this.networkingMisCot.evaluarVersiones(idCotizacion).subscribe({
              next: (r) => {
                console.log('[evaluarVersiones] colectivo edit:', r.data);
                if (r.data?.versionCreada && this.idCotizacionEdicion) {
                  this.cargarVersiones(this.idCotizacionEdicion);
                }
              },
              error: (e) => console.error('[evaluarVersiones] colectivo edit error:', e),
            });
          }
          if (typeof nextIndex === 'number') {
            this.executeTabOption(nextIndex);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.liquidacionColectivoGuardada = false;
          console.error('Error sincronizando liquidación colectiva o actualizando estado:', err);
          this.SnackBarService.alert('alert-danger', err?.message || 'Error al guardar la liquidación colectiva o actualizar el estado de la cotización. Intente nuevamente.', 4000, 'Cerrar');
        },
      });
      return;
    }

    // Modo creación: POST guardar (UPSERT)
    this.networking.guardarLiquidacionColectivo(payload).pipe(
      switchMap((response) => {
        if (!response?.status) {
          throw new Error(response?.errorMessage || 'Error al guardar la liquidación colectiva.');
        }
        return this.networking.actualizarEstadoCotizacion(idCotizacion, 2).pipe(
          map(() => response),
        );
      }),
    ).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.liquidacionColectivoGuardada = true;
        this.colectivoFormSaved = true;
        this.formColectivo.markAsPristine();
        this.guardarProductosColectivoEnStorage();
        this.SnackBarService.alert('alert-success', response.message || 'Liquidación colectiva guardada y estado actualizado correctamente.', 4000, 'Cerrar');
        if (huboModificaciones) {
          this._editSessionDirty = false;
          this.networkingMisCot.evaluarVersiones(idCotizacion).subscribe({
            next: (r) => {
              console.log('[evaluarVersiones] colectivo create:', r.data);
              if (r.data?.versionCreada && this.idCotizacionEdicion) {
                this.cargarVersiones(this.idCotizacionEdicion);
              }
            },
            error: (e) => console.error('[evaluarVersiones] colectivo create error:', e),
          });
        }
        if (typeof nextIndex === 'number') {
          this.executeTabOption(nextIndex);
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.liquidacionColectivoGuardada = false;
        console.error('Error guardando liquidación colectiva o actualizando estado:', err);
        this.SnackBarService.alert('alert-danger', err?.message || 'Error al guardar la liquidación colectiva o actualizar el estado de la cotización. Intente nuevamente.', 4000, 'Cerrar');
      },
    });
  }

  onRegistrosPorPaginaResumenColectivoChange(value: string | number): void {
    const parsed = Number(value);
    this.registrosPorPaginaResumenColectivo = parsed > 0 ? parsed : 10;
    this.paginaResumenColectivoActual = 0;
  }

  irAPrimeraPaginaResumenColectivo(): void {
    this.paginaResumenColectivoActual = 0;
  }

  irAPaginaAnteriorResumenColectivo(): void {
    if (this.paginaResumenColectivoActual > 0) {
      this.paginaResumenColectivoActual--;
    }
  }

  irAPaginaSiguienteResumenColectivo(): void {
    if (this.paginaResumenColectivoActual < this.totalPaginasResumenColectivo - 1) {
      this.paginaResumenColectivoActual++;
    }
  }

  irAUltimaPaginaResumenColectivo(): void {
    this.paginaResumenColectivoActual = this.totalPaginasResumenColectivo - 1;
  }

  private resetResumenCotizacionColectivo(): void {
    this.mostrarTodosEscenariosSubsidio = false;
    this.busquedaResumenColectivo = '';
    this.busquedaResumenColectivoInput = '';
    this.registrosPorPaginaResumenColectivo = 10;
    this.paginaResumenColectivoActual = 0;
  };

  private guardarCotizacionGeneralYColectivoYContacto(
    payload: CotizacionColectivo,
    onSuccess?: () => void,
  ): void {
    this.spinner.show();
    this.obtenerIdAsesorLogueadoObservable().pipe(take(1)).subscribe({
      next: (idasesor) => {
        const idAsesorExtraido = idasesor?.toString() ?? '0';
        const tipoSolicitud = this.formInit.get('tipoSolicitud')?.value;
        const esColectivo = tipoSolicitud === '3';

        // Para colectivo, idTipoCotizacion siempre es 2 (u)
        const idTipoCotizacionFinal = esColectivo ? 2 : this.mapTipoCotizacionToId(this.formInit.get('tipoCotizacion')?.value);

        const request: CrearCotizacionRequest = {
          idAsesor: idAsesorExtraido,
          idTipoSolicitud: 3,
          idTipoPlan: this.mapTipoPlanToId(this.formInit.get('tipoPlan')?.value),
          pasoActual: 1,
          observaciones: '',
          idTipoCotizacion: idTipoCotizacionFinal,
          cotizacionProbabilidadCierre: {
            idProbabilidadCierre: 3
          },
          cotizacionEstado: {
            idCotizacionEstado: 1
          },
        };

        console.log('🚀 Generando cotización:', {
          esColectivo,
          tipoSolicitud,
          idTipoPlan: request.idTipoPlan,
          idTipoCotizacion: request.idTipoCotizacion,
          requestCompleto: request
        });

        if (request.idTipoPlan <= 0 || request.idTipoCotizacion <= 0) {
          this.spinner.hide();
          this.SnackBarService.alert(
            "alert-danger",
            "No se pudo construir el request de cotización. Verifica el tipo de plan y tipo de cotización.",
            4000,
            "Cerrar",
          );
          return;
        }

        // Modo edición: actualizar cotización existente (PUT) sin crear duplicados
        if (this.isEditMode && this.idCotizacionEdicion) {
          const idCotizacion = this.idCotizacionEdicion;
          this.cotizacionService.actualizarCotizacion(idCotizacion, request).subscribe({
            next: () => {
              console.log('✅ Cotización actualizada con éxito:', { idCotizacion });
              payload.idCotizacion = idCotizacion;
              this.actualizarCotizacionColectivaEnApi(payload, (cotizacionGuardada) => {
                this.guardarContactoColectivo(cotizacionGuardada, onSuccess);
              });
            },
            error: (error: any) => {
              this.spinner.hide();
              console.error("❌ Error actualizando cotización general:", error);
              this.SnackBarService.alert(
                "alert-danger",
                "No fue posible actualizar la cotización.",
                4000,
                "Cerrar",
              );
            },
          });
          return;
        }

        // Modo creación: crear cotización nueva (POST)
        this.cotizacionService.crearCotizacion(request).subscribe({
          next: (response: any) => {
            const idCotizacionNueva = Number(response?.data?.idCotizacion ?? 0);
            if (!Number.isFinite(idCotizacionNueva) || idCotizacionNueva <= 0) {
              this.spinner.hide();
              this.SnackBarService.alert(
                "alert-danger",
                "No se pudo obtener el id de cotización desde el servicio.",
                4000,
                "Cerrar",
              );
              return;
            }

            console.log('✅ Cotización creada con éxito:', { idCotizacionNueva, response });

            // Guardar idCotizacion en localStorage
            localStorage.setItem('idCotizacion', idCotizacionNueva.toString());

            payload.idCotizacion = idCotizacionNueva;
            this.guardarCotizacionColectivaEnApi(payload, (cotizacionGuardada) => {
              this.guardarContactoColectivo(cotizacionGuardada, onSuccess);
            });
          },
          error: (error: any) => {
            this.spinner.hide();
            console.error("❌ Error creando cotización general:", error);
            this.SnackBarService.alert(
              "alert-danger",
              "No fue posible crear la cotización general.",
              4000,
              "Cerrar",
            );
          },
        });
      },
      error: (error: any) => {
        this.spinner.hide();
        console.error("Error obteniendo idAsesor logueado:", error);
        this.SnackBarService.alert(
          "alert-danger",
          "No fue posible obtener el id del asesor logueado.",
          4000,
          "Cerrar",
        );
      },
    });
  }

  // private guardarContactoColectivo(
  //   cotizacionGuardada: CotizacionColectivo,
  //   onSuccess?: () => void,
  // ): void {
  //   const raw = this.formColectivo.getRawValue();
  //   const igualAQuienSeDirige = this.esSwitchContactoIgualActivo(raw.igualAQuienSeDirige);

  //   const operaciones: Observable<any>[] = [];

  //   // Siempre guardar el contacto principal
  //   const contactoPayload: CotizacionColectivoContacto = this.construirPayloadContacto(cotizacionGuardada);
  //   if (contactoPayload.idColectivo && contactoPayload.idCotizacion) {
  //     operaciones.push(
  //       (this.isEditMode && contactoPayload.idContacto)
  //         ? this.cotizacionColectivoContactoService.actualizar(contactoPayload)
  //         : this.cotizacionColectivoContactoService.crear(contactoPayload)
  //     );
  //   }

  //   // Si no es igual, guardar el destinatario. Si ahora sí es igual, eliminar el destinatario previo.
  //   if (!igualAQuienSeDirige) {
  //     const destinatarioPayload: CotizacionColectivoContacto = this.construirPayloadDestinatario(cotizacionGuardada);
  //     if (destinatarioPayload.idColectivo && destinatarioPayload.idCotizacion) {
  //       operaciones.push(
  //         (this.isEditMode && destinatarioPayload.idContacto)
  //           ? this.cotizacionColectivoContactoService.actualizar(destinatarioPayload)
  //           : this.cotizacionColectivoContactoService.crear(destinatarioPayload)
  //       );
  //     }
  //   } else if (this.isEditMode && this._idDestinatarioEdicion) {
  //     operaciones.push(this.cotizacionColectivoContactoService.eliminar(this._idDestinatarioEdicion));
  //   }

  //   if (operaciones.length === 0) {
  //     this.SnackBarService.alert(
  //       "alert-danger",
  //       "No se pudo construir los contactos del colectivo.",
  //       4000,
  //       "Cerrar",
  //     );
  //     return;
  //   }

  //   this.spinner.show();
  //   forkJoin(operaciones).subscribe({
  //     next: () => {
  //       this.spinner.hide();
  //       if (igualAQuienSeDirige) {
  //         this._idDestinatarioEdicion = null;
  //       }
  //       this.SnackBarService.alert(
  //         "alert-success",
  //         "Contactos guardados correctamente.",
  //         3000,
  //         "Cerrar",
  //       );
  //       onSuccess?.();
  //     },
  //     error: (error: any) => {
  //       this.spinner.hide();
  //       console.error("Error guardando contactos colectivo:", error);
  //       this.SnackBarService.alert(
  //         "alert-danger",
  //         "No fue posible guardar los contactos del colectivo.",
  //         4000,
  //         "Cerrar",
  //       );
  //     },
  //   });
  // }

  private guardarContactoColectivo(
    cotizacionGuardada: CotizacionColectivo,
    onSuccess?: () => void,
  ): void {
    const raw = this.formColectivo.getRawValue();
    const igualAQuienSeDirige = this.esSwitchContactoIgualActivo(raw.igualAQuienSeDirige);

    // Si el switch está activo, antes de guardar copiamos contacto -> destinatario
    if (igualAQuienSeDirige) {
      this.copiarContactoADestinatario(false);
    }

    const contactoPayload: CotizacionColectivoContacto = this.construirPayloadContacto(cotizacionGuardada);
    const destinatarioPayload: CotizacionColectivoContacto = this.construirPayloadDestinatario(cotizacionGuardada);

    // Modo edición: sincronizar todos los contactos en una sola llamada
    if (this.isEditMode) {
      const contactosParaSincronizar: CotizacionColectivoContacto[] = [];

      if (contactoPayload.idColectivo && contactoPayload.idCotizacion) {
        const { idContacto: _, ...sinId } = contactoPayload;
        contactosParaSincronizar.push(sinId);
      }

      if (destinatarioPayload.idColectivo && destinatarioPayload.idCotizacion) {
        const { idContacto: _, ...sinId } = destinatarioPayload;
        contactosParaSincronizar.push(sinId);
      }

      if (contactosParaSincronizar.length === 0) {
        this.SnackBarService.alert(
          "alert-danger",
          "No se pudo construir los contactos del colectivo.",
          4000,
          "Cerrar",
        );
        return;
      }

      this.spinner.show();
      this.cotizacionColectivoContactoService
        .sincronizar(cotizacionGuardada.idCotizacion, contactosParaSincronizar)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.SnackBarService.alert(
              "alert-success",
              "Contactos guardados correctamente.",
              3000,
              "Cerrar",
            );
            onSuccess?.();
          },
          error: (error: any) => {
            this.spinner.hide();
            console.error("Error sincronizando contactos colectivo:", error);
            this.SnackBarService.alert(
              "alert-danger",
              "No fue posible guardar los contactos del colectivo.",
              4000,
              "Cerrar",
            );
          },
        });
      return;
    }

    // Modo creación: guardar contactos individualmente
    const operaciones: Observable<any>[] = [];

    if (contactoPayload.idColectivo && contactoPayload.idCotizacion) {
      operaciones.push(this.cotizacionColectivoContactoService.crear(contactoPayload));
    }

    if (destinatarioPayload.idColectivo && destinatarioPayload.idCotizacion) {
      operaciones.push(this.cotizacionColectivoContactoService.crear(destinatarioPayload));
    }

    if (operaciones.length === 0) {
      this.SnackBarService.alert(
        "alert-danger",
        "No se pudo construir los contactos del colectivo.",
        4000,
        "Cerrar",
      );
      return;
    }

    this.spinner.show();

    forkJoin(operaciones).subscribe({
      next: () => {
        this.spinner.hide();
        this.SnackBarService.alert(
          "alert-success",
          "Contactos guardados correctamente.",
          3000,
          "Cerrar",
        );
        onSuccess?.();
      },
      error: (error: any) => {
        this.spinner.hide();
        console.error("Error guardando contactos colectivo:", error);
        this.SnackBarService.alert(
          "alert-danger",
          "No fue posible guardar los contactos del colectivo.",
          4000,
          "Cerrar",
        );
      },
    });
  }

  private copiarContactoADestinatario(emitEvent: boolean = false): void {
    const raw = this.formColectivo.getRawValue();

    this.formColectivo.patchValue(
      {
        NombreDestinatario: (raw.NombreContacto ?? '').toString().toUpperCase(),
        cargoDestinatario: (raw.cargoContacto ?? '').toString().toUpperCase(),
        emailDestinatario: raw.emailContacto ?? '',
        telefonoDestinatario: raw.telefonoContacto ?? '',
      },
      { emitEvent }
    );
  }

  private construirPayloadContacto(
    cotizacionGuardada: CotizacionColectivo,
  ): CotizacionColectivoContacto {
    const raw = this.formColectivo.getRawValue();
    return {
      ...(this.isEditMode && this._idContactoEdicion ? { idContacto: this._idContactoEdicion } : {}),
      idColectivo: Number(cotizacionGuardada.idColectivo ?? 0),
      idCotizacion: Number(cotizacionGuardada.idCotizacion),
      rolContacto: 'CONTACTO',
      nombre: (raw.NombreContacto || '').toString().trim(),
      cargo: (raw.cargoContacto || '').toString().trim(),
      email: (raw.emailContacto || '').toString().trim(),
      telefono: (raw.telefonoContacto || '').toString().trim(),
    };
  }

  private construirPayloadDestinatario(
    cotizacionGuardada: CotizacionColectivo,
  ): CotizacionColectivoContacto {
    const raw = this.formColectivo.getRawValue();
    return {
      ...(this.isEditMode && this._idDestinatarioEdicion ? { idContacto: this._idDestinatarioEdicion } : {}),
      idColectivo: Number(cotizacionGuardada.idColectivo ?? 0),
      idCotizacion: Number(cotizacionGuardada.idCotizacion),
      rolContacto: 'DESTINATARIO',
      nombre: (raw.NombreDestinatario || '').toString().trim(),
      cargo: (raw.cargoDestinatario || '').toString().trim(),
      email: (raw.emailDestinatario || '').toString().trim(),
      telefono: (raw.telefonoDestinatario || '').toString().trim(),
    };
  }

  private mapTipoPlanToId(tipoPlan: string): number {
    const value = (tipoPlan || '').toString().trim().toUpperCase();
    if (!value) return 4; // Default to C for colectivo
    switch (value) {
      case 'F':
        return 2;
      case 'A':
        return 1;
      case 'E':
        return 3;
      case 'C':
        return 4;
      case 'GA':
        return 5;
      default:
        return 4;
    }
  }

  private mapTipoCotizacionToId(tipoCotizacion: string): number {
    const value = (tipoCotizacion || '').toString().trim().toLowerCase();
    if (!value) return 1; // Default to m for colectivo
    switch (value) {
      case 'm':
        return 1;
      case 'u':
        return 2;
      default:
        return 1;
    }
  }

  private obtenerIdAsesorLogueadoObservable(): Observable<number | null> {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) {
      return of(null);
    }

    let user: { document?: string };
    try {
      user = JSON.parse(userStr);
    } catch (_) {
      return of(null);
    }

    const documento = user?.document?.replace(/\D/g, '')?.trim();
    if (!documento) {
      return of(null);
    }

    return this.asesorService.getAsesorPorDocumento(documento).pipe(
      take(1),
      map((id) => id ? Number(id) : null),
      catchError(() => of(null)),
    );
  }

  private obtenerProductosColectivoSeleccionados(): { lineaNegocio: number; programa: string; anexos: number }[] {
    return Array.from(this.programasSeleccionadosUI)
      .map((programa) => {
        const programaKey = (programa || '').toString().trim();
        const linea = this.obtenerLineaDePrograma(programaKey);

        if (!programaKey || !linea) {
          return null;
        }

        return {
          lineaNegocio: Number(linea),
          programa: programaKey,
          // Si ese programa fue marcado en SI en el recuadro "Incluir anexos", guarda 1.
          // Si está en NO o no aparece en el recuadro, guarda 0.
          anexos: this.programasConAnexosSeleccionados.has(programaKey) ? 1 : 0,
        };
      })
      .filter((item): item is { lineaNegocio: number; programa: string; anexos: number } => !!item);
  }

  private async construirPayloadCotizacionColectivo(): Promise<CotizacionColectivo> {
    const raw = this.formColectivo.getRawValue();
    const productos = this.obtenerProductosColectivoSeleccionados();
    const primerProducto = productos[0];

    // Asegurar que los datos estén cargados
    await this.asegurarDatosCargados();

    console.log("PROGRAMAS SET:", this.programasSeleccionadosUI);
    console.log("PROGRAMA ENVIADO:", this.obtenerProgramaSeleccionado());
    console.log("ANEXOS ENVIADO:", this.obtenerValorAnexosColectivo());
    console.log("PROGRAMAS CON ANEXOS:", Array.from(this.programasConAnexosSeleccionados));

    return {
      idCotizacion: this.obtenerIdCotizacionColectivoActual(),
      tipoDocumento: "NIT",
      numDocumento: (raw.nit || "").toString().trim(),
      nombreEmpresa: (raw.colectivoNombre || "").toString().trim(),
      estadoMora: this.obtenerEstadoMoraColectivo(),
      asesorPoblacion: this.obtenerAsesorPoblacionColectivo(),
      existeInfo: this.empresaColectivoActual ? "S" : "N",
      nitEmpresa: this.obtenerNitEmpresaCompleto(),
      fechaPresentacion: this.formatearFechaApiColectivo(raw.fechaPresentacion),
      fechaInicioVigencia: this.formatearFechaApiColectivo(raw.fechaInicioVigencia),
      sector: this.obtenerNombreSectorColectivo(raw.sector),
      departamento: this.obtenerNombreDepartamentoColectivo(raw.departamento),
      municipio: this.obtenerNombreMunicipioColectivo(raw.municipio),
      esClienteActual: raw.clienteActual === "1" ? "S" : "N",
      usuariosACotizar: this.obtenerNumeroEntero(raw.usuariosCotizar),
      usuariosMayores60: this.obtenerNumeroEntero(raw.usuariosMayor60),
      pctUsuariosMayores60: this.obtenerPorcentajeMayor60(raw.UsuariosMayor60Total),
      embarazosEnCurso: this.obtenerNumeroEntero(raw.embarazosCurso),
      tieneSubsidio: raw.derechoAsubsidio === "1" ? "S" : "N",
      porcentajeSubsidio: this.obtenerPorcentajeSubsidio(raw.porcentajeSubsidio),
      lineasBloqueadas: this.obtenerLineasBloqueadasColectivo(),
      regional: this.obtenerNombreRegionalColectivo(raw.regional),
      oficina: this.obtenerNombreOficinaColectivo(raw.oficina),
      canal: this.obtenerNombreCanalColectivo(raw.canal),
      tipoAsesor: this.obtenerNombreTipoAsesorColectivo(raw.tipoAsesor),
      // lineaNegocio: this.obtenerNumeroLineaNegocio(),
      // programa: this.obtenerProgramaSeleccionado(),
      lineaNegocio: primerProducto?.lineaNegocio,
      programa: primerProducto?.programa,
      anexos: primerProducto?.anexos ?? 0,
      productos,
    };
  }

  private async asegurarDatosCargados(): Promise<void> {
    const promises: Promise<any>[] = [];

    // Cargar regionales si no están cargadas
    if (!this.regional || this.regional.length === 0) {
      promises.push(
        firstValueFrom(this.networking.consutarRegionales()).then(
          (regionales) => {
            this.regional = Array.isArray(regionales) ? regionales : [];
          }
        ).catch((error) => {
          console.error('Error cargando regionales:', error);
          this.regional = [];
        })
      );
    }

    // Cargar sucursales si hay una regional seleccionada pero no hay sucursales
    const regionalSeleccionada = this.formColectivo.get('regional')?.value;
    if (regionalSeleccionada && (!this.sucursalesRegional || this.sucursalesRegional.length === 0)) {
      promises.push(
        firstValueFrom(this.networking.consultarSucursalesXRegional(regionalSeleccionada)).then(
          (sucursales) => {
            this.sucursalesRegional = sucursales ?? [];
          }
        ).catch((error) => {
          console.error('Error cargando sucursales:', error);
          this.sucursalesRegional = [];
        })
      );
    }

    // Cargar tipos de asesor si no están cargados
    if (!this.tiposDeAsesor || this.tiposDeAsesor.length === 0) {
      promises.push(
        firstValueFrom(this.networking.consultarTiposDeAsesor()).then(
          (tipos) => {
            this.tiposDeAsesor = tipos ?? [];
            // Filtrar tipos según el canal seleccionado
            const canalSeleccionado = this.formColectivo.get('canal')?.value;
            if (canalSeleccionado) {
              this.filtrarTipos(canalSeleccionado);
            } else {
              this.tiposFiltrados = tipos ?? [];
            }
          }
        ).catch((error) => {
          console.error('Error cargando tipos de asesor:', error);
          this.tiposDeAsesor = [];
          this.tiposFiltrados = [];
        })
      );
    }

    // Esperar a que se carguen todos los datos
    await Promise.all(promises);
  }

  private obtenerNumeroLineaNegocio(): number | undefined {
    const value = this.formColectivo.get("lineaNegocio")?.value;
    return value ? Number(value) : undefined;
  }

  private obtenerProgramaSeleccionado(): string | undefined {
    const programas = Array.from(this.programasSeleccionadosUI);
    return programas.length > 0 ? programas[0] : undefined;
  }

  private continuarDespuesDeGuardarColectivo(nextIndex: number): void {
    this.executeTabOption(nextIndex);
  }

  private obtenerIdCotizacionColectivoActual(): number {
    const actual = Number(this.cotizacionColectivoActual?.idCotizacion);
    if (Number.isFinite(actual) && actual > 0) {
      return actual;
    }

    const raw = localStorage.getItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
    if (raw) {
      try {
        const parsed = JSON.parse(raw) as Partial<CotizacionColectivo>;
        const id = Number(parsed?.idCotizacion);
        if (Number.isFinite(id) && id > 0) {
          return id;
        }
      } catch (error) {
        console.error("No se pudo leer la cotizacion colectiva actual:", error);
      }
    }

    return this.obtenerSiguienteIdCotizacionColectivo();
  }

  private obtenerSiguienteIdCotizacionColectivo(): number {
    const actual = Number(localStorage.getItem(this.KEY_COTIZACION_COLECTIVO_SEQ));
    const siguiente = Number.isFinite(actual) && actual > 0 ? actual + 1 : 1;
    localStorage.setItem(this.KEY_COTIZACION_COLECTIVO_SEQ, siguiente.toString());
    return siguiente;
  }

  private restaurarCotizacionColectivoActual(): void {
    const raw = localStorage.getItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
    if (!raw) {
      return;
    }

    try {
      this.cotizacionColectivoActual = JSON.parse(raw) as CotizacionColectivo;
    } catch (error) {
      console.error("No se pudo restaurar la cotizacion colectiva actual:", error);
      localStorage.removeItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
    }
  }

  private asignarCotizacionColectivoActual(cotizacion: CotizacionColectivo | null): void {
    this.cotizacionColectivoActual = cotizacion;
    if (cotizacion) {
      localStorage.setItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL, JSON.stringify(cotizacion));
      return;
    }

    localStorage.removeItem(this.KEY_COTIZACION_COLECTIVO_ACTUAL);
  }

  private formatearFechaApiColectivo(value: any): string | undefined {
    if (!value) {
      return undefined;
    }

    if (value instanceof Date) {
      return `${this.formatDate(value)}T00:00:00`;
    }

    if (typeof value === "object" && typeof value.format === "function") {
      return `${value.format("YYYY-MM-DD")}T00:00:00`;
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return undefined;
    }

    return `${this.formatDate(parsed)}T00:00:00`;
  }

  private obtenerNumeroEntero(value: any): number {
    const parsed = Number((value ?? "").toString().replace(/[^\d.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private obtenerPorcentajeMayor60(value: any): number {
    const parsed = Number((value ?? "").toString().replace("%", "").replace(",", ".").trim());
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private obtenerPorcentajeSubsidio(value: any): number {
    if (value === "1") {
      return 50;
    }
    if (value === "2") {
      return 100;
    }
    const parsed = Number((value ?? "").toString().replace(/[^\d.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private obtenerNombreSectorColectivo(codigoSector: any): string {
    const codigo = (codigoSector || "").toString().trim();
    if (!codigo) {
      return "";
    }
    const sector = this.sectores.find((item) => (item.nombreSector || "").toString().trim() === codigo);
    return (sector?.nombreSector || codigo).toString().trim();
  }

  private obtenerNombreDepartamentoColectivo(codigoDepartamento: any): string {
    const codigo = (codigoDepartamento || "").toString().trim();
    if (!codigo) {
      return "";
    }
    const departamento = this.departamentos.find((item) => (item.codigo || "").toString().trim() === codigo);
    return (departamento?.nombre || codigo).toString().trim();
  }

  private obtenerNombreMunicipioColectivo(codigoMunicipio: any): string {
    const codigo = (codigoMunicipio || "").toString().trim();
    if (!codigo) {
      return "";
    }
    const municipio = this.municipios.find((item) => (item.codigo || "").toString().trim() === codigo);
    return (municipio?.municipio || codigo).toString().trim();
  }

  private obtenerNombreRegionalColectivo(codigoRegional: any): string | undefined {
    const codigo = (codigoRegional || "").toString().trim();
    if (!codigo) {
      return undefined;
    }
    if (!this.regional || this.regional.length === 0) {
      return codigo; // Devolver el código si no está cargado el array
    }
    const regional = this.regional.find((item) => (item.Codigo_regional || "").toString().trim() === codigo);
    return regional?.Nombre_regional || codigo;
  }

  private obtenerNombreOficinaColectivo(codigoOficina: any): string | undefined {
    const codigo = (codigoOficina || "").toString().trim();
    if (!codigo) {
      return undefined;
    }
    if (!this.sucursalesRegional || this.sucursalesRegional.length === 0) {
      return codigo; // Devolver el código si no está cargado el array
    }
    const oficina = this.sucursalesRegional.find((item) => (item.cod_sucursal || "").toString().trim() === codigo);
    return oficina?.nombre_sucursal || codigo;
  }

  private obtenerNombreCanalColectivo(codigoCanal: any): string | undefined {
    const codigo = (codigoCanal || "").toString().trim();
    if (!codigo) {
      return undefined;
    }
    if (!this.canal || this.canal.length === 0) {
      return codigo; // Devolver el código si no está cargado el array
    }
    const canal = this.canal.find((item) => (item.value || "").toString().trim() === codigo);
    return canal?.label || codigo;
  }

  private obtenerNombreTipoAsesorColectivo(codigoTipoAsesor: any): string | undefined {
    const codigo = (codigoTipoAsesor || "").toString().trim();
    if (!codigo) {
      return undefined;
    }
    if (!this.tiposFiltrados || this.tiposFiltrados.length === 0) {
      return codigo; // Devolver el código si no está cargado el array
    }
    const tipoAsesor = this.tiposFiltrados.find((item) => (item.tipo || "").toString().trim() === codigo);
    return tipoAsesor?.nombre || codigo;
  }

  private obtenerEstadoMoraColectivo(): string {
    return (
      this.empresaColectivoActual?.estado_mora
      ?? this.empresaColectivoActual?.estadoMora
      ?? ''
    )
      .toString()
      .trim();
  }

  private obtenerAsesorPoblacionColectivo(): string {
    return (
      this.empresaColectivoActual?.nombre_asesor
      ?? this.empresaColectivoActual?.asesorPoblacion
      ?? this.empresaColectivoActual?.asesor
      ?? ''
    )
      .toString()
      .trim();
  }

  private obtenerNitEmpresaCompleto(): string {
    const nit = (this.formColectivo.get("nit")?.value || "").toString().trim();
    const digitoVerificacion =
      this.empresaColectivoActual?.digitoVerificacion
      ?? this.empresaColectivoActual?.digito_verificacion
      ?? this.empresaColectivoActual?.dv;

    const dv = (digitoVerificacion ?? "").toString().trim();
    if (nit && dv) {
      return `${nit}-${dv}`;
    }

    return nit;
  }

  private obtenerLineasBloqueadasColectivo(): string {
    const bloqueadas = Array.from(this.lineasNegocioBloqueadas)
      .map((item) => (item || "").toString().trim())
      .filter((item) => !!item)
      .sort((a, b) => a.localeCompare(b));

    return bloqueadas.length ? bloqueadas.join(",") : "0";
  }

  /** Metodo para reset contratante */
  resetPeople() {
    if (this.resetData) this.form.get("contratanteTipoDocumento")?.setValue("");
    if (this.resetData) this.form.get("contratanteDocumento")?.setValue("");
    this.form.get("contratanteNombre")?.setValue("");
    this.form.get("contratanteSegundoNombre")?.setValue("");
    this.form.get("contratanteApellido")?.setValue("");
    this.form.get("contratanteSegundoApellido")?.setValue("");
    this.form.get("contratanteGenero")?.setValue("");
    this.form.get("contratanteFechaNacimiento")?.setValue("");
    this.form.get("contratanteEdad")?.setValue("");
    this.form.get("contratanteEmail")?.setValue("");
    this.form.get("contratanteEmail2")?.setValue("");
    this.form.get("contratanteTelefono")?.setValue("");
    this.form.get("contratanteUsuario")?.setValue("2");
    this.form.get("telefonoFijo")?.setValue("");
    this.form.get("campaniaContratante")?.setValue("");
    this.form.get("contratanteFechaTarifa")?.setValue("");
    this.datePerson = null;
    this.mostcampaniaContra = false;
    this.contratante_usuario = false;
    this.dataBeneficiary = [];
    this.modeloAsociadoMultiple = [];
  }

  /** Metodo para buscar la persona */
  buscarPersona() {
    if (this.formInit.get("tipoSolicitud")?.value !== "2") {
      this.esInclusion = false;
      var data = this.form.getRawValue();
      if (data.contratanteDocumento && data.contratanteTipoDocumento) {
        this.spinner.show();
        const requestData: QuotationPeopleRequest = {
          tipoDocumento: data.contratanteTipoDocumento,
          documento: data.contratanteDocumento,
          codigoTipoPlan: '',
          codigoLineaNegocio: ''
        };
        this.networking.searchPeople(requestData).subscribe(
          (response: any) => {
            this.searchPeopleOutputSuccessful(response);
          },
          error => {
            this.searchPeopleOutputFailure(1, error.message);
          }
        );
        this.blockedForm(["contratanteTipoDocumento",]);
      } else {
        this.SnackBarService.alert(
          "alert-danger",
          "Tipo documento o número de documento vacío."
        );
      }
    }
  }

  async buscarEmpresa(): Promise<void> {
    const tipoDocumento = "NI";
    const numeroDocumento = (this.formColectivo.get("nit")?.value || "").toString().trim();

    if (!numeroDocumento) {
      this.SnackBarService.alert(
        "alert-danger",
        "Debe ingresar el número de documento para buscar la empresa."
      );
      return;
    }

    this.resetAnexoContext();

    this.spinner.show();

    this.networking.consultarDatosXEmpresa(tipoDocumento, numeroDocumento).subscribe({
      next: async (data) => {
        this.spinner.hide();

        if (data && data.docu_nro) {

          // Tiene datos de empresa: seleccionar SI
          this.formColectivo.get("clienteActual")?.setValue("1");
          this.empresaColectivoActual = data;
          this.completarDatosEmpresa(data);

          await this.cargarProgramasEmpresaAsync(numeroDocumento, tipoDocumento);

          await this.verificarCotizacionOtroAsesorAsync(numeroDocumento);

          this.verificarCotizacionActiva(numeroDocumento);

          this.obtenerCuentaColectivo(numeroDocumento);

        } else {
          this.SnackBarService.alert(
            "alert-info",
            "No se encontraron datos de la empresa consultada."
          );
        }
      },
      error: (error) => {
        this.spinner.hide();

        this.formColectivo.get("clienteActual")?.setValue("2");
        this.formColectivo.get("clienteActual")?.updateValueAndValidity();


        this.SnackBarService.alert(
          "alert-danger",
          "No se pudo obtener la información de la empresa, intente de nuevo."
        );
      },
    });
  }

  private async cargarProgramasEmpresaAsync(
    documento: string,
    tipoDocumento: string
  ): Promise<void> {
    this.programasEmpresa = [];

    try {
      const programas = await firstValueFrom(
        this.networking.obtenerProgramasxEmpresa(documento, tipoDocumento)
      );

      this.programasEmpresa = Array.isArray(programas) ? programas : [];

      await this.aplicarBloqueoLineasPorProgramasActivos(this.programasEmpresa);

    } catch (error) {
      console.error("Error al cargar programas de empresa:", error);

      await this.aplicarBloqueoLineasPorProgramasActivos([]);
    }
  }

  async verificarCotizacionOtroAsesorAsync(numeroDocumento: string): Promise<void> {
    const estadoActivo = 1;

    try {
      const response: any = await firstValueFrom(
        this.networking.consultarCotizacionActiva(numeroDocumento)
      );

      if (!response) {
        return;
      }

      const idAsesorCotizacion =
        (response.idAsesor || '').toString().trim();

      const idAsesorActual =
        (this.idAsesor || '').toString().trim();

      if (
        idAsesorCotizacion &&
        idAsesorCotizacion !== idAsesorActual
      ) {

        let nombreAsesor = 'otro asesor';

        try {
          const request: ConsultarAsesorByIDRequest = {
            nombreClave: 'getSpCotConsultarAsesorPorID',
            jsonParametros: JSON.stringify({
              prm_id_asesor: idAsesorCotizacion
            })
          };

          const asesorResponse = await firstValueFrom(
            this.consultarAsesorByIDService.consultarAsesorByID(request)
          );

          console.log('Respuesta asesor de la cotización:', asesorResponse);

          if (
            asesorResponse?.status &&
            Array.isArray(asesorResponse.data) &&
            asesorResponse.data.length > 0
          ) {
            nombreAsesor =
              (asesorResponse.data[0]?.NombreCompleto || 'otro asesor')
                .toString()
                .trim();
          }

        } catch (error) {
          console.error(
            'Error consultando nombre del asesor de la cotización:',
            error
          );
        }

        await this.mostrarAdvertenciaEnCola(
          `La empresa ya cuenta con una cotización activa realizada por el asesor <b>${nombreAsesor}</b>.`
        );
      }

    } catch (error) {
      console.error(
        'Error validando cotización de otro asesor:',
        error
      );
    }
  }

  private async aplicarBloqueoLineasPorProgramasActivos(programas: any[]): Promise<void> {
    const bloqueadas = new Set<string>();
    const todasLasLineas = Object.keys(this.lineaNegocioDisplayName);

    (programas || []).forEach((programa) => {
      const linea = (programa?.linea_negocio ?? "").toString().trim();
      if (linea) {
        bloqueadas.add(linea);
      }
    });

    this.lineasNegocioBloqueadas = bloqueadas;

    for (let i = this.lineasNegocio.length - 1; i >= 0; i--) {
      const valor = (this.lineasNegocio.at(i)?.value ?? "").toString().trim();

      if (bloqueadas.has(valor)) {
        this.lineasNegocio.removeAt(i);

        const checkbox = document.getElementById(`linea${valor}`) as HTMLInputElement | null;

        if (checkbox) {
          this.renderer.setProperty(checkbox, "checked", false);
        }
      }
    }

    const tieneTodasLasLineasBloqueadas = todasLasLineas.every((linea) =>
      bloqueadas.has(linea)
    );

    if (tieneTodasLasLineasBloqueadas) {
      this.expulsarDeColectivoAInicio();
    }

    if (!bloqueadas.size) {
      return;
    }

    const nombres = Array.from(bloqueadas)
      .map((linea) => this.lineaNegocioDisplayName[linea] ?? linea)
      .filter(Boolean);

    if (nombres.length) {
      await this.mostrarAdvertenciaEnCola(
        `El cliente ya cuenta con un producto activo en la línea de negocio ${nombres.join(
          ", ",
        )}. Por favor, consulte con su jefe de ventas.`
      );
    }
  }

  private expulsarDeColectivoAInicio(): void {
    this.resetFormularioColectivo();
    this.esNuevoColectivo = false;
    this.tabHabilitado.colectivo = false;
    this.selectedIndex = 0;
    this.maxStepReached = 0;
    this.formInit.get("tipoSolicitud")?.setValue(null, { emitEvent: false });
    this.formInit.get("tipoPlan")?.setValue(null, { emitEvent: false });
    this.tipoSolicitud = "1";
    this.tipoSolicitudTemporal = "1";
  }

  private resetFormularioColectivo(): void {
    this.formColectivo.reset();
    this.empresaColectivoActual = null;
    this.asignarCotizacionColectivoActual(null);
    this.lineasNegocio.clear();
    this.formColectivo.get("oficina")?.disable({ emitEvent: false });
    this.formColectivo.get("municipio")?.disable({ emitEvent: false });
    this.formColectivo.get("UsuariosMayor60Total")?.setValue("", {
      emitEvent: false,
    });
    this.colectivoFormSaved = false;
    this.mostrarAlertaCamposColectivo = false;
    this.resumenCotizacionColectivoData = [];
    this.tarifasColectivoPorPrograma = {};
    this.programasEmpresa = [];
    this.lineasNegocioBloqueadas = new Set();
    this.programasPorLineaSeleccionadas = {};
    this.programasCarnetPorLinea = {};
    this.programasSeleccionadosUI.clear();
    this.resetAnexoContext();
    this.sectoresFiltrados = this.sectores;
    this.ultimoSectorEmpresa = null;
    this.regionalSeleccionada = "";
    this.ultimaRegionalSolicitada = null;
    this.sucursalesRegional = [];
    this.municipios = [];
    this.formColectivo.markAsPristine();
    this.formColectivo.markAsUntouched();
  }

  private completarDatosEmpresa(data: any): void {
    if (!data || !this.formColectivo) {
      return;
    }

    const nombre = (data.nombre || "").trim();
    const sector = (data.sector || "").trim();
    // const sectorEncontrado = this.obtenerSectorPorCodigo(sector);
    this.ultimoSectorEmpresa = sector || null;
    const municipioCodigo = (data.cod_departamento || "").trim();
    let departamentoCodigo = (data.cod_municipio || "").trim();

    if (!departamentoCodigo && municipioCodigo.length >= 2) {
      departamentoCodigo = municipioCodigo.substring(0, 2);
    }

    this.formColectivo.patchValue(
      {
        colectivoNombre: nombre ? this.normalizarTextoInput(nombre.toUpperCase()) : null,
      },
      { emitEvent: false }
    );

    if (departamentoCodigo) {
      this.formColectivo.get("departamento")?.setValue(departamentoCodigo, {
        emitEvent: false,
      });
      this.cargarMunicipiosPorDepartamento(departamentoCodigo, municipioCodigo);
    }

    this.colectivoFormSaved = false;
    this.mostrarAlertaCamposColectivo = false;
  }

  private verificarCotizacionActiva(nit: string): void {
    const idAsesorActual = this.obtenerIdAsesorActual();
    this.cotizacionColectivoService
      .buscarEmpresaPorNit(nit, idAsesorActual ?? 0)
      .subscribe({
        next: (response) => {
          this.procesarCotizacionActiva(response, idAsesorActual);
        },
        error: (err) => {
          console.error("Error verificando cotización activa:", err);
        },
      });
  }

  private procesarCotizacionActiva(response: any, idAsesorActual: number | null): void {
    const cotizacionActiva = this.extraerCotizacionActiva(response);
    if (!cotizacionActiva) {
      return;
    }
    const nombreAsesorActivo = this.obtenerNombreAsesorActivo(cotizacionActiva);
    const idAsesorActivo = this.obtenerIdAsesorActivo(cotizacionActiva);
    if (!nombreAsesorActivo) {
      return;
    }
    if (
      idAsesorActual &&
      idAsesorActivo &&
      idAsesorActual === idAsesorActivo
    ) {
      this.asignarCotizacionColectivoActual(cotizacionActiva as CotizacionColectivo);
      return;
    }
    if (this.nombreAsesor && nombreAsesorActivo.toLowerCase() === this.nombreAsesor.toLowerCase()) {
      this.asignarCotizacionColectivoActual(cotizacionActiva as CotizacionColectivo);
      return;
    }
    Swal.fire({
      icon: "warning",
      title: "Advertencia",
      html: `Advertencia: La empresa ya cuenta con una cotización activa realizada por el asesor <strong>${nombreAsesorActivo}</strong>.`,
      showCloseButton: true,
      confirmButtonText: "Cerrar",
    });
  }

  private extraerCotizacionActiva(response: any): any | null {
    if (!response) {
      return null;
    }
    if (response.cotizacionActiva) {
      return response.cotizacionActiva;
    }
    if (response.data?.cotizacionActiva) {
      return response.data.cotizacionActiva;
    }
    if (response.cotizacion) {
      return response.cotizacion;
    }
    if (response.data?.cotizacion) {
      return response.data.cotizacion;
    }
    if (Array.isArray(response) && response.length > 0) {
      return response[0];
    }
    if (typeof response === "object" && Object.keys(response).length > 0) {
      return response;
    }
    return null;
  }

  private obtenerNombreAsesorActivo(cotizacion: any): string {
    return (
      cotizacion?.asesorPoblacion ||
      cotizacion?.asesor ||
      cotizacion?.nombreAsesor ||
      cotizacion?.nombre_asesor ||
      ""
    )
      .toString()
      .trim();
  }

  private obtenerIdAsesorActivo(cotizacion: any): number | null {
    const raw = cotizacion?.idAsesor ?? cotizacion?.asesorId ?? cotizacion?.id;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private obtenerIdAsesorActual(): number | null {
    const raw = (this.cedulaAsesor || "").toString().replace(/\D/g, "");
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  private resetAnexoContext(): void {
    this.cuentaColectivo = null;
    this.programaAnexoInfoMap = {};
    this.programasConAnexosDisponibles = [];
    this.programasConAnexosSeleccionados.clear();
    this.requiereIncluirAnexos = 'no';
    this.colectivoSubcta = null;
  }

  private obtenerCuentaColectivo(documento: string): void {
    const tipoSolicitud = (
      this.formInit?.get('tipoSolicitud')?.value ||
      localStorage.getItem('tipoSolicitud') ||
      ''
    )
      .toString()
      .trim();

    if (this.esInclusion || tipoSolicitud === '2') {
      this.actualizarCuentaColectivo(null);
      this._datosCompletosColectivoAC = [];
      return;
    }

    const trimmedDocumento = (documento || "").toString().trim();
    if (!trimmedDocumento) {
      this.actualizarCuentaColectivo(null);
      this._datosCompletosColectivoAC = [];
      return;
    }
    const tipoDocumento = "NI";
    const tipoPlanActual = this.formInit?.get('tipoPlan')?.value || localStorage.getItem('tipoPlan') || 'C';
    const tipoPlanNormalizado = tipoPlanActual
      .toString()
      .trim()
      .toUpperCase();

    const esGrupoAfinidad =
      tipoPlanNormalizado === 'GA' ||
      tipoPlanNormalizado === 'AG' ||
      tipoPlanNormalizado.includes('AFINIDAD');

    const evaluadorFinal = esGrupoAfinidad ? 'AC' : 'C';

    this.spinner.show();
    this.networking.getconsultacolectivoac(trimmedDocumento, tipoDocumento, evaluadorFinal).subscribe({
      next: (response: any) => {
        this.spinner.hide();

         const rows = Array.isArray(response)
          ? response
          : (
              response?.data ||
              response?.jsonRespuesta ||
              []
            );

        this.cargarMapaGruposProgramaColectivo(rows);

        const registro = rows[0];

        const cuenta = registro?.cuenta?.toString().trim() || null;
        this.colectivoSubcta = (registro?.subcta || '').toString().trim() || null;

        if (!cuenta) {
          this.SnackBarService.alert("alert-warning", "No fue posible encontrar la cuenta del colectivo; los anexos no estarán disponibles.");
        }
        this.actualizarCuentaColectivo(cuenta);

        const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');
        if (tipoSolicitud === '3') {
          this.actualizarProgramasPorLineasSeleccionadas();
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error("Error al obtener cuenta del colectivo:", error);
        this.SnackBarService.alert("alert-warning", "No se pudo obtener la cuenta del colectivo; la sección de anexos permanecerá oculta.");
        this.actualizarCuentaColectivo(null);
        this._datosCompletosColectivoAC = [];
      },
    });
  }

  private normalizarClavePrograma(valor: any): string {
    return (valor || '')
      .toString()
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  private resolverProgramasTitularVentaNuevaAfinidad(
    programas: ProgramaContratanteStorageItem[]
  ): ProgramaContratanteStorageItem[] {
    const norm = (valor: unknown): string =>
      String(valor ?? '').trim().toUpperCase();

    return programas.map(p => {
      const codigoUi = norm(p?.programa || (p as any)?.id);
      const subcta = norm((p as any)?.subcta);
      const cuenta = norm((p as any)?.cuenta);

      const filas = (this._datosCompletosColectivoAC || []).filter(
        (r: any) => {
          const plan = norm(r?.plan_codi ?? r?.PLAN_CODI);
          const subcuentaFila = norm(r?.subcta ?? r?.SUBCTA);
          const cuentaFila = norm(r?.cuenta ?? r?.CUENTA);

          const mismoPlan =
            plan === codigoUi ||
            (
              codigoUi.endsWith('C') &&
              (plan.endsWith('F') || plan.endsWith('A')) &&
              `${plan.slice(0, -1)}C` === codigoUi
            );

          return mismoPlan &&
            (!subcta || subcuentaFila === subcta) &&
            (!cuenta || cuentaFila === cuenta);
        }
      );

      const codigos = Array.from(new Set<string>(
        filas
          .map((r: any) => norm(r?.plan_codi ?? r?.PLAN_CODI))
          .filter(Boolean)
      ));

      let familiares = codigos.filter((codigo) =>
        codigo.endsWith('F') || codigo.endsWith('A')
      );
      if (!familiares.length) {
        familiares = Array.from(new Set<string>(
          (this._datosCompletosColectivoAC || [])
            .map((r: any) => norm(r?.plan_codi ?? r?.PLAN_CODI))
            .filter((codigo) =>
              (codigo.endsWith('F') || codigo.endsWith('A')) &&
              (codigo === codigoUi || `${codigo.slice(0, -1)}C` === codigoUi)
            )
        ));
      }
      const elegido = familiares.find((codigo) => codigo.endsWith('F')) || familiares[0];

      if (!elegido) {
        return p;
      }

      return {
        ...p,
        programa: elegido
      };
    });
  }

  private cargarMapaGruposProgramaColectivo(
    rows: any[]
  ): void {
    this._datosCompletosColectivoAC =
      Array.isArray(rows) ? rows : [];

    this.gruposProgramaColectivoPorPlan = {};
    this.gruposProgramaColectivoPorNombre = {};

    this._datosCompletosColectivoAC.forEach(
      (item: any) => {
        const planCodi = this.normalizarClavePrograma(
          item?.plan_codi ??
          item?.PLAN_CODI ??
          item?.codigo_plan
        );

        const planDeno = this.normalizarClavePrograma(
          item?.plan_deno ??
          item?.PLAN_DENO
        );

        const grupoPrograma =
          this.normalizarClavePrograma(
            item?.GRUPO_PROGRAMA ??
            item?.grupo_programa ??
            item?.grupoPrograma
          );

        if (!grupoPrograma) {
          return;
        }

        if (planCodi) {
          this.gruposProgramaColectivoPorPlan[
            planCodi
          ] = grupoPrograma;
        }

        if (planDeno) {
          this.gruposProgramaColectivoPorNombre[
            planDeno
          ] = grupoPrograma;
        }
      }
    );

    console.log('[MAPA-GRUPOS-POR-PLAN]', {
      ...this.gruposProgramaColectivoPorPlan
    });

    console.log('[MAPA-GRUPOS-POR-NOMBRE]', {
      ...this.gruposProgramaColectivoPorNombre
    });
  }

  private esFlujoColectivoOAfinidad(): boolean {
    const tipoSolicitud = (
      this.formInit?.get('tipoSolicitud')?.value ??
      localStorage.getItem('tipoSolicitud') ??
      ''
    )
      .toString()
      .trim()
      .toUpperCase();

    const tipoPlan = (
      this.formInit?.get('tipoPlan')?.value ??
      localStorage.getItem('tipoPlan') ??
      ''
    )
      .toString()
      .trim()
      .toUpperCase();

    console.log('[TIPO-PLAN-GUARDADO-BENEFICIARIO]', {
      tipoSolicitud,
      tipoPlan
    });

    if (this.esInclusion || tipoSolicitud === '2') {
      return false;
    }

    return (
      tipoSolicitud === '3' ||
      tipoPlan === 'C' ||
      tipoPlan === 'GA' ||
      tipoPlan === 'AG' ||
      tipoPlan === 'COLECTIVO' ||
      tipoPlan.includes('COLECTIV') ||
      tipoPlan.includes('AFINIDAD')
    );
  }

  private resolverGrupoProgramaParaGuardado(
    programa: string,
    nombrePrograma: string,
    programaOrigen?: any
  ): string {
    const programaCode = (programa || '')
      .toString()
      .trim()
      .toUpperCase();

    const nombre = (nombrePrograma || programaCode)
      .toString()
      .trim();

    const esInclusion = this.esInclusion || (
      this.formInit?.get('tipoSolicitud')?.value ||
      localStorage.getItem('tipoSolicitud') ||
      ''
    )
      .toString()
      .trim() === '2';

    const grupoDeOrigen = this.codigoGrupoUtil(
      programaOrigen?.grupoPrograma
      || programaOrigen?.grupo_programa
      || programaOrigen?.GRUPO_PROGRAMA
    );

    if (esInclusion) {
      return this.codigoGrupoUtil(this.obtenerGrupoProgramaInclusion(programaCode)) || grupoDeOrigen;
    }

    if (this.esFlujoColectivoOAfinidad()) {
      const grupoColectivo = this.codigoGrupoUtil(this.obtenerGrupoProgramaColectivo(
        programaCode,
        nombre
      ));
      if (grupoColectivo) {
        return grupoColectivo;
      }
      return grupoDeOrigen;
    }

    return grupoDeOrigen;
  }

  private codigoGrupoUtil(valor: unknown): string {
    const grupo = (valor ?? '')
      .toString()
      .split('|')[0]
      .trim()
      .toUpperCase();
    if (!grupo) {
      return '';
    }
    if (grupo === 'MI' || grupo === 'SO' || grupo === 'SAO' || grupo === 'CEM' || grupo === 'SMP' || grupo === '1' || grupo === '2' || grupo === '3') {
      return '';
    }
    return grupo;
  }

  private async rellenarGrupoProgramaPorCodigo<T extends { programa: string; grupoPrograma: string }>(items: T[]): Promise<void> {
    const pendientes = (items || []).filter((item) => !this.codigoGrupoUtil(item?.grupoPrograma) && (item?.programa || '').toString().trim());
    if (!pendientes.length) {
      return;
    }
    await Promise.all(pendientes.map(async (item) => {
      const codigo = (item.programa || '').toString().trim().toUpperCase();
      try {
        const resp = await firstValueFrom(this.consultarCotizacionService.consultarGrupoProgramaXPrograma({ programa: codigo }));
        const grupo = this.codigoGrupoUtil(resp?.data?.jsonRespuesta?.[0]?.grupo_programa);
        if (grupo) {
          item.grupoPrograma = grupo;
        }
      } catch {
        item.grupoPrograma = this.codigoGrupoUtil(item.grupoPrograma);
      }
    }));
  }

  private obtenerGrupoProgramaColectivo(
    programa: string,
    nombrePrograma: string
  ): string {
    const codigoNormalizado =
      this.normalizarClavePrograma(programa);

    const nombreNormalizado =
      this.normalizarClavePrograma(nombrePrograma);

    /*
    * Primero intenta por código. Si los códigos del carnet y del
    * servicio son diferentes, busca por el nombre del programa.
    */
    const grupoPrograma =
      this.gruposProgramaColectivoPorPlan[
        codigoNormalizado
      ] ||
      this.gruposProgramaColectivoPorNombre[
        nombreNormalizado
      ] ||
      '';

    console.log('[GRUPO-PROGRAMA-RESUELTO]', {
      programa,
      nombrePrograma,
      codigoNormalizado,
      nombreNormalizado,
      grupoPrograma
    });

    return grupoPrograma;
  }

  private async consultarGruposProgramaColectivo():
    Promise<void> {
    const tipoSolicitud = (
      this.formInit?.get('tipoSolicitud')?.value ||
      localStorage.getItem('tipoSolicitud') ||
      ''
    )
      .toString()
      .trim();

    if (this.esInclusion || tipoSolicitud === '2') {
      return;
    }

    const documento = (
      this.formColectivo?.get('nit')?.value ||
      localStorage.getItem('numeroDocumentoEmpresa') ||
      ''
    )
      .toString()
      .trim();

    if (!documento) {
      console.error(
        '[GRUPO-PROGRAMA] No se encontró el NIT'
      );
      return;
    }

    const tipoPlan = (
      this.formInit?.get('tipoPlan')?.value ||
      localStorage.getItem('tipoPlan') ||
      'C'
    )
      .toString()
      .trim()
      .toUpperCase();

    const esGrupoAfinidad =
      tipoPlan === 'GA' ||
      tipoPlan === 'AG' ||
      tipoPlan.includes('AFINIDAD');

    const evaluador = esGrupoAfinidad ? 'AC' : 'C';

    const response: any = await firstValueFrom(
      this.networking.getconsultacolectivoac(
        documento,
        'NI',
        evaluador
      )
    );

    const rows = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.jsonRespuesta)
          ? response.jsonRespuesta
          : [];

    this.cargarMapaGruposProgramaColectivo(rows);
  }

  private actualizarCuentaColectivo(cuenta: string | null): void {
    this.cuentaColectivo = cuenta;
    if (!cuenta) {
      this.actualizarProgramasConAnexosDisponibles();
      return;
    }
    Array.from(this.programasSeleccionadosUI).forEach((code) => {
      this.ensureProgramaAnexoInfo(code);
      this.tryLoadAnexosForProgram(code);
    });
  }

  private obtenerGrupoProgramaInclusion(codigoPrograma: string): string {
    const normalizar = (valor: unknown): string =>
      (valor ?? '').toString().trim().toUpperCase();

    const codigoBuscado = normalizar(codigoPrograma);

    if (!codigoBuscado) {
      return '';
    }

    try {
      // Primera opción: relación guardada expresamente desde el modal.
      const rawProgramas = localStorage.getItem(
        'programas_grupo_inclusion'
      );

      if (rawProgramas) {
        const programas = JSON.parse(rawProgramas);

        const programaEncontrado = Array.isArray(programas)
          ? programas.find(
              (item: any) =>
                normalizar(item?.programa) === codigoBuscado
            )
          : undefined;

        const grupoDesdeProgramas = normalizar(
          programaEncontrado?.grupoPrograma
        );

        if (grupoDesdeProgramas) {
          return grupoDesdeProgramas;
        }
      }

      // Segunda opción: contratos seleccionados obtenidos de
      // getConsultaContratoUsuario.
      const rawContrato = localStorage.getItem('contrato_radicado');

      if (!rawContrato) {
        return '';
      }

      const contratoRadicado = JSON.parse(rawContrato);

      const contratos = Array.isArray(contratoRadicado?.contrato)
        ? contratoRadicado.contrato
        : [];

      // Busca el contrato correspondiente al programa. No usa [0].
      const contratoEncontrado = contratos.find(
        (contrato: any) =>
          normalizar(
            contrato?.cod_programa_afi ??
            contrato?.programa ??
            contrato?.code
          ) === codigoBuscado
      );

      return normalizar(
        contratoEncontrado?.GRUPO_PROGRAMA ??
        contratoEncontrado?.grupo_programa ??
        contratoEncontrado?.grupoPrograma
      );
    } catch (error) {
      console.error(
        '[Inclusión] Error obteniendo GRUPO_PROGRAMA:',
        error
      );

      return '';
    }
  }

  /** Respuesta exitosa al buscar el contratante */
  searchPeopleOutputSuccessful(data: QuotationPeopleResponse): void {
    this.spinner.hide();
    this.resetData = true;
    this.resetPeople();
    this.dataPersona(data);
    this.updateTableBeneficiary();
    if (data.enMora === "1")
      this.showMessageDialog(
        "Informacion", // Título del diálogo
        `Contratante se encuentra en mora con COOMEVA MP.`, // Mensaje del diálogo
        "Aceptar", // Texto del primer botón
        "", // Texto del segundo botón (vacío si no se usa)
        true, // Uso de un botón (true) o dos botones (false)
        1, // Tipo de icono (puedes ajustar según tu lógica)
        this.dialog, // Objeto MatDialog
        (_: any) => { } // Callback
      );
    // this.openDialog(this.dialog, "Contratante se encuentra en mora con COOMEVA MP.", "", 0, (r: boolean) => { });
    else if (data.esAsociado === "1") {
      this.showMessageDialog(
        "Informacion", // Título del diálogo
        `Contratante es asociado`, // Mensaje del diálogo
        "Aceptar", // Texto del primer botón
        "", // Texto del segundo botón (vacío si no se usa)
        true, // Uso de un botón (true) o dos botones (false)
        1, // Tipo de icono (puedes ajustar según tu lógica)
        this.dialog, // Objeto MatDialog
        (_: any) => { } // Callback
      );
      // this.openDialog(this.dialog, "Contratante es asociado", "", 0, (r: boolean) => { });
    }
  }

  /** Respuesta exitosa al buscar el contrato */
  searchContractOutputSuccessful(data: Array<ContratPeopleResponse>): void {
    this.listContract = data;
    this.dialog.open(DialogContratComponent, {
      data: { opciones: false, data: data },
    });
  }

  /** Respuesta erronea al buscar el contrato */
  searchContractOutputFailure(errorCode: number, message?: string): void {
    // Swal.fire({
    //   text: (message) ? message : `Ocurrio un error con la conexión, contacte con el administrador`,
    //   confirmButtonColor: '#0372b9',
    //   confirmButtonText: 'OK',
    // });
    const lblMensajeElement = document.getElementById("lblMensaje");
    if (lblMensajeElement) {
      lblMensajeElement.innerText =
        message && message != "undefined" && message != "null" && message != ""
          ? message
          : "Ha ocurrido un error al obtener las campañas";
    } else {
      console.error('El elemento con ID "lblMensaje" no se encontró en el DOM.');
    }

  }

  /** Respuesta erronea al buscar el contratante */
  searchPeopleOutputFailure(errorCode: number, message?: string): void {
    this.spinner.hide();
    this.resetData = false;
    this.resetPeople();
    this.showMessageDialog(
      "Error", // Título del diálogo
      `${message}`, // Mensaje del diálogo
      "Aceptar", // Texto del primer botón
      "", // Texto del segundo botón (vacío si no se usa)
      true, // Uso de un botón (true) o dos botones (false)
      1, // Tipo de icono (puedes ajustar según tu lógica)
      this.dialog, // Objeto MatDialog
      (_: any) => { console.log('mesaje de error:', message); } // Callback
    );
  }

  /** Metodo para calcular la edad */
  calculeAge(event: MatDatepickerInputEvent<Date>) {
    const date = this.form.get("contratanteFechaNacimiento")?.value;

    if (date instanceof Date && !isNaN(date.getTime())) {
      const now = new Date();
      const dataBirthe = new Date(date);

      let birthAge = now.getFullYear() - dataBirthe.getFullYear();
      const mes = now.getMonth() - dataBirthe.getMonth();
      if (mes < 0 || (mes === 0 && now.getDate() < dataBirthe.getDate())) {
        birthAge--;
      }

      if (birthAge >= 0) {
        this.datePerson = birthAge;
        this.form.get("contratanteEdad")?.setValue(birthAge);

        // Formatea la fecha de nacimiento
        const formattedDate = this.formatDate(date);
        this.form.get("contratanteFechaNacimiento")?.setValue(formattedDate);
      } else {
        this.datePerson = 0;
        this.form.get("contratanteEdad")?.setValue(0);
      }
      this.resetDataCampain();
    } else {
      console.error("Fecha inválida:", date);
      this.datePerson = 0;
      this.form.get("contratanteEdad")?.setValue(0);
      this.resetDataCampain();
    }
  }

  /** Metodo para identificar el cambio de tarifa */
  selectTarifa() {
    const selectTarifa: string = this.form.get("contratanteTarifa")?.value;
    if (selectTarifa != undefined && selectTarifa != null) {
      this.contratanteTarifa = selectTarifa;
      this.isShowCampain = true;
      this.getCampania();
      this.buscarCampaña();
      if (this.contratanteTarifa == 'AAESFQ') this.ocultarPlanFamiliar = false;
    }
  }

  /** Metodo para habilitar el cambio de la campaña */
  resetDataCampain(enableCampanas: boolean = true) {
    this.form.get("contratanteUsuario")?.setValue("2");
    this.form.get("campaniaContratante")?.setValue("");
    this.form.get("campaniaContratante")?.clearValidators();
    this.form.get("campaniaContratante")?.clearAsyncValidators();
    this.form.get("campaniaContratante")?.updateValueAndValidity();
    this.form.get("contratanteTarifa")?.setValue("");
    this.form.get("contratanteTarifa")?.clearValidators();
    this.form.get("contratanteTarifa")?.clearAsyncValidators();
    this.form.get("contratanteTarifa")?.updateValueAndValidity();
    this.mostcampaniaContra = false;
    this.contratante_usuario = false;
    this.listDataCampania = [];
    this.listTarifa = [];
    this.modeloAsociadoMultiple = [];
    this.dataBeneficiary = this.dataBeneficiary.filter((b) => {
      return b.position !== 1;
    });
    this.updateTableBeneficiary();
    if (enableCampanas) this.enableCampanias();
  }

  /** Metodo para habilitar o dehabilitar las campañas */
  enableCampanias() {
    const tipoCotizacionLocal = this.formInit.get("tipoCotizacion")?.value;
    this.ocultarPlanFamiliar = true;
    this.listDataCampania = [];
    this.listTarifa = [];
    const value = this.form.get("contratanteUsuario")?.value;
    this.contratante_usuario = false;
    this.mostcampaniaContra = false;
    if (value === "1") {
      const gender = this.form.get("contratanteGenero")?.value;
      const birthDate = this.form.get("contratanteFechaNacimiento")?.value;
      const edad = this.form.get("contratanteEdad")?.value;
      if (gender && birthDate && edad >= 0) {
        this.form.get("contratanteTarifa")?.setValidators(Validators.required);
        if (tipoCotizacionLocal == "m") {
          this.mostcampaniaContra = false;
        } else {
          this.mostcampaniaContra = true;
        }
        this.contratante_usuario = true;
        this.getTarifa();
      } else {
        this.listDataCampania = [];
        this.listTarifa = [];
        this.form.get("contratanteUsuario")?.setValue("2");
        this.mostcampaniaContra = false;
        this.contratante_usuario = false;
        Swal.fire({
          text: `Para solicitar la tarifa el campo edad y genero es obligatorío`,
          confirmButtonColor: "#0372b9",
          confirmButtonText: "OK",
        });
      }
    } else {
      this.form.get("campaniaContratante")?.setValue("");
      this.form.get("campaniaContratante")?.clearValidators();
      this.form.get("campaniaContratante")?.clearAsyncValidators();
      this.form.get("campaniaContratante")?.updateValueAndValidity();
      this.form.get("tarifaInclusion")?.setValue("");
      this.form.get("contratanteTarifa")?.setValue("");
      this.form.get("contratanteTarifa")?.clearValidators();
      this.form.get("contratanteTarifa")?.clearAsyncValidators();
      this.form.get("contratanteTarifa")?.updateValueAndValidity();
    }
  }

  /** Metodo para obtener las campañas */
  getCampania() {
    const tipoSolicitudLocal = this.formInit.get("tipoSolicitud")?.value;
    const lineaNegocioLocal = this.formInit.get("lineaNegocio")?.value;
    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    const cuentaTemporal = tipoPlanLocal === "C" ? this.valContrato.codigoCuenta : tipoPlanLocal === "A" ? 1 : 2;

    const selectTarifa: string = this.tipoSolicitud === "1" ? this.form.get("contratanteTarifa")?.value : this.valContrato.codigoTarifa;

    const tarifaCodigo = selectTarifa ? (selectTarifa.match(/\(([^)]+)\)$/)?.[1]?.trim() || selectTarifa) : '';

    const arrayDataModelo = [];
    this.modeloAsociadoUnico = [];
    this.modeloAsociadoMultiple = [];

    const tpUpper = (tipoPlanLocal || '').toString().trim().toUpperCase();
    let normTipo = 'F';
    if (tpUpper === 'A' || tpUpper === 'AS' || tpUpper.includes('ASOCIADO')) normTipo = 'A';
    else if (tpUpper === 'E' || tpUpper === 'EMP' || tpUpper.includes('EMPLEADO')) normTipo = 'E';

    const matrizSubcuentas: Record<string, Record<string, string>> = {
      'SMP': { 'A': 'ASMP', 'F': 'FSMP', 'E': 'EMSMP' },
      'SAO': { 'A': 'ASAO', 'F': 'FSAO', 'E': 'EMSAO' },
      'CEM': { 'A': 'ACEMN', 'F': 'FCEMN', 'E': 'EMCMN' }
    };

    switch (this.formInit.get("tipoCotizacion")?.value) {
      case "u":
        const pCodi = (this.formInit.get("programa")?.value || '').toString().trim().toUpperCase();
        let lKeyU = 'SMP';
        if (pCodi.startsWith('DE') || pCodi.includes('SAO') || pCodi.includes('SO') || lineaNegocioLocal === 'SAO') {
          lKeyU = 'SAO';
        } else if (pCodi.includes('CEM') || lineaNegocioLocal === 'CEM') {
          lKeyU = 'CEM';
        }

        const subcuentaU = matrizSubcuentas[lKeyU]?.[normTipo] || (tipoPlanLocal + lineaNegocioLocal);

        arrayDataModelo.push({
          subcuenta: subcuentaU,
          linea_negocio: lKeyU === "SMP" ? 1 : lKeyU === "SAO" ? 2 : 3,
          programa: [this.formInit.get("programa")?.value],
        });
        this.modeloAsociadoUnico.push({
          subcuenta: "A" + lineaNegocioLocal,
          linea_negocio: lineaNegocioLocal === "SMP" ? 1 : lineaNegocioLocal === "SAO" ? 2 : 3,
          programa: [
            lineaNegocioLocal === "SAO" ? this.formInit.get("programa")?.value : this.formInit.get("programa")?.value.slice(0, -1) + "A",
          ],
        });
        break;

      case "m":
        const dataGlobal = Codigo.getDataCodeProgramas();
        dataGlobal.forEach((valueSearch) => {
          if (valueSearch.plan === tipoPlanLocal) {
            valueSearch.config.forEach((valueCode) => {
              let programasLocales: string[] = [];
              this.listCodeProgramas.forEach((x) => {
                if (valueCode.subcode.indexOf(x) >= 0) programasLocales.push(x);
              });

              // Aplicamos la matriz de subcuentas a cada registro del bucle multiproducto
              let lKeyM = valueCode.programa === "SMP" ? "SMP" : (valueCode.programa === "SAO" ? "SAO" : "CEM");
              const subcuentaM = matrizSubcuentas[lKeyM]?.[normTipo] || (tipoPlanLocal + valueCode.programa);

              arrayDataModelo.push({
                subcuenta: subcuentaM,
                linea_negocio: lKeyM === "SMP" ? 1 : lKeyM === "SAO" ? 2 : 3,
                programa: programasLocales,
              });
            });
          }
          if (valueSearch.plan === "A" && tipoPlanLocal === "F") {
            valueSearch.config.forEach((valueCode) => {
              let programasLocalesAsociados: string[] = [];
              this.listCodeProgramas.forEach((x) => {
                valueCode.subcode.forEach((y) => {
                  if (valueCode.programa !== "SAO") {
                    if (y.includes(x.slice(0, -1))) programasLocalesAsociados.push(y);
                  } else {
                    if (y.indexOf(x) >= 0) programasLocalesAsociados.push(y);
                  }
                });
              });
              this.modeloAsociadoMultiple.push({
                subcuenta: "A" + valueCode.programa,
                linea_negocio: valueCode.programa === "SMP" ? 1 : valueCode.programa === "SAO" ? 2 : 3,
                programa: programasLocalesAsociados,
              });
            });
          }
        });
        if (tipoPlanLocal === "A" || tipoPlanLocal === "C") {
          this.modeloAsociadoMultiple = [];
        }
        this.mostrarResumen = false;
        break;
      default:
        break;
    }

    const generoBase = this.form.get("contratanteGenero")?.value === "1" ? "F" : "M";

    this.dataCampania = {
      cuenta: cuentaTemporal,
      tipo_solicitud: parseInt(tipoSolicitudLocal),
      codigo_sucursal: this.valContrato.codigoSucursal,
      codigo_tipo_plan: tipoPlanLocal,
      tarifa: tarifaCodigo,
      vc_cod_tarifa: tarifaCodigo,
      descripcionTarifa: selectTarifa ? this.valContrato.descripcionTarifa : '',
      edad: this.form.get("contratanteEdad")?.value,
      sexo: generoBase + ',A',
      modelo_negocio: arrayDataModelo,
    };
  }

  getTarifa() {
    const lineaNegocioLocal = this.formInit.get("lineaNegocio")?.value;
    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    const cuentaTemporal =
      tipoPlanLocal === "C"
        ? this.valContrato.codigoCuenta
        : tipoPlanLocal === "A"
          ? 1
          : 2;
    const arrayDataModelo = [];

    switch (this.formInit.get("tipoCotizacion")?.value) {
      case "u":
        arrayDataModelo.push({
          subcuenta: tipoPlanLocal + lineaNegocioLocal,
          linea_negocio:
            lineaNegocioLocal === "SMP"
              ? 1
              : lineaNegocioLocal === "SAO"
                ? 2
                : 3,
          programa: [this.formInit.get("programa")?.value],
        });
        this.modeloAsociadoUnico.push({
          subcuenta: "A" + lineaNegocioLocal,
          linea_negocio:
            lineaNegocioLocal === "SMP"
              ? 1
              : lineaNegocioLocal === "SAO"
                ? 2
                : 3,
          programa: [
            lineaNegocioLocal === "SAO"
              ? this.formInit.get("programa")?.value
              : this.formInit.get("programa")?.value.slice(0, -1) + "A",
          ],
        });
        break;
      case "m":
        const dataGlobal = Codigo.getDataCodeProgramas();
        dataGlobal.forEach((valueSearch) => {
          if (valueSearch.plan === tipoPlanLocal) {
            valueSearch.config.forEach((valueCode) => {
              let programasLocales: string[] = [];
              this.listCodeProgramas.forEach((x) => {
                if (valueCode.subcode.indexOf(x) >= 0) programasLocales.push(x);
              });
              arrayDataModelo.push({
                subcuenta: tipoPlanLocal + valueCode.programa,
                linea_negocio:
                  valueCode.programa === "SMP"
                    ? 1
                    : valueCode.programa === "SAO"
                      ? 2
                      : 3,
                programa: programasLocales,
              });
            });
          }
          if (valueSearch.plan === "A" && tipoPlanLocal === "F") {
            valueSearch.config.forEach((valueCode) => {
              let programasLocalesAsociados: string[] = [];
              this.listCodeProgramas.forEach((x) => {
                valueCode.subcode.forEach((y) => {
                  if (valueCode.programa !== "SAO") {
                    if (y.includes(x.slice(0, -1)))
                      programasLocalesAsociados.push(y);
                  } else {
                    if (y.indexOf(x) >= 0) programasLocalesAsociados.push(y);
                  }
                });
              });
              this.modeloAsociadoMultiple.push({
                subcuenta: "A" + valueCode.programa,
                linea_negocio:
                  valueCode.programa === "SMP"
                    ? 1
                    : valueCode.programa === "SAO"
                      ? 2
                      : 3,
                programa: programasLocalesAsociados,
              });
            });
          }
        });
        if (tipoPlanLocal === "A" || tipoPlanLocal === "C") {
          this.modeloAsociadoMultiple = [];
        }
        this.mostrarResumen = false;
        break;
      default:
        break;
    }

    this.dataTarifa = {
      cuenta: cuentaTemporal,
      modelo_negocio: arrayDataModelo,
    };
    this.buscararTarifas();
  }

  /** Metodo para obtener la campaña en base de datos */
  buscarCampaña() {
    this.spinner.show();
    this.networking.bucarCampa(this.dataCampania).subscribe(
      (data) => {
        this.companiaSuccessfulNetworkingOutput(data);
        // this.spinner.hide();
      },
      (error) => {
        console.error('Error al buscar campaña:', error);
        // Manejo de errores aquí
        this.spinner.hide();
      }
    );
  }

  /** Metodo almacenar las campañas exitosas */
  companiaSuccessfulNetworkingOutput(data: Array<campanias>) {
    this.spinner.hide();
    this.listDataCampania = data;
  }

  /** Metodo almacenar las campañas erroneas */
  companiaFailureNetworkingOutput(errorCode: number, message: string) {
    this.errorgetCampania = message;
    this.form.get("campaniaContratante")?.setValue("");
    this.listDataCampania = [];
    const lblMensajeElement = document.getElementById("lblMensaje");
    if (lblMensajeElement) {
      lblMensajeElement.innerText =
        message && message != "undefined" && message != "null" && message != ""
          ? message
          : "Ha ocurrido un error al obtener las campañas";
    } else {
      console.error('El elemento con ID "lblMensaje" no se encontró en el DOM.');
    }

  }

  selectCampania() {
    const selectCampania: campanias = this.form.get("campaniaContratante")?.value;
    let lineBussines: string = this.lineaNegocio;
    const nameLine: string =
      lineBussines === "SMP" ? "Medicina integral" : "Salud oral";
    lineBussines = lineBussines === "SMP" ? "1" : "2";
    if (selectCampania && selectCampania.solo_nuevos === "S") {
      const listContract = this.listContract.filter(
        (v) => v.codigoLineaNegocio === lineBussines
      );
      if (listContract.length > 1)
        this.openDialog(
          this.dialog,
          `La campaña ${selectCampania.nombre} ${selectCampania.descripcionTarifa} solo admite usuarios nuevos y el contratante tiene ${listContract.length} contratos activos de la linea ${nameLine}.`,
          "",
          0,
          (r: boolean) => { }
        );
    }
  }

  private _norm2(s: any): string {
    return (s ?? '').toString()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim().toUpperCase();
  }

  private buildBeneficiarioIdKeys(input: any): string[] {
    const tipo = this._norm2(input?.tipo_documento ?? input?.tipoDocumento ?? '');
    const doc = this._norm2(input?.num_documento ?? input?.numDocumento ?? input?.documento ?? '');
    const parentesco = this._norm2(input?.parentesco_id ?? input?.parentescoId ?? input?.type ?? '');

    const keys: string[] = [];
    if (tipo && doc && parentesco) {
      keys.push(`${tipo}|${doc}|${parentesco}`);
    }
    if (tipo && doc) {
      keys.push(`${tipo}|${doc}|*`);
    }
    return keys;
  }

  private getBeneficiarioIdFromMap(input: any): number {
    const keys = this.buildBeneficiarioIdKeys(input);
    for (const key of keys) {
      const id = Number(this._beneficiarioIdMap.get(key) || 0);
      if (id > 0) return id;
    }
    return 0;
  }

  private rememberBeneficiarioId(input: any, id: number): void {
    const idOk = Number(id || 0);
    if (!(idOk > 0)) return;

    const keys = this.buildBeneficiarioIdKeys(input);
    keys.forEach(k => this._beneficiarioIdMap.set(k, idOk));
  }

  /*
    private resumirNombreCarnetColectivo(nombre: string, linea: string): string {
      const normalizado = this._norm2(nombre);
      const lineaNormalizada = this._norm2(linea);
  
      if (lineaNormalizada === '1' || lineaNormalizada === 'MI' || lineaNormalizada.includes('INTEGRAL') || lineaNormalizada.includes('SMP')) {
        if (normalizado.includes('ORO PLUS')) return 'ORO PLUS';
        if (normalizado.includes('ORO PRIME')) return 'ORO PRIME';
        if (normalizado.includes('PLATA PRIME')) return 'PLATA PRIME';
        if (normalizado.includes('PLATA JOVEN')) return 'PLATA JOVEN';
        if (normalizado.includes('PREFERENTE')) return 'PREFERENTE';
        if (normalizado.includes('TRADICIONAL ESPECIAL')) return 'TRADICIONAL ESPECIAL';
        if (normalizado.includes('AMBULATORIO ESPECIAL')) return 'AMBULATORIO ESPECIAL';
        if (normalizado.includes('AMBULATORIO ESENCIAL')) return 'AMBULATORIO ESENCIAL';
      }
  
      if (lineaNormalizada === '2' || lineaNormalizada === 'SO' || lineaNormalizada === 'SAO' || lineaNormalizada.includes('ORAL')) {
        if (normalizado.includes('DENTAL ELITE')) return 'DENTAL ÉLITE';
        if (normalizado.includes('DENTAL ESPECIAL')) return 'DENTAL ESPECIAL';
        if (normalizado.includes('DENTAL EXPRESS')) return 'DENTAL EXPRESS';
      }
  
      if (lineaNormalizada === '3' || lineaNormalizada === 'CEM' || lineaNormalizada.includes('EMERGENCIA')) {
        if (normalizado.includes('CEM FULL')) return 'CEM FULL';
      }
  
      return (nombre || '').trim();
    }
  */

  /**
   * @author JSPARRA
   *
   * Estandariza el nombre del programa recibido desde el backend.
   * Aplica mayúsculas, elimina espacios residuales y corrige posibles 
   * problemas de codificación UTF-8 durante la transferencia HTTP.
   * 
   * @param nombre - Nombre original del programa (ej: "ORO PRIME EMPRESARIAL")
   * @param linea - Línea de negocio 
   * @returns Nombre estandarizado de acu
   */
  private resumirNombreCarnetColectivo(nombre: string, linea: string): string {
    if (!nombre) {
      return '';
    }
    console.log('--- PROCESANDO CARNET ---');
    console.log('Nombre original:', nombre);

    let nombreFormateado = nombre.trim().toUpperCase();


    // Intercepta caracteres corruptos
    const mapaCorreccionCaracteres: Record<string, string> = {
      'Ã‘': 'Ñ',
      'Ã¡': 'Á', 'Ã ': 'Á', 'A´': 'Á',
      'Ã©': 'É', 'Ãˆ': 'É', 'E´': 'É',
      'Ã\u00AD': 'Í', 'ÃŒ': 'Í', 'I´': 'Í',
      'Ã³': 'Ó', 'Ã’': 'Ó', 'O´': 'Ó',
      'Ãº': 'Ú', 'Ã™': 'Ú', 'U´': 'Ú'
    };

    // Aplica el reemplazo  solo si se detecta una anomalía
    for (const [caracterCorrupto, caracterValido] of Object.entries(mapaCorreccionCaracteres)) {
      if (nombreFormateado.includes(caracterCorrupto)) {
        nombreFormateado = nombreFormateado.split(caracterCorrupto).join(caracterValido);
      }
    }

    console.log('Nombre resultante:', nombreFormateado);

    return nombreFormateado;
  }

  // Deducción de alias de línea para estética ('MI'|'SO'|'CEM' o nombre tal cual)
  private _aliasONombreLinea2(linea: string): string {
    const up = this._norm2(linea);
    if (up.includes('MEDICINA') || up === 'SMP') return 'MI';
    if (up.includes('SALUD ORAL') || up === 'SAO') return 'SO';
    if (up.includes('CEM') || up === 'CEM') return 'CEM';
    return linea;
  }

  // Construye un clon superficial Beneficiarios
  private _cloneBenef(b: any): any {
    return { ...(b || {}) };
  }

  /** Metodo para actualizar beneficiarios */
  updateTableBeneficiary() {
    var position = 0;
    this.datasBeneficiary.forEach((element) => {
      if (element) { position++; element.position = position; }
    });

    const flattened: any[] = [];
    const filasVistas = new Set<string>();

    const pushFilaUnica = (fila: any, base: any) => {
      const key = [
        (fila?.parentesco_id ?? base?.parentesco_id ?? '').toString().trim(),
        (fila?.num_documento ?? base?.num_documento ?? '').toString().trim(),
        (fila?.lineOfBusiness ?? '').toString().trim(),
        (fila?.program ?? '').toString().trim(),
        (fila?.subcuenta ?? base?.subcuenta ?? '').toString().trim(),
        (fila?.tarifa ?? base?.tarifa ?? '').toString().trim(),
        (fila?.campania ?? base?.campania ?? '').toString().trim(),
      ].join('|');

      if (filasVistas.has(key)) return;
      filasVistas.add(key);
      flattened.push(fila);
    };

    (this.datasBeneficiary || []).forEach((b: any) => {
      // Si el beneficiario heredó los programas del contratante y ya no le queda ninguno,
      // no se pinta la persona sola. La tabla queda vacía.
      const cfgVacio = b?.programasConfig;
      const esFilaContratante = b?.es_contratante === true
        || (b?.es_contratante as any) === 'S'
        || this._norm2(b?.parentesco_id) === 'T';
      const heredadoSinProgramas = !esFilaContratante
        && (b?.usarProgramasContratante === true || cfgVacio?.usarProgramasContratante === true)
        && cfgVacio
        && Array.isArray(cfgVacio.programas)
        && cfgVacio.programas.length === 0;
      if (heredadoSinProgramas) {
        return;
      }

      // Campos de identidad
      const base = this._cloneBenef(b);
      const nombre = [
        (b.primer_nombre || ''), (b.segundo_nombre || ''),
        (b.primer_apellido || ''), (b.segundo_apellido || '')
      ].map((v: string) => v.trim()).filter(Boolean).join(' ');

      // Soportar TRES formatos existentes en tu app:
      // 1) moderno: b.programasConfig.programas[]
      const cfg = b.programasConfig;
      if (cfg && Array.isArray(cfg.programas) && cfg.programas.length > 0) {
        cfg.programas.forEach((p: any) => {
          const fila = this._cloneBenef(base);
          // Priorizar la línea explícita del programa; derivar desde subcuenta solo como último recurso.
          let ln = '';
          if ((p as any)?.lineaNegocio) {
            ln = this._aliasONombreLinea2((p as any).lineaNegocio);
          } else if ((p as any)?.lineaNegocioNombre) {
            ln = this._aliasONombreLinea2((p as any).lineaNegocioNombre);
          } else if (p?.subcuenta) {
            const code = (p.subcuenta || '').toString().slice(1).toUpperCase(); // FSMP -> SMP
            ln = this._aliasONombreLinea2(code);
          } else if (Array.isArray(cfg.lineasSeleccionadas) && cfg.lineasSeleccionadas.length === 1) {
            ln = this._aliasONombreLinea2(cfg.lineasSeleccionadas[0]);
          } else if (b.lineOfBusiness) {
            const lineas = b.lineOfBusiness.split(',').map((s: string) => s.trim()).filter(Boolean);
            ln = lineas.length === 1 ? this._aliasONombreLinea2(lineas[0]) : (lineas[0] || '');
          }
          fila.lineOfBusiness = ln || (b.lineOfBusiness || '');
          fila.program = this.formatearNombrePrograma(p?.nombre || p?.programa || p?.id || (b.program || ''));
          fila.__idBenPrograma = Number(p?.idBenPrograma ?? p?.__idBenPrograma ?? 0) || undefined;
          fila.__idSubcuenta = Number(p?.idSubcuenta ?? p?.__idSubcuenta ?? 0) || undefined;
          fila.__idCotizacionTarifa = Number(p?.idCotizacionTarifa ?? p?.__idCotizacionTarifa ?? 0) || undefined;
          fila.__idCotizacionTarifaAnexo = Number(p?.idCotizacionTarifaAnexo ?? p?.__idCotizacionTarifaAnexo ?? 0) || undefined;
          fila.__idCotizacionCampania = Number(
            p?.idCotizacionCampania ?? p?.__idCotizacionCampania ?? p?.idBenCampania ?? 0
          ) || undefined;
          fila.__programaCodigo = (p?.programa ?? p?.id ?? '').toString().trim();
          pushFilaUnica(fila, base);
        });
        return;
      }

      // 2) semi-moderno: b.programIds[]
      if (Array.isArray(b.programIds) && b.programIds.length > 0) {
        // línea: si solo hay una en lineOfBusiness, úsala
        const lineas = (b.lineOfBusiness || '').split(',')
          .map((s: string) => s.trim()).filter(Boolean);
        const lnUnica = lineas.length === 1 ? this._aliasONombreLinea2(lineas[0]) : (lineas[0] || '');
        b.programIds.forEach((pid: string) => {
          const fila = this._cloneBenef(base);
          fila.lineOfBusiness = lnUnica || (b.lineOfBusiness || '');
          fila.program = this.formatearNombrePrograma(pid);
          pushFilaUnica(fila, base);
        });
        return;
      }

      // 3) legacy: b.program (string) + b.lineOfBusiness (string)
      const progs = (b.program || '').split(',').map((s: string) => s.trim()).filter(Boolean);
      const lobs = (b.lineOfBusiness || '').split(',').map((s: string) => s.trim()).filter(Boolean);

      if (progs.length > 0) {
        const lineas = (lobs.length ? lobs : ['']).map((l: string) => this._aliasONombreLinea2(l));
        progs.forEach((pr: string) => {
          lineas.forEach((ln: string) => {
            const fila = this._cloneBenef(base);
            fila.lineOfBusiness = ln || (b.lineOfBusiness || '');
            fila.program = this.formatearNombrePrograma(pr);
            pushFilaUnica(fila, base);
          });
        });
      } else if (!this.isEditMode) {
        // Alta: todavía puede verse la persona mientras le asignan programa.
        // En edición, si ya no tiene programa, no se pinta una fila vacía.
        pushFilaUnica(base, base);
      }
    });

    // + AJUSTE: Guarda un respaldo de las filas originales para evitar mezclas en búsqueda/limpieza
    this.beneficiaryRowsBackup = [...flattened];

    // La tabla visible usa tu datasource ORIGINAL (respetado)
    this.datasSourceBeneficiary.data = [...flattened];
  }

  private sincronizarContratanteComoBeneficiario(): void {
    if (this.esNuevoColectivo) {
      return;
    }

    if (this.isEditMode && !this.esVersionMasReciente) {
      return;
    }

    this.cargarCatalogoProgramasBeneficiariosSiHaceFalta();

    if (this._omitirSiguienteSyncContratanteBeneficiario) {
      const contratanteExistente = this.datasBeneficiary.find((b: any) => {
        const esTitular = b?.es_contratante === true
          || (b?.parentesco_id || '').toString().trim().toUpperCase() === 'T'
          || (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR';
        if (!esTitular) return false;

        const cfgExistente = b?.programasConfig;
        const tieneProgramasExistentes = Array.isArray(cfgExistente?.programas) && cfgExistente.programas.length > 0;
        const tieneProgramaLegacy = !!(
          (b?.lineOfBusiness || '').toString().trim()
          || (b?.program || '').toString().trim()
        );
        return tieneProgramasExistentes || tieneProgramaLegacy;
      });

      if (contratanteExistente) {
        this._omitirSiguienteSyncContratanteBeneficiario = false;
        this.updateTableBeneficiary();
        return;
      }
    }

    const datosContratante = this.obtenerDatosContratanteDesdeStorage();
    if (!datosContratante) {
      return;
    }

    if (datosContratante.esUsuario !== true) {
      this.removerFilaContratanteAuto(datosContratante.numeroDocumento);
      return;
    }

    const numeroDocumento = (datosContratante.numeroDocumento || '').toString().trim();
    const primerNombre = (datosContratante.primerNombre || '').toString().trim();
    const primerApellido = (datosContratante.primerApellido || '').toString().trim();

    if (!numeroDocumento || !primerNombre || !primerApellido) {
      return;
    }

    const programasContratante = this.obtenerProgramasContratanteDesdeStorage();

    const existenteIdx = this.datasBeneficiary.findIndex((b: any) => {
      const doc = (b?.num_documento || '').toString().trim();
      return doc === numeroDocumento;
    });

    if (this._omitirSiguienteSyncContratanteBeneficiario && existenteIdx >= 0) {
      const existente = this.datasBeneficiary[existenteIdx] as any;
      const cfgExistente = (existente as any)?.programasConfig;
      const tieneProgramasExistentes = Array.isArray(cfgExistente?.programas) && cfgExistente.programas.length > 0;
      const tieneProgramaLegacy = !!(
        (existente?.lineOfBusiness || '').toString().trim()
        || (existente?.program || '').toString().trim()
      );

      if (tieneProgramasExistentes || tieneProgramaLegacy) {
        this._omitirSiguienteSyncContratanteBeneficiario = false;
        this.updateTableBeneficiary();
        return;
      }
    }

    this._omitirSiguienteSyncContratanteBeneficiario = false;

    const beneficiarioContratante = this.construirBeneficiarioContratante(datosContratante, programasContratante);

    if (existenteIdx >= 0) {
      const existente = this.datasBeneficiary[existenteIdx] as any;
      const cfgExistentePrevio = (existente as any)?.programasConfig;
      const tieneProgramasExistentes = Array.isArray(cfgExistentePrevio?.programas) && cfgExistentePrevio.programas.length > 0;
      const tieneProgramaLegacy = !!(
        (existente?.lineOfBusiness || '').toString().trim()
        || (existente?.program || '').toString().trim()
      );

      if (this.isEditMode && programasContratante.length === 0 && (tieneProgramasExistentes || tieneProgramaLegacy)) {
        this.updateTableBeneficiary();
        return;
      }

      // La persona del titular se queda en base por la liquidación, pero si ya no
      // tiene programas ni en pantalla ni en la sesión, no se vuelve a pintar vacía.
      if (this.isEditMode && programasContratante.length === 0) {
        this.datasBeneficiary.splice(existenteIdx, 1);
        this.updateTableBeneficiary();
        return;
      }

      beneficiarioContratante.position = existente?.position || beneficiarioContratante.position;
      // Inclusión: no perder id del titular al re-sincronizar desde storage sin idBeneficiario.
      const prevId = Number(existente?.id_beneficiario || existente?.idBeneficiario || existente?.id_beneficiario_guardado || 0);
      const newId = Number(
        (beneficiarioContratante as any)?.id_beneficiario
        || (beneficiarioContratante as any)?.idBeneficiario
        || (beneficiarioContratante as any)?.id_beneficiario_guardado
        || 0
      );
      if (prevId > 0 && !(newId > 0)) {
        (beneficiarioContratante as any).id_beneficiario = prevId;
        (beneficiarioContratante as any).idBeneficiario = prevId;
        (beneficiarioContratante as any).id_beneficiario_guardado = prevId;
      }
      const cfgExistente = (existente as any)?.programasConfig;
      const cfgNuevo = (beneficiarioContratante as any)?.programasConfig;
      const programasExistentes = Array.isArray(cfgExistente?.programas) ? cfgExistente.programas : [];
      const programasNuevos = Array.isArray(cfgNuevo?.programas) ? cfgNuevo.programas : [];
      const keyProg = (p: any): string => {
        const idBen = Number((p as any)?.idBenPrograma ?? (p as any)?.__idBenPrograma ?? 0);
        if (idBen > 0) return `idBen:${idBen}`;
        const id = ((p as any)?.id ?? (p as any)?.programa ?? '').toString().trim().toUpperCase();
        const linea = ((p as any)?.lineaNegocio ?? '').toString().trim().toUpperCase();
        return `prog:${id}|ln:${linea}`;
      };

      const existentesByKey = new Map<string, any>();
      programasExistentes.forEach((p: any) => existentesByKey.set(keyProg(p), p));

      // Source of truth: lo que venga en storage (cfgNuevo).
      // Solo enriquecemos con campos previos para la misma clave, sin conservar programas huérfanos.
      const programasFinales = programasNuevos.map((p: any) => {
        const prev = existentesByKey.get(keyProg(p));
        return prev ? this.mergeProgramaContratantePreservandoIdsBd(prev, p) : p;
      });

      (beneficiarioContratante as any).programasConfig = {
        ...(cfgExistente || {}),
        ...(cfgNuevo || {}),
        programas: programasFinales
      };
      this.datasBeneficiary[existenteIdx] = beneficiarioContratante;
    } else {
      if (this.isEditMode && programasContratante.length === 0) {
        return;
      }
      this.datasBeneficiary.push(beneficiarioContratante);
    }

    this.updateTableBeneficiary();
  }

  private construirBeneficiarioContratante(
    datos: ContratanteStorageData,
    programasStorage?: ProgramaContratanteStorageItem[]
  ): Beneficiarios {
    const b = new BeneficiariosModel();
    b.es_contratante = true;
    b.parentesco_id = 'T';
    b.typeDescripcion = 'Titular';
    b.tipo_documento = (datos.tipoDocumento || '').toString().trim();
    b.num_documento = (datos.numeroDocumento || '').toString().trim();
    b.primer_nombre = (datos.primerNombre || '').toString().trim();
    b.segundo_nombre = (datos.segundoNombre || '').toString().trim();
    b.primer_apellido = (datos.primerApellido || '').toString().trim();
    b.segundo_apellido = (datos.segundoApellido || '').toString().trim();
    b.genero = (datos.genero || '').toString().trim();
    b.fecha_nacimiento = (datos.fechaNacimiento || '').toString().trim();
    const idBeneficiario = Number(datos.idBeneficiario ?? datos.id_beneficiario_guardado ?? 0);
    if (Number.isFinite(idBeneficiario) && idBeneficiario > 0) {
      (b as any).id_beneficiario = idBeneficiario;
      (b as any).idBeneficiario = idBeneficiario;
      (b as any).id_beneficiario_guardado = idBeneficiario;
    }
    b.program = '';
    b.lineOfBusiness = '';

    const programas = Array.isArray(programasStorage)
      ? programasStorage
      : this.obtenerProgramasContratanteDesdeStorage();
    if (programas.length > 0) {
      (b as any).programasConfig = {
        lineasSeleccionadas: [],
        programas: programas.map((p) => this.construirProgramaConfigContratanteDesdeStorage(p))
      };
    }

    return b as unknown as Beneficiarios;
  }

  private obtenerProgramasContratanteEnvelopeDesdeStorage(): ProgramasContratanteStorageEnvelope | null {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      if (!raw) return null;
      const parsed = JSON.parse(raw || '{}');
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
      return parsed as ProgramasContratanteStorageEnvelope;
    } catch {
      return null;
    }
  }

  private esPersistenciaContratanteVigenteParaCotizacion(
    idCotizacion: number,
    numeroDocumento?: string,
    envelope?: ProgramasContratanteStorageEnvelope | null
  ): boolean {
    if (!(Number(idCotizacion || 0) > 0)) return false;
    const source = envelope ?? this.obtenerProgramasContratanteEnvelopeDesdeStorage();
    if (!source) return false;

    const idCotizacionPersistida = Number(source?.idCotizacion || 0);
    if (!(idCotizacionPersistida > 0) || idCotizacionPersistida !== Number(idCotizacion)) {
      return false;
    }

    const docActual = (numeroDocumento || '').toString().trim();
    const docPersistido = (source?.numeroDocumento || '').toString().trim();
    if (docActual && docPersistido && docActual !== docPersistido) {
      return false;
    }

    return true;
  }

  private obtenerDatosContratanteDesdeStorage(): ContratanteStorageData | null {
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE_STORAGE);
      if (!raw) return null;
      const parsed = JSON.parse(raw || '{}');
      const envelope = this.obtenerProgramasContratanteEnvelopeDesdeStorage();
      const idCotizacionActiva = this.obtenerIdCotizacionActivaParaFlecha();
      const persistenciaVigente = this.esPersistenciaContratanteVigenteParaCotizacion(
        idCotizacionActiva,
        parsed?.numeroDocumento,
        envelope
      ) && this.existeSnapshotGuardadoFlechaParaCotizacion(idCotizacionActiva);
      return {
        tipoDocumento: parsed?.tipoDocumento,
        numeroDocumento: parsed?.numeroDocumento,
        primerNombre: parsed?.primerNombre,
        segundoNombre: parsed?.segundoNombre,
        primerApellido: parsed?.primerApellido,
        segundoApellido: parsed?.segundoApellido,
        genero: parsed?.genero,
        fechaNacimiento: parsed?.fechaNacimiento,
        esUsuario: parsed?.esUsuario === true,
        idBeneficiario: persistenciaVigente ? (Number(parsed?.idBeneficiario || 0) || undefined) : undefined,
        id_beneficiario_guardado: persistenciaVigente ? (Number(parsed?.id_beneficiario_guardado || 0) || undefined) : undefined,
      };
    } catch {
      return null;
    }
  }

  private obtenerProgramasContratanteDesdeStorage(): ProgramaContratanteStorageItem[] {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      if (!raw) return [];
      const parsed = JSON.parse(raw || '[]');
      const envelope = !Array.isArray(parsed) && parsed && typeof parsed === 'object'
        ? parsed as ProgramasContratanteStorageEnvelope
        : null;
      const items: ProgramaContratanteStorageItem[] = Array.isArray(parsed)
        ? parsed
        : (parsed && typeof parsed === 'object' && Array.isArray((parsed as ProgramasContratanteStorageEnvelope).programas))
          ? (parsed as ProgramasContratanteStorageEnvelope).programas || []
          : [];
      const idCotizacionActiva = this.obtenerIdCotizacionActivaParaFlecha();
      const persistenciaVigente = this.esPersistenciaContratanteVigenteParaCotizacion(
        idCotizacionActiva,
        envelope?.numeroDocumento,
        envelope
      ) && this.existeSnapshotGuardadoFlechaParaCotizacion(idCotizacionActiva);
      return items
        .map((p: ProgramaContratanteStorageItem) => ({
          ...p,
          programa: (p?.programa || p?.id || '').toString().trim(),
          idBeneficiario: persistenciaVigente ? (Number((p as any)?.idBeneficiario || 0) || undefined) : undefined,
          idBenPrograma: persistenciaVigente ? (Number((p as any)?.idBenPrograma || 0) || undefined) : undefined,
          idSubcuenta: persistenciaVigente ? (Number((p as any)?.idSubcuenta || 0) || undefined) : undefined,
          idCotizacionTarifa: persistenciaVigente ? (Number((p as any)?.idCotizacionTarifa || 0) || undefined) : undefined,
          idCotizacionTarifaAnexo: persistenciaVigente ? (Number((p as any)?.idCotizacionTarifaAnexo || 0) || undefined) : undefined,
          idCotizacionCampania: persistenciaVigente ? (Number((p as any)?.idCotizacionCampania || 0) || undefined) : undefined,
          idBenCampania: persistenciaVigente ? (Number((p as any)?.idBenCampania || 0) || undefined) : undefined,
          guardadoEnBd: persistenciaVigente ? ((p as any)?.guardadoEnBd === true) : false,
        }))
        .filter((p: any) => !!p?.programa);
    } catch {
      return [];
    }
  }

  private removerFilaContratanteAuto(numeroDocumento?: string): void {
    const doc = (numeroDocumento || '').toString().trim();
    const before = this.datasBeneficiary.length;
    this.datasBeneficiary = this.datasBeneficiary.filter((b: any) => {
      const esContratante = b?.es_contratante === true || (b?.es_contratante as any) === 'S';
      if (!esContratante) return true;
      if (!doc) return false;
      return (b?.num_documento || '').toString().trim() !== doc;
    });
    if (this.datasBeneficiary.length !== before) {
      this.updateTableBeneficiary();
    }
  }

  private normalizarRequiereAnexo(value: any): 'si' | 'no' | null {
    const v = (value ?? '').toString().trim().toUpperCase();
    if (value === true || v === 'SI' || v === 'S' || v === 'TRUE' || v === '1') return 'si';
    if (value === false || v === 'NO' || v === 'N' || v === 'FALSE' || v === '0') return 'no';
    return null;
  }

  private resolverNombreProgramaDinamico(value: string): string {
    const raw = (value || '').toString().trim();
    if (!raw) return '';

    const rawNorm = this._norm2(raw);

    if (this.esInclusion) {
      const rawDesc = localStorage.getItem('programas_descripciones_inclusion');
      const descripcionesInclusion = rawDesc ? JSON.parse(rawDesc) : {};
      if (descripcionesInclusion[rawNorm]) {
        return descripcionesInclusion[rawNorm];
      }
    }

    const fromCarnets = Object.values(this.programasCarnetPorLinea || {})
      .flat()
      .find((item: any) => this._norm2(item?.code) === rawNorm);
    if (fromCarnets?.program) {
      return (fromCarnets.program || '').toString().trim();
    }

    const fromListProgramas = (Array.isArray(this.listProgramas) ? this.listProgramas : [])
      .find((item: any) => this._norm2(item?.code ?? item?.codigo ?? item?.id) === rawNorm);
    if (fromListProgramas) {
      const nombre = (fromListProgramas.program ?? fromListProgramas.programa ?? fromListProgramas.nombre ?? '').toString().trim();
      if (nombre) return nombre;
    }

    return '';
  }

  private formatearNombrePrograma(value: string): string {
    const raw = (value || '').toString().trim();
    if (!raw) return '';

    const dinamico = this.resolverNombreProgramaDinamico(raw);
    const base = dinamico || raw;

    // Si viene nombre completo, respetarlo; si viene con separadores raros, normalizar espacios.
    const cleaned = base.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    return cleaned.toUpperCase();
  }

  private cargarCatalogoProgramasBeneficiariosSiHaceFalta(): void {
    const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');
    if (this._catalogoBenefProgramasCargado) {
      this.aplicarFiltroInclusionGlobal();
      return;
    }
    if (this._catalogoBenefProgramasCargando) return;
    this._catalogoBenefProgramasCargando = true;

    const tipoPlanForm = this.formInit?.get('tipoPlan')?.value;
    const tipoPlanActual = (tipoPlanForm || localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();
    const programasParaEnviar = this.obtenerProgramasParaCarnets([]);

    console.log('[cargarCatalogoProgramasBeneficiariosSiHaceFalta] Verificando catálogo base comercial...');

    const datosCache = (this.consultarLineasGruposProgramasService as any).cacheCarnetsInclusion;
    if ((tipoSolicitud === '2' || this.esInclusion) && datosCache) {
      const carnets = datosCache?.status && Array.isArray(datosCache?.data)
        ? datosCache.data
        : (Array.isArray(datosCache?.data?.data) ? datosCache.data.data : (Array.isArray(datosCache) ? datosCache : []));

      if (carnets && carnets.length > 0) {
        console.log('[cargarCatalogoProgramasBeneficiariosSiHaceFalta] RAM detectada con éxito. Procesando inclusión síncrona.');

        const seenCatCodes = new Set<string>();
        const catalogo: any[] = [];

        carnets.forEach((it: any) => {
          const code = (it?.code || it?.codigo || it?.id || '').toString().trim().toUpperCase();
          const program = (it?.program || it?.programa || it?.nombre || '').toString().trim();
          const file = (it?.file || it?.carnet?.file || '').toString().trim();

          if (code && program && !seenCatCodes.has(code)) {
            seenCatCodes.add(code);
            catalogo.push({ code, program, file });
          }
        });

        if (catalogo.length > 0) {
          const med = catalogo.filter(c => !c.code.startsWith('DE') && !c.code.startsWith('CEM'));
          const dent = catalogo.filter(c => c.code.startsWith('DE'));
          const cem = catalogo.filter(c => c.code.startsWith('CEM'));

          // Mapeo multillave para Inclusión
          this.programasCarnetPorLinea = {
            ...this.programasCarnetPorLinea,
            CAT: catalogo,
            '1': med, 'MI': med, 'SMP': med,
            '2': dent, 'SAO': dent, 'SO': dent,
            '3': cem, 'CEM': cem
          };
        }
        this.aplicarFiltroInclusionGlobal();
        this._catalogoBenefProgramasCargado = true;
        this._catalogoBenefProgramasCargando = false;
        this.refrescarNombresProgramaBeneficiariosDesdeCatalogo();
        return;
      }
    }

    // ===================================================================
    // FLUJO PARA VENTA NUEVA / GRUPO DE AFINIDAD (GA) POR HTTP
    // ===================================================================
    console.log('[cargarCatalogoProgramasBeneficiariosSiHaceFalta] Ejecutando petición HTTP para Venta Nueva / GA:', { tipoPlanActual, programasParaEnviar });
    const edadContratante = Number(
      this.form.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('contratanteEdad')?.value ||
      this.formularioContratanteComponent?.formContratante?.get('edad')?.value ||
      0
    );

    this.consultarLineasGruposProgramasService.consultarCarnets({
      lineaNegocio: ['MI', 'SAO', 'CEM'],
      tipoPlan: tipoPlanActual,
      programas: programasParaEnviar,
      tipoSolicitud: localStorage.getItem('tipoSolicitud') || '2',
      edad: edadContratante
    }).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (tipoSolicitud === '2') {
          (this.consultarLineasGruposProgramasService as any).cacheCarnetsInclusion = response;
        }

        const carnets = response?.data?.data || response?.data || response || [];
        const carnetsArray = Array.isArray(carnets) ? carnets : [];

        console.log(`[cargarCatalogoProgramasBeneficiariosSiHaceFalta] Carnets recibidos exitosamente: ${carnetsArray.length}`);

        const seenCatCodes = new Set<string>();

        const deInclusionGlobal: any[] = [];
        const deLineaMedicina: any[] = [];
        const deLineaDental: any[] = [];
        const deLineaCem: any[] = [];
        const deListProgramasCards: any[] = [];

        carnetsArray.forEach((it: any) => {
          const codigoLimpio = (it?.code || it?.codigo || it?.id || it?.programa || '').toString().trim().toUpperCase();
          const program = (it?.program || it?.programa || it?.nombre || it?.nombrePrograma || '').toString().trim();
          const file = (it?.file || it?.carnet?.file || '').toString().trim();

          if (codigoLimpio && program && !seenCatCodes.has(codigoLimpio)) {
            seenCatCodes.add(codigoLimpio);

            const carnetData = { code: codigoLimpio, program, file };
            deInclusionGlobal.push(carnetData);

            const nombreLinea = (it?.lineaNegocio || it?.lineOfBusiness || it?.linea || '').toString();
            const lineaAsignada = this.clasificarLineaCarnet(nombreLinea, codigoLimpio, program);

            let lineaCardFormato = 'SMP';
            if (lineaAsignada === '2') {
              deLineaDental.push(carnetData);
              lineaCardFormato = 'SAO';
            } else if (lineaAsignada === '3') {
              deLineaCem.push(carnetData);
              lineaCardFormato = 'CEM';
            } else {
              deLineaMedicina.push(carnetData);
              lineaCardFormato = 'SMP';
            }

            // Sincronizamos las propiedades con todas las variantes conocidas del Core
            deListProgramasCards.push({
              ...it,
              code: codigoLimpio,
              codigo: codigoLimpio,
              id: codigoLimpio,
              program: program,
              nombre: program,
              file: file,
              lineaNegocio: lineaCardFormato,
              linea: lineaCardFormato,
              lineOfBusiness: lineaCardFormato,
              linea_nego: lineaCardFormato
            });
          }
        });

        // ===================================================================
        // ESTRATEGIA MULTILLAVE TOTAL: Sembramos todas las variantes posibles
        // para que cualquier componente hijo o modal encuentre los datos.
        // ===================================================================
        this.programasCarnetPorLinea = {
          ...this.programasCarnetPorLinea,
          CAT: deInclusionGlobal,
          // Llaves para Medicina Integral
          '1': deLineaMedicina,
          'MI': deLineaMedicina,
          'SMP': deLineaMedicina,
          // Llaves para Salud Oral / Dental
          '2': deLineaDental,
          'SAO': deLineaDental,
          'SO': deLineaDental,
          // Llaves para CEM
          '3': deLineaCem,
          'CEM': deLineaCem
        };

        this.listProgramas = deListProgramasCards;

        console.log('[cargarCatalogoProgramasBeneficiariosSiHaceFalta] Catálogo inyectado con mapeo multillave completo:', {
          Total_listProgramas: this.listProgramas.length,
          Llaves_Mapeadas: Object.keys(this.programasCarnetPorLinea)
        });

        this.aplicarFiltroInclusionGlobal();
        this._catalogoBenefProgramasCargado = true;
        this._catalogoBenefProgramasCargando = false;
        this.refrescarNombresProgramaBeneficiariosDesdeCatalogo();
      },
      error: (err) => {
        console.error('[cargarCatalogoProgramasBeneficiariosSiHaceFalta] Error crítico en llamada:', err);
        this._catalogoBenefProgramasCargando = false;
      }
    });
  }


  private refrescarNombresProgramaBeneficiariosDesdeCatalogo(): void {
    let changed = false;

    (this.datasBeneficiary || []).forEach((b: any) => {
      const cfg = b?.programasConfig;
      if (cfg && Array.isArray(cfg.programas)) {
        cfg.programas.forEach((p: any) => {
          const nombreActual = (p?.nombre || '').toString().trim();
          const codigo = (p?.id || p?.programa || '').toString().trim();
          const raw = nombreActual || codigo;
          if (!raw) return;

          const debeResolver = !nombreActual || /^[A-Z0-9]{3,10}$/.test(this._norm2(nombreActual));
          if (!debeResolver) return;

          const nombreResuelto = this.formatearNombrePrograma(raw);
          if (nombreResuelto && nombreResuelto !== nombreActual) {
            p.nombre = nombreResuelto;
            changed = true;
          }
        });
      }

      if (typeof b?.program === 'string') {
        const programActual = b.program.toString().trim();
        if (programActual) {
          const programResuelto = this.formatearNombrePrograma(programActual);
          if (programResuelto && programResuelto !== programActual) {
            b.program = programResuelto;
            changed = true;
          }
        }
      }
    });

    if (changed) {
      this.updateTableBeneficiary();
    }
  }

  /** Metodo para validar el contratante */
  validarContratante(): boolean {
    if (this.requisitosMinimosContratante) {
      return true;
    }

    this.form.markAllAsTouched();
    Object.values(this.form.controls).forEach(c => {
      c.updateValueAndValidity({ onlySelf: true });
    });
    const passGender = !!this.form.get("contratanteGenero")?.value;
    if (!passGender) {
      this.SnackBarService.alert("alert-danger", "El genero es obligatorío");
      return false;
    }
    const pass = this.form.valid;
    if (!pass) {
      this.SnackBarService.alert("alert-danger", "Faltan campos por diligenciar");
    }
    return pass;
  }

  private requisitosMinimosContratante = true;

  private setRequisitosContratante(required: boolean): void {
    const f = this.form;
    if (!f) return;

    const toggleReq = (name: string, validators: any[]) => {
      const ctrl = f.get(name);
      if (!ctrl) return;
      if (required) {
        ctrl.setValidators(validators);
      } else {
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    };

    toggleReq('contratanteTipoDocumento', [Validators.required]);
    toggleReq('contratanteDocumento', [Validators.required, Validators.pattern(this.number)]);
    toggleReq('contratanteNombre', [Validators.required, Validators.minLength(3), Validators.maxLength(25), Validators.pattern(this.alphabeticalPattern)]);
    toggleReq('contratanteApellido', [Validators.required, Validators.minLength(3), Validators.maxLength(25), Validators.pattern(this.alphabeticalPattern)]);
    toggleReq('contratanteGenero', [Validators.required]);
    toggleReq('contratanteFechaNacimiento', [Validators.required]);
    toggleReq('contratanteEdad', [Validators.required]);
    toggleReq('contratanteEmail', [Validators.required, Validators.pattern(this.emailPattern)]);
    toggleReq('contratanteTelefono', [Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern(this.number)]);
  }

  /** Metodo para añadir al contratante como beneficiario */
  saveContractor() {
    const contratante = this.dataBeneficiary.filter((b) => {
      return b.type !== "T";
    });

    const data = this.form.getRawValue();
    this.infoDataCotizador();

    if (data.contratanteUsuario == 2) {
      this.dataBeneficiary = this.dataBeneficiary.filter((b) => {
        return b.type !== "T";
      });
      this.updateTableBeneficiary();
      return;
    }

    this.dataBeneficiary = [];
    let objPersona: PersonBeneficiary = {
      name: '',
      secondname: '',
      lastname: '',
      secondsurname: '',
      gender: '',
      datebirth: '',
      tarifa: '',
      descriptionTarifa: '',
      age: '',
      type: '',
      typeDescripcion: '',
      position: 0,
      isContract: false,
      email: '',
      movilNumber: '',
      phone: '',
      codigo_campania: '',
      campania: '',
      tipoDocumento: '',
      documento: '',
      lineOfBusiness: '',
      program: ''
    };
    let compani: boolean = false;
    compani = data.campaniaContratante ? true : false;
    objPersona.type = "T";
    objPersona.name = data.contratanteNombre;
    objPersona.secondname = data.contratanteSegundoNombre;
    objPersona.lastname = data.contratanteApellido;
    objPersona.secondsurname = data.contratanteSegundoApellido;
    objPersona.gender = data.contratanteGenero;
    objPersona.isContract = data.contratanteUsuario;
    objPersona.email = data.contratanteEmail;
    objPersona.movilNumber = data.contratanteTelefono;
    objPersona.phone = data.telefonoFijo;
    objPersona.age = data.contratanteEdad;
    objPersona.campania = compani
      ? `${data.campaniaContratante?.codigo_campania} ${data.campaniaContratante?.nombre} ${data.campaniaContratante?.tarifa}`
      : "";
    objPersona.datebirth = data.contratanteFechaNacimiento;
    objPersona.tarifa = data.contratanteTarifa
      ? data.contratanteTarifa
      : this.valContrato.codigoTarifa;
    this.dataBeneficiary.push(objPersona);
    contratante.forEach((value) => {
      this.dataBeneficiary.push(value);
    });
    this.updateTableBeneficiary();
    this.tabHabilitado.beneficiarios = true;
    this.maxStepReached = Math.max(this.maxStepReached, 2);
  }

  /** Metodo para construir el cotizador */
  infoDataCotizador() {
    const tipoCotizacionLocal = this.formInit.get("tipoCotizacion")?.value;
    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    this.getCampania();
    let modelo_negocio_asociado = Array<ModeloNegocioRequest>();
    if (tipoCotizacionLocal == "u")
      modelo_negocio_asociado =
        tipoPlanLocal === "F" ? this.modeloAsociadoUnico : [];
    else
      modelo_negocio_asociado =
        tipoPlanLocal === "F" ? this.modeloAsociadoMultiple : [];

    this.objDataCotizador = {
      tipo_solicitud: this.dataCampania.tipo_solicitud,
      cuenta: this.dataCampania.cuenta,
      modelo_negocio: this.dataCampania.modelo_negocio,
      cuenta_asociado: 1,
      modelo_negocio_asociado: modelo_negocio_asociado,
      cuota_inscripcion: 0,
      contratante: {
        tipo_documento: this.form.get("contratanteTipoDocumento")?.value,
        numero_documento: this.form.get("contratanteDocumento")?.value,
        nombre1: this.limpiarNull(this.form.get("contratanteNombre")?.value),
        nombre2: this.limpiarNull(
          this.form.get("contratanteSegundoNombre")?.value
        ),
        apellido1: this.limpiarNull(this.form.get("contratanteApellido")?.value),
        apellido2: this.limpiarNull(
          this.form.get("contratanteSegundoApellido")?.value
        ),
        contratante_usuario: this.contratante_usuario,
        correo_electronico: this.limpiarNull(
          this.form.get("contratanteEmail")?.value
        ),
        correo_electronico_2: this.limpiarNull(
          this.form.get("contratanteEmail2")?.value
        ),
        telefono_celular: this.limpiarNull(
          this.form.get("contratanteTelefono")?.value
        ),
        telefono_fijo: this.limpiarNull(this.form.get("telefonoFijo")?.value),
      },
    };
  }

  /** Metodo para obtener el valor de la descripcion */
  showModalCuota() {
    // Si ya hay cuota definida (incluyendo 0), saltar el modal
    if (this.valCuota != null) {
      this.tabOption(null, 3);
      return;
    }

    const okInicio = this.validarInicio();
    const okContr = this.validarContratante();
    const numBens = this.datasBeneficiary.length;
    const validateInicio2 = okInicio ? 1 : 0;
    const validateContratante2 = okContr ? 2 : 1;
    const beneficiarios = numBens;

    if (
      validateInicio2 === 1 &&
      validateContratante2 === 2 &&
      beneficiarios > 0
    ) {
      this.valorFamiliar = [];
      this.valorAsociadoTotal = 0;
      this.valorFamiliaTotal = 0;
      const dialogRef = this.dialog.open(DialogCuotaInscripcionComponent, {
        data: this.valCuota,
        id: "coutaManejo",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != undefined) {
          this.valCuota = result;
          // this.enviarCotizador();
          this.tabOption(null, 3);
        }
      });
    } else {
      this.selectedIndex = 2;
      this.SnackBarService.alert(
        "alert-danger",
        "Debe validar los pasos anteriores o se debe asociar un beneficiario."
      );
    }
  }

  /** Metodos para actualizar las tarifas del cotizador multiple*/
  actualizarTarifas(tarifa: string, beneficiario: string, idxBeneficiario: number, cuenta: string): void {
    if (tarifa) {
      this.selectedValue[idxBeneficiario + '-' + this.subStrCuenta(cuenta)] = tarifa;
      this.dataBeneficiary[idxBeneficiario].tarifa = tarifa;

      if (this.mSelBenTari[idxBeneficiario]) {
        this.mSelBenTari[idxBeneficiario][this.subStrCuenta(cuenta)] = tarifa;
      } else {
        this.mSelBenTari[idxBeneficiario] = {};
        this.mSelBenTari[idxBeneficiario][this.subStrCuenta(cuenta)] = tarifa;
      }

      this.actualizarCotizacionBeneficiario();
    }
  }
  private actualizarCotizacionBeneficiario() {
    var beneficiary = [];
    this.valorFamiliaTotal = 0;
    this.valorAsociadoTotal = 0;
    const valCuota = (this.valCuota?.toString().replace(",", "") ?? '');
    this.objDataCotizador["cuota_inscripcion"] = parseInt(valCuota);

    for (const posB of Object.keys(this.mSelBenTari).map(Number)) {
      const element = this.dataBeneficiary[posB];
      const fechaNacimientoFormatted = this.formatDate(new Date(element.datebirth));
      const tarifas = Object.values(this.mSelBenTari[posB]);
      beneficiary.push({
        parentesco: element.type === "Contratante" ? "T" : element.type,
        sexo: element.gender == "1" ? "F" : "M",
        fecha_nacimiento: fechaNacimientoFormatted,
        edad: element.age,
        nombre1: element.name,
        nombre2: !element.secondname ? "" : element.secondname,
        apellido1: element.lastname,
        apellido2: !element.secondsurname ? "" : element.secondsurname,
        tarifa: tarifas,
        campania: element.campania,
      });
    }
    //console.log("\n\nMi mapa\n\n",this.mSelBenTari);
    this.objDataCotizador["beneficiarios"] = beneficiary;
    this.limpiarSubcuentasInclusionIndividual();
    this.spinner.hide(); // cerrar spinner anterior antes de cancelar la petición previa
    this.cotizadorCancel$.next();
    this.spinner.show();
    this.networking.enviarCotizador(this.objDataCotizador).pipe(takeUntil(this.cotizadorCancel$)).subscribe((r: any) => {
      this.cotizadorSuccessfulNetworkingOutput(r);
    }, error => {
      this.cotizadorFailureNetworkingOutput(1, error);
    });
  }

  /** Metodo para solicitar las cotizaciones */
  enviarCotizador() {
    // Inicializar objDataCotizador si aún no fue construido
    if (!this.objDataCotizador) {
      this.infoDataCotizador();
    }

    const tipoCotizacionLocal = this.formInit.get("tipoCotizacion")?.value;
    const valCuota = (this.valCuota?.toString().replace(",", "") ?? '');
    this.objDataCotizador["cuota_inscripcion"] = parseInt(valCuota);

    // Formatear beneficiarios
    const beneficiary: {
      parentesco: string;
      sexo: string;
      fecha_nacimiento: string; // Asegúrate de que sea string en formato yyyy-MM-dd
      edad: string;
      nombre1: string;
      nombre2: string;
      apellido1: string;
      apellido2: string;
      tarifa: string[];
      campania: string;
    }[] = [];

    this.dataBeneficiary.forEach((element) => {
      // Formatear fecha de nacimiento a yyyy-MM-dd
      const fechaNacimientoFormatted = this.formatDate(new Date(element.datebirth));
      beneficiary.push({
        parentesco: element.type === "Contratante" ? "T" : element.type,
        sexo: element.gender == "1" ? "F" : "M",
        fecha_nacimiento: fechaNacimientoFormatted,
        edad: element.age,
        nombre1: element.name,
        nombre2: !element.secondname ? "" : element.secondname,
        apellido1: element.lastname,
        apellido2: !element.secondsurname ? "" : element.secondsurname,
        tarifa: [element.tarifa],
        campania: element.campania,
      });
    });

    this.objDataCotizador["beneficiarios"] = beneficiary;
    this.limpiarSubcuentasInclusionIndividual();


    if (this.contratanteTarifa == 'AAESFQ') this.ocultarPlanFamiliar = false;

    if (tipoCotizacionLocal === "u") {
      this.spinner.hide(); // cerrar spinner anterior antes de cancelar la petición previa
      this.cotizadorCancel$.next();
      this.spinner.show(); // Mostrar spinner antes de la petición HTTP
      this.networking.enviarCotizador(this.objDataCotizador).pipe(takeUntil(this.cotizadorCancel$)).subscribe(
        (response) => {
          this.spinner.hide();
          this.cotizadorSuccessfulNetworkingOutput(response);
        },
        (error) => {
          this.spinner.hide();
          console.error('Error al enviar cotización:', error);
          this.cotizadorFailureNetworkingOutput(1, error);
        }
      );
    } else if (tipoCotizacionLocal === "m") {
      this.prepararCotizacionMultiple(); // Lógica para cotización múltiple
    } else {
      console.warn('Tipo de cotización no válido:', tipoCotizacionLocal);
    }
  }

  // Función para formatear la fecha a yyyy-MM-dd
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Asegura dos dígitos
    const day = ('0' + date.getDate()).slice(-2); // Asegura dos dígitos
    return `${year}-${month}-${day}`;
  }


  /**
   * Metodo para recibir la respuesta exitosa del cotizador
   */
  /**
   * Metodo para recibir la respuesta exitosa del cotizador
   */
  cotizadorSuccessfulNetworkingOutput(data: any) {
    console.log('[Cotizador] Respuesta exitosa recibida del Core:', data);                                         //Nuevo
    this.spinner.hide();
    this.ocultarPlanAsociado = true;
    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    const programaLocal = this.formInit.get("programa")?.value;
    const lineaNegocioLocal = this.formInit.get("lineaNegocio")?.value;
    const tipoCotizacionLocal = this.formInit.get("tipoCotizacion")?.value;
    this.numeroCotizacion = data.id;
    const plan = Codigo.getPlan().filter((b) => {
      return b.codigo == tipoPlanLocal;
    });
    this.planNombre = plan[0].descripcion;
    if (this.planNombre === "Asociado") {
      this.ocultarPlanFamiliar = false;
    } else if (this.planNombre === "Familiar" && this.esInclusion === true) {
      this.ocultarPlanAsociado = true;
    }
    if (tipoCotizacionLocal == "u") {
      console.log('[Cotizador] Procesando flujo Uniproducto (u)');                                                 //Nuevo
      this.cuotaInscripcion = data.cuota_inscripcion;
      this.cuotaTotal = data.cuota_mensual_total;
      if (parseInt(data.cuota_mensual_total) > 0) {
        const linea = Codigo.getLineaNegocio().filter((b) => {
          return b.valor == lineaNegocioLocal;
        });
        this.lineaNombre = linea[0].nombre;
        let programa: any = this.listProgramas.filter((b: any) => {
          return b.code === programaLocal;
        });
        if (programa.length > 0) {
          this.imgPrograma = programa[0].file;
        }
        this.detalle_descuentos = data.detalle_descuentos;
        const result = this.dataCampania.modelo_negocio[0];
        const t = result.programa[0];
        const cuenta = data.detalle_pago_mensual[result.subcuenta];
        const obj = cuenta["" + t];
        obj.forEach((element: { [x: string]: any; tarifaAsociado: any; }) => {
          element["tarifa_asociado"] = element.tarifaAsociado;
          element["linea_negocio"] = element["subcuenta"].indexOf("SMP") > 0 ? 1 : element["subcuenta"].indexOf("SAO") > 0 ? 2 : 3;
        });
        this.listDetallePagoMensual = obj;
      } else {
        console.warn('[Cotizador] Alerta Uniproducto: cuota_mensual_total es 0 o negativo.');                       //Nuevo
        Swal
          .fire({
            text: `No se encontraron valores para las tarifas seleccionadas `,
            confirmButtonColor: "#0372b9",
            confirmButtonText: "OK",
          })
          .then(() => {
            if (tipoCotizacionLocal != "m") {
              this.selectedIndex = 2;
            }
          });
      }
    } else {
      console.log('[Cotizador] Procesando flujo Multiproducto (m). Llaves encontradas:', Object.keys(data?.detalle_pago_mensual || {})); //Nuevo
      if (data?.detalle_pago_mensual && Object.values(data.detalle_pago_mensual).length > 0) {
        this.valorFamiliaTotal = 0;
        this.valorAsociadoTotal = 0;
        this.valorFamiliaTotalBruto = 0;
        this.valorAsociadoTotalBruto = 0;
        this.valorFamiliar = [];
        const lineaD = Codigo.getLineaNegocio();
        let lineaTemporal = "";
        const lineas = Object.keys(data.detalle_pago_mensual);

        /*
        lineas.map((linea, idxLineas) => {
          const programas = Object.keys(data.detalle_pago_mensual[linea]);
        */
        lineas.map((lineaRaw, idxLineas) => {                                                                               //Nuevo
          const linea = (lineaRaw || '').toString().trim().toUpperCase();                                                   //Nuevo
          const tipoPlanFiltro = (this.dataCampania.codigo_tipo_plan || '').toString().trim().toUpperCase();                 //Nuevo
          console.log(`  [Cotizador] Linea BD: "${lineaRaw}" -> Procesada: "${linea}" | TipoPlan: "${tipoPlanFiltro}"`);   //Nuevo
          const programas = Object.keys(data.detalle_pago_mensual[lineaRaw]);                                               //Nuevo

          const nombresProgramas = Object.keys(programas);
          // OPLF - PJVF
          for (
            let index_tarifa = 0;
            index_tarifa < nombresProgramas.length;
            index_tarifa++
          ) {
            const programaIndex = programas[index_tarifa];
            /*
            const tarifas = Object.keys(
              data.detalle_pago_mensual[linea][programaIndex]
            );
            */
            const tarifas = Object.keys(data.detalle_pago_mensual[lineaRaw][programaIndex]);                                //Nuevo
            console.log(`    [Cotizador] Identificador programa: "${programaIndex}" | Cantidad tarifas: ${tarifas.length}`); //Nuevo

            // FSILVQ - FPLUNQ
            for (let index = 0; index < tarifas.length; index++) {
              /*
              let tableIndex: any = null;
              if (this.dataCampania.codigo_tipo_plan === "F") tableIndex = linea == 'FSAO' ? 1 : 0;
              if (this.dataCampania.codigo_tipo_plan === "A") tableIndex = linea == 'ASAO' ? 1 : 0;
              if (!this.listLineaTable[tableIndex] || this.listLineaTable[tableIndex] == undefined) {
                Swal
                  .fire({
                    text: `No se encontraron valores para las tarifas seleccionadas`,
                    confirmButtonColor: "#0372b9",
                    confirmButtonText: "OK",
                  })
                  .then(() => {
                    if (tipoCotizacionLocal != "m") {
                      this.selectedIndex = 2;
                    }
                  });
              }
              */
              let tableIndex: any = 0;                                                                                      //Nuevo
              if (tipoPlanFiltro === "F") tableIndex = (linea === 'FSAO' || linea === 'SO' || linea === 'SAO') ? 1 : 0;         //Nuevo
              if (tipoPlanFiltro === "A") tableIndex = (linea === 'ASAO' || linea === 'SO' || linea === 'SAO') ? 1 : 0;         //Nuevo
              console.log(`      [Cotizador] Evaluando tarifa: "${tarifas[index]}" | Asignando tableIndex: ${tableIndex}`); //Nuevo
              if (!this.listLineaTable[tableIndex] || this.listLineaTable[tableIndex] == undefined) {                        //Nuevo
                console.warn(`      [Cotizador] Índice ${tableIndex} fuera de limites para listLineaTable, omitiendo loop.`); //Nuevo
                continue;                                                                                                   //Nuevo
              }                                                                                                             //Nuevo

              this.listLineaTable[tableIndex].itemsPago.forEach(
                (element: { data: any[]; }) => {
                  /*
                  let result = element.data.filter((b) => {
                    return (
                      b.beneficiario.toLowerCase().trim() == data.detalle_pago_mensual[linea][programaIndex][
                        index
                      ].beneficiario
                        .toLowerCase()
                        .trim() && b.programa == data.detalle_pago_mensual[linea][programaIndex][index]
                        .programa
                    );
                  });
                  */
                  let result = element.data.filter((b) => {                                                                 //Nuevo
                    const progBD = (data.detalle_pago_mensual[lineaRaw][programaIndex][index].programa || '').toString().trim().toUpperCase(); //Nuevo
                    const progLocal = (b.programa || '').toString().trim().toUpperCase();                                   //Nuevo
                    const benBD = (data.detalle_pago_mensual[lineaRaw][programaIndex][index].beneficiario || '').toString().toLowerCase().trim(); //Nuevo
                    const benLocal = (b.beneficiario || '').toString().toLowerCase().trim();                                //Nuevo
                    return (benLocal === benBD && progLocal === progBD);                                                    //Nuevo
                  });                                                                                                       //Nuevo

                  if (result.length > 0) {
                    console.log(`        [Cotizador] Coincidencia encontrada para ${tarifas[index]}. Registros enlazados: ${result.length}`); //Nuevo
                    result.forEach((items) => {
                      /*
                      items.beneficiario = data.detalle_pago_mensual[linea][programaIndex][ index ].beneficiario;
                      items.valor1 = data.detalle_pago_mensual[linea][programaIndex][ index ].valor1;
                      items.valor1Iva = data.detalle_pago_mensual[linea][programaIndex][ index ].valor1Iva;
                      items.valor1Bruto = data.detalle_pago_mensual[linea][programaIndex][ index ].valor1Bruto;
                      items.valor2 = data.detalle_pago_mensual[linea][programaIndex][ index ].valor2;
                      items.valor2Iva = data.detalle_pago_mensual[linea][programaIndex][ index ].valor2Iva;
                      items.valor2Bruto = data.detalle_pago_mensual[linea][programaIndex][ index ].valor2Bruto;
                      items.iva = data.detalle_pago_mensual[linea][programaIndex][ index ].iva;
                      items.subcuenta = data.detalle_pago_mensual[linea][programaIndex][ index ].subcuenta;
                      items.programa = data.detalle_pago_mensual[linea][programaIndex][ index ].programa;
                      items.tarifa = data.detalle_pago_mensual[linea][programaIndex][ index ].tarifa;
                      items.tarifaAsociado = data.detalle_pago_mensual[linea][programaIndex][ index ].tarifaAsociado;
                      */
                      items.beneficiario = data.detalle_pago_mensual[lineaRaw][programaIndex][index].beneficiario;          //Nuevo
                      items.valor1 = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor1;                      //Nuevo
                      items.valor1Iva = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor1Iva;                //Nuevo
                      items.valor1Bruto = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor1Bruto;            //Nuevo
                      items.valor2 = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor2;                      //Nuevo
                      items.valor2Iva = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor2Iva;                  //Nuevo
                      items.valor2Bruto = data.detalle_pago_mensual[lineaRaw][programaIndex][index].valor2Bruto;              //Nuevo
                      items.iva = data.detalle_pago_mensual[lineaRaw][programaIndex][index].iva;                            //Nuevo
                      items.subcuenta = data.detalle_pago_mensual[lineaRaw][programaIndex][index].subcuenta;                //Nuevo
                      items.programa = data.detalle_pago_mensual[lineaRaw][programaIndex][index].programa;                  //Nuevo
                      items.tarifa = data.detalle_pago_mensual[lineaRaw][programaIndex][index].tarifa;                      //Nuevo
                      items.tarifaAsociado = data.detalle_pago_mensual[lineaRaw][programaIndex][index].tarifaAsociado;      //Nuevo

                      if (items.estado == true) {
                        /*
                        for (let index = 0; index < lineaD.length; index++) {
                          if (
                            items.subcuenta.substring(
                              1,
                              items.subcuenta.length
                            ) === lineaD[index].valor
                          )
                            lineaTemporal = lineaD[index].valor;
                        }
                        */
                        const subCtaLimpia = (items.subcuenta || '').toString().trim();                                     //Nuevo
                        for (let i = 0; i < lineaD.length; i++) {                                                           //Nuevo
                          if (subCtaLimpia.substring(1) === lineaD[i].valor) {                                              //Nuevo
                            lineaTemporal = lineaD[i].valor;                                                                //Nuevo
                          }                                                                                                 //Nuevo
                        }                                                                                                   //Nuevo

                        this.valorFamiliar.push({
                          beneficiario: items.beneficiario,
                          programa: items.programa,
                          subcuenta: items.subcuenta,
                          tarifa: items.tarifa,
                          tarifaAsociado: items.tarifaAsociado,
                          tarifa_asociado: items.tarifa_asociado === "null" || !items.tarifa_asociado ? items.tarifaAsociado : items.tarifa_asociado,
                          linea_negocio: lineaTemporal === "SMP" ? 1 : lineaTemporal === "SAO" ? 2 : 3,                     //Nuevo 
                          valor1: items.valor1,
                          valor2: items.valor2,
                          valorBruto1: items.valor1Bruto,
                          valorBruto2: items.valor2Bruto,
                        });
                      }
                    });
                  } else {                                                                                                  //Nuevo
                    console.log(`        [Cotizador] No se detecto correspondencia local para la combinacion de datos de: ${tarifas[index]}`); //Nuevo
                  }                                                                                                         //Nuevo
                }
              );
            }
          }
        });
        console.log('[Cotizador] Mapeo multiproducto finalizado de forma correcta. Tamaño de listado familiar:', this.valorFamiliar.length); //Nuevo
        if (this.dataCampania.codigo_tipo_plan === "F") {
          this.valorFamiliaTotal = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valor1,
            0
          );
          this.valorAsociadoTotal = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valor2,
            0
          );
          this.valorFamiliaTotalBruto = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valorBruto1,
            0
          );
          this.valorAsociadoTotalBruto = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valorBruto2,                                                                  //Nuevo
            0
          );
        } else {
          this.valorAsociadoTotal = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valor1,
            0
          );
          this.valorAsociadoTotalBruto = this.valorFamiliar.reduce(
            (value, curren) => value + curren.valorBruto1,
            0
          );
        }
      } else {
        console.warn('[Cotizador] El objeto detalle_pago_mensual no contiene registros admisibles en sus propiedades primarias.'); //Nuevo
        Swal
          .fire({
            text: `No se encontraron valores para las tarifas seleccionadas`,
            confirmButtonColor: "#0372b9",
            confirmButtonText: "OK",
          })
          .then(() => {
            if (tipoCotizacionLocal != "m") {
              this.selectedIndex = 2;
            }
          });
      }
    }
  }

  /** Metodo para recibir la respuesta de error del cotizador */
  cotizadorFailureNetworkingOutput(errorCode: number, message: string) {
    this.spinner.hide();
    // this.openDialog(this.dialog, "HA OCURRIDO UN ERROR AL COTIZAR", "", 0, (r: boolean) => { });
    this.showMessageDialog(
      "ERROR", // Título del diálogo
      `HA OCURRIDO UN ERROR AL COTIZAR`, // Mensaje del diálogo
      "Aceptar", // Texto del primer botón
      "", // Texto del segundo botón (vacío si no se usa)
      true, // Uso de un botón (true) o dos botones (false)
      2, // Tipo de icono (puedes ajustar según tu lógica)
      this.dialog, // Objeto MatDialog
      (_: any) => { } // Callback
    );
  }

  /** Metodo para guardar la cotizacion */
  guardar() {
    let next = true;
    const dataTemporal: { linea_negocio: any; cuenta: any; beneficiario: any; programa: any; subcuenta: any; tarifa: any; tarifaAsociado: any; tarifa_asociado: any; valor1: any; valor2: any; }[] = [];
    this.listDetallePagoMensual.forEach(
      (element: {
        [x: string]: any;
        linea_negocio: any;
        cuenta: any;
        beneficiario: any;
        programa: any;
        subcuenta: any;
        tarifa: any;
        tarifaAsociado: any;
        tarifa_asociado: any;
        valor1: any;
        valor2: any;
      }) => {
        if (this.dataCampania.codigo_tipo_plan === "F") {
          if (!element.tarifa) {
            next = false;
            Swal.fire({
              title: "Error al guardar",
              text: "No es posible guardar la cotización porque uno de los beneficiarios, no tiene tarifa o valor en el plan Familia",
              confirmButtonColor: "#0372b9",
              confirmButtonText: "OK",
            });
            return;
          }
        }
        element["cuenta"] = this.dataCampania.cuenta;
        dataTemporal.push({
          linea_negocio: element.linea_negocio,
          cuenta: element.cuenta,
          beneficiario: element.beneficiario,
          programa: element.programa,
          subcuenta: element.subcuenta,
          tarifa: element.tarifa,
          tarifaAsociado: element.tarifaAsociado
            ? element.tarifaAsociado
            : "null",
          tarifa_asociado: element.tarifa_asociado
            ? element.tarifa_asociado
            : "null",
          valor1: element.valor1 ? element.valor1 : 0,
          valor2: element.valor2 ? element.valor2 : 0,
        });
      }
    );
    if (next) {
      const asesorCC: UserLoggedResponse = this.storageService.getItem('user') ?? 'documento null';
      const documentAsesor = asesorCC.document.replace(/\D/g, '');
      this.dataCotizacion = {
        id: parseInt(this.numeroCotizacion),
        tipo_plan: this.formInit.get("tipoPlan")?.value,
        asesor: documentAsesor,
        cuota_inscripcion: parseInt(this.cuotaInscripcion),
        cuota_mensual_total: parseInt(this.cuotaTotal),
        detalles: dataTemporal,
        detalle_descuentos: this.detalle_descuentos,
      };
      this.spinner.show();
      this.networking.guardarCotizacion(this.dataCotizacion).subscribe((response: any) => {
        this.cotizacionSuccessfulNetworkingOutput(response);
      }
        , error => { this.cotizacionFailureNetworkingOutput(1, error ? error : "No se puede hacer la cotización."); });
    }
  }
  /** Metodo para guardar y enviar la cotizacion */
  guardarEnviar() {
    let next = true;
    const dataTemporal: { linea_negocio: any; cuenta: any; beneficiario: any; programa: any; subcuenta: any; tarifa: any; tarifaAsociado: any; tarifa_asociado: any; valor1: any; valor2: any; }[] = [];
    this.listDetallePagoMensual.forEach(
      (element: {
        [x: string]: any;
        linea_negocio: any;
        cuenta: any;
        beneficiario: any;
        programa: any;
        subcuenta: any;
        tarifa: any;
        tarifaAsociado: any;
        tarifa_asociado: any;
        valor1: any;
        valor2: any;
      }) => {
        if (this.dataCampania.codigo_tipo_plan === "F") {
          if (!element.tarifa) {
            next = false;
            Swal.fire({
              title: "Error al guardar",
              text: "No es posible guardar la cotización porque uno de los beneficiarios, no tiene tarifa o valor en el plan Familia",
              confirmButtonColor: "#0372b9",
              confirmButtonText: "OK",
            });
            return;
          }
        }
        element["cuenta"] = this.dataCampania.cuenta;
        dataTemporal.push({
          linea_negocio: element.linea_negocio,
          cuenta: element.cuenta,
          beneficiario: element.beneficiario,
          programa: element.programa,
          subcuenta: element.subcuenta,
          tarifa: element.tarifa,
          tarifaAsociado: element.tarifaAsociado
            ? element.tarifaAsociado
            : "null",
          tarifa_asociado: element.tarifa_asociado
            ? element.tarifa_asociado
            : "null",
          valor1: element.valor1 ? element.valor1 : 0,
          valor2: element.valor2 ? element.valor2 : 0,
        });
      }
    );
    if (next) {
      const asesorCC: UserLoggedResponse = this.storageService.getItem('user') ?? 'documento null';
      const documentAsesor = asesorCC.document.replace(/\D/g, '');
      this.dataCotizacion = {
        id: parseInt(this.numeroCotizacion),
        tipo_plan: this.formInit.get("tipoPlan")?.value,
        asesor: documentAsesor,
        cuota_inscripcion: parseInt(this.cuotaInscripcion),
        cuota_mensual_total: parseInt(this.cuotaTotal),
        detalles: dataTemporal,
        detalle_descuentos: this.detalle_descuentos,
      };
      this.networking
        .guardarCotizacionSusbscribe(this.dataCotizacion)
        .subscribe((dataBodyResponse: BodyResponse) => {
          if (dataBodyResponse.status === "200") {
            this.networking.enviarCotizacion(this.dataCotizacion.id).subscribe((r: any) => {
              this.cotizadorSuccessfulNetworkingOutput;
              this.cotizacionSuccessfulNetworkingOutput(r);
            },
              error => {
                this.cotizacionFailureNetworkingOutput(1, (error) ? error : "No se puede hacer la cotización.");
              });
          }
        });
    }
  }


  /** Metodo para guardar la información exitosa */
  cotizacionSuccessfulNetworkingOutput(data: any) {
    this.spinner.hide();
    if (data.status == 200) {
      this.responseGuardar = true;
      this.showMessageDialog(
        "Cotización exitosa", // Título del diálogo
        `Cotización guardada con el consecutivo: ${this.numeroCotizacion}.`, // Mensaje del diálogo
        "Aceptar", // Texto del primer botón
        "", // Texto del segundo botón (vacío si no se usa)
        true, // Uso de un botón (true) o dos botones (false)
        1, // Tipo de icono (puedes ajustar según tu lógica)
        this.dialog, // Objeto MatDialog
        (_: any) => { location.reload(); } // Callback
      );
    } else {
      this.showMessageDialog(
        "Error", // Título del diálogo
        "Problemas", // Mensaje del diálogo
        "Aceptar", // Texto del primer botón
        "", // Texto del segundo botón (vacío si no se usa)
        true, // Uso de un botón (true) o dos botones (false)
        2, // Tipo de icono (puedes ajustar según tu lógica)
        this.dialog, // Objeto MatDialog
        (_: any) => { location.reload(); } // Callback
      );
    }
  }

  /** Metodo para guardar la información erronea */
  cotizacionFailureNetworkingOutput(errorCode: number, message: string) {
    // Swal.fire({
    //   title: "Problemas",
    //   text: (message) ? message : 'Error al guardar la cotizacion',
    //   confirmButtonColor: '#0372b9',
    //   confirmButtonText: 'OK',
    // });
    this.spinner.hide();
    const lblMensajeElement = document.getElementById("lblMensaje");
    if (lblMensajeElement) {
      lblMensajeElement.innerText =
        message && message != "undefined" && message != "null" && message != ""
          ? message
          : "Ha ocurrido un error al obtener las campañas";
    } else {
      console.error('El elemento con ID "lblMensaje" no se encontró en el DOM.');
    }

  }

  public onTextChange(value: string): void {
    this.searchText = value;
    this.filterByText();
  }

  private normalize(text: string): string {
    return (text ?? '')
      .toLowerCase()
      .normalize('NFD')                // separa letras y tildes
      .replace(/[\u0300-\u036f]/g, '') // elimina tildes
      .replace(/[^a-z0-9\s]/g, '')     // elimina caracteres especiales (paréntesis, comas, etc.)
      .replace(/\s+/g, ' ')            // colapsa espacios
      .trim();
  }

  filterByText() {
    const rawQuery = (this.searchText || '').trim().toLowerCase();

    if (!rawQuery) {
      this.datasSourceBeneficiary.data = [...this.beneficiaryRowsBackup];
      return;
    }

    const filtered = this.beneficiaryRowsBackup.filter(item => {
      // Incluir etiqueta visible (SO → SAO) para que el buscador coincida con lo que ve el usuario.
      const lineaVisible = this.formatLineOfBusinessLabel(item.lineOfBusiness || '');
      const searchable = `
        ${item.primer_nombre || ''}
        ${item.segundo_nombre || ''}
        ${item.primer_apellido || ''}
        ${item.segundo_apellido || ''}
        ${item.num_documento || ''}
        ${item.lineOfBusiness || ''}
        ${lineaVisible}
        ${item.program || ''}
        ${item.typeDescripcion || ''}
        ${item.subcuenta || ''}
        ${item.tarifa || ''}
      `.toLowerCase();

      return searchable.indexOf(rawQuery) !== -1;
    });

    this.datasSourceBeneficiary.data = filtered;
  }

  /** Método para limpiar búsqueda */
  public limpiar() {
    this.searchText = '';
    this.datasSourceBeneficiary.data = [...this.beneficiaryRowsBackup];

    if (this.datasSourceBeneficiary.paginator) {
      this.datasSourceBeneficiary.paginator.firstPage();
    }
  }

  /** Metodo para añadir un beneficiario */
  openDialogBeneficiary() {
    this.idCollapse = []
    const esPantallaReducida = window.innerWidth <= 1200;

    if (this.formInit.get('tipoSolicitud')?.value === '2') {
      const titular = this.datasBeneficiary.find((b: any) =>
        b?.es_contratante === true ||
        (b?.parentesco_id || '').toString().trim().toUpperCase() === 'T' ||
        (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR'
      );
      if (titular) {
        const progsRaw = (titular as any).programasConfig?.programas || (titular as any).programas || [];
        // Alta nueva Inclusión: heredar negocio del titular, NUNCA IDs BD (evita mutar cadena del titular).
        const programasMapeados = Array.isArray(progsRaw)
          ? progsRaw
              .map((p: any) => this.mapearProgramaContratanteSinIdsPersistencia(p))
              .filter((p: any) => !!p.programa)
          : [];
        localStorage.setItem('programas_contratante', JSON.stringify(programasMapeados));
      }
    }

    const dialogRef = this.dialog.open(DialogBeneficiaryComponent, {
      data: [null, this.dataCampania, this.datePerson, {
        idCotizacion: this.numeroCotizacion,
        isEditMode: this.isEditMode,
        esUsuarioContexto: false,
        programasContratanteSwitch: this.programasContratanteParaSwitchBeneficiario(),
      }],
      width: esPantallaReducida ? '98vw' : '1400px',
      maxWidth: esPantallaReducida ? '98vw' : '95vw',
      maxHeight: esPantallaReducida ? '96vh' : '95vh',
      disableClose: true,
      panelClass: 'modal-seleccion-programas'
    });
    dialogRef.afterClosed().subscribe((result: PersonBeneficiary | undefined) => {
      if (!result) return;
      if (this.isEditMode) {
        // En modo edición el dialog ya guardó en el API; refrescar la lista desde el backend
        // y volver a pintar al titular con los programas de la sesión (NC 1065).
        this.refreshBeneficiarios(true);
        return;
      }
      const objPersonas: any = BeneficiariosModel.fromPersons(result);

      objPersonas.programasConfig = (result as any).programasConfig;
      objPersonas.programIds = (result as any).programIds;
      objPersonas.usarProgramasContratante = (result as any).usarProgramasContratante === true;

      objPersonas.tipoVia = (result as any).tipoVia;
      objPersonas.numero = (result as any).numero;
      objPersonas.placaUno = (result as any).placaUno;
      objPersonas.placaDos = (result as any).placaDos;
      objPersonas.ciudad = (result as any).ciudad;
      objPersonas.id_beneficiario = Number((result as any).idBeneficiarioGuardado || 0) || undefined;
      if ((result as any).localId) {
        objPersonas.localId = (result as any).localId;
      }

      const idNuevo = Number(objPersonas.id_beneficiario || 0);
      if (idNuevo > 0) {
        this.rememberBeneficiarioId(objPersonas, idNuevo);
      }

      this.datasBeneficiary.push(objPersonas);
      this.updateTableBeneficiary();
    });
  }

  /** Metodo para editar un beneficiario */
  editarBeneficiario(obj: Beneficiarios) {
    const persona: any = BeneficiariosModel.toPersons(obj);

    if (this.formInit.get('tipoSolicitud')?.value === '2') {
      const titular = this.datasBeneficiary.find((b: any) =>
        b?.es_contratante === true ||
        (b?.parentesco_id || '').toString().trim().toUpperCase() === 'T' ||
        (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR'
      );
      if (titular) {
        const progsRaw = (titular as any).programasConfig?.programas || (titular as any).programas || [];
        // Semilla para switch: negocio del titular sin IDs BD (la fila editada usa su propios programasConfig).
        const programasMapeados = Array.isArray(progsRaw)
          ? progsRaw
              .map((p: any) => this.mapearProgramaContratanteSinIdsPersistencia(p))
              .filter((p: any) => !!p.programa)
          : [];
        localStorage.setItem('programas_contratante', JSON.stringify(programasMapeados));
      }
    }

    const norm = (v: any) => (v ?? '').toString().trim().toUpperCase();
    const datosContratante = this.obtenerDatosContratanteDesdeStorage();
    const rowDoc = norm((obj as any)?.num_documento || (obj as any)?.numeroDocumento || '');
    const rowTipo = norm((obj as any)?.tipo_documento || (obj as any)?.tipoDocumento || '');
    const ctrDoc = norm(datosContratante?.numeroDocumento || '');
    const ctrTipo = norm(datosContratante?.tipoDocumento || '');
    const esTitular = norm((obj as any)?.parentesco_id || '') === 'T' || norm((obj as any)?.typeDescripcion || '') === 'TITULAR';
    const coincideConContratante = !!rowDoc && !!ctrDoc && rowDoc === ctrDoc && (!rowTipo || !ctrTipo || rowTipo === ctrTipo);
    const esContratanteFila =
      (obj as any)?.es_contratante === true
      || (obj as any)?.es_contratante === 'S'
      || (esTitular && coincideConContratante);
    persona.es_contratante = esContratanteFila;
    persona.esUsuario = esContratanteFila;
    persona.programasConfig = (obj as any).programasConfig;
    persona.programIds = (obj as any).programIds;
    persona.usarProgramasContratante =
      (obj as any).usarProgramasContratante === true ||
      (obj as any)?.programasConfig?.usarProgramasContratante === true;

    const programaFila = this._norm2((obj as any)?.program || '');
    const programaFilaNormalizado = this._norm2(this.formatearNombrePrograma((obj as any)?.program || ''));
    const lineaFila = this._aliasONombreLinea2((obj as any)?.lineOfBusiness || '');
    const idBenProgramaFila = Number((obj as any)?.__idBenPrograma || (obj as any)?.idBenPrograma || 0);

    if (programaFila) {
      const cfg = persona.programasConfig;
      if (cfg && Array.isArray(cfg.programas) && cfg.programas.length > 0) {
        persona.programasConfig = {
          ...cfg,
          programas: cfg.programas,
          lineasSeleccionadas: Array.isArray(cfg.lineasSeleccionadas) ? cfg.lineasSeleccionadas : []
        };
        persona.programIds = cfg.programas
          .map((p: any) => (p?.id || '').toString().trim())
          .filter(Boolean);
        persona.program = cfg.programas
          .map((p: any) => (p?.nombre || p?.id || '').toString().trim())
          .filter(Boolean)
          .join(', ');
      } else if (Array.isArray(persona.programIds) && persona.programIds.length > 1) {
        persona.program = persona.programIds.join(', ');
      }
    }

    persona.tipoVia = (obj as any).tipoVia;
    persona.numero = (obj as any).numero;
    persona.placaUno = (obj as any).placaUno;
    persona.placaDos = (obj as any).placaDos;
    persona.ciudad = (obj as any).ciudad;
    if ((obj as any).localId) {
      persona.localId = (obj as any).localId;
    }

    const idFromMap = this.getBeneficiarioIdFromMap(obj);

    const idBeneficiarioRaw =
      (obj as any).id_beneficiario ??
      (obj as any).idBeneficiario ??
      (obj as any).id_beneficiario_guardado ??
      (idFromMap > 0 ? idFromMap : null) ??
      null;
    const idBeneficiario = Number(idBeneficiarioRaw);
    const idBeneficiarioValido = Number.isFinite(idBeneficiario) && idBeneficiario > 0
      ? idBeneficiario
      : null;
    const esPantallaReducida = window.innerWidth <= 1200;

    const dialogRef = this.dialog.open(DialogBeneficiaryComponent, {
      data: [persona, this.dataCampania, this.datePerson, {
        idCotizacion: this.isEditMode
          ? (this.idCotizacionEdicion ?? this.numeroCotizacion)
          : this.numeroCotizacion,
        isEditMode: this.isEditMode,
        idBeneficiario: idBeneficiarioValido,
        esUsuarioContexto: esContratanteFila,
        localId: (obj as any).localId || persona.localId || undefined,
        programasContratanteSwitch: this.programasContratanteParaSwitchBeneficiario(),
      }],
      width: esPantallaReducida ? '98vw' : '1400px',
      maxWidth: esPantallaReducida ? '98vw' : '95vw',
      maxHeight: esPantallaReducida ? '96vh' : '95vh',
      disableClose: true,
      panelClass: 'modal-seleccion-programas'
    });

    dialogRef.afterClosed().subscribe((result: PersonBeneficiary | undefined) => {
      if (!result) return;
      const fueEdicionContratanteLocal = (result as any)?.__edicionContratanteLocal === true;

      // 🎯 SI FUE EDICIÓN DEL TITULAR/CONTRATANTE: Refrescar fila directamente desde LocalStorage
      if (fueEdicionContratanteLocal) {
        this.refrescarFilaContratanteDesdeStorage();
        return;
      }

      if (this.isEditMode) {
        const idGuardado = (result as any).idBeneficiarioGuardado;
        if (idGuardado && idGuardado > 0) {
          this.rememberBeneficiarioId(result, idGuardado);
        }

        const updatedLocal: any = BeneficiariosModel.fromPersons(result);
        updatedLocal.es_contratante = esContratanteFila;
        updatedLocal.id_beneficiario = Number(
          idGuardado || idBeneficiarioValido || (obj as any)?.id_beneficiario || (obj as any)?.idBeneficiario || 0
        ) || undefined;
        updatedLocal.programasConfig = (result as any).programasConfig;
        updatedLocal.programIds = (result as any).programIds;
        updatedLocal.usarProgramasContratante = (result as any).usarProgramasContratante === true;

        const idxById = this.datasBeneficiary.findIndex((b: any) =>
          Number(b?.id_beneficiario || 0) > 0 && Number(b?.id_beneficiario) === Number(updatedLocal.id_beneficiario || 0)
        );
        const idxByDoc = this.datasBeneficiary.findIndex((b: any) =>
          this._norm2(b?.num_documento) === this._norm2(updatedLocal?.num_documento) &&
          this._norm2(b?.parentesco_id) === this._norm2(updatedLocal?.parentesco_id)
        );
        const targetIdx = idxById >= 0 ? idxById : idxByDoc;

        if (targetIdx >= 0) {
          const existente: any = this.datasBeneficiary[targetIdx];
          updatedLocal.position = existente?.position ?? updatedLocal.position;

          if ((result as any)?.programasConfig?.programas) {
            updatedLocal.programasConfig = (result as any).programasConfig;
          }

          this.datasBeneficiary[targetIdx] = updatedLocal;
          this.datasBeneficiary = [...this.datasBeneficiary];
          this.updateTableBeneficiary();
        }

        this.refreshBeneficiarios(true);
        return;
      }

      const updated: any = BeneficiariosModel.fromPersons(result);
      const idGuardado = Number((result as any).idBeneficiarioGuardado || 0);
      const idPrevio = Number(idBeneficiarioValido || (obj as any)?.id_beneficiario || (obj as any)?.idBeneficiario || 0);
      const idFinal = idGuardado > 0 ? idGuardado : (idPrevio > 0 ? idPrevio : 0);

      updated.programasConfig = (result as any).programasConfig;
      updated.programIds = (result as any).programIds;
      updated.usarProgramasContratante = (result as any).usarProgramasContratante === true;

      updated.tipoVia = (result as any).tipoVia;
      updated.numero = (result as any).numero;
      updated.placaUno = (result as any).placaUno;
      updated.placaDos = (result as any).placaDos;
      updated.ciudad = (result as any).ciudad;
      updated.id_beneficiario = idFinal > 0 ? idFinal : undefined;
      if ((result as any).localId) {
        updated.localId = (result as any).localId;
      }

      if (idFinal > 0) {
        this.rememberBeneficiarioId(updated, idFinal);
      }

      this.datasBeneficiary = this.datasBeneficiary.map(b =>
        b.position === updated.position
          ? (() => {
            const existente: any = b as any;
            const mergedCfg = this.mergeProgramasConfigPreservandoOtros(
              existente?.programasConfig,
              (updated as any)?.programasConfig,
              obj
            );
            const mergedIds = this.extraerProgramIdsDesdeConfig(mergedCfg);

            return {
              ...(existente || {}),
              ...(updated as any),
              id_beneficiario: (updated as any).id_beneficiario ?? existente?.id_beneficiario,
              localId: (updated as any).localId ?? existente?.localId,
              programasConfig: mergedCfg,
              programIds: mergedIds.length ? mergedIds : (Array.isArray(existente?.programIds) ? existente.programIds : (updated as any)?.programIds)
            };
          })()
          : b
      );
      this.updateTableBeneficiary();
    });
  }

  private extraerProgramIdsDesdeConfig(cfg: any): string[] {
    const programas = Array.isArray(cfg?.programas) ? cfg.programas : [];
    const ids = programas
      .map((p: any) => (p?.id || '').toString().trim())
      .filter((v: string) => !!v);
    return Array.from(new Set(ids));
  }

  private mergeProgramasConfigPreservandoOtros(cfgExistente: any, cfgIncoming: any, rowCtx?: any): any {
    const existentes = Array.isArray(cfgExistente?.programas) ? cfgExistente.programas : [];
    const incoming = Array.isArray(cfgIncoming?.programas) ? cfgIncoming.programas : [];

    if (!incoming.length) {
      return cfgExistente || cfgIncoming;
    }

    // El diálogo de beneficiario devuelve el estado completo actual del beneficiario.
    // En ese flujo, los programas removidos ya no deben preservarse localmente.
    const incomingLineas = Array.isArray(cfgIncoming?.lineasSeleccionadas)
      ? cfgIncoming.lineasSeleccionadas.filter(Boolean)
      : [];
    if (incomingLineas.length || incoming.length) {
      return {
        ...(cfgExistente || {}),
        ...(cfgIncoming || {}),
        lineasSeleccionadas: incomingLineas,
        programas: incoming
      };
    }

    const norm = (v: any) => (v ?? '').toString().trim().toUpperCase();
    const rowProgram = norm((rowCtx as any)?.program || '');
    const rowLinea = norm((rowCtx as any)?.lineOfBusiness || '');

    const incomingMatches = (base: any, inc: any): boolean => {
      const baseIdBen = Number(base?.idBenPrograma ?? base?.__idBenPrograma ?? 0);
      const incIdBen = Number(inc?.idBenPrograma ?? inc?.__idBenPrograma ?? 0);
      if (baseIdBen > 0 && incIdBen > 0 && baseIdBen === incIdBen) return true;

      const baseId = norm(base?.id);
      const incId = norm(inc?.id);
      if (baseId && incId && baseId === incId) return true;

      const baseNombre = norm(base?.nombre);
      const incNombre = norm(inc?.nombre);
      if (baseNombre && incNombre && baseNombre === incNombre) return true;

      return false;
    };

    const shouldReplaceByRow = (base: any): boolean => {
      if (!rowProgram) return false;
      const baseId = norm(base?.id);
      const baseNombre = norm(this.formatearNombrePrograma(base?.nombre || base?.id || ''));
      const byProgram = baseId === rowProgram || baseNombre === rowProgram;
      if (!byProgram) return false;

      if (!rowLinea) return true;
      const baseLinea = norm(this._aliasONombreLinea2(base?.lineaNegocio || base?.lineOfBusiness || base?.linea || ''));
      return !baseLinea || baseLinea === rowLinea;
    };

    const kept = existentes.filter((base: any) => {
      const replacedByIncoming = incoming.some((inc: any) => incomingMatches(base, inc));
      if (replacedByIncoming) return false;
      if (shouldReplaceByRow(base)) return false;
      return true;
    });

    const mergedProgramas = [...kept, ...incoming];
    const mergedLineas = Array.from(new Set([
      ...(Array.isArray(cfgExistente?.lineasSeleccionadas) ? cfgExistente.lineasSeleccionadas : []),
      ...(Array.isArray(cfgIncoming?.lineasSeleccionadas) ? cfgIncoming.lineasSeleccionadas : [])
    ].filter(Boolean)));

    return {
      ...(cfgExistente || {}),
      ...(cfgIncoming || {}),
      lineasSeleccionadas: mergedLineas,
      programas: mergedProgramas
    };
  }

  removeListBeneficity(row: any) {
    this.openDialogConfirm(
      this.dialog,
      "",
      `¿Desea eliminar el programa "${row?.program}" de la línea "${row?.lineOfBusiness}" para ${row?.primer_nombre} ${row?.primer_apellido}?`,
      0,
      (ok: boolean) => {
        if (!ok) return;

        // Inclusión y venta nueva/edición: misma cascada (BD + tabla + localStorage).
        // El branch solo-backend del merge de inclusiones borraba en Core pero no
        // llamaba aplicarEliminacionLocalBeneficiario / updateTableBeneficiary.
        void this.eliminarBeneficiarioEnCascadaDesdeFila(row);
      },
      {
        width: '640px',
        maxWidth: '100vw',
        panelClass: 'confirm-dialog-lg',
      }
    );
  }

  private async eliminarBeneficiarioEnCascadaDesdeFila(row: any): Promise<void> {
    const baseIndex = this.buscarIndiceBeneficiarioBase(row);
    if (baseIndex < 0) {
      this.SnackBarService.alert('alert-danger', 'No se encontró el beneficiario asociado a la fila seleccionada.');
      return;
    }

    const base = this.datasBeneficiary[baseIndex] as any;
    let plan = this.construirPlanEliminacionBeneficiario(base, row);
    plan = this.enriquecerPlanEliminacionDesdePersistenciaLocal(base, row, plan);

    // Venta nueva sin IDs en BD: solo localStorage + grilla.
    if (this.esBeneficiarioEliminacionSoloLocal(base, plan)) {
      this.aplicarEliminacionLocalBeneficiario(baseIndex, row, plan.deleteDatosBeneficiarios);
      this.actualizarSnapshotDependientesTrasEliminacionLocal(base, plan);
      this.updateTableBeneficiary();
      this.marcarCotizacionIndividualModificada();
      this.SnackBarService.alert(
        'alert-success',
        plan.deleteDatosBeneficiarios
          ? 'Se eliminó el beneficiario.'
          : 'Se eliminó la combinación línea–programa.'
      );
      return;
    }

    if (!this.planEliminacionTienePersistenciaEnBd(plan)) {
      this.aplicarEliminacionLocalBeneficiario(baseIndex, row, plan.deleteDatosBeneficiarios);
      this.actualizarSnapshotDependientesTrasEliminacionLocal(base, plan);
      this.updateTableBeneficiary();
      this.marcarCotizacionIndividualModificada();
      this.SnackBarService.alert(
        'alert-success',
        plan.deleteDatosBeneficiarios
          ? 'Se eliminó el beneficiario.'
          : 'Se eliminó la combinación línea–programa.'
      );
      return;
    }

    this.spinner.show();
    try {
      const planesDelete = plan.deleteDatosBeneficiarios
        ? this.construirPlanesDeleteCompletosBeneficiarioDependiente(base, plan)
        : [plan];

      await this.ejecutarCascadaDeletePlanesBeneficiario(
        planesDelete,
        plan.deleteDatosBeneficiarios,
        'beneficiario'
      );
      this.quitarProgramaBorradoDeEdicionEnMemoria(plan);

      this.aplicarEliminacionLocalBeneficiario(baseIndex, row, plan.deleteDatosBeneficiarios);
      this.actualizarSnapshotDependientesTrasEliminacionLocal(base, plan);
      this.updateTableBeneficiary();
      this.marcarCotizacionIndividualModificada();
      this.SnackBarService.alert(
        'alert-success',
        plan.deleteDatosBeneficiarios
          ? 'Se eliminó el beneficiario y su cascada asociada.'
          : 'Se eliminó la rama seleccionada del beneficiario.'
      );
    } catch (err: any) {
      console.error('[ERROR ELIMINANDO BENEFICIARIO]', err);
      // Si BD ya no tiene el ID (404 stale), igual limpiar tabla + localStorage.
      if (this.esErrorDeleteRecursoNoEncontrado(err) || this.esRespuestaDeleteRecursoNoEncontrado(err?.error || err)) {
        this.quitarProgramaBorradoDeEdicionEnMemoria(plan);
        this.aplicarEliminacionLocalBeneficiario(baseIndex, row, plan.deleteDatosBeneficiarios);
        this.actualizarSnapshotDependientesTrasEliminacionLocal(base, plan);
        this.updateTableBeneficiary();
        this.SnackBarService.alert(
          'alert-success',
          plan.deleteDatosBeneficiarios
            ? 'Se eliminó el beneficiario.'
            : 'Se eliminó la combinación línea–programa.'
        );
        this.marcarCotizacionIndividualModificada();
        return;
      }
      this.SnackBarService.alert('alert-danger', err?.message || 'No fue posible eliminar el beneficiario.');
    } finally {
      this.spinner.hide();
    }
  }

  /**
   * Cascada HTTP: campaña → tarifa → subcuenta → programa → (opcional) datos del beneficiario.
   * Nunca borra el padre si no se intentó primero borrar los hijos conocidos.
   */
  private async ejecutarCascadaDeletePlanesBeneficiario(
    planes: BeneficiaryDeletePlan[],
    borrarDatosBeneficiario: boolean,
    etiquetaPrefijo: string
  ): Promise<void> {
    const campaniasAEliminar = this.extraerIdsUnicosOrdenados(
      (planes || []).map((p) => p.idCotizacionCampania)
    );
    const tarifasAEliminar = this.extraerIdsUnicosOrdenados(
      (planes || []).flatMap((p) => [p.idCotizacionTarifa, p.idCotizacionTarifaAnexo])
    );
    const subcuentasAEliminar = this.extraerIdsUnicosOrdenados((planes || []).map((p) => p.idSubcuenta));
    const programasAEliminar = this.extraerIdsUnicosOrdenados(
      (planes || []).map((p) => p.idBenPrograma)
    );
    const beneficiariosAEliminar = borrarDatosBeneficiario
      ? this.extraerIdsUnicosOrdenados((planes || []).map((p) => p.idBeneficiario))
      : [];

    for (const idCotizacionCampania of campaniasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `${etiquetaPrefijo}-campania:${idCotizacionCampania}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarCampania(idCotizacionCampania))
      );
    }
    for (const idCotizacionTarifa of tarifasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `${etiquetaPrefijo}-tarifa:${idCotizacionTarifa}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarTarifa(idCotizacionTarifa))
      );
    }
    for (const idSubcuenta of subcuentasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `${etiquetaPrefijo}-subcuenta:${idSubcuenta}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarSubcuenta(idSubcuenta))
      );
    }
    for (const idBenPrograma of programasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `${etiquetaPrefijo}-programa:${idBenPrograma}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarBeneficiarioPrograma(idBenPrograma))
      );
    }
    for (const idBeneficiario of beneficiariosAEliminar) {
      await this.ejecutarDeleteSeguro(
        `${etiquetaPrefijo}-datos:${idBeneficiario}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarDatosBeneficiarios(idBeneficiario))
      );
    }
  }

  private async ejecutarDeleteSeguro(etiqueta: string, operacion: () => Promise<any>): Promise<void> {
    try {
      const resp = await operacion();
      // Algunos DELETE responden HTTP 200 con status:false + "no existe..."
      if (this.esRespuestaDeleteRecursoNoEncontrado(resp)) {
        return;
      }
    } catch (err: any) {
      if (this.esErrorEndpointDeleteNoDisponible(err)) {
        console.warn(`[DELETE OMITIDO] ${etiqueta}: endpoint no disponible en backend.`, err);
        return;
      }
      if (this.esErrorDeleteRecursoNoEncontrado(err)) {
        console.warn(`[DELETE OMITIDO] ${etiqueta}: recurso ya no existe en backend.`, err);
        return;
      }
      throw err;
    }
  }

  private esErrorEndpointDeleteNoDisponible(err: any): boolean {
    const status = Number(err?.status || err?.error?.statusCode || err?.error?.codeStatus || 0);
    const texto = this.textoErrorDelete(err).toUpperCase();

    const sinEndpoint = texto.includes('NO ENDPOINT DELETE')
      || texto.includes('NO ENDPOINT')
      || texto.includes('NO HANDLER FOUND');

    return (status === 404 || status === 500) && sinEndpoint;
  }

  private esErrorDeleteRecursoNoEncontrado(err: any): boolean {
    const httpStatus = Number(err?.status || 0);
    const codeStatus = Number(err?.error?.codeStatus || err?.error?.statusCode || 0);
    const texto = this.textoErrorDelete(err).toUpperCase();

    const noEncontrado = this.esTextoRecursoDeleteNoEncontrado(texto);
    // Backend a veces manda HTTP 500/200 con codeStatus "404" y "No existe idCotizacionCampania=..."
    return noEncontrado && (httpStatus === 404 || codeStatus === 404 || httpStatus === 500);
  }

  /** Body exitoso (HTTP 200) con status:false indicando que el recurso ya no está. */
  private esRespuestaDeleteRecursoNoEncontrado(resp: any): boolean {
    if (!resp || resp.status !== false) return false;
    const texto = this.textoErrorDelete(resp).toUpperCase();
    return this.esTextoRecursoDeleteNoEncontrado(texto);
  }

  private esTextoRecursoDeleteNoEncontrado(textoUpper: string): boolean {
    return textoUpper.includes('NO EXISTE IDBENEFICIARIO')
      || textoUpper.includes('NO EXISTE IDCOTIZACIONCAMPANIA')
      || textoUpper.includes('NO EXISTE IDCOTIZACIONTARIFA')
      || textoUpper.includes('NO EXISTE IDSUBCUENTA')
      || textoUpper.includes('NO EXISTE IDBENPROGRAMA')
      || textoUpper.includes('NO EXISTE ID')
      || textoUpper.includes('BENEFICIARIO NO ENCONTRADO')
      || textoUpper.includes('REGISTRO NO ENCONTRADO')
      || textoUpper.includes('NO ENCONTRADO')
      || textoUpper.includes('NOT FOUND');
  }

  private textoErrorDelete(errOrResp: any): string {
    const payload = errOrResp?.error && typeof errOrResp.error === 'object'
      ? errOrResp.error
      : errOrResp;
    return [
      payload?.errorMessage,
      payload?.message,
      payload?.mensaje,
      payload?.detalle,
      errOrResp?.message,
      errOrResp?.statusText,
    ].filter(Boolean).join(' ');
  }

  private buscarIndiceBeneficiarioBase(row: any): number {
    const localIdRow = (row?.localId || '').toString().trim();
    if (localIdRow) {
      const byLocalId = this.datasBeneficiary.findIndex((b: any) =>
        (b?.localId || '').toString().trim() === localIdRow
      );
      if (byLocalId >= 0) return byLocalId;
    }

    const idBeneficiarioRow = Number(
      row?.id_beneficiario ??
      row?.idBeneficiario ??
      row?.id_beneficiario_guardado ??
      0
    );

    if (idBeneficiarioRow > 0) {
      const byId = this.datasBeneficiary.findIndex((b: any) => Number(b?.id_beneficiario ?? b?.idBeneficiario ?? b?.id_beneficiario_guardado ?? 0) === idBeneficiarioRow);
      if (byId >= 0) return byId;
    }

    return this.datasBeneficiary.findIndex((b: any) =>
      this._norm2(b?.num_documento) === this._norm2(row?.num_documento)
      && this._norm2(b?.primer_nombre) === this._norm2(row?.primer_nombre)
      && this._norm2(b?.primer_apellido) === this._norm2(row?.primer_apellido)
      && this._norm2(b?.segundo_apellido) === this._norm2(row?.segundo_apellido)
    );
  }

  private planEliminacionTienePersistenciaEnBd(plan: BeneficiaryDeletePlan): boolean {
    return plan.idBeneficiario > 0
      || plan.idBenPrograma > 0
      || plan.idSubcuenta > 0
      || plan.idCotizacionTarifa > 0
      || plan.idCotizacionTarifaAnexo > 0
      || plan.idCotizacionCampania > 0;
  }

  private construirPlanEliminacionBeneficiario(base: any, row: any): BeneficiaryDeletePlan {
    const idBeneficiario = Number(
      base?.id_beneficiario ??
      base?.idBeneficiario ??
      base?.id_beneficiario_guardado ??
      row?.id_beneficiario ??
      row?.idBeneficiario ??
      row?.id_beneficiario_guardado ??
      0
    );
    const idBenPrograma = Number(row?.__idBenPrograma ?? row?.idBenPrograma ?? 0);
    const idSubcuenta = Number(row?.__idSubcuenta ?? row?.idSubcuenta ?? 0);
    const idCotizacionTarifa = Number(row?.__idCotizacionTarifa ?? row?.idCotizacionTarifa ?? 0);
    const idCotizacionTarifaAnexo = Number(row?.__idCotizacionTarifaAnexo ?? row?.idCotizacionTarifaAnexo ?? 0);
    const idCotizacionCampania = Number(
      row?.__idCotizacionCampania ?? row?.idCotizacionCampania ?? row?.idBenCampania ?? 0
    );
    const baseSinRama = this.removerRamaBeneficiarioClon(base, row);
    const esContratanteFila = base?.es_contratante === true
      || base?.es_contratante === 'S'
      || base?.esContratante === true
      || base?.esContratante === 'S';
    // En edición el titular ya tiene liquidación. Se quita el programa, no la persona.
    const conservarTitular = esContratanteFila && this.debePreservarDatosBeneficiarioPorFkLiquidacion();

    return {
      idBeneficiario,
      idBenPrograma,
      idSubcuenta,
      idCotizacionTarifa,
      idCotizacionTarifaAnexo,
      idCotizacionCampania,
      deleteDatosBeneficiarios: !baseSinRama && !conservarTitular,
    };
  }

  private removerRamaBeneficiarioClon(base: any, row: any): any | null {
    const clone = this._cloneBenef(base);
    const programasCfg = clone?.programasConfig;

    if (programasCfg && Array.isArray(programasCfg.programas) && programasCfg.programas.length > 0) {
      const programasRestantes = programasCfg.programas.filter((p: any) => !this.ramaCoincideConPrograma(row, p));
      if (!programasRestantes.length) {
        return null;
      }

      const lineasRestantes = Array.from(new Set(programasRestantes
        .map((p: any) => this._aliasONombreLinea2((p?.lineaNegocio || p?.lineaNegocioNombre || '').toString().trim()))
        .filter(Boolean)
      ));

      clone.programasConfig = {
        ...(programasCfg || {}),
        programas: programasRestantes,
        lineasSeleccionadas: lineasRestantes
      };
      clone.programIds = this.extraerProgramIdsDesdeConfig(clone.programasConfig);
      clone.program = programasRestantes
        .map((p: any) => (p?.nombre || p?.id || '').toString().trim())
        .filter(Boolean)
        .join(', ');
      clone.lineOfBusiness = lineasRestantes.join(', ');
      return clone;
    }

    if (Array.isArray(clone?.programIds) && clone.programIds.length > 0) {
      const programKey = this._norm2((row as any)?.__programaCodigo || row?.program || '');
      const restantes = clone.programIds.filter((pid: string) => this._norm2(pid) !== programKey);
      if (!restantes.length) {
        return null;
      }
      clone.programIds = restantes;
      clone.program = restantes.join(', ');
      return clone;
    }

    if (typeof clone?.program === 'string') {
      const programKey = this._norm2((row as any)?.__programaCodigo || row?.program || '');
      const restantes = (clone.program || '')
        .split(',')
        .map((s: string) => s.trim())
        .filter(Boolean)
        .filter((name: string) => this._norm2(name) !== programKey && this._norm2(name) !== this._norm2(row?.program || ''));

      if (!restantes.length) {
        return null;
      }

      clone.program = restantes.join(', ');
      return clone;
    }

    return null;
  }

  private ramaCoincideConPrograma(row: any, programa: any): boolean {
    const idBenProgramaRow = Number(row?.__idBenPrograma ?? row?.idBenPrograma ?? 0);
    const idBenProgramaPrograma = Number(programa?.idBenPrograma ?? programa?.__idBenPrograma ?? 0);
    if (idBenProgramaRow > 0 && idBenProgramaPrograma > 0) {
      return idBenProgramaRow === idBenProgramaPrograma;
    }

    const codigoRow = this._norm2(row?.__programaCodigo || row?.program || '');
    const codigoPrograma = this._norm2(programa?.id || programa?.programa || programa?.nombre || '');
    const nombrePrograma = this._norm2(programa?.nombre || '');
    const lineaRow = this._norm2(row?.lineOfBusiness || '');
    const lineaPrograma = this._norm2(this._aliasONombreLinea2((programa?.lineaNegocio || programa?.lineaNegocioNombre || '').toString().trim()));

    const coincidePrograma = !!codigoRow && (codigoRow === codigoPrograma || codigoRow === nombrePrograma);
    const coincideLinea = !lineaRow || !lineaPrograma || lineaRow === lineaPrograma;
    return coincidePrograma && coincideLinea;
  }

  private aplicarEliminacionLocalBeneficiario(baseIndex: number, row: any, deleteDatosBeneficiarios: boolean): void {
    const base = this.datasBeneficiary[baseIndex] as any;
    const esContratanteFila = base?.es_contratante === true || (base?.es_contratante as any) === 'S';

    if (deleteDatosBeneficiarios) {
      if (esContratanteFila) {
        // Último programa del contratante: también hay que limpiar programas_contratante
        // y empujar el cambio a beneficiarios con usarProgramasContratante=true.
        this.removerProgramaDeProgramasContratanteStorage(row);
      } else {
        this.sincronizarEliminacionBeneficiarioLocalStorage(base, row, true);
      }
      this.datasBeneficiary.splice(baseIndex, 1);
      return;
    }

    const updated = this.removerRamaBeneficiarioClon(base, row);
    if (!updated) {
      if (esContratanteFila) {
        this.removerProgramaDeProgramasContratanteStorage(row);
      } else {
        this.sincronizarEliminacionBeneficiarioLocalStorage(base, row, true);
      }
      this.datasBeneficiary.splice(baseIndex, 1);
      return;
    }

    if (esContratanteFila) {
      this.removerProgramaDeProgramasContratanteStorage(row);
    } else {
      this.sincronizarEliminacionBeneficiarioLocalStorage(base, row, false);
    }

    this.datasBeneficiary[baseIndex] = updated;
  }

  /**
   * Venta nueva: elimina programa (o todo el beneficiario si era el último)
   * en datosRQ003_Beneficiario + programas_beneficiario. Sin HTTP.
   */
  private sincronizarEliminacionBeneficiarioLocalStorage(
    base: any,
    row: any,
    eliminarBeneficiarioCompleto: boolean
  ): void {
    try {
      const match = {
        localId: (base?.localId || row?.localId || '').toString().trim() || undefined,
        tipoDocumento: (base?.tipo_documento || row?.tipo_documento || '').toString().trim() || undefined,
        numeroDocumento: (base?.num_documento || row?.num_documento || '').toString().trim() || undefined,
        parentesco: (base?.parentesco_id || row?.parentesco_id || '').toString().trim() || undefined
      };

      if (eliminarBeneficiarioCompleto) {
        this.beneficiarioLocalStorage.eliminarBeneficiario(match);
        return;
      }

      this.beneficiarioLocalStorage.eliminarPrograma(match, {
        programaCodigo: ((row as any)?.__programaCodigo || row?.program || '').toString().trim() || undefined,
        programaNombre: (row?.program || '').toString().trim() || undefined,
        lineaNegocio: (row?.lineOfBusiness || '').toString().trim() || undefined
      });
    } catch {
      // no-op
    }
  }

  /** Beneficiario de venta nueva sin IDs en BD: solo localStorage. Si ya está en BD → cascada HTTP. */
  private esBeneficiarioEliminacionSoloLocal(base: any, plan: BeneficiaryDeletePlan): boolean {
    if (this.isEditMode) return false;
    if (this.esInclusion) return false;
    const esContratante = base?.es_contratante === true || (base?.es_contratante as any) === 'S';
    if (esContratante) return false;
    // Ya persistido por flecha Continuar (o con ids en fila/LS): debe ir a BD.
    if (this.planEliminacionTienePersistenciaEnBd(plan)) return false;
    if ((base?.localId || '').toString().trim()) return true;
    return !(plan.idBeneficiario > 0);
  }

  /**
   * Completa el plan de borrado con IDs guardados en datosRQ003 / programas_beneficiario
   * o en el snapshot de flecha de dependientes (tras Continuar).
   */
  private enriquecerPlanEliminacionDesdePersistenciaLocal(
    base: any,
    row: any,
    plan: BeneficiaryDeletePlan
  ): BeneficiaryDeletePlan {
    const enriched: BeneficiaryDeletePlan = { ...plan };
    const localId = (base?.localId || row?.localId || '').toString().trim();
    const tipo = (base?.tipo_documento || row?.tipo_documento || '').toString().trim();
    const numero = (base?.num_documento || row?.num_documento || '').toString().trim();
    const parentesco = (base?.parentesco_id || row?.parentesco_id || '').toString().trim();
    const programaCodigo = this._norm2((row as any)?.__programaCodigo || row?.program || '');

    try {
      const listaDatos = this.beneficiarioLocalStorage.cargarDatos();
      const datos = listaDatos.find((d) =>
        (localId && (d.localId || '').toString().trim() === localId)
        || (
          this._norm2(d.contratanteTipoDocumento) === this._norm2(tipo)
          && this._norm2(d.contratanteDocumento) === this._norm2(numero)
          && this._norm2(d.parentesco) === this._norm2(parentesco)
        )
      );
      const idDesdeDatos = Number((datos as any)?.idBeneficiario || 0);
      if (!(enriched.idBeneficiario > 0) && idDesdeDatos > 0) {
        enriched.idBeneficiario = idDesdeDatos;
      }

      const listaProgramas = this.beneficiarioLocalStorage.cargarProgramas();
      const envelope = this.resolverEnvelopeProgramasBeneficiarioLocal(
        listaProgramas,
        { localId, tipo, numero, parentesco }
      );
      const idDesdeEnvelope = Number(envelope?.idBeneficiario || 0);
      if (!(enriched.idBeneficiario > 0) && idDesdeEnvelope > 0) {
        enriched.idBeneficiario = idDesdeEnvelope;
      }

      const programas = Array.isArray(envelope?.programas) ? envelope!.programas : [];
      const hit = programas.find((p: any) => {
        const code = this._norm2(p?.programa || p?.id || p?.nombrePrograma || '');
        const name = this._norm2(p?.nombrePrograma || p?.nombre || '');
        return !!programaCodigo && (code === programaCodigo || name === programaCodigo);
      }) as any;

      if (hit) {
        this.completarIdsPlanEliminacionDesdePrograma(enriched, hit);
      }
    } catch {
      // no-op
    }

    try {
      const cfgProgramas = Array.isArray(base?.programasConfig?.programas) ? base.programasConfig.programas : [];
      const hitCfg = cfgProgramas.find((p: any) => {
        const code = this._norm2(p?.programa || p?.id || p?.nombre || '');
        const name = this._norm2(p?.nombrePrograma || p?.nombre || '');
        return !!programaCodigo && (code === programaCodigo || name === programaCodigo);
      });
      if (hitCfg) {
        this.completarIdsPlanEliminacionDesdePrograma(enriched, hitCfg);
      }
    } catch {
      // no-op
    }

    if (!(enriched.idBenPrograma > 0)) {
      const fuentes: any[] = [];
      if (Array.isArray(base?._edicionItem?.programas)) {
        fuentes.push(...base._edicionItem.programas);
      }
      const dataEdicion = this.cotizacionEdicionData || this._cotizacionEdicionDataLatest;
      const beneficiariosEdicion = Array.isArray((dataEdicion as any)?.beneficiarios)
        ? (dataEdicion as any).beneficiarios
        : [];
      const itemEdicion = beneficiariosEdicion.find((b: any) =>
        Number(b?.idBeneficiario || 0) === Number(enriched.idBeneficiario || 0)
      );
      if (Array.isArray(itemEdicion?.programas)) {
        fuentes.push(...itemEdicion.programas);
      }
      const hitEdicion = fuentes.find((p: any) => {
        const code = this._norm2(p?.programa || p?.planCodi || p?.codigo || p?.id || '');
        const name = this._norm2(p?.nombrePrograma || p?.nombre || p?.deno || '');
        return !!programaCodigo && (code === programaCodigo || name === programaCodigo);
      });
      if (hitEdicion) {
        this.completarIdsPlanEliminacionDesdePrograma(enriched, hitEdicion);
      }
    }

    try {
      const idCot = this.obtenerIdCotizacionActivaParaFlecha();
      const snap = this.obtenerSnapshotPersistenciaDependientes(idCot);
      const ben = (snap?.beneficiarios || []).find((b: any) =>
        Number(b?.idBeneficiario || 0) === Number(enriched.idBeneficiario || 0)
        || (localId && (b?.localId || '').toString().trim() === localId)
        || (
          this._norm2(b?.tipoDocumento) === this._norm2(tipo)
          && this._norm2(b?.numeroDocumento) === this._norm2(numero)
          && this._norm2(b?.parentesco) === this._norm2(parentesco)
        )
      );
      if (ben) {
        const idBen = Number(ben.idBeneficiario || 0);
        if (!(enriched.idBeneficiario > 0) && idBen > 0) {
          enriched.idBeneficiario = idBen;
        }
        const progs = Array.isArray(ben.programas) ? ben.programas : [];
        const hitSnap = progs.find((p: any) => this._norm2(p?.programa) === programaCodigo)
          || (progs.length === 1 ? progs[0] : null);
        if (hitSnap) {
          this.completarIdsPlanEliminacionDesdePrograma(enriched, hitSnap);
        }
      }
    } catch {
      // no-op
    }

    try {
      const subcuentasEdicion = Array.isArray(base?._edicionItem?.subcuentas) ? base._edicionItem.subcuentas : [];
      if (!(enriched.idSubcuenta > 0) && subcuentasEdicion.length) {
        const coincidentes = subcuentasEdicion.filter((s: any) => {
          const plan = this._norm2(s?.planCodi ?? s?.plan_codi ?? s?.programa ?? '');
          return !!programaCodigo && !!plan && plan === programaCodigo;
        });
        const elegida = coincidentes[0] || (subcuentasEdicion.length === 1 ? subcuentasEdicion[0] : null);
        const idSub = Number(elegida?.idSubcuenta ?? elegida?.id_subcuenta ?? 0);
        if (idSub > 0) {
          enriched.idSubcuenta = idSub;
        }
      }
    } catch {
      // no-op
    }

    return enriched;
  }

  private completarIdsPlanEliminacionDesdePrograma(plan: BeneficiaryDeletePlan, programa: any): void {
    if (!(plan.idBenPrograma > 0)) {
      plan.idBenPrograma = Number(programa?.idBenPrograma || programa?.__idBenPrograma || programa?.id_ben_programa || 0);
    }
    if (!(plan.idSubcuenta > 0)) {
      plan.idSubcuenta = Number(programa?.idSubcuenta || programa?.__idSubcuenta || programa?.id_subcuenta || 0);
    }
    if (!(plan.idCotizacionTarifa > 0)) {
      plan.idCotizacionTarifa = Number(
        programa?.idCotizacionTarifa || programa?.__idCotizacionTarifa || programa?.id_cotizacion_tarifa || 0
      );
    }
    if (!(plan.idCotizacionTarifaAnexo > 0)) {
      plan.idCotizacionTarifaAnexo = Number(
        programa?.idCotizacionTarifaAnexo || programa?.__idCotizacionTarifaAnexo || 0
      );
    }
    if (!(plan.idCotizacionCampania > 0)) {
      plan.idCotizacionCampania = this.extraerIdCampaniaDesdeItem(programa)
        || Number(programa?.__idCotizacionCampania || 0);
    }
  }

  /** Al borrar el beneficiario completo, arma planes de todas sus ramas persistidas. */
  private construirPlanesDeleteCompletosBeneficiarioDependiente(
    base: any,
    planBase: BeneficiaryDeletePlan
  ): BeneficiaryDeletePlan[] {
    const planes: BeneficiaryDeletePlan[] = [];
    const idBeneficiario = Number(planBase.idBeneficiario || 0);
    const localId = (base?.localId || '').toString().trim();
    const tipo = (base?.tipo_documento || '').toString().trim();
    const numero = (base?.num_documento || '').toString().trim();
    const parentesco = (base?.parentesco_id || '').toString().trim();

    const pushDesdePrograma = (p: any) => {
      const plan: BeneficiaryDeletePlan = {
        idBeneficiario,
        idBenPrograma: Number(p?.idBenPrograma ?? p?.__idBenPrograma ?? p?.id_ben_programa ?? 0),
        idSubcuenta: Number(p?.idSubcuenta ?? p?.__idSubcuenta ?? p?.id_subcuenta ?? 0),
        idCotizacionTarifa: Number(p?.idCotizacionTarifa ?? p?.__idCotizacionTarifa ?? p?.id_cotizacion_tarifa ?? 0),
        idCotizacionTarifaAnexo: Number(p?.idCotizacionTarifaAnexo ?? p?.__idCotizacionTarifaAnexo ?? 0),
        idCotizacionCampania: Number(
          p?.idCotizacionCampania ?? p?.__idCotizacionCampania ?? p?.idBenCampania ?? p?.id_cotizacion_campania ?? 0
        ) || this.extraerIdCampaniaDesdeItem(p),
        deleteDatosBeneficiarios: true
      };
      if (this.planEliminacionTienePersistenciaEnBd(plan) || plan.idBeneficiario > 0) {
        planes.push(plan);
      }
    };

    try {
      const envelope = this.resolverEnvelopeProgramasBeneficiarioLocal(
        this.beneficiarioLocalStorage.cargarProgramas(),
        { localId, tipo, numero, parentesco }
      );
      (Array.isArray(envelope?.programas) ? envelope!.programas : []).forEach(pushDesdePrograma);
    } catch {
      // no-op
    }

    try {
      const snap = this.obtenerSnapshotPersistenciaDependientes(this.obtenerIdCotizacionActivaParaFlecha());
      const ben = (snap?.beneficiarios || []).find((b: any) =>
        Number(b?.idBeneficiario || 0) === idBeneficiario
        || (localId && (b?.localId || '').toString().trim() === localId)
      );
      (Array.isArray(ben?.programas) ? ben.programas : []).forEach(pushDesdePrograma);
    } catch {
      // no-op
    }

    const cfgProgramas = Array.isArray(base?.programasConfig?.programas) ? base.programasConfig.programas : [];
    cfgProgramas.forEach(pushDesdePrograma);

    const subcuentasEdicion = Array.isArray(base?._edicionItem?.subcuentas) ? base._edicionItem.subcuentas : [];
    subcuentasEdicion.forEach((s: any) => {
      const idSubcuenta = Number(s?.idSubcuenta ?? s?.id_subcuenta ?? 0);
      if (!(idSubcuenta > 0)) return;
      planes.push({
        idBeneficiario,
        idBenPrograma: 0,
        idSubcuenta,
        idCotizacionTarifa: 0,
        idCotizacionTarifaAnexo: 0,
        idCotizacionCampania: 0,
        deleteDatosBeneficiarios: true
      });
    });

    if (planBase) {
      planes.push({ ...planBase, deleteDatosBeneficiarios: true });
    }
    return this.deduplicarPlanesDelete(planes);
  }

  /** Mantiene coherente el snapshot de dependientes tras borrar en tabla. */
  private actualizarSnapshotDependientesTrasEliminacionLocal(base: any, plan: BeneficiaryDeletePlan): void {
    try {
      const idCot = this.obtenerIdCotizacionActivaParaFlecha();
      const snap = this.obtenerSnapshotPersistenciaDependientes(idCot);
      if (!snap?.beneficiarios?.length) return;

      const localId = (base?.localId || '').toString().trim();
      const idBeneficiario = Number(plan.idBeneficiario || 0);

      let beneficiarios = [...(snap.beneficiarios || [])];
      if (plan.deleteDatosBeneficiarios) {
        beneficiarios = beneficiarios.filter((b: any) =>
          !(Number(b?.idBeneficiario || 0) === idBeneficiario && idBeneficiario > 0)
          && !(localId && (b?.localId || '').toString().trim() === localId)
        );
      } else {
        beneficiarios = beneficiarios.map((b: any) => {
          const same =
            (idBeneficiario > 0 && Number(b?.idBeneficiario || 0) === idBeneficiario)
            || (localId && (b?.localId || '').toString().trim() === localId);
          if (!same) return b;
          const programas = (Array.isArray(b.programas) ? b.programas : []).filter((p: any) =>
            Number(p?.idBenPrograma || 0) !== Number(plan.idBenPrograma || 0)
            || !(plan.idBenPrograma > 0)
          );
          return { ...b, programas };
        });
      }

      if (!beneficiarios.length) {
        this.limpiarSnapshotPersistenciaDependientes();
      } else {
        this.guardarSnapshotPersistenciaDependientes(idCot, beneficiarios as any);
      }
    } catch {
      // no-op
    }
  }

  private removerProgramaDeProgramasContratanteStorage(row: any): void {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      if (!raw) return;

      const parsed = JSON.parse(raw || '[]');
      const programas: any[] = Array.isArray(parsed)
        ? parsed
        : (Array.isArray(parsed?.programas) ? parsed.programas : []);

      const norm = (v: any) => (v ?? '').toString().trim().toUpperCase();
      const rowCode = norm((row as any)?.__programaCodigo || (row as any)?.program || '');
      const rowName = norm((row as any)?.program || '');
      const rowLinea = norm(this._aliasONombreLinea2((row as any)?.lineOfBusiness || ''));

      const filtrados = programas.filter((p: any) => {
        const codigos = [p?.programa, p?.id, p?.codigo].map(norm).filter(Boolean);
        const nombres = [
          p?.nombrePrograma,
          p?.nombre,
          this.formatearNombrePrograma(p?.nombrePrograma || p?.nombre || p?.programa || '')
        ].map(norm).filter(Boolean);
        const pLinea = norm(this._aliasONombreLinea2(p?.lineaNegocio || p?.lineaNegocioNombre || ''));

        const matchProgram = (!!rowCode && (codigos.includes(rowCode) || nombres.includes(rowCode)))
          || (!!rowName && (nombres.includes(rowName) || codigos.includes(rowName)));
        const matchLinea = !rowLinea || !pLinea || pLinea === rowLinea;
        return !(matchProgram && matchLinea);
      });

      if (!filtrados.length) {
        localStorage.removeItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      } else if (Array.isArray(parsed)) {
        localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify(filtrados));
      } else {
        localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify({
          ...(parsed || {}),
          programas: filtrados,
        }));
      }
      this.sincronizarYRefrescarBeneficiariosHeredados(filtrados as any);
    } catch {
      // no-op
    }
  }

  public get tieneBeneficiarios(): boolean {
    return Array.isArray(this.datasBeneficiary) && this.datasBeneficiary.length > 0;
  }

  onContinuarBeneficiarios(): void {
    const esVersionHistorica = this.isEditMode && !this.esVersionMasReciente;
    if (!this.tieneBeneficiarios && !esVersionHistorica) {
      this.SnackBarService?.alert?.('alert-info', 'Debe crear al menos un beneficiario para continuar.');
      return;
    }

    void this.continuarDesdeFlechaBeneficiarios();
  }

  private async continuarDesdeFlechaBeneficiarios(): Promise<void> {
    if (this.isEditMode) {
      this.spinner.show();
      try {
        await this.asegurarProgramasTitularVisiblesEnEdicion();
      } catch (err) {
        console.warn('[edicion-programas] la flecha no pudo cuadrar los programas del titular', err);
      } finally {
        this.spinner.hide();
      }
    }
    await this.persistirCadenaBeneficiarioDesdeStorageYContinuar();
  }

  private esEdicionDeInclusion(): boolean {
    const tipoCargado = (this.cotizacionEdicionData?.idTipoSolicitud ?? '').toString().trim();
    if (tipoCargado === '2') return true;
    if (tipoCargado === '1') return false;
    return this.esInclusion || localStorage.getItem('tipoSolicitud') === '2';
  }

  private async persistirCadenaBeneficiarioDesdeStorageYContinuar(): Promise<void> {
    const esFlujoInclusion = this.esEdicionDeInclusion();

    if (this.isEditMode && esFlujoInclusion) {
      this.tabHabilitado.cotizacion = true;
      this.maxStepReached = Math.max(this.maxStepReached, 3);
      this.showModalCuota();
      return;
    }

    const idCotizacion = this.obtenerIdCotizacionActivaParaFlecha();
    this.alinearCotizacionCreada(idCotizacion);
    const filasContratante = this.obtenerFilasContratanteTabla();

    // Sin filas de contratante: igual persistir beneficiarios locales (venta nueva) y continuar.
    if (!filasContratante.length) {
      if (!(idCotizacion > 0) && !this.isEditMode) {
        this.SnackBarService.alert('alert-danger', 'No se encontró la cotización activa para continuar.');
        return;
      }
      this.spinner.show();
      try {
        if (!this.isEditMode && idCotizacion > 0) {
          await this.persistirBeneficiariosLocalStorageEnBd(idCotizacion);
        }
        this.tabHabilitado.cotizacion = true;
        this.maxStepReached = Math.max(this.maxStepReached, 3);
        this.showModalCuota();
      } catch (e: any) {
        const msg = (e?.errorMessage || e?.message || e?.error?.message || 'No fue posible persistir los beneficiarios.').toString();
        this.SnackBarService.alert('alert-danger', msg);
      } finally {
        this.spinner.hide();
      }
      return;
    }

    if (!(idCotizacion > 0)) {
      this.SnackBarService.alert('alert-danger', 'No se encontró la cotización activa para continuar.');
      return;
    }

    const datos = this.obtenerDatosContratanteDesdeStorage();
    const programasStorage = this.obtenerProgramasContratanteDesdeStorage();
    let programas = this.filtrarProgramasContratantePorFilas(
      programasStorage,
      filasContratante
    );

    if (!datos) {
      this.SnackBarService.alert('alert-danger', 'No se encontraron datos del contratante en almacenamiento local.');
      return;
    }

    if (!programas.length) {
      if (this.isEditMode) {
        if (this.esVersionMasReciente && !esFlujoInclusion) {
          try {
            await this.asegurarProgramasTitularVisiblesEnEdicion();
          } catch (err) {
            console.warn('[edicion-programas] no se cuadraron los programas del titular antes de cotización', err);
          }
        }
        this.tabHabilitado.cotizacion = true;
        this.maxStepReached = Math.max(this.maxStepReached, 3);
        this.showModalCuota();
        return;
      }
      // Venta nueva: sin programas del contratante, aún pueden existir beneficiarios en LS.
      const tieneBenefLocal = this.beneficiarioLocalStorage.cargarDatos().length > 0;
      if (!tieneBenefLocal) {
        this.SnackBarService.alert('alert-danger', 'No se encontraron programas del contratante para continuar.');
        return;
      }
      this.spinner.show();
      try {
        await this.persistirBeneficiariosLocalStorageEnBd(idCotizacion);
        this.tabHabilitado.cotizacion = true;
        this.maxStepReached = Math.max(this.maxStepReached, 3);
        this.showModalCuota();
      } catch (e: any) {
        const msg = (e?.errorMessage || e?.message || e?.error?.message || 'No fue posible persistir los beneficiarios.').toString();
        this.SnackBarService.alert('alert-danger', msg);
      } finally {
        this.spinner.hide();
      }
      return;
    }

    const snapshotActual = this.buildSnapshotFlechaBeneficiarios(idCotizacion, datos, programas);
    const snapshotGuardado = this.obtenerSnapshotFlechaGuardado();
    // Inclusión siempre vuelve a persistir: si el titular sigue en BD se borra la cadena y se agrega;
    // si ya no está, más abajo se crea de nuevo y no se reutilizan los ids viejos.
    // En edición hay que cuadrar los programas con lo que quedó en pantalla, aunque el resto no haya cambiado.
    if (!esFlujoInclusion && !this.isEditMode && snapshotGuardado && snapshotGuardado === snapshotActual) {
      this.spinner.show();
      try {
        await this.persistirBeneficiariosLocalStorageEnBd(idCotizacion);
        this.tabHabilitado.cotizacion = true;
        this.maxStepReached = Math.max(this.maxStepReached, 3);
        this.showModalCuota();
      } catch (e: any) {
        const msg = (e?.errorMessage || e?.message || e?.error?.message || 'No fue posible persistir los beneficiarios.').toString();
        this.SnackBarService.alert('alert-danger', msg);
      } finally {
        this.spinner.hide();
      }
      return;
    }

    const beneficiarioPayload = this.buildBeneficiarioPayloadDesdeStorage(datos, idCotizacion);

    this.spinner.show();
    try {
      const tipoSolicitudActual = String(
      this.cotizacionEdicionData?.idTipoSolicitud ??
      this.formInit?.get('tipoSolicitud')?.value ??
      localStorage.getItem('tipoSolicitud') ??
      ''
    ).trim();

    const tipoPlanActual = String(
      this.cotizacionEdicionData?.idTipoPlan ??
      this.formInit?.get('tipoPlan')?.value ??
      localStorage.getItem('tipoPlan') ??
      ''
    ).trim().toUpperCase();

    const esVentaNuevaAfinidad =
      !this.esInclusion &&
      tipoSolicitudActual === '1' &&
      (
        tipoPlanActual === '5' ||
        tipoPlanActual === 'GA' ||
        tipoPlanActual === 'AG' ||
        tipoPlanActual.includes('AFINIDAD')
      );

    if (esVentaNuevaAfinidad) {
      await this.consultarGruposProgramaColectivo();

      programas = this.resolverProgramasTitularVentaNuevaAfinidad(
        programas
      );
    }
      const esFlujoInclusionContinuar = this.esInclusion || (localStorage.getItem('tipoSolicitud') === '2');
      // Inclusión y edición: se conserva el beneficiario (tiene liquidaciones).
      // Solo se limpia la cadena hija antes del replace. Alta VN/colectivo sí borra todo.
      const preservarDatosBeneficiario = esFlujoInclusionContinuar
        || this.debePreservarDatosBeneficiarioPorFkLiquidacion();

      if (!preservarDatosBeneficiario && this.tienePersistenciaContratanteGuardada(filasContratante, programas, datos)) {
        await this.eliminarCadenaContratantePersistida(filasContratante, programas, datos);
      }

      let idBeneficiario = 0;
      if (preservarDatosBeneficiario) {
        idBeneficiario =
          this.resolverIdBeneficiarioContratantePersistido(filasContratante, programas, datos)
          || this.resolverIdBeneficiarioDuplicadoDesdeMemoria(beneficiarioPayload);
        if (!(idBeneficiario > 0) && !esFlujoInclusionContinuar) {
          idBeneficiario = await this.resolverIdBeneficiarioTitularInclusionDesdeEdit(
            idCotizacion,
            beneficiarioPayload
          );
        }
        if (idBeneficiario > 0 && esFlujoInclusionContinuar) {
          this.hidratarIdBeneficiarioTitularInclusion(idBeneficiario);
        }
      }
      const idBeneficiarioVeníaGuardado = idBeneficiario > 0;

      if (!(idBeneficiario > 0)) {
        const respGuardar = await this.guardarDatosBeneficiarioContratanteConRecuperacionDuplicado(
          beneficiarioPayload,
          filasContratante,
          programas,
          datos
        );
        idBeneficiario = this.extractIdBeneficiarioFromResponse(respGuardar);
      }

      if (!(idBeneficiario > 0)) {
        throw new Error('No se obtuvo idBeneficiario al guardar datos del beneficiario.');
      }

        const esPlanColectivoOAfinidad =
          this.esFlujoColectivoOAfinidad();

        if (
          esPlanColectivoOAfinidad &&
          !esFlujoInclusionContinuar &&
          !esVentaNuevaAfinidad
        ) {
          await this.consultarGruposProgramaColectivo();
        }

      const itemsProgramas = programas
        .map((p) => {
          const programaCode = (p?.programa || p?.id || '').toString().trim().toUpperCase();
          let nombreProgResuelto = ((p as any)?.nombrePrograma || (p as any)?.nombre || '').toString().trim();

          const esFlujoInclusionActual = localStorage.getItem('tipoSolicitud') === '2';

          if (esFlujoInclusionActual && (!nombreProgResuelto || nombreProgResuelto.toUpperCase() === programaCode)) {
            // 1. Buscar en beneficiarios en memoria viva
            for (const ben of (this.datasBeneficiary || [])) {
              const hit = ((ben as any)?.programasConfig?.programas || []).find((x: any) =>
                (x?.id || x?.programa || '').toString().trim().toUpperCase() === programaCode
              );
              if (hit && hit.nombre && hit.nombre.toUpperCase() !== programaCode) {
                nombreProgResuelto = hit.nombre.toString().trim();
                break;
              }
            }

            // 2. Buscar en 'programas_contratante_inclusiones' de LocalStorage
            if (!nombreProgResuelto || nombreProgResuelto.toUpperCase() === programaCode) {
              try {
                const rawInc = localStorage.getItem('programas_contratante_inclusiones');
                if (rawInc) {
                  const listInc = JSON.parse(rawInc);
                  const hit = listInc.find((x: any) =>
                    (x.programa || x.codigo_plan || x.id || '').toString().trim().toUpperCase() === programaCode
                  );
                  if (hit) {
                    nombreProgResuelto = (hit.nombrePrograma || hit.nombreTarifa || hit.descripcion || hit.tarifa || '').toString().trim();
                  }
                }
              } catch (_) { }
            }

            // 3. Catálogo dinámico
            if (!nombreProgResuelto || nombreProgResuelto.toUpperCase() === programaCode) {
              nombreProgResuelto = this.formatearNombrePrograma(programaCode) || programaCode;
            }

            console.log(`[Inclusion-Cotizador-Prog]  Nombre resuelto EXCLUSIVO INCLUSIÓN para '${programaCode}': "${nombreProgResuelto}"`);
          } else if (!nombreProgResuelto) {
            //  Flujo Nativo (Venta Nueva / Edición): Asignación simple tradicional
            nombreProgResuelto = (p?.programa || p?.id || '').toString().trim();
          }

          return {
            lineaNegocio: this.normalizarLineaNegocioProgramasStorage((p?.lineaNegocio || '').toString()),
            programa: programaCode,
            nombrePrograma: nombreProgResuelto,
            grupoPrograma: this.resolverGrupoProgramaParaGuardado(
              programaCode,
              nombreProgResuelto,
              p
            ),
            esAnexo: esFlujoInclusionActual
              ? false
              : (this.normalizarRequiereAnexo((p as any)?.requiereAnexo) === 'si'),
          };
        })
        .filter((it) => !!it.programa);

      if (esVentaNuevaAfinidad) {
        this.dejarUnSoloPlanAfinidad(itemsProgramas);
      }

      if (!itemsProgramas.length) {
        throw new Error('No se encontraron programas válidos para guardar en beneficiario-programas.');
      }

      // Antes del replace: campaña → tarifa → subcuenta → programa (sin tocar el beneficiario).
      let programasYaEstanEnBd = true;
      let beneficiarioRecienCreado = false;
      if (esFlujoInclusionContinuar && idBeneficiarioVeníaGuardado) {
        const idQueTeniamos = idBeneficiario;
        try {
          const respDatos = await this.guardarDatosBeneficiarioContratanteConRecuperacionDuplicado(
            beneficiarioPayload,
            filasContratante,
            programas,
            datos
          );
          const idNuevo = this.extractIdBeneficiarioFromResponse(respDatos);
          if (idNuevo > 0) {
            idBeneficiario = idNuevo;
            this.hidratarIdBeneficiarioTitularInclusion(idNuevo);
            beneficiarioRecienCreado = idNuevo !== idQueTeniamos;
          }
        } catch (error: any) {
          this.retirarCotizacionLocalSiYaNoEsta(idCotizacion, error);
          throw error;
        }
      }

      // Alta nueva: el servicio reemplaza los programas. En edición ya hay liquidaciones y ese borrado no pasa.
      const reemplazar = true;
      const reemplazarProgramas = !this.isEditMode;

      if (reemplazarProgramas && preservarDatosBeneficiario && !beneficiarioRecienCreado) {
        programasYaEstanEnBd = await this.eliminarHijosTitularInclusionAntesDeReplaceProgramas(
          idCotizacion,
          idBeneficiario,
          filasContratante,
          programas,
          datos,
          itemsProgramas
        );
      } else if (beneficiarioRecienCreado) {
        programasYaEstanEnBd = false;
      }

      const idBenProgramaByPrograma = new Map<string, number>();
      // En edición se deja el que sigue en pantalla y se quita el que ya no está. El que ya existe no se vuelve a insertar.
      if (this.isEditMode) {
        const yaEstan = await this.alinearProgramasEdicionConPantalla(
          idCotizacion,
          idBeneficiario,
          itemsProgramas.map((it) => it.programa)
        );
        yaEstan.forEach((id, codigo) => idBenProgramaByPrograma.set(codigo, id));
      }

      const itemsAInsertar = itemsProgramas.filter(
        (it) => !idBenProgramaByPrograma.has((it.programa || '').toString().trim().toUpperCase())
      );
      await this.rellenarGrupoProgramaPorCodigo(itemsAInsertar);

      if (itemsAInsertar.length) {
        const respProgramas = await firstValueFrom(this.networkingBeneficiary.guardarBeneficiarioProgramas({
          idCotizacion,
          idBeneficiario,
          items: itemsAInsertar,
        }, reemplazarProgramas));
        if (respProgramas?.status === false) {
          const detalle = (respProgramas?.errorMessage || respProgramas?.message || 'No se pudieron guardar los programas del beneficiario.').toString();
          this.retirarCotizacionLocalSiYaNoEsta(idCotizacion, { message: detalle });
          throw new Error(detalle);
        }
        this.hydrateIdBenProgramaByProgramaDesdeRespuestaGuardar(itemsAInsertar, respProgramas, idBenProgramaByPrograma);
      }

      const programasSinId = itemsProgramas.filter(
        (it) => !idBenProgramaByPrograma.has((it.programa || '').toString().trim().toUpperCase())
      );
      if (programasSinId.length) {
        await Promise.all(
          programasSinId.map(async (it) => {
            const respConsultar = await firstValueFrom(this.networkingBeneficiary.consultarBeneficiarioPrograma({
              idCotizacion,
              idBeneficiario,
              programa: it.programa,
            }));
            const idBenPrograma = this.extractIdBenProgramaFromResponse(respConsultar);
            if (idBenPrograma > 0) {
              idBenProgramaByPrograma.set(it.programa.toUpperCase(), idBenPrograma);
            }
          })
        );
      }

      const idSubcuentaByPrograma = new Map<string, number>();

      if (this.debeGuardarSubcuentasPorTipoPlan()) {
        const tipoSolicitudActual = localStorage.getItem('tipoSolicitud');
        const esFlujoInclusionActual = tipoSolicitudActual === '2';

        const esTextoTarifa = (val: string, progObj?: any): boolean => {
          if (!val) return false;
          const s = val.trim().toUpperCase();
          if (s.includes(' - ') || (s.includes(' (') && s.endsWith(')'))) return true;
          if (progObj) {
            const cleanCode = (str: string): string => {
              if (!str) return '';
              let clean = str.trim().toUpperCase();
              if (clean.includes(' - ')) clean = clean.split(' - ')[0].trim();
              const m = clean.match(/\(([^)]+)\)$/);
              if (m && m[1]) clean = m[1].trim();
              return clean;
            };
            const codT = cleanCode((progObj?.tarifa || progObj?.tarifaDetalle?.tari || '').toString());
            if (codT && s === codT) return true;
          }
          return false;
        };

        const subcuentas = Array.from(new Map(
          (programas || [])
            .map((p) => {
              const progCode = (p?.programa || p?.id || '').toString().trim().toUpperCase();

              let subctaCandidate = ((p as any)?.subcta || (p as any)?.__subctaCodeSeleccionada || (p as any)?.subcuenta || '').toString().trim();
              let nombreSubctaCandidate = ((p as any)?.nombreSubcuenta || (p as any)?.subcuenta || '').toString().trim();

              if (esTextoTarifa(subctaCandidate, p)) subctaCandidate = '';
              if (esTextoTarifa(nombreSubctaCandidate, p)) nombreSubctaCandidate = '';

              let subctaFinal = '';
              let nombreSubctaFinal = '';

              if (esFlujoInclusionActual) {
                    // Inclusión: guardarSubcuentas exige subcta técnica numérica (@Size max=4).
                    // No enviar carnet/deno (ACEMN/ASMP) ni inventar ASAO/ASMP.
                    const esSubctaTecnica = (v: string): boolean => /^\d+$/.test(v) && v.length <= 4;
                    const pick = (...vals: any[]): string => {
                      for (const v of vals) {
                        const s = (v ?? '').toString().trim();
                        if (s) return s;
                      }
                      return '';
                    };

                    const candidatosCodigo = [
                      (p as any)?.subcta,
                      (p as any)?.__subctaCodeSeleccionada,
                      (p as any)?.codigoSubcuenta,
                    ].map((v) => (v ?? '').toString().trim()).filter(Boolean);

                    for (const c of candidatosCodigo) {
                      if (esSubctaTecnica(c)) {
                        subctaFinal = c;
                        break;
                      }
                    }

                    let nameDeno = pick(
                      (p as any)?.nombreSubcuenta,
                      // subcuenta/deno suele venir como texto; si es numérico no es deno
                      (() => {
                        const s = ((p as any)?.subcuenta ?? '').toString().trim();
                        return s && !esSubctaTecnica(s) ? s : '';
                      })(),
                      ...candidatosCodigo.filter((c) => !esSubctaTecnica(c))
                    );

                    const resolverDesdeRaw = (rawList: any[]): void => {
                      if (subctaFinal || !Array.isArray(rawList) || !rawList.length) return;
                      const denoUp = nameDeno.toUpperCase();
                      const hit = rawList.find((r: any) => {
                        const code = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim();
                        const deno = (r?.deno ?? r?.DENO ?? '').toString().trim();
                        if (denoUp && deno.toUpperCase() === denoUp && esSubctaTecnica(code)) return true;
                        if (candidatosCodigo.some((c) => c && !esSubctaTecnica(c) && (c.toUpperCase() === deno.toUpperCase() || c.toUpperCase() === code.toUpperCase()))) {
                          return esSubctaTecnica(code);
                        }
                        return false;
                      });
                      if (hit) {
                        const code = (hit.subcta ?? hit.SUBCTA ?? '').toString().trim();
                        if (esSubctaTecnica(code)) subctaFinal = code;
                        const deno = (hit.deno ?? hit.DENO ?? '').toString().trim();
                        if (deno) nameDeno = deno;
                      }
                    };

                    resolverDesdeRaw((p as any)?.__subcuentasRaw || []);

                    if (!subctaFinal && this._datosCompletosColectivoAC?.length) {
                      const denoUp = nameDeno.toUpperCase();
                      const matchAc: any = (this._datosCompletosColectivoAC || []).find((r: any) => {
                        const plan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
                        if (plan !== progCode) return false;
                        const code = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim();
                        if (!esSubctaTecnica(code)) return false;
                        if (!denoUp) return true;
                        const deno = (r?.deno ?? r?.DENO ?? '').toString().trim().toUpperCase();
                        return !deno || deno === denoUp;
                      });
                      if (matchAc) {
                        subctaFinal = (matchAc.subcta || matchAc.SUBCTA || '').toString().trim();
                        const deno = (matchAc.deno || matchAc.DENO || '').toString().trim();
                        if (deno) nameDeno = deno;
                      }
                    }

                    // Si quedó texto carnet en subctaFinal, descartarlo (nunca enviar a API)
                    if (subctaFinal && !esSubctaTecnica(subctaFinal)) {
                      if (!nameDeno) nameDeno = subctaFinal;
                      subctaFinal = '';
                    }

                    nombreSubctaFinal = nameDeno || subctaFinal;

                    console.log(`[INCLUSION-SUBCUENTA-DEBUG] Subcuenta Titular resuelta -> plan: "${progCode}", subcta (código): "${subctaFinal}", nombreSubcuenta (deno): "${nombreSubctaFinal}"`);
              } else {
                if (/^\d+$/.test(subctaCandidate)) {
                  subctaFinal = subctaCandidate;
                }
                if (this._datosCompletosColectivoAC?.length) {
                  const hitAc: any = this._datosCompletosColectivoAC.find((r: any) => (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase() === progCode && (!subctaFinal || (r?.subcta ?? r?.SUBCTA ?? '').toString().trim() === subctaFinal));
                  if (hitAc) {
                    const cAc = (hitAc?.subcta ?? hitAc?.SUBCTA ?? '').toString().trim();
                    if (cAc && /^\d+$/.test(cAc)) {
                      subctaFinal = cAc;
                    }
                    const denoApi = (hitAc?.deno ?? hitAc?.DENO ?? '').toString().trim();
                    if (denoApi && !esTextoTarifa(denoApi, p)) {
                      nombreSubctaFinal = denoApi;
                    }
                  }
                }
                if (!subctaFinal) {
                  subctaFinal = subctaCandidate || nombreSubctaCandidate;
                }

                if (!subctaFinal) {
                  const linea = ((p as any)?.lineaNegocio || '').toString().toUpperCase();
                  subctaFinal = (linea.includes('SAO') || linea.includes('ORAL') || linea === 'SO' || linea === '2') ? 'ASAO' : 'ASMP';
                }

                const denoEvaluada = (nombreSubctaFinal || nombreSubctaCandidate || '').toString().trim();
                const esFraseLarga = !denoEvaluada || denoEvaluada.includes(' ') || denoEvaluada.length > 15 || denoEvaluada.toUpperCase().includes('NUMERO DE USUARIOS');
                if (esFraseLarga) {
                  nombreSubctaFinal = subctaFinal && /^\d+$/.test(subctaFinal) ? `${progCode}${subctaFinal}` : (progCode ? `${progCode}301AA` : 'SUB301AA');
                } else {
                  nombreSubctaFinal = denoEvaluada.toUpperCase();
                }
              }

              console.log(`[Inclusion-Cotizador-Subcta]  Subcuenta resuelta Titular '${progCode}': subcta="${subctaFinal}", nombre="${nombreSubctaFinal}"`);

              return {
                subcta: subctaFinal,
                nombreSubcuenta: nombreSubctaFinal || subctaFinal,
                planCodi: progCode,
              };
            })
            .filter((s) => !!s.subcta)
            .map((s) => [`${s.subcta}|${s.planCodi}`, s])
        ).values());

        if (subcuentas.length > 0) {
          const respSubcuentas = await firstValueFrom(this.networkingBeneficiary.guardarSubcuentas({ idCotizacion, idBeneficiario, subcuentas }, reemplazar));
          this.hydrateIdsSubcuentaByProgramaDesdeRespuestaGuardar(respSubcuentas, subcuentas, idSubcuentaByPrograma);
        }
      }

      const programasTarifas = (programas || [])
        .map((p) => {
          const programaCode = (p?.programa || p?.id || '').toString().trim().toUpperCase();
          const idBenPrograma = Number(idBenProgramaByPrograma.get(programaCode) || 0);
          if (!(idBenPrograma > 0)) return null;

          const tarifas: any[] = [];
          const esFlujoInclusionActual = localStorage.getItem('tipoSolicitud') === '2';
          const tipoPlanActual = (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
          const esFlujoColectivoActual = tipoPlanActual === 'C' || tipoPlanActual === 'GA' || tipoPlanActual === 'AG' || tipoPlanActual.includes('COLECTIV') || tipoPlanActual.includes('AFINIDAD');

          if (esFlujoInclusionActual) {
            const cleanCode = (val: string): string => {
              if (!val) return '';
              let limpio = val.includes(' - ') ? val.split(' - ')[0].trim() : val;
              if (limpio.match(/\(([^)]+)\)$/)) {
                limpio = limpio.match(/\(([^)]+)\)$/)?.[1]?.trim() || limpio;
              }
              return limpio.trim();
            };

            const tariPrincipalClean = cleanCode(((p as any)?.tarifaDetalle?.tari || p?.tarifa || '').toString().trim());

            if (tariPrincipalClean) {
              let valIvaInclusion = Number(
                (p as any)?.valorMensualIva ??
                (p as any)?.tarifaDetalle?.valorMensualIva ??
                (p as any)?.valorMensualBase ??
                (p as any)?.tarifaDetalle?.valorMensualBase ??
                (p as any)?.valor_mensual_iva ??
                (p as any)?.valor_mensual_base ??
                (p as any)?.valor_tari ??
                (p as any)?.VALOR_TARI ??
                (p as any)?.valor ??
                (p as any)?.VALOR ??
                0
              );
              let valBaseInclusion = Number(
                (p as any)?.valorMensualBase ??
                (p as any)?.tarifaDetalle?.valorMensualBase ??
                valIvaInclusion
              );

              console.log(`[Inclusion-Cotizador-Trace] Objeto 'p' leído de 'programas_contratante' para '${programaCode}':`, p);
              console.log(`[Inclusion-Cotizador-Trace] Valores iniciales extraídos -> Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);

              if (valBaseInclusion <= 0) {
                console.warn(`[Inclusion-Cotizador-Trace]  Tarifa dio $0 en 'programas_contratante' para '${programaCode}'. Consultando Fallback 0: 'datasBeneficiary'...`);
                for (const ben of (this.datasBeneficiary || [])) {
                  const cfgProgs = (ben as any)?.programasConfig?.programas || [];
                  const hitProg = cfgProgs.find((x: any) =>
                    (x?.id || x?.programa || x?.code || '').toString().trim().toUpperCase() === programaCode
                  );
                  if (hitProg) {
                    const valRescatado = Number(
                      hitProg.valorMensualIva ??
                      hitProg.valorMensualBase ??
                      hitProg.valor_mensual_iva ??
                      hitProg.valor_mensual_base ??
                      hitProg.valor_tari ??
                      hitProg.valor ??
                      0
                    );
                    if (valRescatado > 0) {
                      valIvaInclusion = valRescatado;
                      valBaseInclusion = Number(hitProg.valorMensualBase ?? valRescatado);
                      console.log(`[Inclusion-Cotizador-Trace]  Rescatado con éxito de 'datasBeneficiary' -> Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);
                      break;
                    }
                  }
                }
              }

              if (valBaseInclusion <= 0 && this.cotizacionEdicionData?.beneficiarios) {
                console.warn(`[Inclusion-Cotizador-Trace] Fallback 2 sin resultados. Consultando Fallback 3: 'cotizacionEdicionData'...`);
                for (const benEd of (this.cotizacionEdicionData.beneficiarios || [])) {
                  const progsEd = (benEd as any)?.programas || [];
                  const hitEd = progsEd.find((x: any) =>
                    (x?.programa || x?.id || x?.codigo || '').toString().trim().toUpperCase() === programaCode
                  );
                  if (hitEd) {
                    const tarifasEd = Array.isArray(hitEd.tarifas) ? hitEd.tarifas : [];
                    const tarifaBaseEd = tarifasEd.find((t: any) => !t.esAnexo) || tarifasEd[0];
                    const valEd = Number(
                      tarifaBaseEd?.valorMensualIva ?? tarifaBaseEd?.valorMensualBase ?? hitEd?.valorMensualIva ?? hitEd?.valorMensualBase ?? 0
                    );
                    if (valEd > 0) {
                      valIvaInclusion = valEd;
                      valBaseInclusion = Number(tarifaBaseEd?.valorMensualBase ?? valEd);
                      console.log(`[Inclusion-Cotizador-Trace]  Rescatado con éxito de 'cotizacionEdicionData' (BD Original) -> Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);
                      break;
                    }
                  }
                }
              }

              if (valBaseInclusion <= 0 && esFlujoColectivoActual) {
                console.warn(`[Inclusion-Cotizador-Trace]  Fallback 0 sin resultados. Consultando Fallback 1: 'programas_contratante_inclusiones'...`);
                try {
                  const rawInc = localStorage.getItem('programas_contratante_inclusiones');
                  if (rawInc) {
                    const listInc = JSON.parse(rawInc);
                    const hit = listInc.find((x: any) =>
                      (x.programa || x.codigo_plan || x.id || '').toString().trim().toUpperCase() === programaCode
                    );
                    console.log(`[Inclusion-Cotizador-Trace] Coincidencia en 'programas_contratante_inclusiones':`, hit);
                    if (hit) {
                      valIvaInclusion = Number(
                        hit.valorMensualIva ??
                        hit.valor_mensual_iva ??
                        hit.valorMensualBase ??
                        hit.valor_mensual_base ??
                        hit.valor_tari ??
                        hit.VALOR_TARI ??
                        hit.valor ??
                        0
                      );
                      valBaseInclusion = Number(hit.valorMensualBase ?? hit.valor_mensual_base ?? valIvaInclusion);
                      if (valBaseInclusion > 0) {
                        console.log(`[Inclusion-Cotizador-Trace] Rescatado de 'programas_contratante_inclusiones' -> Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);
                      }
                    }
                  }
                } catch (e) {
                  console.error(`[Inclusion-Cotizador-Trace] Error leyendo 'programas_contratante_inclusiones':`, e);
                }

                //  Consultar '_datosCompletosColectivoAC'
                if (valBaseInclusion <= 0) {
                  console.warn(`[Inclusion-Cotizador-Trace]  Fallback 1 sin resultados. Consultando Fallback 2: '_datosCompletosColectivoAC'...`);
                  const filaColectivo: any = (this._datosCompletosColectivoAC || []).find((r: any) => {
                    const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
                    return rPlan === programaCode;
                  });
                  console.log(`[Inclusion-Cotizador-Trace] Coincidencia en '_datosCompletosColectivoAC':`, filaColectivo);
                  if (filaColectivo) {
                    const valRef = Number(filaColectivo?.valor_tari ?? filaColectivo?.VALOR_TARI ?? filaColectivo?.valor ?? filaColectivo?.VALOR ?? 0);
                    if (valRef > 0) {
                      valBaseInclusion = valRef;
                      valIvaInclusion = valRef;
                      console.log(`[Inclusion-Cotizador-Trace]  Rescatado de '_datosCompletosColectivoAC' -> Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);
                    }
                  }
                }
              }

              console.log(`[Inclusion-Cotizador-Persist]  Tarifa RESUELTA FINAL para Titular -> Programa: '${programaCode}' | Base: $${valBaseInclusion} | IVA: $${valIvaInclusion}`);

              if (valBaseInclusion > 0) {
                tarifas.push({
                  tari: tariPrincipalClean,
                  nombreTarifa: ((p as any)?.tarifaDetalle?.nombreTarifa || (p as any)?.nombreTarifa || '').toString().trim() || undefined,
                  valorMensualBase: valBaseInclusion,
                  valorMensualIva: valIvaInclusion,
                  porcentajeIva: Number((p as any)?.tarifaDetalle?.porcentajeIva ?? (p as any)?.porcentajeIva ?? 0) || undefined,
                  esTarifaAsociado: (p as any)?.tarifaDetalle?.esTarifaAsociado ?? (p as any)?.esTarifaAsociado ?? undefined,
                  fueSeleccionada: true,
                  esAnexo: false,
                });
              } else {
                console.warn(`[Inclusion-Cotizador-Persist]  Omitida actualización de tarifa en $0 para Titular en '${programaCode}' (se mantiene el valor de BD).`);
              }
            }
            const tariAnexoRaw = ((p as any)?.anexoDetalle?.tari || p?.anexoCodigo || p?.tarifaAnexo || '').toString().trim();
            let tariAnexoClean = /^\d+(\.\d+)?$/.test(tariAnexoRaw) ? '' : cleanCode(tariAnexoRaw);

            if (!tariAnexoClean && (p as any)?.anexoDetalle?.tari) {
              tariAnexoClean = (p as any).anexoDetalle.tari.toString().trim();
            }

            if (tariAnexoClean && tariAnexoClean !== '0' && tariAnexoClean !== '0.0000') {
              const valorAnexoIvaRaw = Number((p as any)?.anexoDetalle?.valorMensualIva ?? 0);
              const valorAnexoIva = Number.isFinite(valorAnexoIvaRaw) ? valorAnexoIvaRaw : 0;

              let nombreAnexoFinal = ((p as any)?.anexoDetalle?.nombreTarifa || (p as any)?.nombreAnexo || (p as any)?.nombreAnexoResuelto || '').toString().trim();
              if (!nombreAnexoFinal) {
                nombreAnexoFinal = `${tariAnexoClean} - ANEXO`;
              }

              console.log(`[INCLUSION-ANEXO-TITULAR-DEBUG] [Cotizador-Sync] DTO Anexo final enviado a BD para Titular '${programaCode}':`, {
                tari: tariAnexoClean,
                nombreTarifa: nombreAnexoFinal,
                valorMensualBase: valorAnexoIva,
                valorMensualIva: valorAnexoIva,
                pObject: p
              });

              tarifas.push({
                tari: tariAnexoClean,
                nombreTarifa: nombreAnexoFinal,
                valorMensualBase: valorAnexoIva,
                valorMensualIva: valorAnexoIva,
                porcentajeIva: Number((p as any)?.anexoDetalle?.porcentajeIva || 0) || undefined,
                esTarifaAsociado: (p as any)?.anexoDetalle?.esTarifaAsociado ?? undefined,
                fueSeleccionada: true,
                esAnexo: true,
              });
            }

            if (!tarifas.length) return null;
            return { idBenPrograma, tarifas };
          }

          else if (esFlujoColectivoActual) {
            const tariRaw = ((p as any)?.tarifaDetalle?.tari || p?.tarifa || '').toString().trim();
            const tariPrincipal = this.extraerCodigoTarifaLimpioParaPersistencia(tariRaw);

            if (tariPrincipal) {
              const filaColectivo: any = (this._datosCompletosColectivoAC || []).find((r: any) => {
                const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
                return rPlan === programaCode;
              });

              let nombreTarifaResuelta = ((p as any)?.tarifaDetalle?.nombreTarifa || (p as any)?.nombreTarifa || '').toString().trim();
              if (!nombreTarifaResuelta && filaColectivo) {
                nombreTarifaResuelta = (filaColectivo?.tari_deno || filaColectivo?.plan_deno || p?.nombrePrograma || '').toString().trim();
              }

              let valorBase = Number((p as any)?.tarifaDetalle?.valorMensualBase ?? (p as any)?.valorMensualBase ?? 0);
              let valorIva = Number((p as any)?.tarifaDetalle?.valorMensualIva ?? (p as any)?.valorMensualIva ?? (p as any)?.valor ?? valorBase);

              if (valorBase <= 0 && filaColectivo) {
                const valRef = Number(filaColectivo?.valor_tari ?? filaColectivo?.VALOR_TARI ?? filaColectivo?.valor ?? filaColectivo?.VALOR ?? 0);
                if (valRef > 0) {
                  valorBase = valRef;
                  valorIva = valRef;
                }
              }

              console.log(`[Colectivo-Cotizador-Save] Inyectando tarifa a BD para Titular -> Programa: '${programaCode}' | Código: '${tariPrincipal}' | Nombre: '${nombreTarifaResuelta}' | Base: $${valorBase} | IVA: $${valorIva}`);

              tarifas.push({
                tari: tariPrincipal,
                nombreTarifa: nombreTarifaResuelta || undefined,
                valorMensualBase: valorBase > 0 ? valorBase : undefined,
                valorMensualIva: valorIva > 0 ? valorIva : undefined,
                porcentajeIva: Number((p as any)?.tarifaDetalle?.porcentajeIva ?? (p as any)?.porcentajeIva ?? 0),
                esTarifaAsociado: (p as any)?.tarifaDetalle?.esTarifaAsociado ?? (p as any)?.esTarifaAsociado ?? false,
                fueSeleccionada: true,
                esAnexo: false,
              });

            }

            const tariAnexo = ((p as any)?.anexoDetalle?.tari || p?.anexoCodigo || '').toString().trim();
            const nombreAnexoStorage = ((p as any)?.anexoDetalle?.nombreTarifa || (p as any)?.nombreAnexo || '').toString().trim();
            const nombreAnexoFinal = nombreAnexoStorage
              ? (nombreAnexoStorage.includes(tariAnexo) ? nombreAnexoStorage : `${tariAnexo} - ${nombreAnexoStorage}`)
              : (tariAnexo ? `${tariAnexo} - ANEXO` : '');

            const valorAnexoIvaRaw = Number((p as any)?.anexoDetalle?.valorMensualIva ?? (p as any)?.tarifaAnexo ?? 0);
            const valorAnexoIva = Number.isFinite(valorAnexoIvaRaw) ? valorAnexoIvaRaw : 0;

            console.log(`[ANEXO-DEBUG-CORRECCION] [Cotizador-BackendSync] Anexo Titular DTO -> Código: "${tariAnexo}", Nombre: "${nombreAnexoFinal}", Valor: ${valorAnexoIva}`, {
              p,
              storageProgramas: JSON.parse(localStorage.getItem('programas_contratante') || '[]')
            });

            if (tariAnexo && tariAnexo !== '0' && tariAnexo !== '0.0000') {
              tarifas.push({
                tari: tariAnexo,
                nombreTarifa: nombreAnexoFinal || undefined,
                valorMensualBase: valorAnexoIva,
                valorMensualIva: valorAnexoIva,
                porcentajeIva: Number((p as any)?.anexoDetalle?.porcentajeIva || 0) || undefined,
                esTarifaAsociado: (p as any)?.anexoDetalle?.esTarifaAsociado ?? undefined,
                fueSeleccionada: true,
                esAnexo: true,
              });
            }

            if (!tarifas.length) return null;
            return { idBenPrograma, tarifas };
          }

          else {
            const tariPrincipalRaw = ((p as any)?.tarifaDetalle?.tari || p?.tarifa || '').toString().trim();
            const tariPrincipal = this.extraerCodigoTarifaLimpioParaPersistencia(tariPrincipalRaw) || tariPrincipalRaw;
            if (tariPrincipal) {
              tarifas.push({
                tari: tariPrincipal,
                nombreTarifa: ((p as any)?.tarifaDetalle?.nombreTarifa || '').toString().trim() || undefined,
                valorMensualBase: Number((p as any)?.tarifaDetalle?.valorMensualBase || 0) || undefined,
                valorMensualIva: Number((p as any)?.tarifaDetalle?.valorMensualIva || 0) || undefined,
                porcentajeIva: Number((p as any)?.tarifaDetalle?.porcentajeIva || 0) || undefined,
                esTarifaAsociado: (p as any)?.tarifaDetalle?.esTarifaAsociado ?? undefined,
                fueSeleccionada: true,
                esAnexo: false,
              });
            }
            const tariAnexoRaw = ((p as any)?.anexoDetalle?.tari || p?.tarifaAnexo || '').toString().trim();
            const tariAnexo = this.extraerCodigoTarifaLimpioParaPersistencia(tariAnexoRaw) || tariAnexoRaw;
            if (tariAnexo) {
              const valorAnexoIvaRaw = Number((p as any)?.anexoDetalle?.valorMensualIva);
              const valorAnexoIva = Number.isFinite(valorAnexoIvaRaw) ? valorAnexoIvaRaw : 0;
              tarifas.push({
                tari: tariAnexo,
                nombreTarifa: ((p as any)?.anexoDetalle?.nombreTarifa || '').toString().trim() || undefined,
                valorMensualBase: valorAnexoIva,
                valorMensualIva: valorAnexoIva,
                porcentajeIva: Number((p as any)?.anexoDetalle?.porcentajeIva || 0) || undefined,
                esTarifaAsociado: (p as any)?.anexoDetalle?.esTarifaAsociado ?? undefined,
                fueSeleccionada: true,
                esAnexo: true,
              });
            }
            if (!tarifas.length) return null;
            return { idBenPrograma, tarifas };
          }
        })
        .filter(Boolean) as Array<{ idBenPrograma: number; tarifas: any[] }>;

      const idCotizacionTarifaByPrograma = new Map<string, number>();
      const idCotizacionTarifaAnexoByPrograma = new Map<string, number>();
      if (programasTarifas.length > 0) {
        const respTarifas = await firstValueFrom(this.networkingBeneficiary.guardarTarifas({
          idCotizacion,
          idBeneficiario,
          programas: programasTarifas,
        }, reemplazar));
        this.hydrateIdsTarifaByProgramaDesdeRespuestaGuardar(
          respTarifas,
          idBenProgramaByPrograma,
          idCotizacionTarifaByPrograma,
          idCotizacionTarifaAnexoByPrograma
        );
      }
      const programasCampanias = (programas || [])
        .map((p) => {
          const programaCode = (p?.programa || p?.id || '').toString().trim().toUpperCase();
          const idBenPrograma = Number(idBenProgramaByPrograma.get(programaCode) || 0);
          if (!(idBenPrograma > 0)) return null;

          let codCampComercial = (((p as any)?.campaniaDetalle?.codigo_campania || (p as any)?.campaniaDetalle?.codCampComercial || p?.campana || '').toString().trim());
          let campanaNombre = ((p as any)?.campanaNombre || (p as any)?.nombre_campana || (p as any)?.campaniaDetalle?.nombreCampania || (p as any)?.campaniaDetalle?.nombre || '').toString().trim();
          let iniVig = (p as any)?.inicioVigencia || (p as any)?.inicio_vigencia || (p as any)?.campaniaDetalle?.inicioVigencia || (p as any)?.campaniaDetalle?.inicio_vigencia;
          let finVig = (p as any)?.finVigencia || (p as any)?.fin_vigencia || (p as any)?.campaniaDetalle?.finVigencia || (p as any)?.campaniaDetalle?.fin_vigencia;
          let cDetalle = (p as any)?.campaniaDetalle;

          if ((!codCampComercial || !iniVig) && this.datasBeneficiary) {
            for (const ben of (this.datasBeneficiary || [])) {
              const hit = ((ben as any)?.programasConfig?.programas || []).find((x: any) =>
                (x?.id || x?.programa || '').toString().trim().toUpperCase() === programaCode
              );
              if (hit) {
                codCampComercial = codCampComercial || (hit.campana || hit.codigo_campania || hit.codCampComercial || '').toString().trim();
                campanaNombre = campanaNombre || (hit.campanaNombre || hit.nombre_campana || '').toString().trim();
                iniVig = iniVig || hit.inicioVigencia || hit.inicio_vigencia;
                finVig = finVig || hit.finVigencia || hit.fin_vigencia;
                cDetalle = cDetalle || hit.campaniaDetalle;
                if (codCampComercial && iniVig) break;
              }
            }
          }

          if (!codCampComercial || !iniVig) {
            try {
              const rawInc = localStorage.getItem('programas_contratante_inclusiones');
              if (rawInc) {
                const listInc = JSON.parse(rawInc);
                const hit = listInc.find((x: any) =>
                  (x.programa || x.codigo_plan || x.id || '').toString().trim().toUpperCase() === programaCode
                );
                if (hit) {
                  codCampComercial = codCampComercial || (hit.campana || hit.codigo_campania || hit.codCampComercial || '').toString().trim();
                  campanaNombre = campanaNombre || (hit.campanaNombre || hit.nombre_campana || hit.nombreTarifa || '').toString().trim();
                  iniVig = iniVig || hit.inicioVigencia || hit.inicio_vigencia || hit.vigen_desde;
                  finVig = finVig || hit.finVigencia || hit.fin_vigencia || hit.vigen_hasta;
                }
              }
            } catch (_) { }
          }

          console.log(`[Inclusion-Cotizador-Campa]  DTO Resuelto para Titular '${programaCode}':`, {
            idBenPrograma,
            codCampComercial,
            campanaNombre,
            inicioVigencia: iniVig,
            finVigencia: finVig
          });

          codCampComercial = this.codigoCampaniaParaGuardar({
            campaniaDetalle: cDetalle,
            codigo_campania: (p as any)?.codigo_campania,
            codCampComercial: cDetalle?.codCampComercial || (p as any)?.codCampComercial,
            campana: codCampComercial,
          });
          if (!codCampComercial) {
            console.log(`[Inclusion-Cotizador-Campa]  Campaña no encontrada para '${programaCode}'. Subnodo omitido.`);
            return null;
          }

          const esFlujoInclusionActual = localStorage.getItem('tipoSolicitud') === '2';
          if (esFlujoInclusionActual) {
            const formatoFecha = (str: any): string | undefined => {
              if (!str) return undefined;
              const limpia = str.toString().trim();
              if (/^\d{2}\/\d{2}\/\d{4}$/.test(limpia)) {
                const [d, m, y] = limpia.split('/');
                return `${y}-${m}-${d}`;
              }
              return limpia || undefined;
            };

            const fechaInicioFinal = formatoFecha(iniVig);
            const fechaFinFinal = formatoFecha(finVig);

            const campaniaObj: any = {
              codCampComercial,
              nombreCampania: (campanaNombre || cDetalle?.nombreCampania || cDetalle?.nombre || codCampComercial).toString().trim(),
              fueSeleccionada: true,
              observaciones: (cDetalle?.observaciones ?? '').toString().trim(),
              inicioVigencia: fechaInicioFinal,
              finVigencia: fechaFinFinal,
            };

            if (cDetalle) {
              campaniaObj.tipoCampania = (cDetalle.tipo_campania || cDetalle.tipoCampania || '').toString().trim() || undefined;
              campaniaObj.modalidad = (cDetalle.modalidad || '').toString().trim() || undefined;
              campaniaObj.cuenta = (cDetalle.cuenta ?? '').toString().trim() || undefined;
              campaniaObj.subcuenta = (cDetalle.subcuenta ?? '').toString().trim() || undefined;
              campaniaObj.tipoPlan = (cDetalle.tipo_plan || cDetalle.tipoPlan || '').toString().trim() || undefined;
              campaniaObj.parentesco = (cDetalle.parentesco ?? '').toString().trim() || undefined;
              campaniaObj.edadDesde = Number(cDetalle.edad_desde ?? cDetalle.edadDesde ?? 0);
              campaniaObj.edadHasta = Number(cDetalle.edad_hasta ?? cDetalle.edadHasta ?? 0);
              campaniaObj.cantBenefDesde = Number(cDetalle.cant_benef_desde ?? cDetalle.cantBenefDesde ?? 0);
              campaniaObj.cantBenefHasta = Number(cDetalle.cant_benef_hasta ?? cDetalle.cantBenefHasta ?? 0);
              campaniaObj.acumulable = cDetalle.acumulable ?? undefined;
              campaniaObj.pagoDebitoAuto = cDetalle.pago_debito_auto ?? undefined;
              campaniaObj.aplicaProntoPago = cDetalle.aplica_pronto_pago ?? undefined;
              campaniaObj.usuarioActualizacion = (cDetalle.usuario_actualizacion || '').toString().trim() || undefined;
              campaniaObj.lineaNegocio = (cDetalle.linea_negocio || cDetalle.lineaNegocio || '').toString().trim() || undefined;
              campaniaObj.grupoPrograma = (cDetalle.grupo_programa || cDetalle.grupoPrograma || '').toString().trim() || undefined;
              campaniaObj.programa = (cDetalle.programa ?? '').toString().trim() || undefined;
              campaniaObj.estado = cDetalle.estado ?? undefined;
            }
            return { idBenPrograma, campanias: [campaniaObj] };
          }

          return {
            idBenPrograma,
            campanias: [{
              codCampComercial,
              nombreCampania: (((p as any)?.campaniaDetalle?.nombreCampania || (p as any)?.campaniaDetalle?.nombre || p?.campanaNombre || '').toString().trim()) || undefined,
              tipoCampania: (((p as any)?.campaniaDetalle?.tipo_campania || (p as any)?.campaniaDetalle?.tipoCampania || '').toString().trim()) || undefined,
              modalidad: (((p as any)?.campaniaDetalle?.modalidad || '').toString().trim()) || undefined,
              fueSeleccionada: true,
              cuenta: (((p as any)?.campaniaDetalle?.cuenta ?? '').toString().trim()) || undefined,
              subcuenta: (((p as any)?.campaniaDetalle?.subcuenta ?? '').toString().trim()) || undefined,
              tipoPlan: (((p as any)?.campaniaDetalle?.tipo_plan || (p as any)?.campaniaDetalle?.tipoPlan || '').toString().trim()) || undefined,
              parentesco: (((p as any)?.campaniaDetalle?.parentesco ?? '').toString().trim()) || undefined,
              edadDesde: Number((p as any)?.campaniaDetalle?.edad_desde ?? (p as any)?.campaniaDetalle?.edadDesde ?? 0),
              edadHasta: Number((p as any)?.campaniaDetalle?.edad_hasta ?? (p as any)?.campaniaDetalle?.edadHasta ?? 0),
              cantBenefDesde: Number((p as any)?.campaniaDetalle?.cant_benef_desde ?? (p as any)?.campaniaDetalle?.cantBenefDesde ?? 0),
              cantBenefHasta: Number((p as any)?.campaniaDetalle?.cant_benef_hasta ?? (p as any)?.campaniaDetalle?.cantBenefHasta ?? 0),
              acumulable: (p as any)?.campaniaDetalle?.acumulable ?? undefined,
              pagoDebitoAuto: (p as any)?.campaniaDetalle?.pago_debito_auto ?? undefined,
              aplicaProntoPago: (p as any)?.campaniaDetalle?.aplica_pronto_pago ?? undefined,
              observaciones: (((p as any)?.campaniaDetalle?.observaciones ?? '').toString().trim()),
              usuarioActualizacion: (((p as any)?.campaniaDetalle?.usuario_actualizacion ?? '').toString().trim()) || undefined,
              lineaNegocio: (((p as any)?.campaniaDetalle?.linea_negocio || (p as any)?.campaniaDetalle?.lineaNegocio || '').toString().trim()) || undefined,
              grupoPrograma: (((p as any)?.campaniaDetalle?.grupo_programa || (p as any)?.campaniaDetalle?.grupoPrograma || '').toString().trim()) || undefined,
              programa: (((p as any)?.campaniaDetalle?.programa ?? '').toString().trim()) || undefined,
              inicioVigencia: (((p as any)?.campaniaDetalle?.inicio_vigencia || (p as any)?.campaniaDetalle?.inicioVigencia || '').toString().trim()) || undefined,
              finVigencia: (((p as any)?.campaniaDetalle?.fin_vigencia || (p as any)?.campaniaDetalle?.finVigencia || '').toString().trim()) || undefined,
              estado: (p as any)?.campaniaDetalle?.estado ?? undefined,
            }]
          };
        })
        .filter(Boolean) as Array<{ idBenPrograma: number; campanias: any[] }>;

      const idCotizacionCampaniaByPrograma = new Map<string, number>();
      const campaniasAGuardar = await this.campaniasPorGuardarEnEdicion(
        idBeneficiario,
        programasCampanias,
        idBenProgramaByPrograma,
        idCotizacionCampaniaByPrograma
      );
      if (campaniasAGuardar.length > 0) {
        const respCampanias = await firstValueFrom(this.networkingBeneficiary.guardarCampanias({
          idCotizacion,
          idBeneficiario,
          programas: campaniasAGuardar,
        }, this.isEditMode ? false : reemplazar));
        this.hydrateIdsCampaniaByProgramaDesdeRespuestaGuardar(
          respCampanias,
          idBenProgramaByPrograma,
          idCotizacionCampaniaByPrograma
        );
      }

      this.persistirIdsContratanteEnStorage(
        idBeneficiario,
        idCotizacion,
        idBenProgramaByPrograma,
        idSubcuentaByPrograma,
        idCotizacionTarifaByPrograma,
        idCotizacionTarifaAnexoByPrograma,
        idCotizacionCampaniaByPrograma
      );
      this.refrescarFilaContratanteDesdeStorage(false);

      this.guardarSnapshotFlecha(this.buildSnapshotFlechaBeneficiarios(
        idCotizacion,
        datos,
        programas,
        this.construirPersistenciaBdDesdeMaps(
          idBeneficiario,
          programas,
          idBenProgramaByPrograma,
          idSubcuentaByPrograma,
          idCotizacionTarifaByPrograma,
          idCotizacionTarifaAnexoByPrograma,
          idCotizacionCampaniaByPrograma
        )
      ));

      await this.persistirBeneficiariosLocalStorageEnBd(idCotizacion);

      this.marcarCotizacionIndividualModificada();

      this.tabHabilitado.cotizacion = true;
      this.maxStepReached = Math.max(this.maxStepReached, 3);
      this.showModalCuota();
    } catch (e: any) {
      const msg = (e?.errorMessage || e?.message || e?.error?.message || 'No fue posible persistir los datos de beneficiario.').toString();
      this.SnackBarService.alert('alert-danger', msg);
    } finally {
      this.spinner.hide();
    }
  }

  /**
   * Persiste en BD los beneficiarios creados en venta nueva desde
   * datosRQ003_Beneficiario + programas_beneficiario (excluye titular/contratante).
   * Si ya existían en BD, borra en cascada (igual que el contratante) y vuelve a guardar.
   * Tras guardar, deja los IDs en localStorage para el próximo Continuar.
   */
  private async persistirBeneficiariosLocalStorageEnBd(idCotizacion: number): Promise<void> {
    if (!(idCotizacion > 0)) return;

      const listaDatos =
      this.beneficiarioLocalStorage.cargarDatos();

    if (!this.isEditMode) {
      await this.eliminarCadenaBeneficiariosDependientesPersistida(
        idCotizacion
      );
    }

    const listaProgramas = this.beneficiarioLocalStorage.cargarProgramas();
    const datosContratante = this.obtenerDatosContratanteDesdeStorage();
    const docCtrTipo = (datosContratante?.tipoDocumento || '').toString().trim().toUpperCase();
    const docCtrNumero = (datosContratante?.numeroDocumento || '').toString().trim();

    const pendientes = listaDatos.filter((datos) => {
      const parentesco = (datos?.parentesco || '').toString().trim().toUpperCase();
      if (parentesco === 'T' || parentesco === 'TITULAR') return false;

      const tipo = (datos?.contratanteTipoDocumento || '').toString().trim().toUpperCase();
      const numero = (datos?.contratanteDocumento || '').toString().trim();
      if (docCtrTipo && docCtrNumero && tipo === docCtrTipo && numero === docCtrNumero) {
        return false;
      }
      return true;
    });

    const persistenciaDependientes: Array<{
      localId: string;
      tipoDocumento: string;
      numeroDocumento: string;
      parentesco: string;
      idBeneficiario: number;
      programas: FlechaPersistenciaBdPrograma[];
    }> = [];

    for (const datos of pendientes) {
      const localId = (datos?.localId || '').toString().trim();
      const tipo = (datos?.contratanteTipoDocumento || '').toString().trim();
      const numero = (datos?.contratanteDocumento || '').toString().trim();
      const parentesco = (datos?.parentesco || '').toString().trim();
      const match = { localId, tipo, numero, parentesco };

      const envelope = this.resolverEnvelopeProgramasBeneficiarioLocal(
        listaProgramas,
        match
      );
      const programas = Array.isArray(envelope?.programas)
        ? envelope!.programas.filter((p) => !!p && typeof p === 'object')
        : [];

      if (!programas.length) {
        throw new Error(
          `El beneficiario ${numero || localId || ''} no tiene programas en localStorage para guardar.`
        );
      }

      const idExistenteEnLs = Number((datos as any)?.idBeneficiario || (envelope as any)?.idBeneficiario || 0)
        || this.buscarIdBeneficiarioEnTablaLocal(match);
      let idBeneficiario = 0;

      // En edición se reusa el id; no se vuelve a crear ni se borra el beneficiario.
      if (this.debePreservarDatosBeneficiarioPorFkLiquidacion() && idExistenteEnLs > 0) {
        idBeneficiario = idExistenteEnLs;
      } else {
        const payload = this.buildBeneficiarioPayloadDesdeDatosLocal(datos, idCotizacion);
        const respGuardar = await this.guardarDatosBeneficiarioLocalConRecuperacionDuplicado(payload, match);
        idBeneficiario = this.extractIdBeneficiarioFromResponse(respGuardar);
      }

      if (!(idBeneficiario > 0)) {
        throw new Error(
          `No se obtuvo idBeneficiario al guardar el beneficiario ${numero || localId || ''}.`
        );
      }

      this.marcarIdBeneficiarioEnTablaLocal(idBeneficiario, match);

      const maps = await this.persistirCadenaProgramasBeneficiarioLocal(
        idCotizacion,
        idBeneficiario,
        programas as ProgramaItemStore[],
        datos
      );

      const idsPorPrograma: Record<string, {
        idBenPrograma?: number;
        idSubcuenta?: number;
        idCotizacionTarifa?: number;
        idCotizacionTarifaAnexo?: number;
        idCotizacionCampania?: number;
      }> = {};
      const programasPersistidos: FlechaPersistenciaBdPrograma[] = [];

      const codigos = new Set<string>([
        ...Array.from(maps.idBenProgramaByPrograma.keys()),
        ...(programas as ProgramaItemStore[]).map((p) =>
          ((p as any)?.programa || (p as any)?.id || '').toString().trim().toUpperCase()
        ).filter(Boolean)
      ]);

      codigos.forEach((codigo) => {
        const prev = (programas as ProgramaItemStore[]).find((p) =>
          ((p as any)?.programa || (p as any)?.id || '').toString().trim().toUpperCase() === codigo
        ) as any;
        const item: FlechaPersistenciaBdPrograma = {
          programa: codigo,
          lineaNegocio: (prev?.lineaNegocio || '').toString().trim(),
          idBenPrograma: Number(maps.idBenProgramaByPrograma.get(codigo) || prev?.idBenPrograma || prev?.__idBenPrograma || 0),
          idSubcuenta: Number(maps.idSubcuentaByPrograma.get(codigo) || prev?.idSubcuenta || prev?.__idSubcuenta || 0),
          idCotizacionTarifa: Number(maps.idCotizacionTarifaByPrograma.get(codigo) || prev?.idCotizacionTarifa || prev?.__idCotizacionTarifa || 0),
          idCotizacionTarifaAnexo: Number(maps.idCotizacionTarifaAnexoByPrograma.get(codigo) || prev?.idCotizacionTarifaAnexo || prev?.__idCotizacionTarifaAnexo || 0),
          idCotizacionCampania: Number(
            maps.idCotizacionCampaniaByPrograma.get(codigo)
            || prev?.idCotizacionCampania
            || prev?.__idCotizacionCampania
            || prev?.idBenCampania
            || 0
          ),
        };
        programasPersistidos.push(item);
        const idsItem = {
          idBenPrograma: item.idBenPrograma || undefined,
          idSubcuenta: item.idSubcuenta || undefined,
          idCotizacionTarifa: item.idCotizacionTarifa || undefined,
          idCotizacionTarifaAnexo: item.idCotizacionTarifaAnexo || undefined,
          idCotizacionCampania: item.idCotizacionCampania || undefined,
        };
        this.clavesProgramaPersistencia(prev || { programa: codigo }).forEach((clave) => {
          idsPorPrograma[clave] = idsItem;
        });
        idsPorPrograma[codigo] = idsItem;
      });

      this.beneficiarioLocalStorage.persistirIdsBeneficiario(
        {
          localId: localId || undefined,
          tipoDocumento: tipo || undefined,
          numeroDocumento: numero || undefined,
          parentesco: parentesco || undefined
        },
        idBeneficiario,
        idCotizacion,
        idsPorPrograma
      );

      this.marcarIdsCadenaEnTablaLocal(match, idBeneficiario, idsPorPrograma);

      persistenciaDependientes.push({
        localId,
        tipoDocumento: tipo,
        numeroDocumento: numero,
        parentesco,
        idBeneficiario,
        programas: programasPersistidos
      });
    }

    this.guardarSnapshotPersistenciaDependientes(idCotizacion, persistenciaDependientes);
    this.refrescarFilasBeneficiariosLocalesDesdeLocalStorage();
  }

  /**
   * Borra la cadena de dependientes ya guardados (campaña → tarifa → subcuenta → programa → datos).
   * En edición deja el beneficiario y solo limpia hijos.
   */
  private async eliminarCadenaBeneficiariosDependientesPersistida(idCotizacion: number): Promise<void> {
    const planes = this.construirPlanesDeleteDependientesPersistidos(idCotizacion);
    if (!planes.length) return;

    const borrarDatos = !this.debePreservarDatosBeneficiarioPorFkLiquidacion();
    await this.ejecutarCascadaDeletePlanesBeneficiario(planes, borrarDatos, 'dependiente');
    if (borrarDatos) {
      this.limpiarPersistenciaDependientesTrasDelete(planes);
    } else {
      this.limpiarIdsHijosDependientesTrasDeletePreservandoBeneficiario(planes);
    }
  }

  private construirPlanesDeleteDependientesPersistidos(idCotizacion: number): BeneficiaryDeletePlan[] {
    const planes: BeneficiaryDeletePlan[] = [];
    const pushPlan = (idBeneficiario: number, p: any) => {
      planes.push({
        idBeneficiario,
        idBenPrograma: Number(p?.idBenPrograma ?? p?.__idBenPrograma ?? 0),
        idSubcuenta: Number(p?.idSubcuenta ?? p?.__idSubcuenta ?? 0),
        idCotizacionTarifa: Number(p?.idCotizacionTarifa ?? p?.__idCotizacionTarifa ?? 0),
        idCotizacionTarifaAnexo: Number(p?.idCotizacionTarifaAnexo ?? p?.__idCotizacionTarifaAnexo ?? 0),
        idCotizacionCampania: Number(
          p?.idCotizacionCampania ?? p?.__idCotizacionCampania ?? p?.idBenCampania ?? 0
        ) || this.extraerIdCampaniaDesdeItem(p),
        deleteDatosBeneficiarios: true
      });
    };

    const snapshot = this.obtenerSnapshotPersistenciaDependientes(idCotizacion);
    for (const ben of (snapshot?.beneficiarios || [])) {
      const idBeneficiario = Number(ben?.idBeneficiario || 0);
      const programas = Array.isArray(ben?.programas) ? ben.programas : [];
      if (!programas.length && idBeneficiario > 0) {
        pushPlan(idBeneficiario, {});
        continue;
      }
      for (const p of programas) {
        pushPlan(idBeneficiario, p);
      }
    }

    const listaDatos = this.beneficiarioLocalStorage.cargarDatos();
    const listaProgramas = this.beneficiarioLocalStorage.cargarProgramas();
    for (const datos of listaDatos) {
      const localId = (datos?.localId || '').toString().trim();
      const tipo = (datos?.contratanteTipoDocumento || '').toString().trim();
      const numero = (datos?.contratanteDocumento || '').toString().trim();
      const parentesco = (datos?.parentesco || '').toString().trim();
      const envelope = this.resolverEnvelopeProgramasBeneficiarioLocal(
        listaProgramas,
        { localId, tipo, numero, parentesco }
      );
      const idBeneficiario = Number(
        (datos as any)?.idBeneficiario
        || envelope?.idBeneficiario
        || 0
      );
      if (!(idBeneficiario > 0)) continue;
      const programas = Array.isArray(envelope?.programas) ? envelope!.programas : [];
      if (!programas.length) {
        pushPlan(idBeneficiario, {});
        continue;
      }
      for (const p of programas) {
        pushPlan(idBeneficiario, p);
      }
    }

    try {
      for (const b of (this.datasBeneficiary || [])) {
        const esContratante = (b as any)?.es_contratante === true || ((b as any)?.es_contratante as any) === 'S'
          || this._norm2((b as any)?.parentesco_id) === 'T';
        if (esContratante) continue;
        const idBeneficiario = Number((b as any)?.idBeneficiario || (b as any)?.id_beneficiario || 0);
        if (!(idBeneficiario > 0)) continue;
        const cfgProgramas = Array.isArray((b as any)?.programasConfig?.programas)
          ? (b as any).programasConfig.programas
          : [];
        if (!cfgProgramas.length) {
          pushPlan(idBeneficiario, b);
          continue;
        }
        cfgProgramas.forEach((p: any) => pushPlan(idBeneficiario, p));
      }
    } catch {
      // no-op
    }

    return this.deduplicarPlanesDelete(planes);
  }

  private planesDeleteTienenHijosPersistidos(planes: BeneficiaryDeletePlan[]): boolean {
    return (planes || []).some((p) =>
      Number(p?.idBenPrograma || 0) > 0
      || Number(p?.idSubcuenta || 0) > 0
      || Number(p?.idCotizacionTarifa || 0) > 0
      || Number(p?.idCotizacionTarifaAnexo || 0) > 0
      || Number(p?.idCotizacionCampania || 0) > 0
    );
  }

  private limpiarPersistenciaDependientesTrasDelete(planes: BeneficiaryDeletePlan[]): void {
    const ids = new Set(
      planes.map((p) => Number(p.idBeneficiario || 0)).filter((id) => id > 0)
    );
    if (!ids.size) {
      this.limpiarSnapshotPersistenciaDependientes();
      return;
    }

    const listaDatos = this.beneficiarioLocalStorage.cargarDatos();
    for (const datos of listaDatos) {
      const id = Number((datos as any)?.idBeneficiario || 0);
      if (!(id > 0) || !ids.has(id)) continue;
      this.beneficiarioLocalStorage.limpiarIdsPersistenciaBeneficiario({
        localId: (datos.localId || '').toString().trim() || undefined,
        tipoDocumento: (datos.contratanteTipoDocumento || '').toString().trim() || undefined,
        numeroDocumento: (datos.contratanteDocumento || '').toString().trim() || undefined,
        parentesco: (datos.parentesco || '').toString().trim() || undefined
      });
    }
    this.limpiarSnapshotPersistenciaDependientes();
  }

  /** Limpia ids de hijos en LS y deja el idBeneficiario. */
  private limpiarIdsHijosDependientesTrasDeletePreservandoBeneficiario(planes: BeneficiaryDeletePlan[]): void {
    const ids = new Set(
      planes.map((p) => Number(p.idBeneficiario || 0)).filter((id) => id > 0)
    );
    if (!ids.size) {
      this.limpiarSnapshotPersistenciaDependientes();
      return;
    }

    this.beneficiarioLocalStorage.limpiarIdsHijosProgramasPreservandoBeneficiario(ids);
    this.limpiarSnapshotPersistenciaDependientes();
  }

  /** true en edición: el beneficiario no se borra porque ya tiene liquidaciones. */
  private debePreservarDatosBeneficiarioPorFkLiquidacion(): boolean {
    return this.isEditMode === true;
  }

  private guardarSnapshotPersistenciaDependientes(
    idCotizacion: number,
    beneficiarios: Array<{
      localId: string;
      tipoDocumento: string;
      numeroDocumento: string;
      parentesco: string;
      idBeneficiario: number;
      programas: FlechaPersistenciaBdPrograma[];
    }>
  ): void {
    try {
      localStorage.setItem(this.KEY_FLECHA_DEPENDIENTES_PERSISTENCIA, JSON.stringify({
        idCotizacion,
        savedAt: new Date().toISOString(),
        beneficiarios
      }));
    } catch {
      // no-op
    }
  }

  private obtenerSnapshotPersistenciaDependientes(idCotizacion: number): {
    idCotizacion: number;
    beneficiarios: Array<{
      localId?: string;
      idBeneficiario?: number;
      programas?: FlechaPersistenciaBdPrograma[];
    }>;
  } | null {
    try {
      const raw = localStorage.getItem(this.KEY_FLECHA_DEPENDIENTES_PERSISTENCIA);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (Number(parsed?.idCotizacion || 0) !== Number(idCotizacion)) return null;
      return parsed;
    } catch {
      return null;
    }
  }

  private limpiarSnapshotPersistenciaDependientes(): void {
    try {
      localStorage.removeItem(this.KEY_FLECHA_DEPENDIENTES_PERSISTENCIA);
    } catch {
      // no-op
    }
  }

  private resolverEnvelopeProgramasBeneficiarioLocal(
    listaProgramas: ProgramasBeneficiarioEnvelope[],
    match: { localId: string; tipo: string; numero: string; parentesco: string }
  ): ProgramasBeneficiarioEnvelope | null {
    const localId = (match.localId || '').toString().trim();
    const tipo = (match.tipo || '').toString().trim().toUpperCase();
    const numero = (match.numero || '').toString().trim();
    const parentesco = (match.parentesco || '').toString().trim().toUpperCase();

    return (listaProgramas || []).find((p) => {
      if (localId && (p?.localId || '').toString().trim() === localId) return true;
      return (
        (p?.tipoDocumento || '').toString().trim().toUpperCase() === tipo
        && (p?.numeroDocumento || '').toString().trim() === numero
        && (p?.parentesco || '').toString().trim().toUpperCase() === parentesco
      );
    }) || null;
  }

  private buildBeneficiarioPayloadDesdeDatosLocal(
    datos: DatosBeneficiarioLocal,
    idCotizacion: number
  ): Beneficiarios {
    const b = new BeneficiariosModel();
    b.id_cotizacion = idCotizacion;
    b.es_contratante = false;
    b.parentesco_id = (datos?.parentesco || '').toString().trim();
    b.tipo_documento = (datos?.contratanteTipoDocumento || '').toString().trim();
    b.num_documento = (datos?.contratanteDocumento || '').toString().trim();
    b.primer_nombre = (datos?.nombre || '').toString().trim();
    b.segundo_nombre = (datos?.nombreSegundo || '').toString().trim();
    b.primer_apellido = (datos?.apellido || '').toString().trim();
    b.segundo_apellido = (datos?.apellidoSegundo || '').toString().trim();
    b.genero = (datos?.genero || '').toString().trim();
    b.fecha_nacimiento = this.normalizarFechaSoloYYYYMMDD((datos?.fechaNacimiento || '').toString().trim());
    const edadLs = Number((datos?.edad || '').toString().trim());
    b.edad = (Number.isFinite(edadLs) && edadLs > 0)
      ? String(edadLs)
      : this.calcularEdadDesdeFechaYYYYMMDD(b.fecha_nacimiento).toString();
    return b as unknown as Beneficiarios;
  }

  private async guardarDatosBeneficiarioLocalConRecuperacionDuplicado(
    beneficiarioPayload: Beneficiarios,
    match: { localId: string; tipo: string; numero: string; parentesco: string }
  ): Promise<any> {
    let firstAttempt: { response?: any; error?: any };
    try {
      firstAttempt = {
        response: await firstValueFrom(this.networkingBeneficiary.guardarDatosBeneficiarios(beneficiarioPayload))
      };
    } catch (error: any) {
      firstAttempt = { error };
    }

    if (!this.esRespuestaDuplicadoBeneficiario(firstAttempt.response, firstAttempt.error)) {
      if (this.esRespuestaFallidaBeneficiario(firstAttempt.response, firstAttempt.error)) {
        throw this.buildBeneficiarioPersistError(firstAttempt.response, firstAttempt.error);
      }
      return firstAttempt.response;
    }

    const idExistente =
      this.extractIdBeneficiarioFromResponse(
        this.normalizarPayloadRespuestaBeneficiario(firstAttempt.response, firstAttempt.error)
      )
      || this.buscarIdBeneficiarioEnTablaLocal(match)
      || Number((this.beneficiarioLocalStorage.cargarDatos().find((d) =>
        (match.localId && (d.localId || '').toString().trim() === match.localId)
        || (
          (d.contratanteTipoDocumento || '').toString().trim().toUpperCase() === (match.tipo || '').toString().trim().toUpperCase()
          && (d.contratanteDocumento || '').toString().trim() === (match.numero || '').toString().trim()
          && (d.parentesco || '').toString().trim().toUpperCase() === (match.parentesco || '').toString().trim().toUpperCase()
        )
      ) as any)?.idBeneficiario || 0);

    if (idExistente > 0) {
      // En edición se reusa el id; no se borra para reintentar el alta.
      if (this.debePreservarDatosBeneficiarioPorFkLiquidacion()) {
        return {
          status: true,
          message: 'Beneficiario existente reutilizado (edición)',
          data: { idBeneficiario: idExistente },
        };
      }

      let planes = this.construirPlanesDeleteDependientesPersistidos(
        this.obtenerIdCotizacionActivaParaFlecha()
      ).filter((p) => Number(p.idBeneficiario || 0) === idExistente);

      const planFallback: BeneficiaryDeletePlan = {
        idBeneficiario: idExistente,
        idBenPrograma: 0,
        idSubcuenta: 0,
        idCotizacionTarifa: 0,
        idCotizacionTarifaAnexo: 0,
        idCotizacionCampania: 0,
        deleteDatosBeneficiarios: true
      };

      if (!this.planesDeleteTienenHijosPersistidos(planes)) {
        const fila = (this.datasBeneficiary || []).find((b: any) =>
          Number(b?.idBeneficiario || b?.id_beneficiario || 0) === idExistente
          || (match.localId && (b?.localId || '').toString().trim() === match.localId)
          || (
            this._norm2(b?.tipo_documento) === this._norm2(match.tipo)
            && this._norm2(b?.num_documento) === this._norm2(match.numero)
            && this._norm2(b?.parentesco_id) === this._norm2(match.parentesco)
          )
        );
        const base = fila || {
          localId: match.localId,
          tipo_documento: match.tipo,
          num_documento: match.numero,
          parentesco_id: match.parentesco,
          idBeneficiario: idExistente,
          id_beneficiario: idExistente
        };
        planes = this.construirPlanesDeleteCompletosBeneficiarioDependiente(base, planFallback);
      }

      await this.ejecutarCascadaDeletePlanesBeneficiario(
        planes.length ? planes : [planFallback],
        true,
        'dependiente-duplicado'
      );
    }

    let response: any;
    try {
      response = await firstValueFrom(this.networkingBeneficiary.guardarDatosBeneficiarios(beneficiarioPayload));
    } catch (error: any) {
      throw this.buildBeneficiarioPersistError(null, error);
    }

    if (this.esRespuestaFallidaBeneficiario(response, null)) {
      throw this.buildBeneficiarioPersistError(response, null);
    }
    return response;
  }

  private async persistirCadenaProgramasBeneficiarioLocal(
    idCotizacion: number,
    idBeneficiario: number,
    programas: ProgramaItemStore[],
    datosBeneficiario?: DatosBeneficiarioLocal
  ): Promise<{
    idBenProgramaByPrograma: Map<string, number>;
    idSubcuentaByPrograma: Map<string, number>;
    idCotizacionTarifaByPrograma: Map<string, number>;
    idCotizacionTarifaAnexoByPrograma: Map<string, number>;
    idCotizacionCampaniaByPrograma: Map<string, number>;
  }> {
    const idBenProgramaByPrograma = new Map<string, number>();
    const idSubcuentaByPrograma = new Map<string, number>();
    const idCotizacionTarifaByPrograma = new Map<string, number>();
    const idCotizacionTarifaAnexoByPrograma = new Map<string, number>();
    const idCotizacionCampaniaByPrograma = new Map<string, number>();

    const esFlujoInclusionActual = this.esInclusion || (
      this.formInit?.get('tipoSolicitud')?.value ||
      localStorage.getItem('tipoSolicitud') ||
      ''
    ).toString().trim() === '2';

    const esPlanColectivoOAfinidad =
      this.esFlujoColectivoOAfinidad();

    if (esPlanColectivoOAfinidad && !esFlujoInclusionActual) {
      await this.consultarGruposProgramaColectivo();
    }

    const tipoPlan = String(
      this.formInit?.get('tipoPlan')?.value ??
      localStorage.getItem('tipoPlan') ??
      ''
    ).trim().toUpperCase();

    const esAfinidad =
      tipoPlan === 'GA' ||
      tipoPlan === 'AG' ||
      tipoPlan.includes('AFINIDAD');

    const programasPersistencia = (programas || []).map(p => {
      const codigoUi = String(p?.programa || (p as any)?.id || '')
        .trim().toUpperCase();

      // Inclusión guarda el código del programa tal como se eligió. El plan_codi de Afilmed es de venta nueva.
      if (!esAfinidad || esFlujoInclusionActual) return p;

      const subcta = String((p as any)?.subcta || '').trim();
      const cuenta = String((p as any)?.cuenta || '').trim();

      const filasAfinidad = (this._datosCompletosColectivoAC || []).filter((r: any) => {
        const plan = String(r?.plan_codi ?? r?.PLAN_CODI ?? '')
          .trim().toUpperCase();
        const subcuentaFila = String(r?.subcta ?? r?.SUBCTA ?? '').trim();
        const cuentaFila = String(r?.cuenta ?? r?.CUENTA ?? '').trim();

        const mismoPlan =
          plan === codigoUi ||
          (
            (plan.endsWith('F') || plan.endsWith('A')) &&
            `${plan.slice(0, -1)}C` === codigoUi
          );

        return mismoPlan &&
          (!subcta || subcuentaFila === subcta) &&
          (!cuenta || cuentaFila === cuenta);
      });

      const codigosAfinidad = Array.from(new Set<string>(
        filasAfinidad
          .map((r: any) => String(r?.plan_codi ?? r?.PLAN_CODI ?? '').trim().toUpperCase())
          .filter(Boolean)
      ));
      let familiares = codigosAfinidad.filter((codigo) =>
        codigo.endsWith('F') || codigo.endsWith('A')
      );
      if (!familiares.length) {
        familiares = Array.from(new Set<string>(
          (this._datosCompletosColectivoAC || [])
            .map((r: any) => String(r?.plan_codi ?? r?.PLAN_CODI ?? '').trim().toUpperCase())
            .filter((codigo) =>
              (codigo.endsWith('F') || codigo.endsWith('A')) &&
              (codigo === codigoUi || `${codigo.slice(0, -1)}C` === codigoUi)
            )
        ));
      }
      const codigoAfilmed = familiares.find((codigo) => codigo.endsWith('F')) || familiares[0] || '';

      if (!codigoAfilmed) {
        return p;
      }

      return { ...p, programa: codigoAfilmed };
    });

    const itemsProgramas = (programasPersistencia || [])
      .map((p) => {
        const programaCode = (p?.programa || (p as any)?.id || '').toString().trim().toUpperCase();
        if (!programaCode) return null;
        const nombreProgResuelto = (
          (p as any)?.nombrePrograma || (p as any)?.nombre || programaCode
        ).toString().trim();
        return {
          lineaNegocio: this.normalizarLineaNegocioProgramasStorage((p?.lineaNegocio || '').toString()),
          programa: programaCode,
          nombrePrograma: nombreProgResuelto,
          grupoPrograma: this.resolverGrupoProgramaParaGuardado(
            programaCode,
            nombreProgResuelto,
            p
          ),
          esAnexo: esFlujoInclusionActual
            ? false
            : this.normalizarRequiereAnexo((p as any)?.requiereAnexo) === 'si',
        };
      })
      .filter(Boolean) as Array<{
        lineaNegocio: string;
        programa: string;
        nombrePrograma: string;
        grupoPrograma: string;
        esAnexo: boolean;
      }>;

    if (esAfinidad && !esFlujoInclusionActual) {
      this.dejarUnSoloPlanAfinidad(itemsProgramas);
    }

    if (!itemsProgramas.length) {
      throw new Error('No se encontraron programas válidos del beneficiario para guardar.');
    }

    // En edición se deja el que sigue en pantalla y se quita el que ya no está. El que ya existe no se vuelve a insertar.
    if (this.isEditMode) {
      const yaEstan = await this.alinearProgramasEdicionConPantalla(
        idCotizacion,
        idBeneficiario,
        itemsProgramas.map((it) => it.programa)
      );
      yaEstan.forEach((id, codigo) => idBenProgramaByPrograma.set(codigo, id));
    }

    const itemsAInsertar = itemsProgramas.filter(
      (it) => !idBenProgramaByPrograma.has((it.programa || '').toString().trim().toUpperCase())
    );
    await this.rellenarGrupoProgramaPorCodigo(itemsAInsertar);

    if (itemsAInsertar.length) {
      const respProgramas = await firstValueFrom(this.networkingBeneficiary.guardarBeneficiarioProgramas({
        idCotizacion,
        idBeneficiario,
        items: itemsAInsertar,
      }, !this.isEditMode));

      this.hydrateIdBenProgramaByProgramaDesdeRespuestaGuardar(
        itemsAInsertar,
        respProgramas,
        idBenProgramaByPrograma
      );
    }

    const programasSinId = itemsProgramas.filter(
      (it) => !idBenProgramaByPrograma.has((it.programa || '').toString().trim().toUpperCase())
    );
    if (programasSinId.length) {
      await Promise.all(
        programasSinId.map(async (it) => {
          const respConsultar = await firstValueFrom(this.networkingBeneficiary.consultarBeneficiarioPrograma({
            idCotizacion,
            idBeneficiario,
            programa: it.programa,
          }));
          const idBenPrograma = this.extractIdBenProgramaFromResponse(respConsultar);
          if (idBenPrograma > 0) {
            idBenProgramaByPrograma.set(it.programa.toUpperCase(), idBenPrograma);
          }
        })
      );
    }

    if (this.debeGuardarSubcuentasPorTipoPlan()) {
      const subcuentas = Array.from(new Map(
        (programasPersistencia || [])
          .map((p) => {
            const progCode = (p?.programa || (p as any)?.id || '').toString().trim().toUpperCase();
            let subctaFinal = ((p as any)?.subcta || (p as any)?.subcuenta || '').toString().trim();
            let nombreSubctaFinal = ((p as any)?.nombreSubcuenta || (p as any)?.subcuenta || subctaFinal).toString().trim();

            if (!subctaFinal) {
              const linea = ((p as any)?.lineaNegocio || '').toString().toUpperCase();
              subctaFinal = (linea.includes('SAO') || linea.includes('ORAL') || linea === 'SO' || linea === '2')
                ? 'ASAO'
                : 'ASMP';
              nombreSubctaFinal = subctaFinal;
            }

            return {
              subcta: subctaFinal,
              nombreSubcuenta: nombreSubctaFinal || subctaFinal,
              planCodi: progCode,
            };
          })
          .filter((s) => !!s.subcta)
          .map((s) => [`${s.subcta}|${s.planCodi}`, s])
      ).values());

      if (subcuentas.length > 0) {
        const respSubcuentas = await firstValueFrom(this.networkingBeneficiary.guardarSubcuentas({
          idCotizacion,
          idBeneficiario,
          subcuentas
        }, true));
        this.hydrateIdsSubcuentaByProgramaDesdeRespuestaGuardar(
          respSubcuentas,
          subcuentas,
          idSubcuentaByPrograma
        );
      }
    }

    if (datosBeneficiario) {
      await this.actualizarTarifasBeneficiarioAntesDeGuardar(
        programas,
        datosBeneficiario
      );
    }

    const programasTarifas = (programasPersistencia  || [])
      .map((p) => {
        const programaCode = (p?.programa || (p as any)?.id || '').toString().trim().toUpperCase();
        const idBenPrograma = Number(idBenProgramaByPrograma.get(programaCode) || 0);
        if (!(idBenPrograma > 0)) return null;

        const tarifas: any[] = [];
        const tariPrincipalRaw = this.resolverCodigoTarifaPrograma(p);
        const tariPrincipal = this.extraerCodigoTarifaLimpioParaPersistencia(tariPrincipalRaw);
        if (tariPrincipal) {
          tarifas.push({
            tari: tariPrincipal,
            nombreTarifa: ((p as any)?.tarifaDetalle?.nombreTarifa || (p as any)?.nombreTarifa || '').toString().trim() || undefined,
            valorMensualBase: this.valorTarifaParaGuardar((p as any)?.tarifaDetalle?.valorMensualBase ?? (p as any)?.valorMensualBase),
            valorMensualIva: this.valorTarifaParaGuardar((p as any)?.tarifaDetalle?.valorMensualIva ?? (p as any)?.valorMensualIva),
            porcentajeIva: this.valorTarifaParaGuardar((p as any)?.tarifaDetalle?.porcentajeIva),
            esTarifaAsociado: (p as any)?.tarifaDetalle?.esTarifaAsociado ?? undefined,
            fueSeleccionada: true,
            esAnexo: false,
          });
        }
        const tariAnexoRaw = ((p as any)?.anexoDetalle?.tari || (p as any)?.tarifaAnexo || '').toString().trim();
        const tariAnexo = this.extraerCodigoTarifaLimpioParaPersistencia(tariAnexoRaw) || tariAnexoRaw;
        if (tariAnexo) {
          const valorAnexoIvaRaw = Number((p as any)?.anexoDetalle?.valorMensualIva);
          const valorAnexoIva = Number.isFinite(valorAnexoIvaRaw) ? valorAnexoIvaRaw : 0;
          tarifas.push({
            tari: tariAnexo,
            nombreTarifa: ((p as any)?.anexoDetalle?.nombreTarifa || '').toString().trim() || undefined,
            valorMensualBase: valorAnexoIva,
            valorMensualIva: valorAnexoIva,
            porcentajeIva: Number((p as any)?.anexoDetalle?.porcentajeIva || 0) || undefined,
            esTarifaAsociado: (p as any)?.anexoDetalle?.esTarifaAsociado ?? undefined,
            fueSeleccionada: true,
            esAnexo: true,
          });
        }
        if (!tarifas.length) return null;
        return { idBenPrograma, tarifas };
      })
      .filter(Boolean) as Array<{ idBenPrograma: number; tarifas: any[] }>;

    if (programasTarifas.length > 0) {
      const respTarifas = await firstValueFrom(this.networkingBeneficiary.guardarTarifas({
        idCotizacion,
        idBeneficiario,
        programas: programasTarifas,
      }, true));
      this.hydrateIdsTarifaByProgramaDesdeRespuestaGuardar(
        respTarifas,
        idBenProgramaByPrograma,
        idCotizacionTarifaByPrograma,
        idCotizacionTarifaAnexoByPrograma
      );
    }

    const programasCampanias = (programasPersistencia || [])
      .map((p) => {
        const programaCode = (p?.programa || (p as any)?.id || '').toString().trim().toUpperCase();
        const idBenPrograma = Number(idBenProgramaByPrograma.get(programaCode) || 0);
        if (!(idBenPrograma > 0)) return null;

        const codCampComercial = this.codigoCampaniaParaGuardar(p);
        if (!codCampComercial) return null;

        return {
          idBenPrograma,
          campanias: [{
            codCampComercial,
            nombreCampania: (((p as any)?.campaniaDetalle?.nombreCampania || (p as any)?.campaniaDetalle?.nombre || (p as any)?.campanaNombre || '').toString().trim()) || undefined,
            tipoCampania: (((p as any)?.campaniaDetalle?.tipo_campania || (p as any)?.campaniaDetalle?.tipoCampania || '').toString().trim()) || undefined,
            modalidad: (((p as any)?.campaniaDetalle?.modalidad || '').toString().trim()) || undefined,
            fueSeleccionada: true,
            cuenta: (((p as any)?.campaniaDetalle?.cuenta ?? '').toString().trim()) || undefined,
            subcuenta: (((p as any)?.campaniaDetalle?.subcuenta ?? '').toString().trim()) || undefined,
            tipoPlan: (((p as any)?.campaniaDetalle?.tipo_plan || (p as any)?.campaniaDetalle?.tipoPlan || '').toString().trim()) || undefined,
            parentesco: (((p as any)?.campaniaDetalle?.parentesco ?? '').toString().trim()) || undefined,
            edadDesde: Number((p as any)?.campaniaDetalle?.edad_desde ?? (p as any)?.campaniaDetalle?.edadDesde ?? 0),
            edadHasta: Number((p as any)?.campaniaDetalle?.edad_hasta ?? (p as any)?.campaniaDetalle?.edadHasta ?? 0),
            cantBenefDesde: Number((p as any)?.campaniaDetalle?.cant_benef_desde ?? (p as any)?.campaniaDetalle?.cantBenefDesde ?? 0),
            cantBenefHasta: Number((p as any)?.campaniaDetalle?.cant_benef_hasta ?? (p as any)?.campaniaDetalle?.cantBenefHasta ?? 0),
            acumulable: (p as any)?.campaniaDetalle?.acumulable ?? undefined,
            pagoDebitoAuto: (p as any)?.campaniaDetalle?.pago_debito_auto ?? undefined,
            aplicaProntoPago: (p as any)?.campaniaDetalle?.aplica_pronto_pago ?? undefined,
            observaciones: (((p as any)?.campaniaDetalle?.observaciones ?? '').toString().trim()),
            usuarioActualizacion: (((p as any)?.campaniaDetalle?.usuario_actualizacion ?? '').toString().trim()) || undefined,
            lineaNegocio: (((p as any)?.campaniaDetalle?.linea_negocio || (p as any)?.campaniaDetalle?.lineaNegocio || '').toString().trim()) || undefined,
            grupoPrograma: (((p as any)?.campaniaDetalle?.grupo_programa || (p as any)?.campaniaDetalle?.grupoPrograma || '').toString().trim()) || undefined,
            programa: (((p as any)?.campaniaDetalle?.programa ?? '').toString().trim()) || undefined,
            inicioVigencia: (((p as any)?.campaniaDetalle?.inicio_vigencia || (p as any)?.campaniaDetalle?.inicioVigencia || '').toString().trim()) || undefined,
            finVigencia: (((p as any)?.campaniaDetalle?.fin_vigencia || (p as any)?.campaniaDetalle?.finVigencia || '').toString().trim()) || undefined,
            estado: (p as any)?.campaniaDetalle?.estado ?? undefined,
          }]
        };
      })
      .filter(Boolean) as Array<{ idBenPrograma: number; campanias: any[] }>;

    const campaniasAGuardar = await this.campaniasPorGuardarEnEdicion(
      idBeneficiario,
      programasCampanias,
      idBenProgramaByPrograma,
      idCotizacionCampaniaByPrograma
    );
    if (campaniasAGuardar.length > 0) {
      const respCampanias = await firstValueFrom(this.networkingBeneficiary.guardarCampanias({
        idCotizacion,
        idBeneficiario,
        programas: campaniasAGuardar,
      }, !this.isEditMode));
      this.hydrateIdsCampaniaByProgramaDesdeRespuestaGuardar(
        respCampanias,
        idBenProgramaByPrograma,
        idCotizacionCampaniaByPrograma
      );
    }

    return {
      idBenProgramaByPrograma,
      idSubcuentaByPrograma,
      idCotizacionTarifaByPrograma,
      idCotizacionTarifaAnexoByPrograma,
      idCotizacionCampaniaByPrograma
    };
  }

  /**
   * Extrae código técnico de tarifa desde display "NOMBRE (CODIGO)" o valor ya limpio.
   * Evita mandar a guardarTarifas textos como "PREFERENTE CATEGORIA B Y C COLECTIVO (PREF0...)".
   */
  // Si en el programa quedó el nombre de la campaña, no se manda como código.
  private codigoCampaniaParaGuardar(p: any): string {
    const detalle = p?.campaniaDetalle || {};
    const candidatos = [
      detalle?.codigo_campania,
      detalle?.codCampComercial,
      p?.codigo_campania,
      p?.codCampComercial,
      p?.campana,
      p?.campania,
    ];
    for (const candidato of candidatos) {
      const codigo = this.normalizarCodigoCampaniaComercial(candidato);
      if (codigo) return codigo;
    }
    return '';
  }

  private normalizarCodigoCampaniaComercial(valor: any): string {
    const texto = (valor ?? '').toString().trim();
    if (!texto) return '';
    const conCodigo = texto.match(/^([A-Za-z0-9]+)\s*-\s+/);
    if (conCodigo?.[1] && !/\s/.test(conCodigo[1]) && conCodigo[1].length <= 15) {
      return conCodigo[1];
    }
    if (!/\s/.test(texto) && texto.length <= 15) return texto;
    return '';
  }

  private extraerCodigoTarifaLimpioParaPersistencia(...candidatos: Array<string | null | undefined>): string {
    for (const raw of candidatos) {
      const s = (raw ?? '').toString().trim();
      if (!s) continue;
      const m = s.match(/\(([^)]+)\)$/);
      if (m?.[1]) return m[1].trim();
      if (s.includes(' - ')) {
        const left = s.split(' - ')[0].trim();
        if (/^[A-Z0-9_-]+$/i.test(left)) return left;
      }
      if (/^[A-Z0-9_-]+$/i.test(s) && !s.includes(' ')) return s;
    }
    return '';
  }

  private valorTarifaParaGuardar(value: any): number | undefined {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : undefined;
  }

  private resolverCodigoTarifaPrograma(programa: any): string {
    const detalleRaw = (programa?.tarifaDetalle?.tari || '').toString().trim();
    const detalleCodigo = this.extraerCodigoTarifaLimpioParaPersistencia(detalleRaw);
    if (detalleCodigo && /^[A-Z0-9_-]+$/i.test(detalleRaw) && !detalleRaw.includes(' ')) {
      return detalleCodigo;
    }

    const esInclusion = localStorage.getItem('tipoSolicitud') === '2';
    if (esInclusion) {
      try {
        const raw = localStorage.getItem('programas_contratante_inclusiones');
        const lista = raw ? JSON.parse(raw) : [];
        const codigoPrograma = (programa?.programa || programa?.id || '').toString().trim().toUpperCase();
        const hit = (Array.isArray(lista) ? lista : []).find((item: any) =>
          (item?.programa || item?.codigo_plan || item?.id || '').toString().trim().toUpperCase() === codigoPrograma
        );
        const codigoCatalogo = this.extraerCodigoTarifaLimpioParaPersistencia(
          hit?.__tarifaInclusionOriginal,
          hit?.tarifaCodigo,
          hit?.tarifaDetalle?.tari
        );
        if (codigoCatalogo) return codigoCatalogo;
      } catch {
        // Se utiliza el valor almacenado en el programa.
      }
    }

    return this.extraerCodigoTarifaLimpioParaPersistencia(
      programa?.tarifaCodigo,
      programa?.__tarifaCodigoLimpio,
      detalleRaw,
      programa?.tarifa
    );
  }

  private async actualizarTarifasBeneficiarioAntesDeGuardar(
    programas: ProgramaItemStore[],
    datos: DatosBeneficiarioLocal
  ): Promise<void> {
    const esInclusion = localStorage.getItem('tipoSolicitud') === '2';
    if (!esInclusion && this.esFlujoColectivoOAfinidad()) return;

    await Promise.all((programas || []).map(async (programa: any) => {
      const codigoPrograma = (programa?.programa || programa?.id || '').toString().trim().toUpperCase();
      const codigoTarifa = this.resolverCodigoTarifaPrograma(programa);
      const linea = (programa?.lineaNegocio || '').toString().trim().toUpperCase();
      const lineaNumero = linea === 'MI' || linea === 'SMP' || linea === '1'
        ? 1
        : linea === 'SO' || linea === 'SAO' || linea === '2'
          ? 2
          : linea === 'CEM' || linea === '3'
            ? 3
            : 0;
      if (!codigoPrograma || !codigoTarifa || !lineaNumero) {
        throw new Error(`No se pudo resolver la tarifa del programa ${codigoPrograma || 'desconocido'}.`);
      }

      const cuenta = (() => {
        if (!esInclusion) {
          return Number(programa?.cuenta || programa?.__cuentaFromColectivo || 1) || 1;
        }
        const plan = (this.formInit?.get('tipoPlan')?.value || localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
        return plan === 'A' || plan === 'AS' ? 1 : 2;
      })();
      const subcuenta = (
        programa?.subcta
        || programa?.__subctaCodeSeleccionada
        || programa?.codigoSubcuenta
        || programa?.subcuenta
        || ''
      ).toString().trim();
      const genero = (datos?.genero || '').toString().trim().toUpperCase();
      const sexo = genero === '1' || genero.startsWith('F') ? 'F' : genero === '2' || genero.startsWith('M') ? 'M' : (genero || 'A');
      const cantidad = this.contarIntegrantesPrograma(codigoPrograma);
      const payload: IDataTarifa = {
        cuenta,
        modelo_negocio: [{ subcuenta, linea_negocio: lineaNumero, programa: [codigoPrograma] }],
        prm_tari: codigoTarifa,
        prm_edad: (datos?.edad || '').toString(),
        prm_fecha: '',
        vigen_desde: '',
        prm_paren: (datos?.parentesco || 'T').toString().trim() || 'T',
        prm_sexo: sexo,
        prm_inte_tipo: 'I',
        cant_inte: esInclusion ? String(cantidad) : ''
      };

      let respuesta = await firstValueFrom(this.networkingBeneficiary.bucarTarifas(payload, esInclusion));
      let tarifa = this.seleccionarTarifaRespuesta(respuesta, codigoTarifa);
      const tariTipo = String((tarifa as any)?.tariTipo || (tarifa as any)?.tari_tipo || programa?.tariTipo || programa?.tarifaDetalle?.tariTipo || '').trim().toUpperCase();
      if (tariTipo === 'I' && !payload.cant_inte) {
        respuesta = await firstValueFrom(this.networkingBeneficiary.bucarTarifas({ ...payload, cant_inte: String(cantidad) }, esInclusion));
        tarifa = this.seleccionarTarifaRespuesta(respuesta, codigoTarifa);
      }
      if (!tarifa) throw new Error(`No se encontró la tarifa ${codigoTarifa} para ${codigoPrograma}.`);

      const codigoFinal = this.extraerCodigoTarifaRespuesta(tarifa) || codigoTarifa;
      const valorBase = this.valorTarifaParaGuardar((tarifa as any)?.valorMensualBase ?? (tarifa as any)?.valor);
      const valorIva = this.valorTarifaParaGuardar((tarifa as any)?.valorMensualIva ?? (tarifa as any)?.valor_iva ?? (tarifa as any)?.valor ?? valorBase);
      programa.tarifa = codigoFinal;
      programa.tarifaCodigo = codigoFinal;
      programa.valorMensualBase = valorBase;
      programa.valorMensualIva = valorIva;
      programa.tarifaDetalle = {
        ...(programa.tarifaDetalle || {}),
        tari: codigoFinal,
        valorMensualBase: valorBase,
        valorMensualIva: valorIva,
        porcentajeIva: this.valorTarifaParaGuardar((tarifa as any)?.porcentajeIva),
        tariTipo: tariTipo || programa.tarifaDetalle?.tariTipo,
        fueSeleccionada: true,
        esAnexo: false
      };
    }));
  }

  private seleccionarTarifaRespuesta(lista: any, codigo: string): any | null {
    const codigoNormalizado = (codigo || '').toString().trim().toUpperCase();
    if (!codigoNormalizado || !Array.isArray(lista)) return null;
    return lista.find((item: any) => this.extraerCodigoTarifaRespuesta(item).toUpperCase() === codigoNormalizado) || null;
  }

  private extraerCodigoTarifaRespuesta(item: any): string {
    const raw = (item?.tari || item?.TARI || item?.tarifa_codigo || item?.tarifa || '').toString().trim();
    const parentesis = raw.match(/\(([^)]+)\)$/);
    if (parentesis?.[1]) return parentesis[1].trim();
    return raw.includes(' - ') ? raw.split(' - ')[0].trim() : raw;
  }

  private contarIntegrantesPrograma(codigoPrograma: string): number {
    const codigo = codigoPrograma.toString().trim().toUpperCase();
    let cantidad = 0;
    const contratante = this.obtenerProgramasContratanteDesdeStorage();
    if (contratante.some((programa: any) => (programa?.programa || programa?.id || '').toString().trim().toUpperCase() === codigo)) cantidad++;
    this.beneficiarioLocalStorage.cargarProgramas().forEach((envelope: any) => {
      const programas = Array.isArray(envelope?.programas) ? envelope.programas : [];
      if (programas.some((programa: any) => (programa?.programa || programa?.id || '').toString().trim().toUpperCase() === codigo)) cantidad++;
    });
    return Math.max(cantidad, 1);
  }

  private marcarIdBeneficiarioEnTablaLocal(
    idBeneficiario: number,
    match: { localId: string; tipo: string; numero: string; parentesco: string }
  ): void {
    try {
      if (!(idBeneficiario > 0) || !Array.isArray(this.datasBeneficiary)) return;
      const localId = (match.localId || '').toString().trim();
      const tipo = (match.tipo || '').toString().trim().toUpperCase();
      const numero = (match.numero || '').toString().trim();
      const parentesco = (match.parentesco || '').toString().trim().toUpperCase();

      let changed = false;
      for (const b of this.datasBeneficiary) {
        const sameLocal = localId && (b as any)?.localId?.toString().trim() === localId;
        const sameDoc =
          this._norm2((b as any)?.num_documento) === this._norm2(numero)
          && this._norm2((b as any)?.tipo_documento) === this._norm2(tipo)
          && this._norm2((b as any)?.parentesco_id) === this._norm2(parentesco);
        if (!sameLocal && !sameDoc) continue;
        (b as any).id_beneficiario = idBeneficiario;
        (b as any).idBeneficiario = idBeneficiario;
        changed = true;
      }
      if (changed) {
        this.datasBeneficiary = [...this.datasBeneficiary];
        this.updateTableBeneficiary();
      }
    } catch {
      // no-op
    }
  }

  private marcarIdsCadenaEnTablaLocal(
    match: { localId: string; tipo: string; numero: string; parentesco: string },
    idBeneficiario: number,
    idsPorPrograma: Record<string, {
      idBenPrograma?: number;
      idSubcuenta?: number;
      idCotizacionTarifa?: number;
      idCotizacionTarifaAnexo?: number;
      idCotizacionCampania?: number;
    }>
  ): void {
    try {
      if (!Array.isArray(this.datasBeneficiary)) return;
      const localId = (match.localId || '').toString().trim();
      const tipo = (match.tipo || '').toString().trim().toUpperCase();
      const numero = (match.numero || '').toString().trim();
      const parentesco = (match.parentesco || '').toString().trim().toUpperCase();

      let changed = false;
      for (const b of this.datasBeneficiary) {
        const sameLocal = localId && (b as any)?.localId?.toString().trim() === localId;
        const sameDoc =
          this._norm2((b as any)?.num_documento) === this._norm2(numero)
          && this._norm2((b as any)?.tipo_documento) === this._norm2(tipo)
          && this._norm2((b as any)?.parentesco_id) === this._norm2(parentesco);
        if (!sameLocal && !sameDoc) continue;

        (b as any).id_beneficiario = idBeneficiario;
        (b as any).idBeneficiario = idBeneficiario;
        const cfgProgramas = Array.isArray((b as any)?.programasConfig?.programas)
          ? (b as any).programasConfig.programas
          : [];
        cfgProgramas.forEach((p: any) => {
          const ids = this.resolverIdsProgramaDesdeMapa(idsPorPrograma, p);
          if (!ids) return;
          if (Number(ids.idBenPrograma || 0) > 0) {
            p.idBenPrograma = ids.idBenPrograma;
            p.__idBenPrograma = ids.idBenPrograma;
          }
          if (Number(ids.idSubcuenta || 0) > 0) {
            p.idSubcuenta = ids.idSubcuenta;
            p.__idSubcuenta = ids.idSubcuenta;
          }
          if (Number(ids.idCotizacionTarifa || 0) > 0) {
            p.idCotizacionTarifa = ids.idCotizacionTarifa;
            p.__idCotizacionTarifa = ids.idCotizacionTarifa;
          }
          if (Number(ids.idCotizacionTarifaAnexo || 0) > 0) {
            p.idCotizacionTarifaAnexo = ids.idCotizacionTarifaAnexo;
            p.__idCotizacionTarifaAnexo = ids.idCotizacionTarifaAnexo;
          }
          if (Number(ids.idCotizacionCampania || 0) > 0) {
            p.idCotizacionCampania = ids.idCotizacionCampania;
            p.__idCotizacionCampania = ids.idCotizacionCampania;
          }
          p.guardadoEnBd = true;
        });
        changed = true;
      }
      if (changed) {
        this.datasBeneficiary = [...this.datasBeneficiary];
        this.updateTableBeneficiary();
      }
    } catch {
      // no-op
    }
  }

  private clavesProgramaPersistencia(p: any): string[] {
    const raw = [
      p?.programa,
      p?.id,
      p?.nombrePrograma,
      p?.nombre,
      (p?.id || '').toString().split('|')[0],
      (p?.id || '').toString().split('-').pop()
    ];
    const uniq = new Set<string>();
    raw.forEach((v) => {
      const n = this._norm2(v);
      if (n) uniq.add(n);
    });
    return Array.from(uniq);
  }

  private resolverIdsProgramaDesdeMapa(
    idsPorPrograma: Record<string, {
      idBenPrograma?: number;
      idSubcuenta?: number;
      idCotizacionTarifa?: number;
      idCotizacionTarifaAnexo?: number;
      idCotizacionCampania?: number;
    }>,
    p: any
  ) {
    for (const clave of this.clavesProgramaPersistencia(p)) {
      if (idsPorPrograma[clave]) return idsPorPrograma[clave];
    }
    return null;
  }

  private buscarIdBeneficiarioEnTablaLocal(
    match: { localId: string; tipo: string; numero: string; parentesco: string }
  ): number {
    try {
      if (!Array.isArray(this.datasBeneficiary)) return 0;
      const localId = (match.localId || '').toString().trim();
      const tipo = (match.tipo || '').toString().trim().toUpperCase();
      const numero = (match.numero || '').toString().trim();
      const parentesco = (match.parentesco || '').toString().trim().toUpperCase();

      for (const b of this.datasBeneficiary) {
        const sameLocal = localId && (b as any)?.localId?.toString().trim() === localId;
        const sameDoc =
          this._norm2((b as any)?.num_documento) === this._norm2(numero)
          && this._norm2((b as any)?.tipo_documento) === this._norm2(tipo)
          && this._norm2((b as any)?.parentesco_id) === this._norm2(parentesco);
        if (!sameLocal && !sameDoc) continue;
        const id = Number((b as any)?.id_beneficiario ?? (b as any)?.idBeneficiario ?? 0);
        if (Number.isFinite(id) && id > 0) return id;
      }
    } catch {
      // no-op
    }
    return 0;
  }

  private retirarCotizacionLocalSiYaNoEsta(idCotizacion: number, error: any): void {
    const texto = (
      error?.message
      || error?.errorMessage
      || error?.error?.message
      || error?.error?.errorMessage
      || ''
    ).toString().toUpperCase();
    const yaNoEsta = texto.includes('NO EXISTE')
      || texto.includes('NO ENCONTR');
    if (!yaNoEsta || !(Number(idCotizacion) > 0)) return;

    ['cotizacion_creada_desde_contratante', 'cotizacion_precargada', 'cotizacion_cargada'].forEach((key) => {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        const enRaiz = Number(parsed?.idCotizacion || 0);
        const enData = Number(parsed?.data?.idCotizacion || 0);
        const id = enRaiz > 0 ? enRaiz : enData;
        if (id === Number(idCotizacion) || enData === Number(idCotizacion) || enRaiz === Number(idCotizacion)) {
          localStorage.removeItem(key);
        }
      } catch {
        // no-op
      }
    });
    if (Number(this.numeroCotizacion || 0) === Number(idCotizacion)) {
      this.numeroCotizacion = '';
    }
    if (Number(this.idCotizacionEdicion || 0) === Number(idCotizacion)) {
      this.idCotizacionEdicion = null;
    }
  }

  private obtenerIdCotizacionActivaParaFlecha(): number {
    if (this.isEditMode) {
      try {
        const rawCargada = localStorage.getItem('cotizacion_cargada');
        if (rawCargada) {
          const parsed = JSON.parse(rawCargada);
          const id = Number(parsed?.idCotizacion || 0);
          if (Number.isFinite(id) && id > 0) return id;
        }
      } catch {
        // no-op
      }
      const idEdicion = Number(this.idCotizacionEdicion || 0);
      if (Number.isFinite(idEdicion) && idEdicion > 0) return idEdicion;
    }

    const creada = this.leerIdCotizacionGuardadaEnNavegador();
    if (creada > 0) return creada;

    const precargada = this.leerIdCotizacionPrecargada();
    if (precargada > 0) return precargada;

    const programas = this.leerIdCotizacionProgramasContratante();
    if (programas > 0) return programas;

    const enPantalla = Number(this.numeroCotizacion || 0);
    return Number.isFinite(enPantalla) && enPantalla > 0 ? enPantalla : 0;
  }

  // La cotización de esta visita queda en la raíz. data a veces se queda con la anterior.
  private leerIdCotizacionGuardadaEnNavegador(): number {
    try {
      const rawCreada = localStorage.getItem('cotizacion_creada_desde_contratante');
      if (!rawCreada) return 0;
      const parsed = JSON.parse(rawCreada);
      const enRaiz = Number(parsed?.idCotizacion || 0);
      const enData = Number(parsed?.data?.idCotizacion || 0);
      if (Number.isFinite(enRaiz) && enRaiz > 0) return enRaiz;
      return Number.isFinite(enData) && enData > 0 ? enData : 0;
    } catch {
      return 0;
    }
  }

  private leerIdCotizacionPrecargada(): number {
    try {
      const rawPrecargada = localStorage.getItem('cotizacion_precargada');
      if (!rawPrecargada) return 0;
      const parsed = JSON.parse(rawPrecargada);
      const id = Number(parsed?.idCotizacion || 0);
      return Number.isFinite(id) && id > 0 ? id : 0;
    } catch {
      return 0;
    }
  }

  private leerIdCotizacionProgramasContratante(): number {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      if (!raw) return 0;
      const parsed = JSON.parse(raw);
      if (!parsed || Array.isArray(parsed)) return 0;
      const id = Number(parsed?.idCotizacion || 0);
      return Number.isFinite(id) && id > 0 ? id : 0;
    } catch {
      return 0;
    }
  }

  // Iguala raíz y data. Si no, el guardar del beneficiario vuelve a mandar la cotización vieja.
  private alinearCotizacionCreada(idVigente: number): void {
    if (!(Number(idVigente) > 0)) return;
    try {
      const raw = localStorage.getItem('cotizacion_creada_desde_contratante');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      const enRaiz = Number(parsed?.idCotizacion || 0);
      const enData = Number(parsed?.data?.idCotizacion || 0);
      if (enRaiz === Number(idVigente) && enData === Number(idVigente)) return;
      parsed.idCotizacion = Number(idVigente);
      if (parsed?.data && typeof parsed.data === 'object') {
        parsed.data.idCotizacion = Number(idVigente);
      }
      localStorage.setItem('cotizacion_creada_desde_contratante', JSON.stringify(parsed));
    } catch {
      // no-op
    }
  }

  private async guardarDatosBeneficiarioContratanteConRecuperacionDuplicado(
    beneficiarioPayload: Beneficiarios,
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    datos: ContratanteStorageData
  ): Promise<any> {
    let firstAttempt: { response?: any; error?: any; };
    try {
      firstAttempt = {
        response: await firstValueFrom(this.networkingBeneficiary.guardarDatosBeneficiarios(beneficiarioPayload))
      };
    } catch (error: any) {
      firstAttempt = { error };
    }

    if (!this.esRespuestaDuplicadoBeneficiario(firstAttempt.response, firstAttempt.error)) {
      if (this.esRespuestaFallidaBeneficiario(firstAttempt.response, firstAttempt.error)) {
        throw this.buildBeneficiarioPersistError(firstAttempt.response, firstAttempt.error);
      }
      return firstAttempt.response;
    }

    const esFlujoInclusion = this.esInclusion || (localStorage.getItem('tipoSolicitud') === '2');
    // Inclusión y edición: si ya existe, se reusa el id (sin borrar y volver a crear).
    if (esFlujoInclusion || this.debePreservarDatosBeneficiarioPorFkLiquidacion()) {
      let recoveredId =
        this.extractIdBeneficiarioFromResponse(firstAttempt.response)
        || this.extractIdBeneficiarioFromResponse(this.normalizarPayloadRespuestaBeneficiario(firstAttempt.response, firstAttempt.error))
        || this.resolverIdBeneficiarioContratantePersistido(filasContratante, programas, datos)
        || this.resolverIdBeneficiarioDuplicadoDesdeMemoria(beneficiarioPayload);

      if (!(recoveredId > 0)) {
        const idCot = Number(
          (beneficiarioPayload as any)?.id_cotizacion
          || (beneficiarioPayload as any)?.idCotizacion
          || this.obtenerIdCotizacionActivaParaFlecha()
          || 0
        );
        recoveredId = await this.resolverIdBeneficiarioTitularInclusionDesdeEdit(idCot, beneficiarioPayload);
      }

      if (recoveredId > 0) {
        if (esFlujoInclusion) {
          this.hidratarIdBeneficiarioTitularInclusion(recoveredId);
        }
        return {
          status: true,
          message: 'Beneficiario existente reutilizado',
          data: { idBeneficiario: recoveredId },
        };
      }

      throw this.buildBeneficiarioPersistError(firstAttempt.response, firstAttempt.error);
    }

    await this.eliminarCadenaContratantePersistida(filasContratante, programas, datos);

    let response: any;
    try {
      response = await firstValueFrom(this.networkingBeneficiary.guardarDatosBeneficiarios(beneficiarioPayload));
    } catch (error: any) {
      throw this.buildBeneficiarioPersistError(null, error);
    }

    if (this.esRespuestaFallidaBeneficiario(response, null)) {
      throw this.buildBeneficiarioPersistError(response, null);
    }

    return response;
  }

  /** Si el mismo plan llegó como familiar y como colectivo, se queda el de Afilmed. */
  private dejarUnSoloPlanAfinidad(items: Array<{ programa: string }>): void {
    const codigos = new Set(
      (items || []).map((item) => (item?.programa || '').toString().trim().toUpperCase()).filter(Boolean)
    );
    const quitar = new Set<string>();
    codigos.forEach((codigo) => {
      if (!codigo.endsWith('C')) return;
      const hayFamiliar = Array.from(codigos).some((otro) =>
        (otro.endsWith('F') || otro.endsWith('A')) && `${otro.slice(0, -1)}C` === codigo
      );
      if (hayFamiliar) quitar.add(codigo);
    });

    const vistos = new Set<string>();
    for (let i = items.length - 1; i >= 0; i--) {
      const codigo = (items[i]?.programa || '').toString().trim().toUpperCase();
      if (!codigo || quitar.has(codigo) || vistos.has(codigo)) {
        items.splice(i, 1);
        continue;
      }
      vistos.add(codigo);
    }
  }

  /**
   * Programas del titular para el switch del beneficiario.
   * No escribe localStorage: en edición la sesión vacía no debe reemplazar lo que trajo la cotización.
   */
  private programasContratanteParaSwitchBeneficiario(): any[] {
    const titular = (this.datasBeneficiary || []).find((b: any) =>
      b?.es_contratante === true ||
      (b?.parentesco_id || '').toString().trim().toUpperCase() === 'T' ||
      (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR'
    );
    const progsRaw = (titular as any)?.programasConfig?.programas || (titular as any)?.programas || [];
    const desdeTitular = Array.isArray(progsRaw)
      ? progsRaw
          .map((p: any) => this.mapearProgramaContratanteSinIdsPersistencia(p))
          .filter((p: any) => !!p?.programa)
      : [];
    if (desdeTitular.length > 0) {
      return desdeTitular;
    }
    return this.obtenerProgramasContratanteDesdeStorage();
  }

  /** Clona programa del titular para switch Inclusión sin IDs de persistencia BD. */
  private mapearProgramaContratanteSinIdsPersistencia(p: any): any {
    const mapped: any = {
      ...(p || {}),
      id: ((p?.id || p?.programa || '') as any).toString().trim().toUpperCase(),
      programa: ((p?.programa || p?.id || '') as any).toString().trim().toUpperCase(),
      lineaNegocio: (p?.lineaNegocio || p?.linea_negocio || ''),
      tarifa: (p?.tarifa || ''),
      guardadoEnBd: false,
    };

    const keysToStrip = [
      'idBenPrograma', '__idBenPrograma', 'id_ben_programa',
      'idSubcuenta', '__idSubcuenta', 'id_subcuenta', 'idBenSubcuenta', 'id_ben_subcuenta',
      'idCotizacionTarifa', '__idCotizacionTarifa', 'id_cotizacion_tarifa',
      'idCotizacionTarifaAnexo', '__idCotizacionTarifaAnexo', 'id_cotizacion_tarifa_anexo',
      'idCotizacionCampania', '__idCotizacionCampania', 'id_cotizacion_campania',
      'idBenCampania', '__idBenCampania', 'id_ben_campania',
      'idBeneficiario', 'id_beneficiario',
    ];
    for (const key of keysToStrip) {
      if (key in mapped) {
        delete mapped[key];
      }
    }
    return mapped;
  }

  /** Lookup local del idBeneficiario ante anti-dup (backend hoy responde data:null). */
  private resolverIdBeneficiarioDuplicadoDesdeMemoria(payload: Beneficiarios): number {
    const tipo = ((payload as any)?.tipo_documento || (payload as any)?.tipoDocumento || '').toString().trim().toUpperCase();
    const num = ((payload as any)?.num_documento || (payload as any)?.numeroDocumento || '').toString().trim();
    const parentesco = ((payload as any)?.parentesco_id || (payload as any)?.parentescoId || 'T').toString().trim().toUpperCase();
    if (!num) return 0;

    const coincide = (b: any): boolean => {
      if (!b) return false;
      const bNum = (b?.num_documento || b?.numeroDocumento || b?.documento || '').toString().trim();
      if (!bNum || bNum !== num) return false;
      const bTipo = (b?.tipo_documento || b?.tipoDocumento || '').toString().trim().toUpperCase();
      if (tipo && bTipo && bTipo !== tipo) return false;
      const bPar = (b?.parentesco_id || b?.parentescoId || '').toString().trim().toUpperCase();
      const esTitularMem =
        b?.es_contratante === true
        || b?.es_contratante === 'S'
        || bPar === 'T'
        || (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR';
      if (parentesco === 'T') return esTitularMem || !bPar || bPar === 'T';
      return !bPar || bPar === parentesco;
    };

    for (const b of (this.datasBeneficiary || [])) {
      if (!coincide(b)) continue;
      const id = Number((b as any)?.id_beneficiario || (b as any)?.idBeneficiario || (b as any)?.idBeneficiarioGuardado || 0);
      if (id > 0) return id;
    }

    const filas = (this.datasSourceBeneficiary?.data || this.obtenerFilasContratanteTabla() || []) as any[];
    for (const row of filas) {
      if (!coincide(row) && !coincide(row?._edicionItem)) continue;
      const id = Number(
        row?.id_beneficiario
        || row?.idBeneficiario
        || row?.idBeneficiarioGuardado
        || row?._edicionItem?.idBeneficiario
        || row?._edicionItem?.id_beneficiario
        || 0
      );
      if (id > 0) return id;
    }

    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (raw) {
        const parsed = JSON.parse(raw);
        const lsNum = (parsed?.numeroDocumento || '').toString().trim();
        const lsTipo = (parsed?.tipoDocumento || '').toString().trim().toUpperCase();
        if (lsNum === num && (!tipo || !lsTipo || lsTipo === tipo)) {
          const id = Number(parsed?.idBeneficiario || parsed?.id_beneficiario_guardado || 0);
          if (id > 0) return id;
        }
      }
    } catch {
      // no-op
    }

    // Inclusión escribe array plano (sin envelope): leer id raw sin exigir persistenciaVigente.
    try {
      const rawProg = localStorage.getItem('programas_contratante');
      if (rawProg) {
        const parsed = JSON.parse(rawProg);
        const list = Array.isArray(parsed) ? parsed : (Array.isArray(parsed?.programas) ? parsed.programas : []);
        for (const p of list) {
          const id = Number((p as any)?.idBeneficiario || (p as any)?.id_beneficiario || 0);
          if (id > 0) return id;
        }
      }
    } catch {
      // no-op
    }

    return 0;
  }

  /**
   * Inclusión-only: resuelve idBeneficiario del titular vía GET /edit cuando LS/memoria no lo tienen.
   * No DELETE. VN no llama este helper.
   */
  private async resolverIdBeneficiarioTitularInclusionDesdeEdit(
    idCotizacion: number,
    payload: Beneficiarios
  ): Promise<number> {
    const esFlujoInclusion = this.esInclusion || (localStorage.getItem('tipoSolicitud') === '2');
    if (!esFlujoInclusion || !(Number(idCotizacion || 0) > 0)) {
      return 0;
    }

    const tipo = ((payload as any)?.tipo_documento || (payload as any)?.tipoDocumento || '').toString().trim().toUpperCase();
    const num = ((payload as any)?.num_documento || (payload as any)?.numeroDocumento || '').toString().trim();

    try {
      const edit = await firstValueFrom(this.networkingMisCot.refreshBeneficiariosEdicion(idCotizacion));
      const list = edit?.data?.beneficiarios || [];
      const titular = list.find((b: any) => {
        const bNum = (b?.numDocumento || b?.num_documento || b?.numeroDocumento || '').toString().trim();
        const bTipo = (b?.tipoDocumento || b?.tipo_documento || '').toString().trim().toUpperCase();
        const esTit =
          b?.parentescoId === 'T'
          || b?.parentesco_id === 'T'
          || b?.esContratante === 'S'
          || b?.es_contratante === 'S'
          || b?.esContratante === true
          || b?.es_contratante === true;
        if (!esTit) return false;
        if (num && bNum && bNum !== num) return false;
        if (tipo && bTipo && bTipo !== tipo) return false;
        return true;
      });
      const id = Number(titular?.idBeneficiario || (titular as any)?.id_beneficiario || 0);
      if (id > 0) {
        console.log('[Inclusion-Dup-Recovery][Edit] Titular encontrado en GET /edit:', id);
      }
      return id > 0 ? id : 0;
    } catch (err) {
      console.warn('[Inclusion-Dup-Recovery][Edit] No se pudo resolver titular vía /edit:', err);
      return 0;
    }
  }

  /** Persiste id del titular en LS + memoria para siguientes Continuar (solo Inclusión recovery). */
  private hidratarIdBeneficiarioTitularInclusion(idBeneficiario: number): void {
    if (!(Number(idBeneficiario || 0) > 0)) return;

    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      const parsed = raw ? JSON.parse(raw) : {};
      parsed.idBeneficiario = idBeneficiario;
      parsed.id_beneficiario_guardado = idBeneficiario;
      localStorage.setItem('datosRQ002_Contratante', JSON.stringify(parsed));
    } catch {
      // no-op
    }

    const marcarTitular = (b: any): void => {
      if (!b) return;
      const bPar = (b?.parentesco_id || b?.parentescoId || '').toString().trim().toUpperCase();
      const esTit =
        b?.es_contratante === true
        || b?.es_contratante === 'S'
        || bPar === 'T'
        || (b?.typeDescripcion || '').toString().trim().toUpperCase() === 'TITULAR';
      if (!esTit) return;
      b.id_beneficiario = idBeneficiario;
      b.idBeneficiario = idBeneficiario;
      b.id_beneficiario_guardado = idBeneficiario;
    };

    (this.datasBeneficiary || []).forEach(marcarTitular);
    ((this.datasSourceBeneficiary?.data || []) as any[]).forEach(marcarTitular);
  }

  private normalizarPayloadRespuestaBeneficiario(response?: any, error?: any): any {
    return error?.error || error || response || null;
  }

  private esRespuestaFallidaBeneficiario(response?: any, error?: any): boolean {
    const payload = this.normalizarPayloadRespuestaBeneficiario(response, error);
    return payload?.status === false || !!error;
  }

  private esRespuestaDuplicadoBeneficiario(response?: any, error?: any): boolean {
    const payload = this.normalizarPayloadRespuestaBeneficiario(response, error);
    const message = (payload?.errorMessage || payload?.message || error?.message || '').toString().toUpperCase();
    return (
      payload?.status === false
      || !!error
    ) && (
        message.includes('DUPLICADO')
        || message.includes('YA EXISTE')
        || message.includes('(IDCOTIZACION, PARENTESCOID, TIPODOCUMENTO, NUMDOCUMENTO)')
      );
  }

  private buildBeneficiarioPersistError(response?: any, error?: any): Error {
    const payload = this.normalizarPayloadRespuestaBeneficiario(response, error);
    const message = (
      payload?.errorMessage
      || payload?.message
      || error?.error?.message
      || error?.message
      || 'No fue posible persistir los datos del beneficiario.'
    ).toString();
    return new Error(message);
  }

  private tienePersistenciaContratanteGuardada(
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    datos: ContratanteStorageData
  ): boolean {
    const idCotizacionActiva = this.obtenerIdCotizacionActivaParaFlecha();
    if (!this.existeSnapshotGuardadoFlechaParaCotizacion(idCotizacionActiva)) {
      return false;
    }

    const idBeneficiario = this.resolverIdBeneficiarioContratantePersistido(filasContratante, programas, datos);
    if (idBeneficiario > 0 && (programas || []).some((programa) => (programa as any)?.guardadoEnBd === true || Number((programa as any)?.idBenPrograma || 0) > 0)) {
      return true;
    }

    return (programas || []).some((programa) => {
      return (programa as any)?.guardadoEnBd === true
        || Number((programa as any)?.idBenPrograma || 0) > 0
        || Number((programa as any)?.idSubcuenta || 0) > 0
        || Number((programa as any)?.idCotizacionTarifa || 0) > 0
        || Number((programa as any)?.idCotizacionTarifaAnexo || 0) > 0
        || Number((programa as any)?.idCotizacionCampania || 0) > 0
        || Number((programa as any)?.idBenCampania || 0) > 0;
    });
  }

  private existeSnapshotGuardadoFlechaParaCotizacion(idCotizacion: number): boolean {
    if (!(Number(idCotizacion || 0) > 0)) return false;
    const snapshot = this.obtenerSnapshotFlechaGuardado();
    if (!snapshot) return false;

    try {
      const parsed = JSON.parse(snapshot || '{}');
      return Number(parsed?.idCotizacion || 0) === Number(idCotizacion);
    } catch {
      return false;
    }
  }

  // En edición la flecha no reemplaza todos los programas del beneficiario.
  // El que sigue en pantalla se deja. El que ya no está se borra (campaña, tarifa, subcuenta y programa).
  // El que no existe se agrega después, en el guardado.
  private async alinearProgramasEdicionConPantalla(
    idCotizacion: number,
    idBeneficiario: number,
    codigosDeseados: string[]
  ): Promise<Map<string, number>> {
    const conservar = new Map<string, number>();
    if (!this.isEditMode || !(idBeneficiario > 0) || !(idCotizacion > 0)) {
      return conservar;
    }

    const deseados = new Set(
      (codigosDeseados || [])
        .map((codigo) => (codigo || '').toString().trim().toUpperCase())
        .filter(Boolean)
    );
    if (!deseados.size) {
      return conservar;
    }

    const porCodigo = new Map<string, ReturnType<CotizadorComponent['filasProgramaBdEdicion']>>();
    for (const fila of this.filasProgramaBdEdicion(idBeneficiario)) {
      const lista = porCodigo.get(fila.codigo) || [];
      lista.push(fila);
      porCodigo.set(fila.codigo, lista);
    }

    const planes: BeneficiaryDeletePlan[] = [];
    porCodigo.forEach((lista, codigo) => {
      const ordenadas = [...lista].sort((a, b) => a.idBenPrograma - b.idBenPrograma);
      if (deseados.has(codigo)) {
        conservar.set(codigo, ordenadas[0].idBenPrograma);
        ordenadas.slice(1).forEach((extra) => {
          planes.push(this.planDeleteDesdeFilaPrograma(idBeneficiario, extra));
        });
        return;
      }
      ordenadas.forEach((fila) => {
        planes.push(this.planDeleteDesdeFilaPrograma(idBeneficiario, fila));
      });
    });

    for (const codigo of deseados) {
      if (conservar.has(codigo)) continue;
      try {
        const resp = await firstValueFrom(this.networkingBeneficiary.consultarBeneficiarioPrograma({
          idCotizacion,
          idBeneficiario,
          programa: codigo,
        }));
        const idBenPrograma = this.extractIdBenProgramaFromResponse(resp);
        if (idBenPrograma > 0) {
          conservar.set(codigo, idBenPrograma);
        }
      } catch (err: any) {
        if (!this.consultarProgramaIndicaAusente(err) && Number(err?.status) !== 404) {
          console.warn('[edicion-programas] no se pudo consultar el programa', codigo, err);
        }
      }
    }

    if (planes.length) {
      await this.ejecutarCascadaDeletePlanesBeneficiario(planes, false, 'edicion-programas');
      this.quitarProgramasBorradosDeEdicionEnMemoria(
        idBeneficiario,
        planes.map((plan) => plan.idBenPrograma)
      );
    }

    return conservar;
  }

  private filasProgramaBdEdicion(idBeneficiario: number): Array<{
    codigo: string;
    idBenPrograma: number;
    idSubcuenta: number;
    idCotizacionTarifa: number;
    idCotizacionTarifaAnexo: number;
    idCotizacionCampania: number;
  }> {
    const fuentes: any[] = [];
    const data = this.cotizacionEdicionData || this._cotizacionEdicionDataLatest;
    const beneficiarios = Array.isArray((data as any)?.beneficiarios) ? (data as any).beneficiarios : [];
    const item = beneficiarios.find((b: any) => Number(b?.idBeneficiario || 0) === Number(idBeneficiario));
    if (item) fuentes.push(item);

    const filaTabla = (this.dataBeneficiary || []).find((b: any) =>
      Number(b?.idBeneficiario || b?.id_beneficiario || 0) === Number(idBeneficiario)
    );
    const edicionItem = (filaTabla as any)?._edicionItem;
    if (edicionItem && edicionItem !== item) fuentes.push(edicionItem);

    const vistos = new Set<number>();
    const filas: Array<{
      codigo: string;
      idBenPrograma: number;
      idSubcuenta: number;
      idCotizacionTarifa: number;
      idCotizacionTarifaAnexo: number;
      idCotizacionCampania: number;
    }> = [];

    const esTarifaAnexo = (tarifa: any): boolean => {
      const value = tarifa?.esAnexo ?? tarifa?.es_anexo;
      const normalizado = (value ?? '').toString().trim().toUpperCase();
      return value === true || ['S', 'SI', 'Y', 'TRUE', '1'].includes(normalizado);
    };

    for (const fuente of fuentes) {
      const programas = Array.isArray(fuente?.programas) ? fuente.programas : [];
      for (const programa of programas) {
        const codigo = (
          programa?.programa || programa?.planCodi || programa?.codigo || programa?.id || ''
        ).toString().trim().toUpperCase();
        const idBenPrograma = Number(programa?.idBenPrograma || programa?.id_ben_programa || 0);
        if (!codigo || !(idBenPrograma > 0) || vistos.has(idBenPrograma)) continue;
        vistos.add(idBenPrograma);

        const tarifas = Array.isArray(programa?.tarifas) ? programa.tarifas : [];
        const campanias = Array.isArray(programa?.campanias) ? programa.campanias : [];
        const tarifaBase = tarifas.find((tarifa: any) => !esTarifaAnexo(tarifa)) || tarifas[0];
        const tarifaAnexo = tarifas.find((tarifa: any) => esTarifaAnexo(tarifa));
        const campania = campanias[0];

        filas.push({
          codigo,
          idBenPrograma,
          idSubcuenta: Number(programa?.idSubcuenta || programa?.id_subcuenta || 0),
          idCotizacionTarifa: Number(tarifaBase?.idCotizacionTarifa || tarifaBase?.id_cotizacion_tarifa || 0),
          idCotizacionTarifaAnexo: Number(tarifaAnexo?.idCotizacionTarifa || tarifaAnexo?.id_cotizacion_tarifa || 0),
          idCotizacionCampania: Number(
            campania?.idCotizacionCampania
            || campania?.id_cotizacion_campania
            || campania?.idBenCampania
            || 0
          ),
        });
      }
    }

    return filas;
  }

  private planDeleteDesdeFilaPrograma(
    idBeneficiario: number,
    fila: {
      idBenPrograma: number;
      idSubcuenta: number;
      idCotizacionTarifa: number;
      idCotizacionTarifaAnexo: number;
      idCotizacionCampania: number;
    }
  ): BeneficiaryDeletePlan {
    return {
      idBeneficiario,
      idBenPrograma: fila.idBenPrograma,
      idSubcuenta: fila.idSubcuenta,
      idCotizacionTarifa: fila.idCotizacionTarifa,
      idCotizacionTarifaAnexo: fila.idCotizacionTarifaAnexo,
      idCotizacionCampania: fila.idCotizacionCampania,
      deleteDatosBeneficiarios: false,
    };
  }

  // En edición no se reemplazan las campañas. Si ya está la misma, se deja.
  // Si cambió, se borra esa fila y se agrega la nueva. Si no existe, se agrega.
  private async campaniasPorGuardarEnEdicion(
    idBeneficiario: number,
    programasCampanias: Array<{ idBenPrograma: number; campanias: any[] }>,
    idBenProgramaByPrograma: Map<string, number>,
    idCotizacionCampaniaByPrograma: Map<string, number>
  ): Promise<Array<{ idBenPrograma: number; campanias: any[] }>> {
    if (!this.isEditMode) return programasCampanias;

    const guardadas = this.campaniasYaGuardadasEdicion(idBeneficiario);
    const codigoPorId = new Map<number, string>();
    idBenProgramaByPrograma.forEach((id, codigo) => {
      if (id > 0) codigoPorId.set(id, codigo);
    });

    const pendientes: Array<{ idBenPrograma: number; campanias: any[] }> = [];
    for (const item of programasCampanias || []) {
      const idBenPrograma = Number(item?.idBenPrograma || 0);
      const codigoNuevo = (item?.campanias?.[0]?.codCampComercial || '').toString().trim();
      const ya = guardadas.get(idBenPrograma);
      const codigoPrograma = codigoPorId.get(idBenPrograma) || '';

      if (ya && ya.idCotizacionCampania > 0 && (!codigoNuevo || !ya.codigo || ya.codigo === codigoNuevo)) {
        if (codigoPrograma) {
          idCotizacionCampaniaByPrograma.set(codigoPrograma, ya.idCotizacionCampania);
        }
        continue;
      }

      if (ya && ya.idCotizacionCampania > 0 && ya.codigo && codigoNuevo && ya.codigo !== codigoNuevo) {
        await this.ejecutarDeleteSeguro(
          `edicion-campania:${ya.idCotizacionCampania}`,
          () => firstValueFrom(this.networkingBeneficiary.eliminarCampania(ya.idCotizacionCampania))
        );
      }

      pendientes.push(item);
    }

    return pendientes;
  }

  private campaniasYaGuardadasEdicion(idBeneficiario: number): Map<number, { idCotizacionCampania: number; codigo: string }> {
    const guardadas = new Map<number, { idCotizacionCampania: number; codigo: string }>();
    const fuentes: any[] = [];
    const data = this.cotizacionEdicionData || this._cotizacionEdicionDataLatest;
    const beneficiarios = Array.isArray((data as any)?.beneficiarios) ? (data as any).beneficiarios : [];
    const item = beneficiarios.find((b: any) => Number(b?.idBeneficiario || 0) === Number(idBeneficiario));
    if (item) fuentes.push(item);

    const filaTabla = (this.dataBeneficiary || []).find((b: any) =>
      Number(b?.idBeneficiario || b?.id_beneficiario || 0) === Number(idBeneficiario)
    );
    const edicionItem = (filaTabla as any)?._edicionItem;
    if (edicionItem && edicionItem !== item) fuentes.push(edicionItem);

    for (const fuente of fuentes) {
      const programas = Array.isArray(fuente?.programas) ? fuente.programas : [];
      for (const programa of programas) {
        const idBenPrograma = Number(programa?.idBenPrograma || programa?.id_ben_programa || 0);
        if (!(idBenPrograma > 0) || guardadas.has(idBenPrograma)) continue;
        const campanias = Array.isArray(programa?.campanias) ? programa.campanias : [];
        const campania = campanias.find((c: any) => c?.fueSeleccionada !== false) || campanias[0];
        const idCotizacionCampania = Number(
          campania?.idCotizacionCampania
          || campania?.id_cotizacion_campania
          || campania?.idBenCampania
          || programa?.idCotizacionCampania
          || 0
        );
        const codigo = (
          campania?.codCampComercial
          || campania?.codigo_campania
          || campania?.codigoCampania
          || programa?.campana
          || programa?.codCampComercial
          || ''
        ).toString().trim();
        if (!(idCotizacionCampania > 0) && !codigo) continue;
        guardadas.set(idBenPrograma, { idCotizacionCampania, codigo });
      }
    }

    return guardadas;
  }

  private quitarProgramaBorradoDeEdicionEnMemoria(plan: BeneficiaryDeletePlan): void {
    const idBeneficiario = Number(plan?.idBeneficiario || 0);
    const idBenPrograma = Number(plan?.idBenPrograma || 0);
    if (!(idBeneficiario > 0) || !(idBenPrograma > 0)) return;
    this.quitarProgramasBorradosDeEdicionEnMemoria(idBeneficiario, [idBenPrograma]);
  }

  /**
   * En edición, la flecha cuadra los programas del titular con la grilla.
   * El que ya no se ve se elimina. El que se ve y no está en base se agrega.
   */
  private async asegurarProgramasTitularVisiblesEnEdicion(): Promise<void> {
    if (!this.isEditMode) return;

    const filas = this.obtenerFilasContratanteTabla();
    if (!filas.length) return;

    const idBeneficiario = this.idBeneficiarioTitularParaCotizacion(filas);
    const idEdicion = Number(this.idCotizacionEdicion || (this.cotizacionEdicionData as any)?.idCotizacion || 0);
    const idCotizacion = idEdicion > 0 ? idEdicion : this.obtenerIdCotizacionActivaParaFlecha();
    if (!(idBeneficiario > 0) || !(idCotizacion > 0)) return;

    const pares = filas.map((fila: any) => ({
      fila,
      codigo: this.codigoCortoProgramaFila(fila, idBeneficiario),
    }));
    const codigos = Array.from(new Set(pares.map((par) => par.codigo).filter(Boolean)));
    if (!codigos.length) {
      const titular = (this.datasBeneficiary || []).find((b: any) => this.esFilaContratante(b)) as any;
      const desdeConfig = (titular?.programasConfig?.programas || [])
        .map((p: any) => (p?.programa || p?.id || '').toString().trim().toUpperCase())
        .filter((code: string) => !!code && code.length <= 15 && !/\s/.test(code));
      desdeConfig.forEach((code: string) => {
        if (!codigos.includes(code)) codigos.push(code);
      });
    }
    if (!codigos.length) return;
    const puedeBorrarLosQueNoSeVen = pares.every((par) => !!par.codigo);

    try {
      const idBenProgramaByPrograma = new Map<string, number>();
      if (puedeBorrarLosQueNoSeVen) {
        const yaEstan = await this.alinearProgramasEdicionConPantalla(idCotizacion, idBeneficiario, codigos);
        yaEstan.forEach((id, codigo) => idBenProgramaByPrograma.set(codigo, id));
      }

      // La memoria puede decir que el programa sigue, aunque en base ya no esté.
      // Se consulta y, si no está, se agrega. Eso es lo que tiene que verse en la red.
      const faltanConsulta: string[] = [];
      for (const codigo of codigos) {
        try {
          const respConsulta = await firstValueFrom(this.networkingBeneficiary.consultarBeneficiarioPrograma({
            idCotizacion,
            idBeneficiario,
            programa: codigo,
          }));
          const idEncontrado = this.extractIdBenProgramaFromResponse(respConsulta);
          if (idEncontrado > 0) {
            idBenProgramaByPrograma.set(codigo, idEncontrado);
          } else {
            idBenProgramaByPrograma.delete(codigo);
            faltanConsulta.push(codigo);
          }
        } catch (err: any) {
          if (this.consultarProgramaIndicaAusente(err) || Number(err?.status) === 404) {
            idBenProgramaByPrograma.delete(codigo);
            faltanConsulta.push(codigo);
          } else {
            console.warn('[edicion-programas] no se pudo consultar el programa del titular', codigo, err);
          }
        }
      }

      const storage = this.obtenerProgramasContratanteDesdeStorage();
      const armarItem = (codigo: string) => {
        const guardado = storage.find((p) =>
          (p?.programa || (p as any)?.id || '').toString().trim().toUpperCase() === codigo
        );
        const fila = pares.find((par) => par.codigo === codigo)?.fila;
        const nombre = (
          (guardado as any)?.nombrePrograma
          || (guardado as any)?.nombre
          || fila?.program
          || codigo
        ).toString().trim();
        const linea = this.normalizarLineaNegocioProgramasStorage(
          ((guardado as any)?.lineaNegocio || (guardado as any)?.lineaNegocioNombre || fila?.lineOfBusiness || '').toString()
        );
        if (!linea) return null;
        return {
          lineaNegocio: linea,
          programa: codigo,
          nombrePrograma: nombre,
          grupoPrograma: this.resolverGrupoProgramaParaGuardado(codigo, nombre, guardado || fila),
          esAnexo: this.normalizarRequiereAnexo((guardado as any)?.requiereAnexo) === 'si',
          guardado,
        };
      };

      const faltan = codigos.filter((codigo) => !idBenProgramaByPrograma.has(codigo));
      const itemsNuevos = faltan
        .map((codigo) => armarItem(codigo))
        .filter((item): item is NonNullable<typeof item> => !!item);

      if (itemsNuevos.length) {
        await this.rellenarGrupoProgramaPorCodigo(itemsNuevos);
        const resp = await firstValueFrom(this.networkingBeneficiary.guardarBeneficiarioProgramas({
          idCotizacion,
          idBeneficiario,
          items: itemsNuevos.map(({ guardado, ...item }) => item),
        }, false));
        if (resp?.status === false) {
          console.warn('[edicion-programas] no se pudo guardar el programa que sigue en pantalla', resp?.errorMessage || resp?.message);
        } else {
          this.hydrateIdBenProgramaByProgramaDesdeRespuestaGuardar(itemsNuevos, resp, idBenProgramaByPrograma);
        }
      }

      const programasTarifas = itemsNuevos
        .map((item) => {
          const idBenPrograma = Number(idBenProgramaByPrograma.get(item.programa) || 0);
          const guardado = item.guardado as any;
          if (!(idBenPrograma > 0) || !guardado) return null;
          const tariRaw = (guardado?.tarifaDetalle?.tari || guardado?.tarifa || '').toString().trim();
          const tari = this.extraerCodigoTarifaLimpioParaPersistencia(tariRaw) || tariRaw;
          if (!tari) return null;
          const tarifas: any[] = [{
            tari,
            nombreTarifa: (guardado?.tarifaDetalle?.nombreTarifa || '').toString().trim() || undefined,
            valorMensualBase: Number(guardado?.tarifaDetalle?.valorMensualBase || guardado?.valorMensualBase || 0) || undefined,
            valorMensualIva: Number(guardado?.tarifaDetalle?.valorMensualIva || guardado?.valorMensualIva || 0) || undefined,
            fueSeleccionada: true,
            esAnexo: false,
          }];
          const tariAnexoRaw = (guardado?.anexoDetalle?.tari || guardado?.tarifaAnexo || '').toString().trim();
          const tariAnexo = this.extraerCodigoTarifaLimpioParaPersistencia(tariAnexoRaw) || tariAnexoRaw;
          if (tariAnexo) {
            const valorAnexo = Number(guardado?.anexoDetalle?.valorMensualIva || 0);
            tarifas.push({
              tari: tariAnexo,
              nombreTarifa: (guardado?.anexoDetalle?.nombreTarifa || '').toString().trim() || undefined,
              valorMensualBase: Number.isFinite(valorAnexo) ? valorAnexo : 0,
              valorMensualIva: Number.isFinite(valorAnexo) ? valorAnexo : 0,
              fueSeleccionada: true,
              esAnexo: true,
            });
          }
          return { idBenPrograma, tarifas };
        })
        .filter((item): item is { idBenPrograma: number; tarifas: any[] } => !!item);

      if (programasTarifas.length) {
        await firstValueFrom(this.networkingBeneficiary.guardarTarifas({
          idCotizacion,
          idBeneficiario,
          programas: programasTarifas,
        }, false));
      }
    } catch (err) {
      console.warn('[edicion-programas] no se pudo dejar el programa del titular en la cotización', err);
    }
  }

  private idBeneficiarioTitularParaCotizacion(filas: any[]): number {
    const deFila = filas
      .map((fila: any) => Number(fila?.id_beneficiario || fila?.idBeneficiario || 0))
      .find((id: number) => id > 0);
    if (deFila && deFila > 0) return deFila;

    const data = this.cotizacionEdicionData || this._cotizacionEdicionDataLatest;
    const beneficiarios = Array.isArray((data as any)?.beneficiarios) ? (data as any).beneficiarios : [];
    const doc = (filas[0]?.num_documento || '').toString().trim();
    const esTitular = (b: any): boolean =>
      b?.esContratante === 'S' || b?.esContratante === true
      || (b?.parentescoId || '').toString().trim().toUpperCase() === 'T';
    const porDocumento = beneficiarios.find((b: any) =>
      esTitular(b) && !!doc && (b?.numDocumento || '').toString().trim() === doc
    );
    const titular = porDocumento || beneficiarios.find((b: any) => esTitular(b));
    return Number(titular?.idBeneficiario || 0);
  }

  private codigoCortoProgramaFila(fila: any, idBeneficiario: number): string {
    const pareceCodigo = (valor: string): boolean =>
      !!valor && valor.length <= 15 && !/\s/.test(valor);

    const directo = (fila?.__programaCodigo || fila?.programa || '').toString().trim().toUpperCase();
    if (pareceCodigo(directo)) return directo;

    const nombre = (fila?.program || '').toString().trim().toUpperCase();
    const linea = (fila?.lineOfBusiness || '').toString().trim().toUpperCase();
    if (!nombre) return '';

    const coincideNombre = (codigo: string, nombrePrograma: string): boolean => {
      const visible = this.formatearNombrePrograma(nombrePrograma || codigo).toString().trim().toUpperCase();
      const crudo = (nombrePrograma || '').toString().trim().toUpperCase();
      return visible === nombre || crudo === nombre || (pareceCodigo(codigo) && codigo === nombre);
    };

    const data = this.cotizacionEdicionData || this._cotizacionEdicionDataLatest;
    const beneficiarios = Array.isArray((data as any)?.beneficiarios) ? (data as any).beneficiarios : [];
    const item = beneficiarios.find((b: any) => Number(b?.idBeneficiario || 0) === Number(idBeneficiario));
    const programasEdicion = Array.isArray(item?.programas) ? item.programas : [];
    const deEdicion = programasEdicion.find((programa: any) => {
      const code = (programa?.programa || programa?.planCodi || programa?.codigo || '').toString().trim().toUpperCase();
      return coincideNombre(code, programa?.nombrePrograma || programa?.nombre || '');
    });
    const codeEdicion = (deEdicion?.programa || deEdicion?.planCodi || deEdicion?.codigo || '').toString().trim().toUpperCase();
    if (pareceCodigo(codeEdicion)) return codeEdicion;

    const deStorage = this.obtenerProgramasContratanteDesdeStorage().find((programa) => {
      const code = (programa?.programa || (programa as any)?.id || '').toString().trim().toUpperCase();
      const lineaPrograma = this._aliasONombreLinea2(
        (programa as any)?.lineaNegocio || (programa as any)?.lineaNegocioNombre || ''
      ).toString().trim().toUpperCase();
      const mismaLinea = !linea || !lineaPrograma || linea === lineaPrograma;
      return mismaLinea && coincideNombre(code, (programa as any)?.nombrePrograma || (programa as any)?.nombre || '');
    });
    const codeStorage = (deStorage?.programa || (deStorage as any)?.id || '').toString().trim().toUpperCase();
    if (pareceCodigo(codeStorage)) return codeStorage;

    const catalogo = [
      ...Object.values(this.programasCarnetPorLinea || {}).flat(),
      ...(Array.isArray(this.listProgramas) ? this.listProgramas : []),
    ];
    const deCatalogo = catalogo.find((programa: any) => {
      const code = (programa?.code ?? programa?.codigo ?? programa?.id ?? '').toString().trim().toUpperCase();
      const program = (programa?.program ?? programa?.programa ?? programa?.nombre ?? '').toString().trim();
      return coincideNombre(code, program);
    });
    const codeCatalogo = (deCatalogo?.code ?? deCatalogo?.codigo ?? deCatalogo?.id ?? '').toString().trim().toUpperCase();
    if (pareceCodigo(codeCatalogo)) return codeCatalogo;

    const deLista = (Codigo.getPrograma() || []).find((programa: any) => {
      const code = (programa?.codigo || '').toString().trim().toUpperCase();
      const descripcion = (programa?.descripcion || '').toString().trim().toUpperCase();
      return descripcion === nombre || this.formatearNombrePrograma(descripcion) === nombre;
    });
    const codeLista = (deLista?.codigo || '').toString().trim().toUpperCase();
    return pareceCodigo(codeLista) ? codeLista : '';
  }

  private quitarProgramasBorradosDeEdicionEnMemoria(idBeneficiario: number, idsBenPrograma: number[]): void {
    const ids = new Set((idsBenPrograma || []).map((id) => Number(id || 0)).filter((id) => id > 0));
    if (!ids.size) return;

    const limpiar = (data: any) => {
      const beneficiarios = Array.isArray(data?.beneficiarios) ? data.beneficiarios : [];
      const item = beneficiarios.find((b: any) => Number(b?.idBeneficiario || 0) === Number(idBeneficiario));
      if (!item || !Array.isArray(item.programas)) return;
      item.programas = item.programas.filter((programa: any) =>
        !ids.has(Number(programa?.idBenPrograma || programa?.id_ben_programa || 0))
      );
    };

    limpiar(this.cotizacionEdicionData);
    limpiar(this._cotizacionEdicionDataLatest);
  }

  // Borra campaña, tarifa, subcuenta y programa del titular antes del replace. El beneficiario se queda.
  // Si en inclusión la consulta dice que ya no están, no borra esos ids y sigue el insert.
  private async eliminarHijosTitularInclusionAntesDeReplaceProgramas(
    idCotizacion: number,
    idBeneficiario: number,
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    datos: ContratanteStorageData,
    itemsProgramas: Array<{ programa: string }>
  ): Promise<boolean> {
    if (!(idBeneficiario > 0) || !(idCotizacion > 0)) return true;

    const planesDesdeSnapshot = this.construirPlanesDeleteDesdeSnapshotFlecha(datos, idBeneficiario)
      .map((p) => ({ ...p, deleteDatosBeneficiarios: false }));
    const planesDesdeStorage = this.construirPlanesDeleteContratantePersistido(
      filasContratante,
      programas,
      idBeneficiario
    ).map((p) => ({ ...p, deleteDatosBeneficiarios: false }));

    let planes: BeneficiaryDeletePlan[] = this.deduplicarPlanesDelete([
      ...planesDesdeSnapshot,
      ...planesDesdeStorage,
    ]);

    const programasYaCubiertos = new Set(
      planes.map((p) => Number(p.idBenPrograma || 0)).filter((id) => id > 0)
    );
    const esInclusion = this.esInclusion || (localStorage.getItem('tipoSolicitud') === '2');
    let consultasHechas = 0;
    let programasAusentes = 0;
    for (const it of (itemsProgramas || [])) {
      const codigo = (it?.programa || '').toString().trim().toUpperCase();
      if (!codigo) continue;
      consultasHechas++;
      try {
        const respConsultar = await firstValueFrom(this.networkingBeneficiary.consultarBeneficiarioPrograma({
          idCotizacion,
          idBeneficiario,
          programa: codigo,
        }));
        if (this.consultarProgramaIndicaAusente(respConsultar)) {
          programasAusentes++;
          continue;
        }
        const idBenPrograma = this.extractIdBenProgramaFromResponse(respConsultar);
        if (idBenPrograma > 0 && !programasYaCubiertos.has(idBenPrograma)) {
          programasYaCubiertos.add(idBenPrograma);
          planes.push({
            idBeneficiario,
            idBenPrograma,
            idSubcuenta: 0,
            idCotizacionTarifa: 0,
            idCotizacionTarifaAnexo: 0,
            idCotizacionCampania: 0,
            deleteDatosBeneficiarios: false,
          });
        }
      } catch (err: any) {
        if (this.consultarProgramaIndicaAusente(err) || Number(err?.status) === 404) {
          programasAusentes++;
        }
      }
    }

    // Los ids del snapshot ya no sirven si la consulta acaba de decir que el programa no está.
    if (esInclusion && consultasHechas > 0 && programasAusentes === consultasHechas) {
      return false;
    }

    planes = this.deduplicarPlanesDelete(planes);
    if (!planes.length) {
      return true;
    }

    await this.ejecutarCascadaDeletePlanesBeneficiario(planes, false, 'inclusion-titular-hijos');
    return true;
  }

  private consultarProgramaIndicaAusente(respOrErr: any): boolean {
    const body = respOrErr?.error && typeof respOrErr.error === 'object' ? respOrErr.error : respOrErr;
    if (!body) return false;
    const texto = [
      body?.message,
      body?.errorMessage,
      body?.mensaje,
      body?.detalle,
    ].filter(Boolean).join(' ').toUpperCase();
    const code = String(body?.codeStatus ?? body?.statusCode ?? '');
    const noEsta = texto.includes('NO SE ENCONTR')
      || texto.includes('SIN RESULTADO')
      || texto.includes('NO EXISTE')
      || texto.includes('REGISTRO NO ENCONTRADO');
    return body?.status === false && (code === '404' || noEsta);
  }

  private async eliminarCadenaContratantePersistida(
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    datos: ContratanteStorageData
  ): Promise<void> {
    const idBeneficiario = this.resolverIdBeneficiarioContratantePersistido(filasContratante, programas, datos);
    const planesDesdeSnapshot = this.construirPlanesDeleteDesdeSnapshotFlecha(datos, idBeneficiario);
    const planes = planesDesdeSnapshot.length > 0
      ? planesDesdeSnapshot
      : this.construirPlanesDeleteContratantePersistido(filasContratante, programas, idBeneficiario);
    const idBeneficiarioDelete = this.obtenerPrimerIdPositivo(
      idBeneficiario,
      ...planes.map((plan) => plan.idBeneficiario)
    );
    const campaniasAEliminar = this.extraerIdsUnicosOrdenados(planes.map((plan) => plan.idCotizacionCampania));
    const tarifasAEliminar = this.extraerIdsUnicosOrdenados(
      planes.flatMap((plan) => [plan.idCotizacionTarifa, plan.idCotizacionTarifaAnexo])
    );
    const subcuentasAEliminar = this.extraerIdsUnicosOrdenados(planes.map((plan) => plan.idSubcuenta));
    const beneficiarioProgramasAEliminar = this.extraerIdsUnicosOrdenados(planes.map((plan) => plan.idBenPrograma));

    console.group(`[Diagnostico-Delete-Cascade] Evaluando borrado para Beneficiario ${idBeneficiario}`);
    console.log('1. Filas Contratante recibidas:', filasContratante);
    console.log('2. Programas en storage:', programas);
    console.log('3. Planes estructurados para DELETE:', planes);
    console.log('4. Campañas calculadas a eliminar:', campaniasAEliminar);
    console.log('5. Tarifas calculadas a eliminar:', tarifasAEliminar);
    console.log('6. Subcuentas calculadas a eliminar:', subcuentasAEliminar);
    console.log('7. Programas calculados a eliminar:', beneficiarioProgramasAEliminar);
    console.log('8. ¿Evaluación debeGuardarSubcuentasPorTipoPlan?:', this.debeGuardarSubcuentasPorTipoPlan());
    console.groupEnd();

    for (const idCotizacionCampania of campaniasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `contratante-campania:${idCotizacionCampania}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarCampania(idCotizacionCampania))
      );
    }

    for (const idCotizacionTarifa of tarifasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `contratante-tarifa:${idCotizacionTarifa}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarTarifa(idCotizacionTarifa))
      );
    }

    for (const idSubcuenta of subcuentasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `contratante-subcuenta:${idSubcuenta}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarSubcuenta(idSubcuenta))
      );
    }

    for (const idBenPrograma of beneficiarioProgramasAEliminar) {
      await this.ejecutarDeleteSeguro(
        `contratante-beneficiario-programa:${idBenPrograma}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarBeneficiarioPrograma(idBenPrograma))
      );
    }

    if (idBeneficiarioDelete > 0) {
      await this.ejecutarDeleteSeguro(
        `contratante-datos-beneficiario:${idBeneficiarioDelete}`,
        () => firstValueFrom(this.networkingBeneficiary.eliminarDatosBeneficiarios(idBeneficiarioDelete))
      );
    }

    this.limpiarPersistenciaContratanteTrasDelete();
  }

  private resolverIdBeneficiarioContratantePersistido(
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    datos: ContratanteStorageData
  ): number {
    const candidates = [
      datos?.idBeneficiario,
      datos?.id_beneficiario_guardado,
      ...((programas || []).map((p) => (p as any)?.idBeneficiario)),
      ...((filasContratante || []).map((fila) =>
        fila?.idBeneficiario ?? fila?.id_beneficiario ?? fila?.id_beneficiario_guardado
      ))
    ];

    for (const candidate of candidates) {
      const id = Number(candidate || 0);
      if (Number.isFinite(id) && id > 0) return id;
    }

    return 0;
  }

  private construirPlanesDeleteContratantePersistido(
    filasContratante: any[],
    programas: ProgramaContratanteStorageItem[],
    idBeneficiario: number
  ): BeneficiaryDeletePlan[] {
    const usados = new Set<any>();
    const plans: BeneficiaryDeletePlan[] = [];

    (programas || []).forEach((programa) => {
      const row = (filasContratante || []).find((fila) => this.ramaCoincideConPrograma(fila, programa));
      if (row) {
        usados.add(row);
      }

      plans.push({
        idBeneficiario,
        idBenPrograma: this.obtenerPrimerIdPositivo(
          row?.__idBenPrograma,
          row?.idBenPrograma,
          row?.id_ben_programa,
          programa?.idBenPrograma,
          (programa as any)?.id_ben_programa
        ),
        idSubcuenta: this.obtenerPrimerIdPositivo(
          row?.__idSubcuenta,
          row?.idSubcuenta,
          row?.id_subcuenta,
          row?.idBenSubcuenta,
          row?.id_ben_subcuenta,
          programa?.idSubcuenta,
          (programa as any)?.id_subcuenta,
          (programa as any)?.idBenSubcuenta,
          (programa as any)?.id_ben_subcuenta
        ),
        idCotizacionTarifa: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionTarifa,
          row?.idCotizacionTarifa,
          row?.id_cotizacion_tarifa,
          programa?.idCotizacionTarifa,
          (programa as any)?.id_cotizacion_tarifa
        ),
        idCotizacionTarifaAnexo: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionTarifaAnexo,
          row?.idCotizacionTarifaAnexo,
          row?.id_cotizacion_tarifa_anexo,
          programa?.idCotizacionTarifaAnexo,
          (programa as any)?.id_cotizacion_tarifa_anexo
        ),
        idCotizacionCampania: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionCampania,
          row?.idCotizacionCampania,
          row?.id_cotizacion_campania,
          programa?.idCotizacionCampania,
          (programa as any)?.id_cotizacion_campania,
          (programa as any)?.idBenCampania
        ),
        deleteDatosBeneficiarios: false,
      });
    });

    (filasContratante || []).forEach((row) => {
      if (usados.has(row)) return;
      plans.push({
        idBeneficiario: this.obtenerPrimerIdPositivo(
          row?.idBeneficiario,
          row?.id_beneficiario,
          row?.id_beneficiario_guardado,
          idBeneficiario
        ),
        idBenPrograma: this.obtenerPrimerIdPositivo(
          row?.__idBenPrograma,
          row?.idBenPrograma,
          row?.id_ben_programa
        ),
        idSubcuenta: this.obtenerPrimerIdPositivo(
          row?.__idSubcuenta,
          row?.idSubcuenta,
          row?.id_subcuenta,
          row?.idBenSubcuenta,
          row?.id_ben_subcuenta,
        ),
        idCotizacionTarifa: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionTarifa,
          row?.idCotizacionTarifa,
          row?.id_cotizacion_tarifa
        ),
        idCotizacionTarifaAnexo: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionTarifaAnexo,
          row?.idCotizacionTarifaAnexo,
          row?.id_cotizacion_tarifa_anexo
        ),
        idCotizacionCampania: this.obtenerPrimerIdPositivo(
          row?.__idCotizacionCampania,
          row?.idCotizacionCampania,
          row?.id_cotizacion_campania
        ),
        deleteDatosBeneficiarios: false,
      });
    });

    const unique = this.deduplicarPlanesDelete(plans);

    return unique;
  }

  /**
   * Usa la persistencia BD guardada en el snapshot de la flecha para borrar en cascada
   * aunque el modal de contratante haya reescrito programas_contratante sin IDs.
   */
  private construirPlanesDeleteDesdeSnapshotFlecha(
    datos: ContratanteStorageData,
    idBeneficiarioFallback: number
  ): BeneficiaryDeletePlan[] {
    try {
      const raw = this.obtenerSnapshotFlechaGuardado();
      if (!raw) return [];

      const parsed = JSON.parse(raw || '{}');
      const persistencia = parsed?.persistenciaBd as FlechaPersistenciaBdSnapshot | undefined;
      if (!persistencia) return [];

      const idBeneficiario = this.obtenerPrimerIdPositivo(
        persistencia?.idBeneficiario,
        datos?.idBeneficiario,
        datos?.id_beneficiario_guardado,
        idBeneficiarioFallback
      );
      const programas = Array.isArray(persistencia?.programas) ? persistencia.programas : [];
      if (!(idBeneficiario > 0) && !programas.length) {
        return [];
      }

      const plans = programas.map((programa) => ({
        idBeneficiario,
        idBenPrograma: Number(programa?.idBenPrograma || 0),
        idSubcuenta: Number(programa?.idSubcuenta || 0),
        idCotizacionTarifa: Number(programa?.idCotizacionTarifa || 0),
        idCotizacionTarifaAnexo: Number(programa?.idCotizacionTarifaAnexo || 0),
        idCotizacionCampania: Number(programa?.idCotizacionCampania || 0),
        deleteDatosBeneficiarios: false,
      }));

      return this.deduplicarPlanesDelete(plans);
    } catch {
      return [];
    }
  }

  private deduplicarPlanesDelete(plans: BeneficiaryDeletePlan[]): BeneficiaryDeletePlan[] {
    const unique = new Map<string, BeneficiaryDeletePlan>();
    (plans || []).forEach((plan) => {
      const key = [
        Number(plan.idBeneficiario || 0),
        Number(plan.idBenPrograma || 0),
        Number(plan.idSubcuenta || 0),
        Number(plan.idCotizacionTarifa || 0),
        Number(plan.idCotizacionTarifaAnexo || 0),
        Number(plan.idCotizacionCampania || 0)
      ].join('|');
      // Permite planes solo con idBeneficiario (borrar datos sin ramas hijas conocidas).
      if (key === '0|0|0|0|0|0') return;
      if (!unique.has(key)) {
        unique.set(key, plan);
      }
    });
    return Array.from(unique.values());
  }

  private construirPersistenciaBdDesdeMaps(
    idBeneficiario: number,
    programas: ProgramaContratanteStorageItem[],
    idBenProgramaByPrograma: Map<string, number>,
    idSubcuentaByPrograma: Map<string, number>,
    idCotizacionTarifaByPrograma: Map<string, number>,
    idCotizacionTarifaAnexoByPrograma: Map<string, number>,
    idCotizacionCampaniaByPrograma: Map<string, number>
  ): FlechaPersistenciaBdSnapshot {
    const norm = (v: any) => (v ?? '').toString().trim().toUpperCase();
    const programasPersistidos: FlechaPersistenciaBdPrograma[] = (programas || [])
      .map((programa) => {
        const codigo = norm(programa?.programa || programa?.id || '');
        if (!codigo) return null;
        return {
          programa: codigo,
          lineaNegocio: norm((programa as any)?.lineaNegocio || (programa as any)?.lineaNegocioNombre || ''),
          idBenPrograma: Number(idBenProgramaByPrograma.get(codigo) || (programa as any)?.idBenPrograma || 0),
          idSubcuenta: Number(idSubcuentaByPrograma.get(codigo) || (programa as any)?.idSubcuenta || 0),
          idCotizacionTarifa: Number(idCotizacionTarifaByPrograma.get(codigo) || (programa as any)?.idCotizacionTarifa || 0),
          idCotizacionTarifaAnexo: Number(idCotizacionTarifaAnexoByPrograma.get(codigo) || (programa as any)?.idCotizacionTarifaAnexo || 0),
          idCotizacionCampania: Number(idCotizacionCampaniaByPrograma.get(codigo) || (programa as any)?.idCotizacionCampania || 0),
        };
      })
      .filter((item): item is FlechaPersistenciaBdPrograma => !!item && (
        item.idBenPrograma > 0 || item.idSubcuenta > 0 || item.idCotizacionTarifa > 0 || item.idCotizacionTarifaAnexo > 0 || item.idCotizacionCampania > 0
      )
      );
    return {
      idBeneficiario: Number(idBeneficiario || 0),
      programas: programasPersistidos,
    };
  }

  private construirProgramaConfigContratanteDesdeStorage(p: ProgramaContratanteStorageItem): any {
    const tipoPlanActual = (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
    const tipoSolicitudActual = (localStorage.getItem('tipoSolicitud') || '').toString().trim();

    const esColectivoGenerico = (tipoPlanActual === 'C' || tipoPlanActual === 'GA' || tipoPlanActual === 'AG' || tipoPlanActual.includes('COLECTIV') || tipoPlanActual.includes('AFINIDAD'));

    const valBase = (p as any).valorMensualBase ?? (p as any).tarifaDetalle?.valorMensualBase ?? (p as any).valor_tari ?? (p as any).VALOR_TARI ?? (p as any).valor ?? undefined;
    const valIva = (p as any).valorMensualIva ?? (p as any).tarifaDetalle?.valorMensualIva ?? valBase;

    const campanaCod = (p.campana || (p as any).codigo_campania || (p as any).campaniaDetalle?.codigo_campania || '').toString().trim();
    const campanaNom = ((p as any).campanaNombre || (p as any).nombre_campana || (p as any).campaniaDetalle?.nombreCampania || campanaCod).toString().trim();
    const iniVig = (p as any).inicioVigencia || (p as any).inicio_vigencia || (p as any).campaniaDetalle?.inicioVigencia || (p as any).campaniaDetalle?.inicio_vigencia || undefined;
    const finVig = (p as any).finVigencia || (p as any).fin_vigencia || (p as any).campaniaDetalle?.finVigencia || (p as any).campaniaDetalle?.fin_vigencia || undefined;

    const progrCode = (p.programa || p.id || '').toString().trim();
    let progNombre = ((p as any).nombrePrograma || (p as any).nombre || '').toString().trim();

    let tarifaAnexoRescatada = (p.tarifaAnexo || (p as any).anexoCodigo || '').toString().trim(); //rescatar la tarifa anexo para agg al localStorage antes de hacer el guardado y asi asigna al modal de editar la tarifa (nc-721)
    let anexoDetalleRescatado = (p as any).anexoDetalle ?? null;

    if (!tarifaAnexoRescatada && Array.isArray((p as any).tarifas)) {
      const tarifaAnexoBD = (p as any).tarifas.find((t: any) => t.esAnexo === true);
      if (tarifaAnexoBD) {
        tarifaAnexoRescatada = (tarifaAnexoBD.tari || '').toString().trim();
        anexoDetalleRescatado = tarifaAnexoBD;
      }
    }

    const esFlujoColectivoPuro = tipoSolicitudActual === '3' || tipoPlanActual === 'C';

    if (esFlujoColectivoPuro && (!progNombre || progNombre.toUpperCase() === progrCode.toUpperCase())) {
      const filaColectivo: any = (this._datosCompletosColectivoAC || []).find((r: any) =>
        (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase() === progrCode.toUpperCase()
      );

      if (filaColectivo?.plan_deno && filaColectivo.plan_deno.toUpperCase() !== progrCode.toUpperCase()) {
        progNombre = filaColectivo.plan_deno.trim().toUpperCase();
      } else {
        progNombre = this.formatearNombrePrograma(progrCode) || progNombre;
      }
    }

    const item: any = {
      id: progrCode,
      programa: progrCode,
      nombre: progNombre,
      nombrePrograma: progNombre,
      lineaNegocio: (p.lineaNegocio || '').toString().trim(),
      grupoPrograma: (
        tipoSolicitudActual === '2'
          ? this.obtenerGrupoProgramaInclusion(progrCode)
          : (
              p.grupoPrograma ??
              (p as any).grupo_programa ??
              (p as any).GRUPO_PROGRAMA ??
              ''
            )
      ).toString().trim(),
      tarifa: (p.tarifa || '').toString().trim(),
      subcuenta: ((p as any).subcuenta || '').toString().trim(),
      campana: campanaCod,
      campanaNombre: campanaNom,
      inicioVigencia: iniVig,
      finVigencia: finVig,
      inicio_vigencia: iniVig,
      fin_vigencia: finVig,
      campaniaDetalle: (p as any).campaniaDetalle ?? null,
      anexoDetalle: anexoDetalleRescatado,
      anexoCodigo: tarifaAnexoRescatada,

      requiereAnexo: (p.requiereAnexo || '').toString().trim(),
      tarifaAnexo: tarifaAnexoRescatada,
      idBeneficiario: (p as any).idBeneficiario || (p as any).id_beneficiario,
      idBenPrograma: (p as any).idBenPrograma || (p as any).id_ben_programa,
      idSubcuenta: (p as any).idSubcuenta || (p as any).id_subcuenta,
      idCotizacionTarifa: (p as any).idCotizacionTarifa || (p as any).id_cotizacion_tarifa,
      idCotizacionTarifaAnexo: (p as any).idCotizacionTarifaAnexo || (p as any).id_cotizacion_tarifa_anexo,
      idCotizacionCampania: (p as any).idCotizacionCampania || (p as any).id_cotizacion_campania || (p as any).idBenCampania,
      guardadoEnBd: (p as any).guardadoEnBd,

      nombreTarifa: (p as any).nombreTarifa || (p as any).tarifaDetalle?.nombreTarifa || (p.tarifa || '').toString().trim(),
      valorMensualBase: valBase,
      valorMensualIva: valIva,
      porcentajeIva: (p as any).porcentajeIva ?? (p as any).tarifaDetalle?.porcentajeIva ?? undefined,
      tarifaDetalle: (p as any).tarifaDetalle ?? {
        tari: (p.tarifa || '').toString().trim(),
        nombreTarifa: (p as any).nombreTarifa || (p.tarifa || '').toString().trim(),
        valorMensualBase: valBase,
        valorMensualIva: valIva,
        porcentajeIva: (p as any).porcentajeIva ?? undefined,
        fueSeleccionada: true,
        esAnexo: false
      }
    };

    if (esColectivoGenerico) {
      item.subcuenta = ((p as any).subcuenta || (p as any).subcta || (p as any).nombreSubcuenta || '').toString().trim();
      item.subcta = ((p as any).subcta || (p as any).subcuenta || '').toString().trim();
    }
    this.asignarIdsPersistenciaProgramaContratante(item, p as any);
    return item;
  }

  private asignarIdsPersistenciaProgramaContratante(target: any, source: any): void {
    const idBeneficiario = Number(source?.idBeneficiario || 0);
    if (idBeneficiario > 0) {
      target.idBeneficiario = idBeneficiario;
    }

    const camposId: Array<{ campo: string; alias?: string; extras?: string[]; }> = [
      { campo: 'idBenPrograma', alias: '__idBenPrograma' },
      { campo: 'idSubcuenta', alias: '__idSubcuenta' },
      { campo: 'idCotizacionTarifa', alias: '__idCotizacionTarifa' },
      { campo: 'idCotizacionTarifaAnexo', alias: '__idCotizacionTarifaAnexo' },
      { campo: 'idCotizacionCampania', alias: '__idCotizacionCampania', extras: ['idBenCampania', 'id_ben_campania'] },
    ];

    camposId.forEach(({ campo, alias, extras }) => {
      const id = Number(
        source?.[campo]
        || source?.[alias || '']
        || (extras || []).reduce((acc, key) => acc || source?.[key], 0)
        || 0
      );
      if (id > 0) {
        target[campo] = id;
        if (alias) {
          target[alias] = id;
        }
      }
    });

    if (source?.guardadoEnBd === true) {
      target.guardadoEnBd = true;
    }
  }

  private mergeProgramaContratantePreservandoIdsBd(prev: any, nuevo: any): any {
    const merged = { ...(prev || {}), ...(nuevo || {}) };
    this.asignarIdsPersistenciaProgramaContratante(merged, {
      ...(prev || {}),
      ...(nuevo || {}),
      idBeneficiario: this.obtenerPrimerIdPositivo(nuevo?.idBeneficiario, prev?.idBeneficiario),
      idBenPrograma: this.obtenerPrimerIdPositivo(nuevo?.idBenPrograma, nuevo?.__idBenPrograma, prev?.idBenPrograma, prev?.__idBenPrograma),
      idSubcuenta: this.obtenerPrimerIdPositivo(nuevo?.idSubcuenta, nuevo?.__idSubcuenta, prev?.idSubcuenta, prev?.__idSubcuenta),
      idCotizacionTarifa: this.obtenerPrimerIdPositivo(
        nuevo?.idCotizacionTarifa,
        nuevo?.__idCotizacionTarifa,
        prev?.idCotizacionTarifa,
        prev?.__idCotizacionTarifa
      ),
      idCotizacionTarifaAnexo: this.obtenerPrimerIdPositivo(
        nuevo?.idCotizacionTarifaAnexo,
        nuevo?.__idCotizacionTarifaAnexo,
        prev?.idCotizacionTarifaAnexo,
        prev?.__idCotizacionTarifaAnexo
      ),
      idCotizacionCampania: this.obtenerPrimerIdPositivo(
        nuevo?.idCotizacionCampania,
        nuevo?.__idCotizacionCampania,
        prev?.idCotizacionCampania,
        prev?.__idCotizacionCampania
      ),
      guardadoEnBd: nuevo?.guardadoEnBd === true || prev?.guardadoEnBd === true,
    });
    return merged;
  }

  private extraerIdsUnicosOrdenados(ids: Array<number | null | undefined>): number[] {
    const unique = new Set<number>();
    (ids || []).forEach((value) => {
      const id = Number(value || 0);
      if (id > 0) {
        unique.add(id);
      }
    });
    return Array.from(unique.values());
  }

  private obtenerPrimerIdPositivo(...candidates: any[]): number {
    for (const candidate of candidates) {
      const id = Number(candidate || 0);
      if (Number.isFinite(id) && id > 0) {
        return id;
      }
    }
    return 0;
  }

  private limpiarPersistenciaContratanteTrasDelete(): void {
    try {
      const rawDatos = localStorage.getItem(this.KEY_DATOS_CONTRATANTE_STORAGE);
      if (rawDatos) {
        const parsed = JSON.parse(rawDatos || '{}');
        delete parsed.idBeneficiario;
        delete parsed.id_beneficiario_guardado;
        localStorage.setItem(this.KEY_DATOS_CONTRATANTE_STORAGE, JSON.stringify(parsed));
      }
    } catch {
      // no-op
    }

    try {
      const rawProgramas = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      if (rawProgramas) {
        const parsed = JSON.parse(rawProgramas || '[]');
        const mapped = (items: any[]) => items.map((item) => ({
          ...(item || {}),
          idBeneficiario: null,
          idBenPrograma: null,
          idSubcuenta: null,
          idCotizacionTarifa: null,
          idCotizacionTarifaAnexo: null,
          idCotizacionCampania: null,
          idBenCampania: null,
          guardadoEnBd: false,
        }));

        if (Array.isArray(parsed)) {
          localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify(mapped(parsed)));
        } else {
          localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify({
            ...(parsed || {}),
            programas: mapped(Array.isArray(parsed?.programas) ? parsed.programas : []),
          }));
        }
      }
    } catch {
      // no-op
    }

    try {
      localStorage.removeItem(this.KEY_FLECHA_BENEFICIARIOS_SNAPSHOT);
    } catch {
      // no-op
    }

    this.refrescarFilaContratanteDesdeStorage(false);
  }

  private extraerItemsRespuestaPersistencia(response: any): any[] {
    const d = response?.data ?? response;
    const collected: any[] = [];
    const seen = new Set<any>();

    const push = (item: any, inheritedIdBenPrograma?: number) => {
      if (item == null || typeof item !== 'object') return;
      if (seen.has(item)) return;
      seen.add(item);

      const idBenPrograma = Number(
        item?.idBenPrograma ?? item?.id_ben_programa ?? inheritedIdBenPrograma ?? 0
      );
      collected.push({
        ...item,
        idBenPrograma: idBenPrograma > 0 ? idBenPrograma : (item?.idBenPrograma ?? item?.id_ben_programa)
      });

      const nested = [
        item?.items,
        item?.jsonRespuesta,
        item?.programas,
        item?.campanias,
        item?.tarifas,
        item?.subcuentas
      ];
      nested.forEach((arr) => {
        if (Array.isArray(arr)) {
          arr.forEach((child: any) => push(child, idBenPrograma || inheritedIdBenPrograma));
        } else if (arr && typeof arr === 'object') {
          push(arr, idBenPrograma || inheritedIdBenPrograma);
        }
      });
    };

    if (Array.isArray(d)) {
      d.forEach((item) => push(item));
    } else if (d && typeof d === 'object') {
      push(d);
    }

    return collected;
  }

  private extraerIdCampaniaDesdeItem(item: any): number {
    return Number(
      item?.idCotizacionCampania
      ?? item?.id_cotizacion_campania
      ?? item?.idBenCampania
      ?? item?.id_ben_campania
      ?? item?.idCotizacionCampana
      ?? 0
    );
  }

  private hydrateIdBenProgramaByProgramaDesdeRespuestaGuardar(
    itemsProgramas: Array<{ programa: string; nombrePrograma: string; lineaNegocio: string; esAnexo: boolean; }>,
    response: any,
    target: Map<string, number>
  ): void {
    const items = this.extraerItemsRespuestaPersistencia(response);

    items.forEach((item: any) => {
      const programa = (item?.programa || '').toString().trim().toUpperCase();
      const idBenPrograma = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      if (programa && idBenPrograma > 0) {
        target.set(programa, idBenPrograma);
      }
    });

    if (target.size) return;

    itemsProgramas.forEach((it, index) => {
      const item = items[index];
      const idBenPrograma = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      if (idBenPrograma > 0) {
        target.set((it.programa || '').toString().trim().toUpperCase(), idBenPrograma);
      }
    });
  }

  private hydrateIdsTarifaByProgramaDesdeRespuestaGuardar(
    response: any,
    idBenProgramaByPrograma: Map<string, number>,
    idCotizacionTarifaByPrograma: Map<string, number>,
    idCotizacionTarifaAnexoByPrograma: Map<string, number>
  ): void {
    const items = this.extraerItemsRespuestaPersistencia(response);

    const programaByIdBenPrograma = new Map<number, string>();
    idBenProgramaByPrograma.forEach((idBenPrograma, programa) => {
      if (idBenPrograma > 0) {
        programaByIdBenPrograma.set(idBenPrograma, programa);
      }
    });

    items.forEach((item: any) => {
      const idBenPrograma = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      const idCotizacionTarifa = Number(item?.idCotizacionTarifa ?? item?.id_cotizacion_tarifa ?? 0);
      const esAnexo = item?.esAnexo === true;
      const programaCode = (item?.programa || item?.planCodi || '').toString().trim().toUpperCase();
      const programa = programaByIdBenPrograma.get(idBenPrograma)
        || (programaCode && idBenProgramaByPrograma.has(programaCode) ? programaCode : '');
      if (!programa || !(idCotizacionTarifa > 0)) return;
      if (esAnexo) {
        idCotizacionTarifaAnexoByPrograma.set(programa, idCotizacionTarifa);
      } else {
        idCotizacionTarifaByPrograma.set(programa, idCotizacionTarifa);
      }
    });
  }

  private hydrateIdsCampaniaByProgramaDesdeRespuestaGuardar(
    response: any,
    idBenProgramaByPrograma: Map<string, number>,
    idCotizacionCampaniaByPrograma: Map<string, number>
  ): void {
    const items = this.extraerItemsRespuestaPersistencia(response);

    const programaByIdBenPrograma = new Map<number, string>();
    idBenProgramaByPrograma.forEach((idBenPrograma, programa) => {
      if (idBenPrograma > 0) {
        programaByIdBenPrograma.set(idBenPrograma, programa);
      }
    });

    items.forEach((item: any) => {
      const idBenPrograma = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      const idCotizacionCampania = this.extraerIdCampaniaDesdeItem(item);
      const programaCode = (item?.programa || item?.planCodi || '').toString().trim().toUpperCase();
      const programa = programaByIdBenPrograma.get(idBenPrograma)
        || (programaCode && idBenProgramaByPrograma.has(programaCode) ? programaCode : '');
      if (!programa || !(idCotizacionCampania > 0)) return;
      idCotizacionCampaniaByPrograma.set(programa, idCotizacionCampania);
    });

    if (idCotizacionCampaniaByPrograma.size) return;

    const campIds = items
      .map((item: any) => this.extraerIdCampaniaDesdeItem(item))
      .filter((id: number) => id > 0);
    const programasOrden = Array.from(idBenProgramaByPrograma.keys());
    programasOrden.forEach((programa, idx) => {
      const idCamp = Number(campIds[idx] || 0);
      if (idCamp > 0) {
        idCotizacionCampaniaByPrograma.set(programa, idCamp);
      }
    });
  }

  private hydrateIdsSubcuentaByProgramaDesdeRespuestaGuardar(
    response: any,
    subcuentasEnviadas: Array<{ subcta: string; nombreSubcuenta: string; planCodi: string }>,
    targetMap: Map<string, number>
  ): void {
    const data = response?.data;
    const items = Array.isArray(data) ? data : Array.isArray(data?.subcuentas) ? data.subcuentas : Array.isArray(data?.items) ? data.items : data ? [data] : [];

    items.forEach((item: any) => {
      const idSubcuenta = Number(item?.idSubcuenta ?? item?.id_subcuenta ?? item?.id_cotizacion_subcuenta ?? item?.idSubcuentaCotizacion ?? 0);
      const planCodi = (item?.planCodi ?? item?.plan_codi ?? item?.programa ?? '').toString().trim().toUpperCase();
      if (idSubcuenta > 0 && planCodi) {
        targetMap.set(planCodi, idSubcuenta);
      }
    });

    if (!targetMap.size && items.length > 0) {
      subcuentasEnviadas.forEach((s, idx) => {
        const item = items[idx];
        const idSubcuenta = Number(item?.idSubcuenta ?? item?.id_subcuenta ?? item?.id_cotizacion_subcuenta ?? 0);
        if (idSubcuenta > 0) {
          targetMap.set((s.planCodi || '').toString().trim().toUpperCase(), idSubcuenta);
        }
      });
    }
  }

  private persistirIdsContratanteEnStorage(
    idBeneficiario: number,
    idCotizacion: number,
    idBenProgramaByPrograma: Map<string, number>,
    idSubcuentaByPrograma: Map<string, number>,
    idCotizacionTarifaByPrograma: Map<string, number>,
    idCotizacionTarifaAnexoByPrograma: Map<string, number>,
    idCotizacionCampaniaByPrograma: Map<string, number>
  ): void {
    const programas = this.obtenerProgramasContratanteDesdeStorage();
    if (!programas || !programas.length) return;
    const actualizados = programas.map((p: any) => {
      const progCode = (p?.programa || p?.id || '').toString().trim().toUpperCase();
      return {
        ...p,
        idBeneficiario: idBeneficiario,
        idBenPrograma: idBenProgramaByPrograma.get(progCode) ?? p?.idBenPrograma,
        idSubcuenta: idSubcuentaByPrograma.get(progCode) ?? p?.idSubcuenta,
        idCotizacionTarifa: idCotizacionTarifaByPrograma.get(progCode) ?? p?.idCotizacionTarifa,
        idCotizacionTarifaAnexo: idCotizacionTarifaAnexoByPrograma.get(progCode) ?? p?.idCotizacionTarifaAnexo,
        idCotizacionCampania: idCotizacionCampaniaByPrograma.get(progCode) ?? p?.idCotizacionCampania,
        guardadoEnBd: true
      };
    });

    // Conservar envelope { idCotizacion, doc, programas } para que el modal pueda precargar.
    // Si se escribe array plano, ProgramaSeleccionStore.cargar() retorna null y la UI queda vacía.
    this.escribirProgramasContratanteEnStorage(actualizados, idCotizacion, idBeneficiario);

    // Inclusión: también anclar id en datosRQ002 (lectura gated + recovery local lo necesitan).
    try {
      const rawDatos = localStorage.getItem('datosRQ002_Contratante');
      if (rawDatos) {
        const parsed = JSON.parse(rawDatos);
        parsed.idBeneficiario = idBeneficiario;
        parsed.id_beneficiario_guardado = idBeneficiario;
        localStorage.setItem('datosRQ002_Contratante', JSON.stringify(parsed));
      }
    } catch {
      // no-op
    }
    // No sincronizar heredados aquí: solo se escribieron IDs de BD del contratante.
    // Re-mergearía programas que el usuario ya eliminó del beneficiario.
  }

  /**
   * Escribe programas_contratante preservando (o reconstruyendo) el envelope del store.
   * El modal de selección precarga solo si hay envelope con idCotizacion coincidente.
   */
  private escribirProgramasContratanteEnStorage(
    programas: any[],
    idCotizacion?: number,
    idBeneficiario?: number
  ): void {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE);
      const parsed = raw ? JSON.parse(raw) : null;
      const datos = this.obtenerDatosContratanteDesdeStorage();
      const idCot = Number(
        idCotizacion
        || (!Array.isArray(parsed) ? parsed?.idCotizacion : 0)
        || this.obtenerIdCotizacionActivaParaFlecha()
        || 0
      );
      const tipoDocumento = (
        (!Array.isArray(parsed) ? parsed?.tipoDocumento : '')
        || datos?.tipoDocumento
        || ''
      ).toString().trim();
      const numeroDocumento = (
        (!Array.isArray(parsed) ? parsed?.numeroDocumento : '')
        || datos?.numeroDocumento
        || ''
      ).toString().trim();

      const envelope = {
        ...((parsed && !Array.isArray(parsed) && typeof parsed === 'object') ? parsed : {}),
        idCotizacion: idCot > 0 ? idCot : Number((parsed as any)?.idCotizacion || 0) || 0,
        tipoDocumento,
        numeroDocumento,
        savedAt: new Date().toISOString(),
        programas: (programas || []).map((p: any) => ({
          ...p,
          ...(Number(idBeneficiario || 0) > 0 ? { idBeneficiario: Number(idBeneficiario) } : {}),
        })),
      };

      localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify(envelope));
    } catch {
      try {
        localStorage.setItem(this.KEY_PROGRAMAS_CONTRATANTE_STORAGE, JSON.stringify(programas || []));
      } catch {
        // no-op
      }
    }
  }

  private refrescarFilaContratanteDesdeStorage(sincronizarHeredados: boolean = true): void {
    const datos = this.obtenerDatosContratanteDesdeStorage();
    if (!datos) return;

    const programas = this.obtenerProgramasContratanteDesdeStorage();
    const beneficiarioContratante = this.construirBeneficiarioContratante(datos, programas) as any;
    const idx = this.datasBeneficiary.findIndex((b: any) => this.esFilaContratante(b));
    if (idx >= 0) {
      const existente = this.datasBeneficiary[idx] as any;
      beneficiarioContratante.position = existente?.position ?? beneficiarioContratante.position;
      this.datasBeneficiary[idx] = {
        ...(existente || {}),
        ...(beneficiarioContratante || {}),
      };
      this.datasBeneficiary = [...this.datasBeneficiary];
      this.updateTableBeneficiary();
    }

    if (!sincronizarHeredados) {
      return;
    }

    // Empuja programas del contratante a beneficiarios vinculados y refresca filas.
    this.sincronizarYRefrescarBeneficiariosHeredados(programas as any);
  }

  /**
   * Beneficiarios con usarProgramasContratante=true: merge inteligente de
   * programas_beneficiario (conserva personalizados) y refresca la tabla.
   */
  private sincronizarYRefrescarBeneficiariosHeredados(programasFuente?: any[]): void {
    if (this._refrescoHeredadosEnCurso) {
      return;
    }
    this._refrescoHeredadosEnCurso = true;
    try {
      this.beneficiarioLocalStorage.sincronizarProgramasDesdeContratante(programasFuente ?? null);
      this.refrescarFilasBeneficiariosHeredadosDesdeLocalStorage();
    } catch {
      // no-op
    } finally {
      this._refrescoHeredadosEnCurso = false;
    }
  }

  /**
   * Copia IDs de BD y programas desde localStorage a TODAS las filas locales
   * (con o sin switch), para que Eliminar/flecha tengan llaves de cascada.
   */
  private refrescarFilasBeneficiariosLocalesDesdeLocalStorage(): void {
    try {
      if (!Array.isArray(this.datasBeneficiary)) return;

      const listaDatos = this.beneficiarioLocalStorage.cargarDatos();
      const listaProgramas = this.beneficiarioLocalStorage.cargarProgramas();
      if (!listaDatos.length) return;

      const docCtr = (() => {
        try {
          const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE_STORAGE);
          const parsed = raw ? JSON.parse(raw) : null;
          return {
            tipo: (parsed?.tipoDocumento || '').toString().trim().toUpperCase(),
            numero: (parsed?.numeroDocumento || '').toString().trim()
          };
        } catch {
          return { tipo: '', numero: '' };
        }
      })();

      let changed = false;
      for (const datos of listaDatos) {
        const parentesco = (datos.parentesco || '').toString().trim().toUpperCase();
        if (parentesco === 'T' || parentesco === 'TITULAR') continue;

        const tipo = (datos.contratanteTipoDocumento || '').toString().trim().toUpperCase();
        const numero = (datos.contratanteDocumento || '').toString().trim();
        if (docCtr.tipo && docCtr.numero && tipo === docCtr.tipo && numero === docCtr.numero) {
          continue;
        }

        const localId = (datos.localId || '').toString().trim();
        const idx = this.datasBeneficiary.findIndex((b: any) => {
          if (localId && (b?.localId || '').toString().trim() === localId) return true;
          return this._norm2(b?.num_documento) === this._norm2(numero)
            && this._norm2(b?.tipo_documento) === this._norm2(tipo)
            && this._norm2(b?.parentesco_id) === this._norm2(parentesco);
        });
        if (idx < 0) continue;

        const envelope = this.resolverEnvelopeProgramasBeneficiarioLocal(
          listaProgramas,
          { localId, tipo, numero, parentesco }
        );
        const programasRaw = Array.isArray(envelope?.programas)
          ? envelope!.programas.filter((p: any) => !!p && typeof p === 'object')
          : [];
        const programasCfg = programasRaw.map((p: any) => {
          try {
            return this.construirProgramaConfigContratanteDesdeStorage(p);
          } catch {
            return {
              id: (p?.programa || p?.id || '').toString().trim(),
              programa: (p?.programa || p?.id || '').toString().trim(),
              nombre: (p?.nombrePrograma || p?.nombre || p?.programa || p?.id || '').toString().trim(),
              lineaNegocio: (p?.lineaNegocio || '').toString().trim(),
              tarifa: (p?.tarifa || '').toString().trim(),
              subcuenta: (p?.subcuenta || '').toString().trim(),
              campana: (p?.campana || '').toString().trim(),
              idBenPrograma: p?.idBenPrograma,
              idSubcuenta: p?.idSubcuenta,
              idCotizacionTarifa: p?.idCotizacionTarifa,
              idCotizacionTarifaAnexo: p?.idCotizacionTarifaAnexo,
              idCotizacionCampania: p?.idCotizacionCampania
            };
          }
        }).filter((p: any) => !!(p?.id || p?.programa));

        const existente = this.datasBeneficiary[idx] as any;
        const usarSwitch = datos?.usarProgramasContratante === true
          || existente?.usarProgramasContratante === true
          || existente?.programasConfig?.usarProgramasContratante === true;
        this.datasBeneficiary[idx] = {
          ...existente,
          localId: localId || existente?.localId,
          id_beneficiario: Number((datos as any)?.idBeneficiario || existente?.id_beneficiario || existente?.idBeneficiario || 0) || existente?.id_beneficiario,
          idBeneficiario: Number((datos as any)?.idBeneficiario || existente?.idBeneficiario || existente?.id_beneficiario || 0) || existente?.idBeneficiario,
          usarProgramasContratante: usarSwitch,
          program: programasCfg.map((p: any) => p.nombre || p.programa || p.id).filter(Boolean).join(', ') || existente?.program,
          lineOfBusiness: (datos.lineaNegocios || existente?.lineOfBusiness || '').toString(),
          programasConfig: {
            ...(existente?.programasConfig || {}),
            usarProgramasContratante: usarSwitch,
            programas: programasCfg.length ? programasCfg : (existente?.programasConfig?.programas || [])
          }
        };
        changed = true;
      }

      if (changed) {
        this.datasBeneficiary = [...this.datasBeneficiary];
        this.updateTableBeneficiary();
      }
    } catch {
      // no-op
    }
  }

  private refrescarFilasBeneficiariosHeredadosDesdeLocalStorage(): void {
    try {
      if (!Array.isArray(this.datasBeneficiary)) {
        return;
      }

      const listaDatos = this.beneficiarioLocalStorage.cargarDatos();
      const listaProgramas = this.beneficiarioLocalStorage.cargarProgramas();
      let changed = false;

      const sigueEnStorage = (b: any): boolean => {
        const localId = (b?.localId || '').toString().trim();
        const tipo = this._norm2(b?.tipo_documento);
        const numero = this._norm2(b?.num_documento);
        const parentesco = this._norm2(b?.parentesco_id);
        return listaDatos.some(d => {
          if (d?.usarProgramasContratante !== true) return false;
          const dLocalId = (d?.localId || '').toString().trim();
          if (localId && dLocalId && localId === dLocalId) return true;
          return this._norm2(d?.contratanteTipoDocumento) === tipo
            && this._norm2(d?.contratanteDocumento) === numero
            && this._norm2(d?.parentesco) === parentesco;
        });
      };

      // Quitar de la tabla beneficiarios sincronizados que ya no existen en LS
      // (contratante en 0 programas → se eliminaron del storage).
      const antes = this.datasBeneficiary.length;
      this.datasBeneficiary = this.datasBeneficiary.filter((b: any) => {
        const esContratante = b?.es_contratante === true || (b?.es_contratante as any) === 'S'
          || this._norm2(b?.parentesco_id) === 'T';
        if (esContratante) return true;

        const synced = b?.usarProgramasContratante === true
          || b?.programasConfig?.usarProgramasContratante === true;
        if (!synced) return true;

        return sigueEnStorage(b);
      });
      if (this.datasBeneficiary.length !== antes) {
        changed = true;
      }

      if (!listaDatos.length) {
        if (changed) {
          this.datasBeneficiary = [...this.datasBeneficiary];
          this.updateTableBeneficiary();
        }
        return;
      }

      const docCtr = (() => {
        try {
          const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE_STORAGE);
          const parsed = raw ? JSON.parse(raw) : null;
          return {
            tipo: (parsed?.tipoDocumento || '').toString().trim().toUpperCase(),
            numero: (parsed?.numeroDocumento || '').toString().trim()
          };
        } catch {
          return { tipo: '', numero: '' };
        }
      })();

      for (const datos of listaDatos) {
        if (datos?.usarProgramasContratante !== true) continue;

        const parentesco = (datos.parentesco || '').toString().trim().toUpperCase();
        if (parentesco === 'T' || parentesco === 'TITULAR') continue;

        const tipo = (datos.contratanteTipoDocumento || '').toString().trim().toUpperCase();
        const numero = (datos.contratanteDocumento || '').toString().trim();
        if (docCtr.tipo && docCtr.numero && tipo === docCtr.tipo && numero === docCtr.numero) {
          continue;
        }

        const localId = (datos.localId || '').toString().trim();
        const idx = this.datasBeneficiary.findIndex((b: any) => {
          if (localId && (b?.localId || '').toString().trim() === localId) return true;
          return this._norm2(b?.num_documento) === this._norm2(numero)
            && this._norm2(b?.tipo_documento) === this._norm2(tipo)
            && this._norm2(b?.parentesco_id) === this._norm2(parentesco);
        });
        if (idx < 0) continue;

        const envelope = listaProgramas.find(p =>
          (localId && (p?.localId || '').toString().trim() === localId) ||
          (
            this._norm2(p?.numeroDocumento) === this._norm2(numero) &&
            this._norm2(p?.tipoDocumento) === this._norm2(tipo) &&
            this._norm2(p?.parentesco) === this._norm2(parentesco)
          )
        );
        const programasRaw = Array.isArray(envelope?.programas)
          ? envelope!.programas.filter((p: any) => !!p && typeof p === 'object')
          : [];
        const programasCfg = programasRaw.map((p: any) => {
          try {
            return this.construirProgramaConfigContratanteDesdeStorage(p);
          } catch {
            return {
              id: (p?.programa || p?.id || '').toString().trim(),
              programa: (p?.programa || p?.id || '').toString().trim(),
              nombre: (p?.nombrePrograma || p?.nombre || p?.programa || p?.id || '').toString().trim(),
              lineaNegocio: (p?.lineaNegocio || '').toString().trim(),
              tarifa: (p?.tarifa || '').toString().trim(),
              subcuenta: (p?.subcuenta || '').toString().trim(),
              campana: (p?.campana || '').toString().trim()
            };
          }
        }).filter((p: any) => !!(p?.id || p?.programa));

        const existente = this.datasBeneficiary[idx] as any;
        this.datasBeneficiary[idx] = {
          ...existente,
          localId: localId || existente?.localId,
          id_beneficiario: Number((datos as any)?.idBeneficiario || existente?.id_beneficiario || existente?.idBeneficiario || 0) || existente?.id_beneficiario,
          idBeneficiario: Number((datos as any)?.idBeneficiario || existente?.idBeneficiario || existente?.id_beneficiario || 0) || existente?.idBeneficiario,
          usarProgramasContratante: true,
          program: programasCfg.map((p: any) => p.nombre || p.programa || p.id).filter(Boolean).join(', '),
          lineOfBusiness: programasCfg.length
            ? (datos.lineaNegocios || existente?.lineOfBusiness || '').toString()
            : '',
          programasConfig: {
            usarProgramasContratante: true,
            lineasSeleccionadas: Array.from(new Set(
              programasCfg.map((p: any) => this._aliasONombreLinea2(p?.lineaNegocio || '')).filter(Boolean)
            )),
            programas: programasCfg
          },
          programIds: programasCfg.map((p: any) => p.id || p.programa).filter(Boolean)
        };
        changed = true;
      }

      if (changed) {
        this.datasBeneficiary = [...this.datasBeneficiary];
        this.updateTableBeneficiary();
      }
    } catch {
      // no-op
    }
  }

  private buildBeneficiarioPayloadDesdeStorage(datos: ContratanteStorageData, idCotizacion: number): Beneficiarios {
    const b = new BeneficiariosModel();
    b.id_cotizacion = idCotizacion;
    b.es_contratante = true;
    b.parentesco_id = 'T';
    b.tipo_documento = (datos?.tipoDocumento || '').toString().trim();
    b.num_documento = (datos?.numeroDocumento || '').toString().trim();
    b.primer_nombre = (datos?.primerNombre || '').toString().trim();
    b.segundo_nombre = (datos?.segundoNombre || '').toString().trim();
    b.primer_apellido = (datos?.primerApellido || '').toString().trim();
    b.segundo_apellido = (datos?.segundoApellido || '').toString().trim();
    b.genero = (datos?.genero || '').toString().trim();
    b.fecha_nacimiento = this.normalizarFechaSoloYYYYMMDD((datos?.fechaNacimiento || '').toString().trim());
    b.edad = this.calcularEdadDesdeFechaYYYYMMDD(b.fecha_nacimiento).toString();
    return b as unknown as Beneficiarios;
  }

  private normalizarFechaSoloYYYYMMDD(value: string): string {
    const raw = (value || '').toString().trim();
    if (!raw) return '';

    const ymd = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) {
      return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;
    }

    const dmy = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dmy) {
      return `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
    }

    return raw;
  }

  private calcularEdadDesdeFechaYYYYMMDD(fecha: string): number {
    const raw = (fecha || '').toString().trim();
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return 0;
    const birth = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    if (Number.isNaN(birth.getTime())) return 0;
    const now = new Date();
    let edad = now.getFullYear() - birth.getFullYear();
    const mNow = now.getMonth() - birth.getMonth();
    if (mNow < 0 || (mNow === 0 && now.getDate() < birth.getDate())) {
      edad--;
    }
    return Math.max(edad, 0);
  }

  private extractIdBeneficiarioFromResponse(resp: any): number {
    const candidates = [
      resp?.data?.idBeneficiario,
      resp?.data?.id_beneficiario,
      resp?.idBeneficiario,
      resp?.id_beneficiario,
      resp?.data?.beneficiario?.idBeneficiario,
      resp?.data?.beneficiario?.id_beneficiario,
      Array.isArray(resp?.data) ? resp.data?.[0]?.idBeneficiario : null,
      Array.isArray(resp?.data) ? resp.data?.[0]?.id_beneficiario : null,
      resp?.data?.jsonRespuesta?.idBeneficiario,
      resp?.data?.jsonRespuesta?.id_beneficiario,
      Array.isArray(resp?.data?.jsonRespuesta) ? resp.data?.jsonRespuesta?.[0]?.idBeneficiario : null,
      Array.isArray(resp?.data?.jsonRespuesta) ? resp.data?.jsonRespuesta?.[0]?.id_beneficiario : null,
    ];

    for (const value of candidates) {
      const n = Number(value);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return 0;
  }

  private extractIdBenProgramaFromResponse(resp: any): number {
    const d = resp?.data;
    const candidates = [
      d?.idBenPrograma,
      d?.id_ben_programa,
      resp?.idBenPrograma,
      resp?.id_ben_programa,
      d?.jsonRespuesta?.[0]?.idBenPrograma,
      d?.jsonRespuesta?.[0]?.id_ben_programa,
      Array.isArray(d) ? d?.[0]?.idBenPrograma : undefined,
      Array.isArray(d) ? d?.[0]?.id_ben_programa : undefined,
    ];
    for (const c of candidates) {
      const n = Number(c || 0);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return 0;
  }

  private normalizarLineaNegocioProgramasStorage(value: string): string {
    const v = (value || '').toString().trim().toUpperCase();
    if (!v) return '';
    if (v === 'SALUD ORAL' || v === 'SAO') return 'SO';
    if (v === 'MEDICINA INTEGRAL' || v === 'SMP') return 'MI';
    return v;
  }

  debeGuardarSubcuentasPorTipoPlan(): boolean {
    const plan = (localStorage.getItem('tipoPlan') || '').toString().trim().toUpperCase();
    return plan === 'C' || plan === 'CY' || plan === 'GA' || plan === 'AG' || plan.includes('COLECTIV') || plan.includes('AFINIDAD');
  }

  private esFilaContratante(fila: any): boolean {
    if (!fila) return false;

    const esUsuarioFila = fila?.esUsuario === true;
    const esContratanteFlag = fila?.es_contratante === true || (fila?.es_contratante as any) === 'S';
    const parentesco = (fila?.parentesco_id || '').toString().trim().toUpperCase();
    const typeDesc = (fila?.typeDescripcion || '').toString().trim().toUpperCase();
    const esTitular = parentesco === 'T' || typeDesc === 'TITULAR';

    return esUsuarioFila || esContratanteFlag || esTitular;
  }

  private obtenerFilasContratanteTabla(): any[] {
    const rows = Array.isArray(this.datasSourceBeneficiary?.data) ? this.datasSourceBeneficiary.data : [];
    return rows.filter((r: any) => this.esFilaContratante(r));
  }

  private filtrarProgramasContratantePorFilas(
    programas: ProgramaContratanteStorageItem[],
    filasContratante: any[]
  ): ProgramaContratanteStorageItem[] {
    if (!Array.isArray(programas) || !programas.length) return [];
    if (!Array.isArray(filasContratante) || !filasContratante.length) return [];

    const norm = (v: any) => (v ?? '').toString().trim().toUpperCase();
    const clavesFila = new Set(
      filasContratante.map((f: any) => {
        const p = norm((f as any)?.__programaCodigo || f?.program || '');
        const l = norm(this._aliasONombreLinea2((f as any)?.lineOfBusiness || ''));
        return `${p}|${l}`;
      })
    );

    const filtrados = programas.filter((p) => {
      const pCode = norm(p?.programa || p?.id || '');
      const pLinea = norm(this._aliasONombreLinea2((p as any)?.lineaNegocio || (p as any)?.lineaNegocioNombre || ''));
      const exactKey = `${pCode}|${pLinea}`;
      const byProgramOnly = Array.from(clavesFila).some((k) => k.startsWith(`${pCode}|`));
      return clavesFila.has(exactKey) || byProgramOnly;
    });

    return filtrados.length ? filtrados : programas;
  }

  private buildSnapshotFlechaBeneficiarios(
    idCotizacion: number,
    datos: ContratanteStorageData,
    programas: ProgramaContratanteStorageItem[],
    persistenciaBd?: FlechaPersistenciaBdSnapshot
  ): string {
    const norm = (v: any) => (v ?? '').toString().trim();

    const programasCanonicos = (programas || [])
      .map((p) => ({
        lineaNegocio: norm((p as any)?.lineaNegocio || (p as any)?.lineaNegocioNombre || '').toUpperCase(),
        programa: norm(p?.programa || p?.id || '').toUpperCase(),
        grupoPrograma: norm(
          p?.grupoPrograma ||
          (p as any)?.grupo_programa ||
          (p as any)?.GRUPO_PROGRAMA ||
          ''
        ).toUpperCase(),
        subcta: norm((p as any)?.subcta || ''),
        tarifa: norm((p as any)?.tarifa || (p as any)?.tarifaDetalle?.tari || ''),
        tarifaAnexo: norm((p as any)?.tarifaAnexo || (p as any)?.anexoDetalle?.tari || ''),
        campana: norm((p as any)?.campana || (p as any)?.campaniaDetalle?.codigo_campania || ''),
        requiereAnexo: this.normalizarRequiereAnexo((p as any)?.requiereAnexo) || 'no',
      }))
      .filter((p) => !!p.programa)
      .sort((a, b) => `${a.programa}|${a.lineaNegocio}`.localeCompare(`${b.programa}|${b.lineaNegocio}`));

    const payload = {
      idCotizacion: Number(idCotizacion || 0),
      contratante: {
        tipoDocumento: norm(datos?.tipoDocumento).toUpperCase(),
        numeroDocumento: norm(datos?.numeroDocumento),
        primerNombre: norm(datos?.primerNombre).toUpperCase(),
        primerApellido: norm(datos?.primerApellido).toUpperCase(),
        genero: norm(datos?.genero).toUpperCase(),
        fechaNacimiento: norm(this.normalizarFechaSoloYYYYMMDD(datos?.fechaNacimiento || '')),
      },
      programas: programasCanonicos,
      ...(persistenciaBd && (persistenciaBd.idBeneficiario > 0 || (persistenciaBd.programas || []).length > 0)
        ? { persistenciaBd }
        : {}),
    };

    return JSON.stringify(payload);
  }

  private obtenerSnapshotFlechaGuardado(): string | null {
    try {
      const raw = localStorage.getItem(this.KEY_FLECHA_BENEFICIARIOS_SNAPSHOT);
      if (!raw) return null;
      return raw;
    } catch {
      return null;
    }
  }

  private guardarSnapshotFlecha(snapshot: string): void {
    try {
      localStorage.setItem(this.KEY_FLECHA_BENEFICIARIOS_SNAPSHOT, snapshot);
    } catch {
      // no-op
    }
  }

  /** Metodo para setear la moneda */
  valorMoneda(value: any) {
    var numero = "0";
    if (value != null && value != "") {
      value = value.toString().replace(",", "");

      numero = value;
    }
    return new Intl.NumberFormat("es-CO").format(parseInt(numero));
  }

  /** Metodo para validar seleccion de programas */
  /** NO SE ESTA USANDO */
  seleccionarProducto(
    item: {
      beneficiario: any;
      programa: any;
      estado: boolean;
      subcuenta: string;
      tarifa: any;
      tarifaAsociado: any;
      tarifa_asociado: string;
      valor2: any;
      valor1: any;
    },
    tabla: { itemsPago: any[]; }
  ) {
    const itemTEmporal = item.estado;
    if (this.dataCampania.codigo_tipo_plan === "F" && item.valor1 <= 0) {
      this.SnackBarService.alert(
        "alert-danger",
        "Debe seleccionar un programa familiar con valores"
      );
      return;
    }

    if (this.dataCampania.codigo_tipo_plan !== "F" && item.valor1 <= 0) {
      this.SnackBarService.alert(
        "alert-danger",
        "Debe seleccionar un programa con valores"
      );
      return;
    }

    const valorTemporal = this.valorFamiliar.find(
      (value) =>
        value.beneficiario === item.beneficiario &&
        value.programa === item.programa
    );
    if (valorTemporal)
      this.valorFamiliar.splice(this.valorFamiliar.indexOf(valorTemporal), 1);

    tabla.itemsPago.forEach((element: { data: any[]; }) => {
      let result = element.data.filter((b: { beneficiario: any; }) => {
        return (
          b.beneficiario.toLowerCase().trim() ==
          item.beneficiario.toLowerCase().trim()
        );
      });
      if (result.length > 0) {
        result.forEach((items) => {
          items.estado = false;
          const dataTemporal = this.valorFamiliar.filter(
            (value) =>
              value.beneficiario === items.beneficiario &&
              value.programa === items.programa
          );
          dataTemporal.forEach((value) =>
            this.valorFamiliar.splice(this.valorFamiliar.indexOf(value), 1)
          );
        });
      }
    });

    item.estado = !itemTEmporal;
    if (item.estado) {
      const linea = Codigo.getLineaNegocio();
      let lineaTemporal = "";
      for (let index = 0; index < linea.length; index++) {
        if (
          item.subcuenta.substring(1, item.subcuenta.length) ===
          linea[index].valor
        )
          lineaTemporal = linea[index].valor;
      }
      this.valorFamiliar.push({
        beneficiario: item.beneficiario,
        programa: item.programa,
        subcuenta: item.subcuenta,
        tarifa: item.tarifa,
        tarifaAsociado: item.tarifaAsociado,
        tarifa_asociado: item.tarifa_asociado === "null" || !item.tarifa_asociado
          ? item.tarifaAsociado
          : item.tarifa_asociado,
        linea_negocio: lineaTemporal === "SMP" ? 1 : lineaTemporal === "SAO" ? 2 : 3,
        valor1: item.valor1,
        valor2: item.valor2,
        valorBruto1: undefined,
        valorBruto2: undefined
      });
    }

    if (this.dataCampania.codigo_tipo_plan === "F") {
      this.valorFamiliaTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor1,
        0
      );
      this.valorAsociadoTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor2,
        0
      );
    } else {
      this.valorAsociadoTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor1,
        0
      );
    }
  }

  /** Metodo para generar descuentos */
  continuarMultiple() {
    let isAnyFieldSelected = false;

    for (let key in this.selectedValue) {
      if (this.selectedValue[key]) {
        isAnyFieldSelected = true;
        break;
      }
    }

    if (!isAnyFieldSelected) {
      for (let item of this.listLineaTable) {
        for (let pago of item.itemsPago) {
          for (let data of pago.data) {
            if (data.estado) {
              isAnyFieldSelected = true;
              break;
            }
          }
          if (isAnyFieldSelected) break;
        }
        if (isAnyFieldSelected) break;
      }
    }

    if (!isAnyFieldSelected) {
      this.showMessageDialog(
        "Error", // Título del diálogo
        "Debes seleccionar primero un plan.", // Mensaje del diálogo
        "Aceptar", // Texto del primer botón
        "", // Texto del segundo botón (vacío si no se usa)
        true, // Uso de un botón (true) o dos botones (false)
        2, // Tipo de icono (puedes ajustar según tu lógica)
        this.dialog, // Objeto MatDialog
        (_: any) => { } // Callback
      );
      return;
    }

    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    this.ocultarPlanFamiliar = this.formInit.get('tipoPlan')?.value == 'F';
    let Des3FyC: IPorcentajeDescuentos[];
    let Des3A: IPorcentajeDescuentos[];
    let Des6FyC: IPorcentajeDescuentos[];
    let Des6A: IPorcentajeDescuentos[];
    let Des12FyC: IPorcentajeDescuentos[];
    let Des12A: IPorcentajeDescuentos[];
    let IVA: IPorcentajeDescuentos[];
    this.idCollapse = [];
    this.networking
      .buscarDescuentosSubscribe()
      .subscribe((r: ModelDefaultResponse<any>) => {
        let dat: any = r;
        let result: Array<IPorcentajeDescuentos> = dat;
        Des3FyC = result.filter(
          (b: { nombre: string; }) => b.nombre === "Des3FyC"
        );
        Des3A = result.filter((b: { nombre: string; }) => b.nombre === "Des3A");
        Des6FyC = result.filter(
          (b: { nombre: string; }) => b.nombre === "Des6FyC"
        );
        Des6A = result.filter((b: { nombre: string; }) => b.nombre === "Des6A");
        Des12FyC = result.filter(
          (b: { nombre: string; }) => b.nombre === "Des12FyC"
        );
        Des12A = result.filter(
          (b: { nombre: string; }) => b.nombre === "Des12A"
        );
        IVA = result.filter((b: { nombre: string; }) => b.nombre === "IVA");

        if (this.listLineaTable != undefined) {
          this.mostrarResumen = true;
          this.listDetallePagoMensual = [...this.valorFamiliar];
          this.cuotaInscripcion = this.valCuota.replace(",", "");
          if (tipoPlanLocal == "A") {
            this.cuotaTotalAsociado = this.valorFamiliar.reduce(
              (value, curren) => value + curren.valorBruto1,
              0
            );
            this.cuotaTotal = this.valorFamiliar.reduce(
              (value, curren) => value + curren.valorBruto2,
              0
            );
          } else {
            this.cuotaTotal = this.valorFamiliar.reduce(
              (value, curren) => value + curren.valorBruto1,
              0
            );
            this.cuotaTotalAsociado = this.valorFamiliar.reduce(
              (value, curren) => value + curren.valorBruto2,
              0
            );
          }

          const tres = [+Des3FyC[0].valor, +Des3A[0].valor];
          const seis = [+Des6FyC[0].valor, +Des6A[0].valor];
          const doce = [+Des12FyC[0].valor, +Des12A[0].valor];
          const iva = +IVA[0].valor;

          const value = parseInt(this.cuotaTotal);
          const valueAsociado = parseInt(this.cuotaTotalAsociado);
          const valorPorTresMeses = value * 3;
          const valorPorSeisMeses = value * 6;
          const valorPorDoceMeses = value * 12;
          const valorPorTresMesesAsociado = valueAsociado * 3;
          const valorPorSeisMesesAsociado = valueAsociado * 6;
          const valorPorDoceMesesAsociado = valueAsociado * 12;
          const valorDescuentoAsociado = [
            Math.round((valorPorTresMesesAsociado * tres[1]) / 100),
            Math.round((valorPorSeisMesesAsociado * seis[1]) / 100),
            Math.round((valorPorDoceMesesAsociado * doce[1]) / 100),
          ];
          const valorDescuentoFamiliar = [
            Math.round((valorPorTresMeses * tres[0]) / 100),
            Math.round((valorPorSeisMeses * seis[0]) / 100),
            Math.round((valorPorDoceMeses * doce[0]) / 100),
          ];
          const valorDescuentoAsociadoSinIVA = [
            valorPorTresMesesAsociado - valorDescuentoAsociado[0],
            valorPorSeisMesesAsociado - valorDescuentoAsociado[1],
            valorPorDoceMesesAsociado - valorDescuentoAsociado[2],
          ];
          const valorDescuentoFamiliarSinIVA = [
            valorPorTresMeses - valorDescuentoFamiliar[0],
            valorPorSeisMeses - valorDescuentoFamiliar[1],
            valorPorDoceMeses - valorDescuentoFamiliar[2],
          ];
          const valorIvaDescuentoAsociado = [
            (valorDescuentoAsociadoSinIVA[0] * iva) / 100,
            (valorDescuentoAsociadoSinIVA[1] * iva) / 100,
            (valorDescuentoAsociadoSinIVA[2] * iva) / 100,
          ];
          const valorIvaDescuentoFamiliar = [
            (valorDescuentoFamiliarSinIVA[0] * iva) / 100,
            (valorDescuentoFamiliarSinIVA[1] * iva) / 100,
            (valorDescuentoFamiliarSinIVA[2] * iva) / 100,
          ];

          this.detalle_descuentos = [
            {
              cantidad_mes: 3,
              valor_pago_anticipado_asociado:
                valorDescuentoAsociadoSinIVA[0] + valorIvaDescuentoAsociado[0],
              valor_descuento_asociado: valorDescuentoAsociado[0],
              valor_descuento_familiar: valorDescuentoFamiliar[0],
              valor_pago_anticipado_familiar:
                valorDescuentoFamiliarSinIVA[0] + valorIvaDescuentoFamiliar[0],
            },
            {
              cantidad_mes: 6,
              valor_pago_anticipado_asociado:
                valorDescuentoAsociadoSinIVA[1] + valorIvaDescuentoAsociado[1],
              valor_descuento_asociado: valorDescuentoAsociado[1],
              valor_descuento_familiar: valorDescuentoFamiliar[1],
              valor_pago_anticipado_familiar:
                valorDescuentoFamiliarSinIVA[1] + valorIvaDescuentoFamiliar[1],
            },
            {
              cantidad_mes: 12,
              valor_pago_anticipado_asociado:
                valorDescuentoAsociadoSinIVA[2] + valorIvaDescuentoAsociado[2],
              valor_descuento_asociado: valorDescuentoAsociado[2],
              valor_descuento_familiar: valorDescuentoFamiliar[2],
              valor_pago_anticipado_familiar:
                valorDescuentoFamiliarSinIVA[2] + valorIvaDescuentoFamiliar[2],
            },
          ];
          this.listMultiProduct();
        } else {
          this.showMessageDialog(
            "Error", // Título del diálogo
            "No se puede continuar, no se ha obtenido la cotización.", // Mensaje del diálogo
            "Aceptar", // Texto del primer botón
            "", // Texto del segundo botón (vacío si no se usa)
            true, // Uso de un botón (true) o dos botones (false)
            1, // Tipo de icono (puedes ajustar según tu lógica)
            this.dialog, // Objeto MatDialog
            (_: any) => { } // Callback
          );
        }
      });
  }

  /**
   * Medotod de creación de la lista multiproducto
   */
  listMultiProduct() {
    this.listLineaTableMulti = [];
    let beneficiaryList: any = [];
    this.listLineaTable.forEach(
      (listMultiple: { itemsPago: any[]; nombre: string; }) => {
        beneficiaryList = [];
        let resultTotalMonthly = 0;
        let valueMedIntegral = 0;
        let valueSaludOral = 0;
        this.listDetallePagoMensual.forEach(
          (pagoMensual: {
            linea_negocio: number;
            beneficiario: string;
            programa: string;
            valor1: string;
            valor2: string;
          }) => {
            let imgPrograma = "";
            let result = listMultiple.itemsPago.filter(
              (b: { programa: any; }) => {
                return b.programa.code === pagoMensual.programa;
              }
            );
            if (result.length > 0) {
              result.forEach((dataPrograma: { programa: any; }) => {
                imgPrograma = dataPrograma.programa.file;
              });
              const info2 = {
                beneficiaryName: pagoMensual.beneficiario,
                familyValue: pagoMensual.valor1,
                associatedValue: pagoMensual.valor2,
                imgProgram: imgPrograma,
              };
              beneficiaryList.push(info2);
              if (pagoMensual.linea_negocio === 1) {
                const value = parseInt(pagoMensual.valor1);
                valueMedIntegral = value + valueMedIntegral;
                resultTotalMonthly = valueMedIntegral;
              } else {
                const value = parseInt(pagoMensual.valor1);
                valueSaludOral = value + valueSaludOral;
                resultTotalMonthly = valueSaludOral;
              }
            }
          }
        );

        if (beneficiaryList.length > 0) {
          const info: IListDetail = {
            businessName: listMultiple.nombre,
            typeLine: listMultiple.nombre,
            planType: this.planNombre,
            registrationFee: this.cuotaInscripcion,
            totalMonthlyFee: resultTotalMonthly.toString(),
            beneficiaryList: beneficiaryList,
          };
          this.listLineaTableMulti.push(info);
        }
      }
    );

  }

  /*
searchProductOutputSuccessful(data: any[]) {
    const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');
    const rawInclusion = localStorage.getItem('programas_seleccionados_inclusion');

    // DICCIONARIO DECLARATIVO DE HOMOLOGACIÓN (ADAPTER)
    const homologarLineaUI = (linea: any): string => {
      const l = String(linea || '').trim().toUpperCase();
      if (l === '1' || l === 'MI' || l.includes('INTEGRAL')) return 'SMP';
      if (l === '2' || l === 'SAO' || l.includes('ORAL')) return 'SAO';
      if (l === '3' || l === 'CEM' || l.includes('EMERGENCIA')) return 'CEM';
      return l;
    };

    let productosAdaptados = (data || []).map(prod => {
      const lineaEstandar = homologarLineaUI(prod.lineaNegocio || prod.linea || prod.lineOfBusiness);
      return {
        ...prod,
        lineaNegocio: lineaEstandar,
        linea: lineaEstandar,
        lineOfBusiness: lineaEstandar
      };
    });

    if (tipoSolicitud === '2' && rawInclusion) {
      try {
        const permitidos = JSON.parse(rawInclusion).map((p: string) => p.trim().toUpperCase());
        
        productosAdaptados = productosAdaptados.filter(prod => {
          const codigoProd = String(prod?.code || prod?.codigo || prod?.id || '').trim().toUpperCase();
          
          return permitidos.some((p: string) => {
            const equivalentes = this.obtenerEquivalentesInclusion(p);
            return equivalentes.some(val => 
              codigoProd === val || codigoProd.startsWith(val) || val.startsWith(codigoProd)
            );
          });
        });
      } catch (e) {
        console.error('Error en el filtro de productos de inclusión:', e);
      }
    }


    this.listProgramas = productosAdaptados;
    this.spinner.hide();
  }
  */

  searchProductOutputSuccessful(data: any[]) {
    // 1. DICCIONARIO DE HOMOLOGACIÓN CORRECTO PARA VISTAS INDIVIDUALES / GA
    const homologarLineaUI = (linea: any): string => {
      const l = String(linea || '').trim().toUpperCase();
      if (l === '1' || l === 'MI' || l.includes('INTEGRAL') || l === 'SMP') return 'SMP'; // Retorna 'SMP' para hacer match con el dropdown
      if (l === '2' || l === 'SAO' || l.includes('ORAL') || l === 'SO') return 'SAO';   // Retorna 'SAO' para hacer match con el dropdown
      if (l === '3' || l === 'CEM' || l.includes('EMERGENCIA')) return 'CEM';
      return l;
    };

    let productosAdaptados = (data || []).map(prod => {
      const lineaOriginal = prod.lineaNegocio || prod.linea || prod.lineOfBusiness || prod.linea_nego;
      const codigoProd = String(prod?.code || prod?.codigo || prod?.id || prod?.programa || '').trim().toUpperCase();
      const lineaDeducida = this.clasificarLineaCarnet(lineaOriginal, codigoProd, prod.program || prod.nombrePrograma || '');
      const lineaEstandar = homologarLineaUI(lineaDeducida);
      return { ...prod, lineaNegocio: lineaEstandar, linea: lineaEstandar, lineOfBusiness: lineaEstandar };
    });

    const rawInclusion = localStorage.getItem('programas_seleccionados_inclusion');
    if (rawInclusion) {
      try {
        const permitidos: string[] = JSON.parse(rawInclusion).map((p: string) => p.trim().toUpperCase());
        productosAdaptados = productosAdaptados.filter(prod => {
          const codigoProd = String(prod?.code || prod?.codigo || prod?.id || prod?.programa || '').trim().toUpperCase();
          return permitidos.some((p: string) => codigoProd === p || codigoProd.startsWith(p) || p.startsWith(codigoProd));
        });
      } catch (e) {
        console.error(e);
      }
    }

    this.listProgramas = productosAdaptados;
    this.spinner.hide();
  }

  /** Metodo para mostrar error al recolectar los productos los productos */
  searchProductOutputFailure(error: number, message: string) {
    this.spinner.hide();
    // Swal.fire({
    //   text: (message) ? message : `No se pudo obtener los programas, contacte con administrador`,
    //   confirmButtonColor: '#0372b9',
    //   confirmButtonText: 'OK',
    // });
    const lblMensajeElement = document.getElementById("lblMensaje");
    if (lblMensajeElement) {
      lblMensajeElement.innerText =
        message && message != "undefined" && message != "null" && message != ""
          ? message
          : "Ha ocurrido un error al obtener las campañas";
    } else {
      console.error('El elemento con ID "lblMensaje" no se encontró en el DOM.');
    }

  }

  /** Metodo para validar exp regulares */
  checkPattern(event: any, e: string | (string | number)[]) {
    var re = /^[0-9]+$/;
    var text = "";
    if (this.form.get(e)?.value) {
      this.form.get(e)?.value.split("")
        .forEach((element: string) => {
          if (re.test(element)) {
            text += element;
          }
        });
    }
    this.form.get(e)?.setValue(text);
  }

  /** Metodo para restablecer datos */
  limpiarNull(value: any) {
    return value == null ? "" : value;
  }

  /** Añadir beneficiario desde cotizador */
  multAddClient() {
    this.selectedIndex = 2;
    this.mostrarResumen = false;
    this.idCollapse = [];
    this.ocultarPlanFamiliar = this.formInit.get('tipoPlan')?.value == 'F';
    if (this.contratanteTarifa == 'AAESFQ') this.ocultarPlanFamiliar = false;
  }

  /** regresar desde cotizador */
  comeBackBeneficiary() {
    this.mostrarResumen = false;
    this.idCollapse = [];
  }

  /** eliminar beneficiario */
  eliminarItem(item: { beneficiario: any; }) {
    var newArray: { beneficiario: any; }[] = [];
    this.listDetallePagoMensual.forEach((element: { beneficiario: any; }) => {
      if (element.beneficiario != item.beneficiario) {
        newArray.push(element);
      }
    });
    this.listDetallePagoMensual = newArray;
  }

  hiddenBody(i: any) {
    let x = this.idCollapse.indexOf(parseInt(i));
    if (x !== -1) this.idCollapse.splice(x, 1);
    let element = document.getElementById("hiddenChildre" + i);
    if (element) {
      element.style.visibility = "collapse"; // Oculta el elemento si existe
    } else {
      console.log(`Elemento con ID "hiddenChildre${i}" no encontrado.`);
    }
  }

  showBody(i: any) {
    this.idCollapse.push(parseInt(i));
    let element = document.getElementById("hiddenChildre" + i);
    if (element) {
      element.style.visibility = "visible";
    } else {
      console.log(`Elemento con ID "hiddenChildre${i}" no encontrado.`);
    }
  }

  prepararCotizacionMultiple() {
    this.objDataCotizador["modelo_negocio"] = [];
    this.objDataCotizador["modelo_negocio_asociado"] = [];
    this.listLineaTable = [];
    const linea = Codigo.getLineaNegocio();
    const listCuenta = [];
    const listBeneficiario: { beneficiario: string; list_tarifa: never[]; }[] = [];
    const tipoPlanLocal = this.formInit.get("tipoPlan")?.value;
    let infoMedicina: IListInfoPago[] = [];
    let infoDentales: IListInfoPago[] = [];

    linea.forEach((item) => {
      listCuenta.push({
        key: `${tipoPlanLocal}${item.valor}`,
        nombre: item.nombre,
      });
    });

    this.dataBeneficiary.forEach((element) => {
      let name = element.name + " ";
      let secondname = !element.secondname ? "" : element.secondname + " ";
      let lastname = element.lastname + " ";
      let secondsurname = !element.secondsurname ? "" : element.secondsurname;
      listBeneficiario.push({
        beneficiario: `${name}${secondname}${lastname}${secondsurname}`,
        list_tarifa: [],
      });
    });

    const programasPermitidosMedicina = this.listProgramas.filter((b: any) => b.code != "DEB" && b.code != "DESCB");
    const programasPermitidosDentales = this.listProgramas.filter((b: any) => b.code == "DEB" || b.code == "DESCB");

    programasPermitidosMedicina.forEach((item: any) => {
      let data: {}[] = [];
      this.dataBeneficiary.forEach((element) => {
        let detallePagoMensualDummy = {};
        let name = element.name + " ";
        let secondname = !element.secondname ? "" : element.secondname + " ";
        let lastname = element.lastname + " ";
        let secondsurname = !element.secondsurname ? "" : element.secondsurname;
        detallePagoMensualDummy = {
          beneficiario: `${name}${secondname}${lastname}${secondsurname}`,
          programa: item.code,
          subcuenta: "FSMP",
          valor1: 0,
          valor1Bruto: 0,
          valor1Iva: 0,
          valor2: 0,
          valor2Bruto: 0,
          valor2Iva: 0,
          iva: 0,
          tarifa: "",
          tarifaAsociado: "",
          estado: false,
        };
        data.push(detallePagoMensualDummy);
      });
      let obj: IListInfoPago = {
        programa: item,
        data: data,
      };
      infoMedicina.push(obj);
    });

    // TODO: habilitar programas dentales
    programasPermitidosDentales.forEach((item: any) => {
      let data: {}[] = [];
      this.dataBeneficiary.forEach((element) => {
        let detallePagoMensualDummy = {};
        let name = element.name + " ";
        let secondname = !element.secondname ? "" : element.secondname + " ";
        let lastname = element.lastname + " ";
        let secondsurname = !element.secondsurname ? "" : element.secondsurname;
        detallePagoMensualDummy = {
          beneficiario: `${name}${secondname}${lastname}${secondsurname}`,
          programa: item.code,
          subcuenta: "FSAO",
          valor1: 0,
          valor1Bruto: 0,
          valor1Iva: 0,
          valor2: 0,
          valor2Bruto: 0,
          valor2Iva: 0,
          iva: 0,
          tarifa: "",
          tarifaAsociado: "",
          estado: false,
        };
        data.push(detallePagoMensualDummy);
      });
      let obj: IListInfoPago = {
        programa: item,
        data: data,
      };
      infoDentales.push(obj);
    });


    this.listLineaTable.push({
      key: "FSMP",
      nombre: "MEDICINA INTEGRAL",
      itemsPago: infoMedicina,
      listBeneficiario: listBeneficiario,
    });

    // TODO: habilitar programas dentales
    this.listLineaTable.push({
      key: "FSAO",
      nombre: "SALUD ORAL",
      itemsPago: infoDentales,
      listBeneficiario: listBeneficiario,
    });


    this.selectedIndex = 3;
  }

  seleccionarMultiProducto(
    item: {
      beneficiario: any;
      programa: any;
      estado: boolean;
      subcuenta: string;
      iva: number;
      tarifa: string;
      tarifaAsociado: string;
      valor1: number;
      valor1Bruto: number;
      valor1Iva: number;
      valor2: number;
      valor2Bruto: number;
      valor2Iva: number;
    },
    tabla: { key: string, itemsPago: any[]; listBeneficiario: any[]; nombre: string; },
    idxBeneficiary: number
  ) {
    // TODO: ITEM -> OBTIENE EL PROGRAMA SELECCIONADO DESDE LA TARJETA
    let arrayDataModeloFamiliar;
    let arrayDataModeloFamiliar2;
    let arrayDataModeloAsociado;
    let arrayDataModeloAsociado2;
    // TODO: TIPOPLAN -> F (FAMILIAR) O A (ASOSIADO)
    const tipoPlan = this.formInit.get("tipoPlan")?.value;
    this.listTarifa = [];
    this.programasOrdenados = [];
    // TODO: ESTADO -> LLEGA TRUE / FALSE
    const itemTEmporal = item.estado;
    const arrayDataModelo = [];
    item.estado = !itemTEmporal;

    this.marcarCotizacionIndividualModificada();

    // Cuando se deselecciona el Item
    if (!item.estado) {
      delete this.mSelBenTari[idxBeneficiary][tabla.key.substring(1)];
      if (Object.keys(this.mSelBenTari[idxBeneficiary]).length == 0) {
        delete this.mSelBenTari[idxBeneficiary];
      }

      //console.log("\n\nMi mapa\n\n",this.mSelBenTari);
      item.iva = 0;
      item.tarifa = "";
      item.tarifaAsociado = "";
      item.valor1 = 0;
      item.valor1Bruto = 0;
      item.valor1Iva = 0;
      item.valor2 = 0;
      item.valor2Bruto = 0;
      item.valor2Iva = 0;
      this.actualizarCotizacionBeneficiario();
      this.marcarCotizacionIndividualModificada();
      return;
    }

    //Setiar los valores a 0 en la tabla (Visual)
    tabla.itemsPago.forEach(item => {
      const beneficiary = item.data[idxBeneficiary];
      beneficiary.iva = 0;
      beneficiary.tarifa = "";
      beneficiary.tarifaAsociado = "";
      beneficiary.valor1 = 0;
      beneficiary.valor1Bruto = 0;
      beneficiary.valor1Iva = 0;
      beneficiary.valor2 = 0;
      beneficiary.valor2Bruto = 0;
      beneficiary.valor2Iva = 0;
    });

    // TODO: itemsPago -> programa | data
    tabla.itemsPago.forEach((element: { data: any[]; }) => {
      let result = element.data.filter((b: { beneficiario: any; }) => {
        // TODO: Compara el beneficiario de la tabla con el que viene en la propiedad item
        return (
          b.beneficiario.toLowerCase().trim() ==
          item.beneficiario.toLowerCase().trim()
        );
      });
      if (result.length > 0) {
        result.forEach((items) => {
          items.estado = false;
          /* TODO: QUEDA PENDIENTE SU USO NO SE LE ENCUENTRA UN SIGNIFICADO */
          const dataTemporal = this.valorFamiliar.filter(
            (value) =>
              value.beneficiario === items.beneficiario &&
              value.programa === items.programa
          );
          dataTemporal.forEach((value) =>
            this.valorFamiliar.splice(this.valorFamiliar.indexOf(value), 1)
          );
        });
      }
    });

    if (this.dataCampania.codigo_tipo_plan === "F") {
      this.valorFamiliaTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor1,
        0
      );
      this.valorAsociadoTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor2,
        0
      );
      this.valorFamiliaTotalBruto = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valorBruto1,
        0
      );
      this.valorAsociadoTotalBruto = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valorBruto2,
        0
      );
    } else {
      this.valorAsociadoTotal = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valor1,
        0
      );
      this.valorAsociadoTotalBruto = this.valorFamiliar.reduce(
        (value, curren) => value + curren.valorBruto1,
        0
      );
    }

    item.estado = !itemTEmporal;

    if (item.estado) {
      let programas = this.programasSeleccionados.filter((p: { k: string; b: any; }) => p.k === item.subcuenta && p.b === item.beneficiario.toLowerCase().trim());
      if (programas.length > 0) {
        const programasD: any[] = [];
        this.programasSeleccionados.map((p: { k: string; b: any; }) => {
          if (p.k !== item.subcuenta && p.b === item.beneficiario.toLowerCase().trim()) {
            programasD.push(p);
          }
          if (p.b !== item.beneficiario.toLowerCase().trim()) {
            programasD.push(p);
          }
        });
        this.programasSeleccionados = programasD;
      }
      this.programasSeleccionados.push({
        k: item.subcuenta,
        p: item.programa,
        b: item.beneficiario.toLowerCase().trim()
      });
    } else {
      this.programasSeleccionados = this.programasSeleccionados.filter((p: { p: any; b: any; }) => p.p !== item.programa && p.b !== item.beneficiario.toLowerCase().trim());
    }

    this.programasSeleccionados.map((p: { p: string; }) => {
      if (!this.programasOrdenados.includes(p.p)) this.programasOrdenados.push(p.p);
    });

    // TODO: el beneficiario de la tabla
    let result2 = tabla.listBeneficiario.filter(
      (b: { beneficiario: any; }) => {
        // TODO: Compara el beneficiario de la tabla con el que viene en la propiedad item
        return (
          b.beneficiario.toLowerCase().trim() ==
          item.beneficiario.toLowerCase().trim()
        );
      }
    );
    // TODO: posición en que se encuentra el beneficiario de la tabla
    let index = tabla.listBeneficiario.findIndex(
      (b: { beneficiario: any; }) => {
        // TODO: Compara el beneficiario de la tabla con el que viene en la propiedad item
        return (
          b.beneficiario.toLowerCase().trim() ==
          item.beneficiario.toLowerCase().trim()
        );
      }
    );

    if (item.estado) {
      //TODO: OBTIENE UN ARREGLO CON TODAS LAS LINEAS DE NEGOCIO
      const linea = Codigo.getLineaNegocio();

      let lineaTemporal = "";
      for (let index = 0; index < linea.length; index++) {
        //TODO:  SE REMUEVE EL PRIMER CARACTER DE TEXTO (FSAO) = SAO
        if (
          item.subcuenta.substring(1, item.subcuenta.length) ===
          linea[index].valor
        )
          lineaTemporal = linea[index].valor;
      }
      if (tipoPlan == "A") {
        arrayDataModelo.push({
          subcuenta: "A" + item.subcuenta.slice(1),
          linea_negocio:
            lineaTemporal === "SMP" ? 1 : lineaTemporal === "SAO" ? 2 : 3,
          programa: [item.programa],
        });
        this.dataTarifa = {
          cuenta: 1,
          modelo_negocio: arrayDataModelo,
        };
      } else {
        arrayDataModelo.push({
          subcuenta: item.subcuenta, //TODO:  "FSAO"
          linea_negocio:
            lineaTemporal === "SMP" ? 1 : lineaTemporal === "SAO" ? 2 : 3,
          programa: [item.programa], //TODO:  "DESCB"
        });

        this.dataTarifa = {
          cuenta: 2, //TODO: FAMILIAR
          modelo_negocio: arrayDataModelo,
        };
      }
      // TODO: SI TIPO PLAN ES FAMILIAR
      if (tipoPlan == "F") {
        // TODO: PROGRAMAS DE MODELO DE NEGOCIO FAMILIAR PARA MEDICIA GENERAL

        let medicinaFamiliar: any = [];
        let medicinaAsociados: any = [];

        this.programasOrdenados.map((p) => {

          const medicina = this.programasMedicinaGeneral.find((c) => c.f === p);
          if (medicina) {
            medicinaFamiliar.push(medicina.f);
            medicinaAsociados.push(medicina.a);
          }
        });

        arrayDataModeloFamiliar = {
          subcuenta: "FSMP",
          linea_negocio: 1,
          programa: medicinaFamiliar,
        };

        arrayDataModeloAsociado = {
          subcuenta: "ASMP",
          linea_negocio: 1,
          programa: medicinaAsociados,
        };

        let saludFamiliar: any = [];
        let saludAsociados: any = [];
        this.programasOrdenados.map((p) => {
          const salud = this.programasSaludOral.find((c) => c.f === p);
          if (salud) {
            saludFamiliar.push(salud.f);
            saludAsociados.push(salud.a);
          }
        });
        // TODO: PROGRAMAS DE MODELO DE NEGOCIO FAMILIAR PARA SALUD ORAL
        arrayDataModeloFamiliar2 = {
          subcuenta: "FSAO",
          linea_negocio: 2,
          programa: saludFamiliar,
        };

        // TODO: PROGRAMAS DE MODELO DE NEGOCIO ASOCIADO PARA  SALUD ORAL
        arrayDataModeloAsociado2 = {
          subcuenta: "ASAO",
          linea_negocio: 2,
          programa: saludAsociados,
        };

        this.objDataCotizador["modelo_negocio"][0] = arrayDataModeloFamiliar;
        this.objDataCotizador["modelo_negocio"][1] = arrayDataModeloFamiliar2;
        this.objDataCotizador["modelo_negocio_asociado"][0] = arrayDataModeloAsociado;
        this.objDataCotizador["modelo_negocio_asociado"][1] = arrayDataModeloAsociado2;
      }
      if (tipoPlan == "A") {
        // TODO: PROGRAMAS DE MODELO DE NEGOCIO FAMILIAR PARA MEDICIA GENERAL
        let medicinaAsociados: any = [];
        this.programasOrdenados.map((p) => {
          const medicina = this.programasMedicinaGeneral.find((c) => c.a === p);
          if (medicina) {
            medicinaAsociados.push(medicina.a);
          }
        });

        arrayDataModeloFamiliar = {
          subcuenta: "FSMP",
          linea_negocio: 1,
          programa: [],
        };

        arrayDataModeloAsociado = {
          subcuenta: "ASMP",
          linea_negocio: 1,
          programa: medicinaAsociados,
        };

        let saludAsociados: any = [];
        this.programasOrdenados.map((p) => {
          const salud = this.programasSaludOral.find((c) => c.a === p);
          if (salud) {
            saludAsociados.push(salud.a);
          }
        });

        // TODO: PROGRAMAS DE MODELO DE NEGOCIO ASOCIADO PARA  SALUD ORAL
        arrayDataModeloAsociado2 = {
          subcuenta: "ASAO",
          linea_negocio: 2,
          programa: saludAsociados,
        };

        arrayDataModeloFamiliar2 = {
          subcuenta: "FSAO",
          linea_negocio: 2,
          programa: [],
        };

        this.objDataCotizador["modelo_negocio"][0] = arrayDataModeloFamiliar;
        this.objDataCotizador["modelo_negocio"][1] = arrayDataModeloFamiliar2;
        this.objDataCotizador["modelo_negocio_asociado"][0] = arrayDataModeloAsociado;
        this.objDataCotizador["modelo_negocio_asociado"][1] = arrayDataModeloAsociado2;
      }
      this.networking
        .buscarTarifaSubscribe(this.dataTarifa)
        .subscribe((r: ModelDefaultResponse<any>) => {

          let dat: any = r;
          let result: Array<IListTarifa> = dat;
          this.listTarifa = result;
          if (result2.length > 0) {
            result2.forEach((items) => {
              items.list_tarifa[this.subStrCuenta(item.subcuenta)] = this.listTarifa;
              //if(this.listTarifa.length == 1) {
              this.selectedValue[index + '-' + this.subStrCuenta(item.subcuenta)] = this.listTarifa[0].tarifa;
              this.actualizarTarifas(
                items.list_tarifa[this.subStrCuenta(item.subcuenta)][0].tarifa,
                items.beneficiario,
                index,
                item.subcuenta,
              );
              //}
            });
          }
        });
    } else {
      this.selectedValue[index + '-' + this.subStrCuenta(item.subcuenta)] = null;
    }
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }

  removeSpaces(controlName: string) {
    const control = this.form.get(controlName) ?? this.formColectivo.get(controlName);
    if (control) {
      const value = (control.value || '').toString();
      const normalizedValue = this.normalizarTextoInput(value);
      if (value !== normalizedValue) {
        control.setValue(normalizedValue);
      }
      return;
    } else {
      console.error(`Control with name ${controlName} not found`);
    }
  }

  private normalizarTextoInput(value: string): string {
    return value.replace(/\s+/g, ' ').trim();
  }

  normalizarTextoContacto(controlName: string): void {
    const control = this.formColectivo.get(controlName);
    if (control) {
      const value = (control.value || '').toString();
      const normalized = value.toUpperCase();
      if (value !== normalized) {
        control.setValue(normalized, { emitEvent: false });
      }
    }
  }

  bloquearEspaciosEmail(controlName: string): void {
    const control = this.formColectivo.get(controlName);
    if (control) {
      const value = (control.value || '').toString();
      const normalized = value.replace(/\s/g, '');
      if (value !== normalized) {
        control.setValue(normalized, { emitEvent: false });
      }
    }
  }

  async consultarIDxAsesor(): Promise<string> {
    try {
      const authInfo = await this.authService.getAuthInfo();
      const documentUser = authInfo.document;
      console.log('Información de autenticación obtenida:', authInfo);

      this.cedulaAsesor = documentUser.split('.')[1].trim();
      console.log('Documento asesor:', this.cedulaAsesor);

      this.idAsesor = await this.networkingMisCot.obtenerIdAsesorPorDocumento(this.cedulaAsesor);
      console.log('ID Asesor obtenido:', this.idAsesor);

      if (this.idAsesor) {
        localStorage.setItem('idAsesorAutenticadoGlobal', this.idAsesor.toString());
      }

      if (this.idAsesor == null) {
        console.warn('No se obtuvo idAsesor');
        return this.cedulaAsesor;
      }

      const request: ConsultarAsesorByIDRequest = {
        nombreClave: 'getSpCotConsultarAsesorPorID',
        jsonParametros: JSON.stringify({
          prm_id_asesor: String(this.idAsesor)
        })
      };

      const response = await firstValueFrom(
        this.consultarAsesorByIDService.consultarAsesorByID(request)
      );

      console.log('Respuesta consultarAsesorByID:', response);

      if (response?.status && Array.isArray(response.data) && response.data.length > 0) {
        const asesor = response.data[0];

        this.asesorLogueadoData = asesor;

        this.NombreCompleto = (asesor?.NombreCompleto ?? '').toString().trim();
        this.NumeroDocumento = (asesor?.NumeroDocumento ?? '').toString().trim();
        this.correoAsesor = (asesor?.email ?? '').toString().trim();
        this.celularAsesor = (asesor?.telefono ?? '').toString().trim();
        this.ciudadAsesor = this.capitalizeFirstLetter(
          (asesor?.ciudad ?? '').toString().trim()
        );
        this.cargoAsesor = this.capitalizeFirstLetter(
          (asesor?.TipoAsesor ?? '').toString().trim()
        );

        this.aplicarRegionalAsesorPorDefecto();
      } else {
        console.warn('No se encontró información del asesor para el id:', this.idAsesor);
      }

      return this.cedulaAsesor;
    } catch (error) {
      console.error('Error al obtener la información del asesor:', error);
      return this.cedulaAsesor;
    }
  }

  private capitalizeFirstLetter(value: string): string {
    const trimmed = (value ?? '').toString().trim();
    if (!trimmed) {
      return '';
    }
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }

  descargarPDFDesdeDatos() {
    const idCotizacion = this.obtenerIdCotizacionDesdeStorage();
    const nombreCliente = (this.formColectivo.get('colectivoNombre')?.value ?? '').toString().trim();
    const emailDestinatario = (this.formColectivo.get('emailDestinatario')?.value ?? '').toString().trim();
    const ciudad = this.ciudadAsesor;
    const pdfUrl = this.crearPdfColectivoInlineUrl(idCotizacion);

    const derechoSubsidio = (
      this.formColectivo.get('derechoAsubsidio')?.value ?? ''
    ).toString();

    const porcentajeSeleccionado = (
      this.formColectivo.get('porcentajeSubsidio')?.value ?? ''
    ).toString();

    let porcentajeSubsidio = '0';

    if (derechoSubsidio === '1') {
      if (porcentajeSeleccionado === '1') {
        porcentajeSubsidio = '50';
      } else if (porcentajeSeleccionado === '2') {
        porcentajeSubsidio = '100';
      }
    }

    const mostrarTodosEscenarios = this.mostrarTodosEscenariosSubsidio;

    const aplicaAnexos =
      this.requiereIncluirAnexos === 'si' &&
      this.programasConAnexosSeleccionados.size > 0;

    const nombreJefe = this.nombreAsesor?.trim() || '';
    const cargoJefe = this.cargoAsesor?.trim() || '';

    this.spinner.show();
    this.networking.descargarPdfCotizacionColectivo(
      idCotizacion.toString(),
      ciudad,
      porcentajeSubsidio,
      mostrarTodosEscenarios,
      aplicaAnexos,
      nombreJefe,
      cargoJefe
    ).subscribe({
      next: (pdfBlob: Blob) => {
        this.spinner.hide();

        pdfBlob.arrayBuffer().then(buffer => {

          const header = String.fromCharCode(...new Uint8Array(buffer.slice(0, 5)));

          if (!header.startsWith('%PDF')) {
            console.error('Header inválido. No es un PDF válido.');
            console.error('Primeros 100 bytes del buffer:', new Uint8Array(buffer.slice(0, 100)));
            this.SnackBarService.alert(
              'btn-danger',
              'No se pudo generar el PDF. El contenido recibido no es un PDF válido. Verifique la consola para más detalles.'
            );
            return;
          }

          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result as string;
            // Extraer solo la parte base64 (sin el prefijo "data:application/pdf;base64,")
            const pdfBase64 = dataUrl.split(',')[1] ?? '';
            const blobUrl = URL.createObjectURL(pdfBlob);
            const dialogRef = this.dialog.open(ModalEnviarCotizacionComponent, {
              width: '96vw',
              maxWidth: '1100px',
              disableClose: true,
              data: {
                titulo: 'Cotización Colectiva',
                pdfUrl,
                pdfDownloadUrl: blobUrl,
                idCotizacion: idCotizacion,
                numeroCotizacion: idCotizacion.toString(),
                nombreCliente: nombreCliente,
                esColectivo: true,
                emailDestinatario: emailDestinatario,
                pdfBase64: pdfBase64,
                nombreContratante: nombreCliente
              } as ModalEnviarCotizacionData
            });
            dialogRef.afterClosed().subscribe(() => {
              URL.revokeObjectURL(blobUrl);
            });

            // Al mostrar el PDF en el modal, marcar la cotización como ENVIADA (idEstado=3).
            // Antes este cambio de estado vivía en el botón ENVIAR del modal (hoy oculto para colectivo).
            if (Number.isFinite(idCotizacion) && idCotizacion > 0) {
              this.networking.actualizarEstadoCotizacion(idCotizacion, 3).subscribe({
                error: (err) => console.error('Error al actualizar estado de cotización a ENVIADA:', err),
              });
            }
          };
          reader.readAsDataURL(pdfBlob);
        }).catch(err => {
          console.error('Error procesando arrayBuffer:', err);
          this.SnackBarService.alert('btn-danger', 'Error procesando el PDF: ' + err.message);
        });
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error completo al generar el PDF de la cotización:', err);
        console.error('Mensaje de error:', err?.message);
        const mensajeError = err?.message || 'Error desconocido al descargar el PDF';
        this.SnackBarService.alert('btn-danger', `Error al generar el PDF de la cotización: ${mensajeError}`);
      },
    });
  }

  /**
   * Porque a veces se guarda ASAO y FSAO. Genera confusión en los datos lo cual provoca bugs,
   * pendiente por aclarar
   * @param cuenta 
   * @returns 
   */
  private crearPdfColectivoInlineUrl(idCotizacion: number): string {
    const params = new HttpParams()
      .set('idCotizacion', idCotizacion.toString())
      .set('nombreAsesor', (this.NombreCompleto ?? '').trim())
      .set('telefonoAsesor', (this.celularAsesor ?? '').trim())
      .set('correoAsesor', (this.correoAsesor ?? '').trim())
      .set('ciudadAsesor', this.ciudadAsesor ?? '');
    const nombreArchivo = `cotización_${idCotizacion}.pdf`;

    return `${environment.HOST}${URL_MAP.API.PDF_COTIZACION_COLECTIVO}/${nombreArchivo}?${params.toString()}`;
  }

  subStrCuenta(cuenta: string) {
    return cuenta.substring(1);
  }

  /**
  * Determina qué programas enviar al servicio de carnets.
  * Si es Inclusión (2), lee exclusivamente los que el usuario chuleó en la modal de Contratante.
  * Si es Venta Nueva (1) u otro flujo, envía el arreglo por defecto.
  */
  private obtenerProgramasParaCarnets(programasPorDefecto: string[] = []): string[] {
    const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');

    // Si NO es Inclusión, se retoma el comportamiento normal del cotizador (VENTA NUEVA INTACTA)
    if (tipoSolicitud !== '2') {
      return programasPorDefecto;
    }

    try {
      const seleccionadosStr = localStorage.getItem('programas_seleccionados_inclusion');
      if (seleccionadosStr) {
        const permitidos = JSON.parse(seleccionadosStr) as string[];
        if (Array.isArray(permitidos) && permitidos.length > 0) {
          return permitidos.map(p => p.trim().toUpperCase());
        }
      }
    } catch (e) {
      console.error('Error leyendo programas preseleccionados de Inclusión', e);
    }

    if (this.valContrato?.codigoPrograma) {
      return [this.valContrato.codigoPrograma.trim().toUpperCase()];
    }

    return programasPorDefecto;
  }

  /**
   * Obtiene los códigos equivalentes entre planes (Familiar/Asociado)
   * basándose en las matrices nativas del componente para evitar colisiones de nombres.
   */
  private obtenerEquivalentesInclusion(codigo: string): string[] {
    const cd = codigo.trim().toUpperCase();
    return [cd];
  }

  /**
   * elimina cualquier carnet que no haya sido seleccionado para inclución.
   */
  private aplicarFiltroInclusionGlobal(): void {
    const tipoSolicitud = this.formInit?.get('tipoSolicitud')?.value || localStorage.getItem('tipoSolicitud');
    if (tipoSolicitud !== '2') return;

    try {
      const raw = localStorage.getItem('programas_seleccionados_inclusion');
      if (!raw) return;

      const permitidos = JSON.parse(raw).map((p: string) => p.toString().trim().toUpperCase());
      if (permitidos.length === 0) return;

      if (this.programasCarnetPorLinea) {
        Object.keys(this.programasCarnetPorLinea).forEach(key => {
          if (Array.isArray(this.programasCarnetPorLinea[key])) {

            this.programasCarnetPorLinea[key] = this.programasCarnetPorLinea[key].filter((item: any) => {
              const code = (item?.code || '').toString().trim().toUpperCase();

              const esPermitido = permitidos.some((p: string) => {
                const codigosValidos = this.obtenerEquivalentesInclusion(p);
                return codigosValidos.includes(code);
              });

              return esPermitido;
            });

          }
        });
      }
    } catch (e) {
      console.error('Error en el filtro global de inclusión:', e);
    }
  }

  /**
     * 
     * Alinea las subcuentas y tarifas basándose en el tipo de plan ('F' o 'A')
     * ejecutándose únicamente para el pipeline de Inclusión (TipoSolicitud = 2).
     */


  private limpiarSubcuentasInclusionIndividual(): void {
    const tipoSolicitud = localStorage.getItem('tipoSolicitud');

    // 🛡️ Filtro de contención: Si no es inclusión, salimos de inmediato para no alterar venta nueva
    if (tipoSolicitud !== '2') return;

    try {
      const tipoPlanLocal = this.formInit?.get("tipoPlan")?.value;
      const tipoPlanActual = (localStorage.getItem('tipoPlan') || tipoPlanLocal || '').toString().trim().toUpperCase();

      if (this.esInclusion) {
        console.log(`[Inclusion] Evaluando alineación de subcuentas para TipoPlan: "${tipoPlanActual}"`);
      }

      let tarifaDetectada = this.contratanteTarifa || this.dataCampania?.tarifa || "";
      if (!tarifaDetectada) {
        try {
          const rawProg = localStorage.getItem('programas_contratante');
          if (rawProg) {
            const progs = JSON.parse(rawProg);
            if (Array.isArray(progs) && progs.length > 0) tarifaDetectada = progs[0]?.tarifa || "";
          }
        } catch (_) { }
      }

      if (!tarifaDetectada || tarifaDetectada.trim() === "") {
        tarifaDetectada = "ATRADN"; // Tarifa histórica de respaldo
      }

      const arregloTarifaSegura = [tarifaDetectada.toString().trim()];

      if (this.objDataCotizador) {
        // CASO A: Si es Plan Particular/Familiar ("F"), las subcuentas se purgan obligatoriamente a vacío
        if (tipoPlanActual === 'F') {
          if (Array.isArray(this.objDataCotizador.modelo_negocio)) {
            this.objDataCotizador.modelo_negocio.forEach((mn: any) => {
              mn.subcuenta = "";
              mn.tarifa = arregloTarifaSegura;
            });
          }
          if (Array.isArray(this.objDataCotizador.modelo_negocio_asociado)) {
            this.objDataCotizador.modelo_negocio_asociado.forEach((mna: any) => {
              mna.subcuenta = "";
              mna.tarifa = arregloTarifaSegura;
            });
          }
          if (this.esInclusion) console.log('[Inclusion]  Subcuentas purgadas a vacío para Plan Familiar.');
        }
        // CASO B: Si es Plan Asociado ("A"), se fuerza el token mandatorio ASMP
        else if (tipoPlanActual === 'A') {
          if (Array.isArray(this.objDataCotizador.modelo_negocio)) {
            this.objDataCotizador.modelo_negocio.forEach((mn: any) => {
              if (!mn.subcuenta || mn.subcuenta === "") mn.subcuenta = "ASMP";
              mn.tarifa = arregloTarifaSegura;
            });
          }
          if (Array.isArray(this.objDataCotizador.modelo_negocio_asociado)) {
            this.objDataCotizador.modelo_negocio_asociado.forEach((mna: any) => {
              if (!mna.subcuenta || mna.subcuenta === "") mna.subcuenta = "ASMP";
              mna.tarifa = arregloTarifaSegura;
            });
          }
          if (this.esInclusion) console.log('[Inclusion-Purificador]  Token "ASMP" asegurado para Plan Asociado.');
        }
      }
    } catch (error) {
      console.error('[Inclusion-Purificador]  Error en pipeline de purificación:', error);
    }
  }

  formatLineOfBusinessLabel(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    if (!raw) {
      return '';
    }

    return raw
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => item.toUpperCase() === 'SO' ? 'SAO' : item)
      .join(', ');
  }

  ngOnDestroy(): void {
    // Al salir del cotizador: limpiar sesión fantasma para que una nueva visita arranque limpia
    // (evita bloquear tipo/número documento solo por coincidir con una cotización previa en LS).
    if (!this.isEditMode) {
      localStorage.removeItem('cotizacion_creada_desde_contratante');
      localStorage.removeItem('cotizacion_contratante_actual');
      localStorage.removeItem('cotizacion_precargada');
      sessionStorage.removeItem('cotizacion_contratante_sesion_activa');
      localStorage.removeItem('datosRQ003_Beneficiarios');
      localStorage.removeItem('datosRQ003_Beneficiario');
      localStorage.removeItem('programas_beneficiario');
      localStorage.removeItem(this.KEY_FLECHA_DEPENDIENTES_PERSISTENCIA);
      localStorage.removeItem(this.KEY_FLECHA_BENEFICIARIOS_SNAPSHOT);
    }
    this.cotizadorCancel$.next();
    this.cotizadorCancel$.complete();
  }

  /**
   * Cascada de borrado usada históricamente por el merge de inclusiones.
   * Delega a eliminarBeneficiarioEnCascadaDesdeFila para que BD + tabla + LS
   * queden sincronizados (el path solo-HTTP dejaba la grilla sin refrescar).
   */
  private async ejecutarCascadaEliminacionBackend(row: any): Promise<void> {
    await this.eliminarBeneficiarioEnCascadaDesdeFila(row);
  }

  private async sincronizarProgramasColectivoParaBeneficiarios(): Promise<void> {
    // Garantiza que los grupos estén cargados desde getconsultacolectivoac
    await this.consultarGruposProgramaColectivo();

    const payload: any[] = Array.from(this.programasSeleccionadosUI).map(code => {
      const metadata = this.findProgramaMetadata(code);
      const linea = this.obtenerLineaDePrograma(code);
      const resumenItem = (this.resumenCotizacionColectivoData || [])
        .find(r => r.programaCode === code);

      const nombrePrograma = metadata?.program || code;

      return {
        id: code,
        programa: code,
        nombrePrograma,
        lineaNegocio:
          linea === '1'
            ? 'MI'
            : linea === '2'
              ? 'SAO'
              : 'CEM',
        subcuenta: this.colectivoSubcta || '',
        tarifa: resumenItem
          ? `TARIFA COLECTIVA (${resumenItem.programaCode})`
          : '',
        valorMensualIva: resumenItem?.tarifaSinSubsidio || 0,
        requiereAnexo: this.programasConAnexosSeleccionados.has(code)
          ? 'si'
          : 'no',

        // Para Colectivo y Afinidad se obtiene del servicio colectivo
        grupoPrograma: this.obtenerGrupoProgramaColectivo(
          code,
          nombrePrograma
        )
          .toString()
          .trim()
          .toUpperCase(),
      };
    });

    localStorage.setItem(
      'programas_contratante',
      JSON.stringify(payload)
    );

    console.log(
      '[Colectivo-Padre] Programas heredados por los beneficiarios:',
      payload
    );

    this.sincronizarYRefrescarBeneficiariosHeredados(payload as any);
  }

}
